/* eslint-disable */
/* prettier-ignore */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

/** A Field Group registered by ACF */
export type AcfFieldGroup = {
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
};

/** Blog Homepage Options options. */
export type AcfOptionsBlogHomepageOptions = {
  __typename?: 'AcfOptionsBlogHomepageOptions';
  /** Added to the GraphQL Schema because the ACF Field Group &quot;Homepage Featured Posts&quot; was set to Show in GraphQL. */
  blogHomeFeaturedPosts?: Maybe<AcfOptionsBlogHomepageOptionsBloghomefeaturedposts>;
  /** Added to the GraphQL Schema because the ACF Field Group &quot;Blog Homepage Options&quot; was set to Show in GraphQL. */
  blogHomeOptions?: Maybe<AcfOptionsBlogHomepageOptionsBloghomeoptions>;
  pageSlug?: Maybe<Scalars['String']>;
  pageTitle?: Maybe<Scalars['String']>;
};

/** Field Group */
export type AcfOptionsBlogHomepageOptionsBloghomefeaturedposts = AcfFieldGroup & {
  __typename?: 'AcfOptionsBlogHomepageOptions_Bloghomefeaturedposts';
  /** Posts featured on the blog homepage, in order. Up to 10. */
  featuredPosts?: Maybe<Array<Maybe<AcfOptionsBlogHomepageOptionsBloghomefeaturedpostsBlogHomeFeaturedPosts>>>;
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
};

export type AcfOptionsBlogHomepageOptionsBloghomefeaturedpostsBlogHomeFeaturedPosts = Post;

/** Field Group */
export type AcfOptionsBlogHomepageOptionsBloghomeoptions = AcfFieldGroup & {
  __typename?: 'AcfOptionsBlogHomepageOptions_Bloghomeoptions';
  categories?: Maybe<Array<Maybe<AcfOptionsBlogHomepageOptionsBloghomeoptionsCategories>>>;
  /** Select the main featured post */
  featuredPost?: Maybe<AcfOptionsBlogHomepageOptionsBloghomeoptionsFeaturedPost>;
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
  mostReadPostsOptions?: Maybe<AcfOptionsBlogHomepageOptionsBloghomeoptionsMostReadPostsOptions>;
};

export type AcfOptionsBlogHomepageOptionsBloghomeoptionsFeaturedPost = Post;

/** Field Group */
export type AcfOptionsBlogHomepageOptionsBloghomeoptionsMostReadPostsOptions = AcfFieldGroup & {
  __typename?: 'AcfOptionsBlogHomepageOptions_Bloghomeoptions_MostReadPostsOptions';
  /** System will get a set of most read posts to this one automatically. By turning this off, you will need to manually select five posts. */
  automaticMostReadPosts?: Maybe<Scalars['Boolean']>;
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
  mostReadPosts?: Maybe<Array<Maybe<AcfOptionsBlogHomepageOptionsBloghomeoptionsMostReadPostsOptionsMostReadPosts>>>;
};

export type AcfOptionsBlogHomepageOptionsBloghomeoptionsMostReadPostsOptionsMostReadPosts = Post;

/** Field Group */
export type AcfOptionsBlogHomepageOptionsBloghomeoptionsCategories = AcfFieldGroup & {
  __typename?: 'AcfOptionsBlogHomepageOptions_Bloghomeoptions_categories';
  /** Select the desired category */
  category?: Maybe<Category>;
  /** Select 3 posts of the desired category */
  categoryPosts?: Maybe<Array<Maybe<AcfOptionsBlogHomepageOptionsBloghomeoptionsCategoriesCategoryPosts>>>;
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
  showLatest?: Maybe<Scalars['Boolean']>;
};

export type AcfOptionsBlogHomepageOptionsBloghomeoptionsCategoriesCategoryPosts = Post;

/** Blog Search Results Options options. */
export type AcfOptionsBlogSearchResultsOptions = {
  __typename?: 'AcfOptionsBlogSearchResultsOptions';
  pageSlug?: Maybe<Scalars['String']>;
  pageTitle?: Maybe<Scalars['String']>;
};

/** Avatars are profile images for users. WordPress by default uses the Gravatar service to host and fetch avatars from. */
export type Avatar = {
  __typename?: 'Avatar';
  /** URL for the default image or a default type. Accepts &#039;404&#039; (return a 404 instead of a default image), &#039;retro&#039; (8bit), &#039;monsterid&#039; (monster), &#039;wavatar&#039; (cartoon face), &#039;indenticon&#039; (the &#039;quilt&#039;), &#039;mystery&#039;, &#039;mm&#039;, or &#039;mysteryman&#039; (The Oyster Man), &#039;blank&#039; (transparent GIF), or &#039;gravatar_default&#039; (the Gravatar logo). */
  default?: Maybe<Scalars['String']>;
  /** HTML attributes to insert in the IMG element. Is not sanitized. */
  extraAttr?: Maybe<Scalars['String']>;
  /** Whether to always show the default image, never the Gravatar. */
  forceDefault?: Maybe<Scalars['Boolean']>;
  /** Whether the avatar was successfully found. */
  foundAvatar?: Maybe<Scalars['Boolean']>;
  /** Height of the avatar image. */
  height?: Maybe<Scalars['Int']>;
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** What rating to display avatars up to. Accepts &#039;G&#039;, &#039;PG&#039;, &#039;R&#039;, &#039;X&#039;, and are judged in that order. */
  rating?: Maybe<Scalars['String']>;
  /** Type of url scheme to use. Typically HTTP vs. HTTPS. */
  scheme?: Maybe<Scalars['String']>;
  /** The size of the avatar in pixels. A value of 96 will match a 96px x 96px gravatar image. */
  size?: Maybe<Scalars['Int']>;
  /** URL for the gravatar image source. */
  url?: Maybe<Scalars['String']>;
  /** Width of the avatar image. */
  width?: Maybe<Scalars['Int']>;
};

/** What rating to display avatars up to. Accepts 'G', 'PG', 'R', 'X', and are judged in that order. Default is the value of the 'avatar_rating' option */
export enum AvatarRatingEnum {
  /** Indicates a G level avatar rating level. */
  G = 'G',
  /** Indicates a PG level avatar rating level. */
  Pg = 'PG',
  /** Indicates an R level avatar rating level. */
  R = 'R',
  /** Indicates an X level avatar rating level. */
  X = 'X'
}

/** The category type */
export type Category = DatabaseIdentifier & HierarchicalNode & HierarchicalTermNode & MenuItemLinkable & Node & NodeWithRankMathSeo & TermNode & UniformResourceIdentifiable & {
  __typename?: 'Category';
  /** The ancestors of the node. Default ordered as lowest (closest to the child) to highest (closest to the root). */
  ancestors?: Maybe<CategoryToAncestorsCategoryConnection>;
  /**
   * The id field matches the WP_Post-&gt;ID field.
   * @deprecated Deprecated in favor of databaseId
   */
  categoryId?: Maybe<Scalars['Int']>;
  /** Content for the category and subcategory pages. The intro is the category description. | Added to the GraphQL Schema because the ACF Field Group &quot;Category Page&quot; was set to Show in GraphQL. */
  categoryPage?: Maybe<CategoryCategorypage>;
  /** Connection between the category type and its children categories. */
  children?: Maybe<CategoryToCategoryConnection>;
  /** Connection between the Category type and the ContentNode type */
  contentNodes?: Maybe<CategoryToContentNodeConnection>;
  /** The number of objects connected to the object */
  count?: Maybe<Scalars['Int']>;
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int'];
  /** The description of the object */
  description?: Maybe<Scalars['String']>;
  /** Connection between the TermNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<TermNodeToEnqueuedScriptConnection>;
  /** Connection between the TermNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<TermNodeToEnqueuedStylesheetConnection>;
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The link to the term */
  link?: Maybe<Scalars['String']>;
  /** The human friendly name of the object. */
  name?: Maybe<Scalars['String']>;
  /** Connection between the category type and its parent category. */
  parent?: Maybe<CategoryToParentCategoryConnectionEdge>;
  /** Database id of the parent node */
  parentDatabaseId?: Maybe<Scalars['Int']>;
  /** The globally unique identifier of the parent node. */
  parentId?: Maybe<Scalars['ID']>;
  /** Connection between the Category type and the post type */
  posts?: Maybe<CategoryToPostConnection>;
  /** The RankMath SEO data for the node. */
  seo?: Maybe<RankMathSeo>;
  /** An alphanumeric identifier for the object unique to its type. */
  slug?: Maybe<Scalars['String']>;
  /** Connection between the Category type and the Taxonomy type */
  taxonomy?: Maybe<CategoryToTaxonomyConnectionEdge>;
  /** The name of the taxonomy that the object is associated with */
  taxonomyName?: Maybe<Scalars['String']>;
  /** The ID of the term group that this term object belongs to */
  termGroupId?: Maybe<Scalars['Int']>;
  /** The taxonomy ID that the object is associated with */
  termTaxonomyId?: Maybe<Scalars['Int']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};


/** The category type */
export type CategoryAncestorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The category type */
export type CategoryChildrenArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CategoryToCategoryConnectionWhereArgs>;
};


/** The category type */
export type CategoryContentNodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CategoryToContentNodeConnectionWhereArgs>;
};


/** The category type */
export type CategoryEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The category type */
export type CategoryEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The category type */
export type CategoryPostsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CategoryToPostConnectionWhereArgs>;
};

/** Connection to category Nodes */
export type CategoryConnection = {
  /** A list of edges (relational context) between RootQuery and connected category Nodes */
  edges: Array<CategoryConnectionEdge>;
  /** A list of connected category Nodes */
  nodes: Array<Category>;
  /** Information about pagination in a connection. */
  pageInfo: CategoryConnectionPageInfo;
};

/** Edge between a Node and a connected category */
export type CategoryConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The connected category Node */
  node: Category;
};

/** Page Info on the connected CategoryConnectionEdge */
export type CategoryConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum CategoryIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI'
}

/** The RankMath SEO meta settings for Categories. */
export type CategoryMetaSettings = RankMathMetaSettingWithArchive & RankMathMetaSettingWithRobots & {
  __typename?: 'CategoryMetaSettings';
  /** Advanced robots meta tag settings. */
  advancedRobotsMeta?: Maybe<RankMathAdvancedRobotsMeta>;
  /** Description for archive pages. */
  archiveDescription?: Maybe<Scalars['String']>;
  /** Default title tag for archive page. */
  archiveTitle?: Maybe<Scalars['String']>;
  /** Whether custom robots meta for author page are set. Otherwise the default meta will be used, as set in the Global Meta tab. */
  hasCustomRobotsMeta?: Maybe<Scalars['Boolean']>;
  /** Whether the SEO Controls meta box for user profile pages is enabled. */
  hasSeoControls?: Maybe<Scalars['Boolean']>;
  /** Whether to show additional information (name &amp; total number of posts) when an author archive is shared on Slack. */
  hasSlackEnhancedSharing?: Maybe<Scalars['Boolean']>;
  /** Whether to include snippet data for this taxonomy. */
  hasSnippetData?: Maybe<Scalars['Boolean']>;
  /** Custom values for robots meta tag. */
  robotsMeta?: Maybe<Array<Maybe<RankMathRobotsMetaValueEnum>>>;
};

/** Connection between the Category type and the category type */
export type CategoryToAncestorsCategoryConnection = CategoryConnection & Connection & {
  __typename?: 'CategoryToAncestorsCategoryConnection';
  /** Edges for the CategoryToAncestorsCategoryConnection connection */
  edges: Array<CategoryToAncestorsCategoryConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Category>;
  /** Information about pagination in a connection. */
  pageInfo: CategoryToAncestorsCategoryConnectionPageInfo;
};

/** An edge in a connection */
export type CategoryToAncestorsCategoryConnectionEdge = CategoryConnectionEdge & Edge & {
  __typename?: 'CategoryToAncestorsCategoryConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Category;
};

/** Page Info on the &quot;CategoryToAncestorsCategoryConnection&quot; */
export type CategoryToAncestorsCategoryConnectionPageInfo = CategoryConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'CategoryToAncestorsCategoryConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Connection between the Category type and the category type */
export type CategoryToCategoryConnection = CategoryConnection & Connection & {
  __typename?: 'CategoryToCategoryConnection';
  /** Edges for the CategoryToCategoryConnection connection */
  edges: Array<CategoryToCategoryConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Category>;
  /** Information about pagination in a connection. */
  pageInfo: CategoryToCategoryConnectionPageInfo;
};

/** An edge in a connection */
export type CategoryToCategoryConnectionEdge = CategoryConnectionEdge & Edge & {
  __typename?: 'CategoryToCategoryConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Category;
};

/** Page Info on the &quot;CategoryToCategoryConnection&quot; */
export type CategoryToCategoryConnectionPageInfo = CategoryConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'CategoryToCategoryConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the CategoryToCategoryConnection connection */
export type CategoryToCategoryConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the Category type and the ContentNode type */
export type CategoryToContentNodeConnection = Connection & ContentNodeConnection & {
  __typename?: 'CategoryToContentNodeConnection';
  /** Edges for the CategoryToContentNodeConnection connection */
  edges: Array<CategoryToContentNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<ContentNode>;
  /** Information about pagination in a connection. */
  pageInfo: CategoryToContentNodeConnectionPageInfo;
};

/** An edge in a connection */
export type CategoryToContentNodeConnectionEdge = ContentNodeConnectionEdge & Edge & {
  __typename?: 'CategoryToContentNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: ContentNode;
};

/** Page Info on the &quot;CategoryToContentNodeConnection&quot; */
export type CategoryToContentNodeConnectionPageInfo = ContentNodeConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'CategoryToContentNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the CategoryToContentNodeConnection connection */
export type CategoryToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypesOfCategoryEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the Category type and the category type */
export type CategoryToParentCategoryConnectionEdge = CategoryConnectionEdge & Edge & OneToOneConnection & {
  __typename?: 'CategoryToParentCategoryConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The node of the connection, without the edges */
  node: Category;
};

/** Connection between the Category type and the post type */
export type CategoryToPostConnection = Connection & PostConnection & {
  __typename?: 'CategoryToPostConnection';
  /** Edges for the CategoryToPostConnection connection */
  edges: Array<CategoryToPostConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Post>;
  /** Information about pagination in a connection. */
  pageInfo: CategoryToPostConnectionPageInfo;
};

/** An edge in a connection */
export type CategoryToPostConnectionEdge = Edge & PostConnectionEdge & {
  __typename?: 'CategoryToPostConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Post;
};

/** Page Info on the &quot;CategoryToPostConnection&quot; */
export type CategoryToPostConnectionPageInfo = PageInfo & PostConnectionPageInfo & WpPageInfo & {
  __typename?: 'CategoryToPostConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the CategoryToPostConnection connection */
export type CategoryToPostConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Category ID */
  categoryId?: InputMaybe<Scalars['Int']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Use Category Slug */
  categoryName?: InputMaybe<Scalars['String']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  tag?: InputMaybe<Scalars['String']>;
  /** Use Tag ID */
  tagId?: InputMaybe<Scalars['String']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  tagSlugAnd?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  tagSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the Category type and the Taxonomy type */
export type CategoryToTaxonomyConnectionEdge = Edge & OneToOneConnection & TaxonomyConnectionEdge & {
  __typename?: 'CategoryToTaxonomyConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The node of the connection, without the edges */
  node: Taxonomy;
};

/** Field Group */
export type CategoryCategorypage = AcfFieldGroup & {
  __typename?: 'Category_Categorypage';
  about?: Maybe<Scalars['String']>;
  ctaBody?: Maybe<Scalars['String']>;
  /** May contain &lt;em&gt; for emphasis. */
  ctaHeadline?: Maybe<Scalars['String']>;
  /** Categories: one or more links. Subcategories: one link. */
  ctaLinks?: Maybe<Array<Maybe<CategoryCategorypageHubCtaLinks>>>;
  /** Top-level categories only. */
  faq?: Maybe<Array<Maybe<CategoryCategorypageHubFaq>>>;
  /** Posts featured on this page, in order. Up to 10 for a category, 6 for a subcategory. Only posts in this category can be picked. */
  featuredPosts?: Maybe<Array<Maybe<CategoryCategorypageCategoryFeaturedPosts>>>;
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
};

export type CategoryCategorypageCategoryFeaturedPosts = Post;

/** Field Group */
export type CategoryCategorypageHubCtaLinks = AcfFieldGroup & {
  __typename?: 'Category_Categorypage_hubCtaLinks';
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** Field Group */
export type CategoryCategorypageHubFaq = AcfFieldGroup & {
  __typename?: 'Category_Categorypage_hubFaq';
  answer?: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
};

/** Code snippet with an associated language. */
export type CodeBlock = {
  __typename?: 'CodeBlock';
  /** Code snippet contents. */
  code?: Maybe<Scalars['String']>;
  /** Unique block identifier. */
  id?: Maybe<Scalars['String']>;
  /** Language key (e.g. js, php, css). */
  language?: Maybe<Scalars['String']>;
};

/** A Comment object */
export type Comment = DatabaseIdentifier & Node & UniformResourceIdentifiable & {
  __typename?: 'Comment';
  /** User agent used to post the comment. This field is equivalent to WP_Comment-&gt;comment_agent and the value matching the &quot;comment_agent&quot; column in SQL. */
  agent?: Maybe<Scalars['String']>;
  /**
   * The approval status of the comment. This field is equivalent to WP_Comment-&gt;comment_approved and the value matching the &quot;comment_approved&quot; column in SQL.
   * @deprecated Deprecated in favor of the `status` field
   */
  approved?: Maybe<Scalars['Boolean']>;
  /** The author of the comment */
  author?: Maybe<CommentToCommenterConnectionEdge>;
  /**
   * IP address for the author at the time of commenting. This field is equivalent to WP_Comment-&gt;comment_author_IP and the value matching the &quot;comment_author_IP&quot; column in SQL.
   * @deprecated Use the ipAddress field on the edge between the comment and author
   */
  authorIp?: Maybe<Scalars['String']>;
  /**
   * ID for the comment, unique among comments.
   * @deprecated Deprecated in favor of databaseId
   */
  commentId?: Maybe<Scalars['Int']>;
  /** Connection between the Comment type and the ContentNode type */
  commentedOn?: Maybe<CommentToContentNodeConnectionEdge>;
  /** Content of the comment. This field is equivalent to WP_Comment-&gt;comment_content and the value matching the &quot;comment_content&quot; column in SQL. */
  content?: Maybe<Scalars['String']>;
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int'];
  /** Date the comment was posted in local time. This field is equivalent to WP_Comment-&gt;date and the value matching the &quot;date&quot; column in SQL. */
  date?: Maybe<Scalars['String']>;
  /** Date the comment was posted in GMT. This field is equivalent to WP_Comment-&gt;date_gmt and the value matching the &quot;date_gmt&quot; column in SQL. */
  dateGmt?: Maybe<Scalars['String']>;
  /** The globally unique identifier for the comment object */
  id: Scalars['ID'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** Karma value for the comment. This field is equivalent to WP_Comment-&gt;comment_karma and the value matching the &quot;comment_karma&quot; column in SQL. */
  karma?: Maybe<Scalars['Int']>;
  /** The permalink of the comment */
  link?: Maybe<Scalars['String']>;
  /** Connection between the Comment type and the Comment type */
  parent?: Maybe<CommentToParentCommentConnectionEdge>;
  /** The database id of the parent comment node or null if it is the root comment */
  parentDatabaseId?: Maybe<Scalars['Int']>;
  /** The globally unique identifier of the parent comment node. */
  parentId?: Maybe<Scalars['ID']>;
  /** Connection between the Comment type and the Comment type */
  replies?: Maybe<CommentToCommentConnection>;
  /** The approval status of the comment. This field is equivalent to WP_Comment-&gt;comment_approved and the value matching the &quot;comment_approved&quot; column in SQL. */
  status?: Maybe<CommentStatusEnum>;
  /** Type of comment. This field is equivalent to WP_Comment-&gt;comment_type and the value matching the &quot;comment_type&quot; column in SQL. */
  type?: Maybe<Scalars['String']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};


/** A Comment object */
export type CommentContentArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};


/** A Comment object */
export type CommentParentArgs = {
  where?: InputMaybe<CommentToParentCommentConnectionWhereArgs>;
};


/** A Comment object */
export type CommentRepliesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CommentToCommentConnectionWhereArgs>;
};

/** A Comment Author object */
export type CommentAuthor = Commenter & DatabaseIdentifier & Node & {
  __typename?: 'CommentAuthor';
  /** Avatar object for user. The avatar object can be retrieved in different sizes by specifying the size argument. */
  avatar?: Maybe<Avatar>;
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int'];
  /** The email for the comment author */
  email?: Maybe<Scalars['String']>;
  /** The globally unique identifier for the comment author object */
  id: Scalars['ID'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** The name for the comment author. */
  name?: Maybe<Scalars['String']>;
  /** The url the comment author. */
  url?: Maybe<Scalars['String']>;
};


/** A Comment Author object */
export type CommentAuthorAvatarArgs = {
  forceDefault?: InputMaybe<Scalars['Boolean']>;
  rating?: InputMaybe<AvatarRatingEnum>;
  size?: InputMaybe<Scalars['Int']>;
};

/** Connection to Comment Nodes */
export type CommentConnection = {
  /** A list of edges (relational context) between RootQuery and connected Comment Nodes */
  edges: Array<CommentConnectionEdge>;
  /** A list of connected Comment Nodes */
  nodes: Array<Comment>;
  /** Information about pagination in a connection. */
  pageInfo: CommentConnectionPageInfo;
};

/** Edge between a Node and a connected Comment */
export type CommentConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The connected Comment Node */
  node: Comment;
};

/** Page Info on the connected CommentConnectionEdge */
export type CommentConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single comment node. Default is "ID". To be used along with the "id" field. */
export enum CommentNodeIdTypeEnum {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID'
}

/** The status of the comment object. */
export enum CommentStatusEnum {
  /** Comments with the Approved status */
  Approve = 'APPROVE',
  /** Comments with the Unapproved status */
  Hold = 'HOLD',
  /** Comments with the Spam status */
  Spam = 'SPAM',
  /** Comments with the Trash status */
  Trash = 'TRASH'
}

/** Connection between the Comment type and the Comment type */
export type CommentToCommentConnection = CommentConnection & Connection & {
  __typename?: 'CommentToCommentConnection';
  /** Edges for the CommentToCommentConnection connection */
  edges: Array<CommentToCommentConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Comment>;
  /** Information about pagination in a connection. */
  pageInfo: CommentToCommentConnectionPageInfo;
};

/** An edge in a connection */
export type CommentToCommentConnectionEdge = CommentConnectionEdge & Edge & {
  __typename?: 'CommentToCommentConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Comment;
};

/** Page Info on the &quot;CommentToCommentConnection&quot; */
export type CommentToCommentConnectionPageInfo = CommentConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'CommentToCommentConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the CommentToCommentConnection connection */
export type CommentToCommentConnectionWhereArgs = {
  /** Comment author email address. */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** Array of author IDs to include comments for. */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to exclude comments for. */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Comment author URL. */
  authorUrl?: InputMaybe<Scalars['String']>;
  /** Array of comment IDs to include. */
  commentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  commentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Include comments of a given type. */
  commentType?: InputMaybe<Scalars['String']>;
  /** Include comments from a given array of comment types. */
  commentTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude comments from a given array of comment types. */
  commentTypeNotIn?: InputMaybe<Scalars['String']>;
  /** Content object author ID to limit results by. */
  contentAuthor?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to retrieve comments for. */
  contentAuthorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  contentAuthorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  contentId?: InputMaybe<Scalars['ID']>;
  /** Array of content object IDs to include affiliated comments for. */
  contentIdIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  contentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  contentName?: InputMaybe<Scalars['String']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  contentParent?: InputMaybe<Scalars['Int']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentStatus?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentType?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  includeUnapproved?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Karma score to retrieve matching comments for. */
  karma?: InputMaybe<Scalars['Int']>;
  /** The cardinality of the order of the connection */
  order?: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  orderby?: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Array of parent IDs of comments to retrieve children for. */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Search term(s) to retrieve matching comments for. */
  search?: InputMaybe<Scalars['String']>;
  /** Comment status to limit results by. */
  status?: InputMaybe<Scalars['String']>;
  /** Include comments for a specific user ID. */
  userId?: InputMaybe<Scalars['ID']>;
};

/** Connection between the Comment type and the Commenter type */
export type CommentToCommenterConnectionEdge = CommenterConnectionEdge & Edge & OneToOneConnection & {
  __typename?: 'CommentToCommenterConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The email address representing the author for this particular comment */
  email?: Maybe<Scalars['String']>;
  /** IP address of the author at the time of making this comment. This field is equivalent to WP_Comment-&gt;comment_author_IP and the value matching the &quot;comment_author_IP&quot; column in SQL. */
  ipAddress?: Maybe<Scalars['String']>;
  /** The display name of the comment author for this particular comment */
  name?: Maybe<Scalars['String']>;
  /** The node of the connection, without the edges */
  node: Commenter;
  /** The url entered for the comment author on this particular comment */
  url?: Maybe<Scalars['String']>;
};

/** Connection between the Comment type and the ContentNode type */
export type CommentToContentNodeConnectionEdge = ContentNodeConnectionEdge & Edge & OneToOneConnection & {
  __typename?: 'CommentToContentNodeConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The node of the connection, without the edges */
  node: ContentNode;
};

/** Connection between the Comment type and the Comment type */
export type CommentToParentCommentConnectionEdge = CommentConnectionEdge & Edge & OneToOneConnection & {
  __typename?: 'CommentToParentCommentConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The node of the connection, without the edges */
  node: Comment;
};

/** Arguments for filtering the CommentToParentCommentConnection connection */
export type CommentToParentCommentConnectionWhereArgs = {
  /** Comment author email address. */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** Array of author IDs to include comments for. */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to exclude comments for. */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Comment author URL. */
  authorUrl?: InputMaybe<Scalars['String']>;
  /** Array of comment IDs to include. */
  commentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  commentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Include comments of a given type. */
  commentType?: InputMaybe<Scalars['String']>;
  /** Include comments from a given array of comment types. */
  commentTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude comments from a given array of comment types. */
  commentTypeNotIn?: InputMaybe<Scalars['String']>;
  /** Content object author ID to limit results by. */
  contentAuthor?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to retrieve comments for. */
  contentAuthorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  contentAuthorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  contentId?: InputMaybe<Scalars['ID']>;
  /** Array of content object IDs to include affiliated comments for. */
  contentIdIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  contentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  contentName?: InputMaybe<Scalars['String']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  contentParent?: InputMaybe<Scalars['Int']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentStatus?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentType?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  includeUnapproved?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Karma score to retrieve matching comments for. */
  karma?: InputMaybe<Scalars['Int']>;
  /** The cardinality of the order of the connection */
  order?: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  orderby?: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Array of parent IDs of comments to retrieve children for. */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Search term(s) to retrieve matching comments for. */
  search?: InputMaybe<Scalars['String']>;
  /** Comment status to limit results by. */
  status?: InputMaybe<Scalars['String']>;
  /** Include comments for a specific user ID. */
  userId?: InputMaybe<Scalars['ID']>;
};

/** The author of a comment */
export type Commenter = {
  /** Avatar object for user. The avatar object can be retrieved in different sizes by specifying the size argument. */
  avatar?: Maybe<Avatar>;
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int'];
  /** The email address of the author of a comment. */
  email?: Maybe<Scalars['String']>;
  /** The globally unique identifier for the comment author. */
  id: Scalars['ID'];
  /** Whether the author information is considered restricted. (not fully public) */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** The name of the author of a comment. */
  name?: Maybe<Scalars['String']>;
  /** The url of the author of a comment. */
  url?: Maybe<Scalars['String']>;
};

/** Edge between a Node and a connected Commenter */
export type CommenterConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The connected Commenter Node */
  node: Commenter;
};

/** Options for ordering the connection */
export enum CommentsConnectionOrderbyEnum {
  /** Order by browser user agent of the commenter. */
  CommentAgent = 'COMMENT_AGENT',
  /** Order by approval status of the comment. */
  CommentApproved = 'COMMENT_APPROVED',
  /** Order by name of the comment author. */
  CommentAuthor = 'COMMENT_AUTHOR',
  /** Order by e-mail of the comment author. */
  CommentAuthorEmail = 'COMMENT_AUTHOR_EMAIL',
  /** Order by IP address of the comment author. */
  CommentAuthorIp = 'COMMENT_AUTHOR_IP',
  /** Order by URL address of the comment author. */
  CommentAuthorUrl = 'COMMENT_AUTHOR_URL',
  /** Order by the comment contents. */
  CommentContent = 'COMMENT_CONTENT',
  /** Order by date/time timestamp of the comment. */
  CommentDate = 'COMMENT_DATE',
  /** Order by GMT timezone date/time timestamp of the comment. */
  CommentDateGmt = 'COMMENT_DATE_GMT',
  /** Order by the globally unique identifier for the comment object */
  CommentId = 'COMMENT_ID',
  /** Order by the array list of comment IDs listed in the where clause. */
  CommentIn = 'COMMENT_IN',
  /** Order by the comment karma score. */
  CommentKarma = 'COMMENT_KARMA',
  /** Order by the comment parent ID. */
  CommentParent = 'COMMENT_PARENT',
  /** Order by the post object ID. */
  CommentPostId = 'COMMENT_POST_ID',
  /** Order by the the type of comment, such as 'comment', 'pingback', or 'trackback'. */
  CommentType = 'COMMENT_TYPE',
  /** Order by the user ID. */
  UserId = 'USER_ID'
}

/** A plural connection from one Node Type in the Graph to another Node Type, with support for relational data via &quot;edges&quot;. */
export type Connection = {
  /** A list of edges (relational context) between connected nodes */
  edges: Array<Edge>;
  /** A list of connected nodes */
  nodes: Array<Node>;
  /** Information about pagination in a connection. */
  pageInfo: PageInfo;
};

/** Nodes used to manage content */
export type ContentNode = {
  /** Connection between the ContentNode type and the ContentType type */
  contentType?: Maybe<ContentNodeToContentTypeConnectionEdge>;
  /** The name of the Content Type the node belongs to */
  contentTypeName: Scalars['String'];
  /** The ID of the node in the database. */
  databaseId: Scalars['Int'];
  /** Post publishing date. */
  date?: Maybe<Scalars['String']>;
  /** The publishing date set in GMT. */
  dateGmt?: Maybe<Scalars['String']>;
  /** The desired slug of the post */
  desiredSlug?: Maybe<Scalars['String']>;
  /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
  editingLockedBy?: Maybe<ContentNodeToEditLockConnectionEdge>;
  /** The RSS enclosure for the object */
  enclosure?: Maybe<Scalars['String']>;
  /** Connection between the ContentNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<ContentNodeToEnqueuedScriptConnection>;
  /** Connection between the ContentNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
  /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
  guid?: Maybe<Scalars['String']>;
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean'];
  /** Whether the object is a node in the preview state */
  isPreview?: Maybe<Scalars['Boolean']>;
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The user that most recently edited the node */
  lastEditedBy?: Maybe<ContentNodeToEditLastConnectionEdge>;
  /** The permalink of the post */
  link?: Maybe<Scalars['String']>;
  /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
  modified?: Maybe<Scalars['String']>;
  /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
  modifiedGmt?: Maybe<Scalars['String']>;
  /** The database id of the preview node */
  previewRevisionDatabaseId?: Maybe<Scalars['Int']>;
  /** Whether the object is a node in the preview state */
  previewRevisionId?: Maybe<Scalars['ID']>;
  /** The RankMath SEO data for the node. */
  seo?: Maybe<RankMathSeo>;
  /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
  slug?: Maybe<Scalars['String']>;
  /** The current status of the object */
  status?: Maybe<Scalars['String']>;
  /** The template assigned to a node of content */
  template?: Maybe<ContentTemplate>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};


/** Nodes used to manage content */
export type ContentNodeEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Nodes used to manage content */
export type ContentNodeEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Connection to ContentNode Nodes */
export type ContentNodeConnection = {
  /** A list of edges (relational context) between ContentType and connected ContentNode Nodes */
  edges: Array<ContentNodeConnectionEdge>;
  /** A list of connected ContentNode Nodes */
  nodes: Array<ContentNode>;
  /** Information about pagination in a connection. */
  pageInfo: ContentNodeConnectionPageInfo;
};

/** Edge between a Node and a connected ContentNode */
export type ContentNodeConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The connected ContentNode Node */
  node: ContentNode;
};

/** Page Info on the connected ContentNodeConnectionEdge */
export type ContentNodeConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum ContentNodeIdTypeEnum {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the URI. */
  Uri = 'URI'
}

/** Connection between the ContentNode type and the ContentType type */
export type ContentNodeToContentTypeConnectionEdge = ContentTypeConnectionEdge & Edge & OneToOneConnection & {
  __typename?: 'ContentNodeToContentTypeConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The node of the connection, without the edges */
  node: ContentType;
};

/** Connection between the ContentNode type and the User type */
export type ContentNodeToEditLastConnectionEdge = Edge & OneToOneConnection & UserConnectionEdge & {
  __typename?: 'ContentNodeToEditLastConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The node of the connection, without the edges */
  node: User;
};

/** Connection between the ContentNode type and the User type */
export type ContentNodeToEditLockConnectionEdge = Edge & OneToOneConnection & UserConnectionEdge & {
  __typename?: 'ContentNodeToEditLockConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The timestamp for when the node was last edited */
  lockTimestamp?: Maybe<Scalars['String']>;
  /** The node of the connection, without the edges */
  node: User;
};

/** Connection between the ContentNode type and the EnqueuedScript type */
export type ContentNodeToEnqueuedScriptConnection = Connection & EnqueuedScriptConnection & {
  __typename?: 'ContentNodeToEnqueuedScriptConnection';
  /** Edges for the ContentNodeToEnqueuedScriptConnection connection */
  edges: Array<ContentNodeToEnqueuedScriptConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<EnqueuedScript>;
  /** Information about pagination in a connection. */
  pageInfo: ContentNodeToEnqueuedScriptConnectionPageInfo;
};

/** An edge in a connection */
export type ContentNodeToEnqueuedScriptConnectionEdge = Edge & EnqueuedScriptConnectionEdge & {
  __typename?: 'ContentNodeToEnqueuedScriptConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: EnqueuedScript;
};

/** Page Info on the &quot;ContentNodeToEnqueuedScriptConnection&quot; */
export type ContentNodeToEnqueuedScriptConnectionPageInfo = EnqueuedScriptConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'ContentNodeToEnqueuedScriptConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Connection between the ContentNode type and the EnqueuedStylesheet type */
export type ContentNodeToEnqueuedStylesheetConnection = Connection & EnqueuedStylesheetConnection & {
  __typename?: 'ContentNodeToEnqueuedStylesheetConnection';
  /** Edges for the ContentNodeToEnqueuedStylesheetConnection connection */
  edges: Array<ContentNodeToEnqueuedStylesheetConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<EnqueuedStylesheet>;
  /** Information about pagination in a connection. */
  pageInfo: ContentNodeToEnqueuedStylesheetConnectionPageInfo;
};

/** An edge in a connection */
export type ContentNodeToEnqueuedStylesheetConnectionEdge = Edge & EnqueuedStylesheetConnectionEdge & {
  __typename?: 'ContentNodeToEnqueuedStylesheetConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: EnqueuedStylesheet;
};

/** Page Info on the &quot;ContentNodeToEnqueuedStylesheetConnection&quot; */
export type ContentNodeToEnqueuedStylesheetConnectionPageInfo = EnqueuedStylesheetConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'ContentNodeToEnqueuedStylesheetConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** The template assigned to a node of content */
export type ContentTemplate = {
  /** The name of the template */
  templateName?: Maybe<Scalars['String']>;
};

/** An Post Type object */
export type ContentType = Node & NodeWithRankMathSeo & UniformResourceIdentifiable & {
  __typename?: 'ContentType';
  /** Whether this content type should can be exported. */
  canExport?: Maybe<Scalars['Boolean']>;
  /** Connection between the ContentType type and the Taxonomy type */
  connectedTaxonomies?: Maybe<ContentTypeToTaxonomyConnection>;
  /** Connection between the ContentType type and the ContentNode type */
  contentNodes?: Maybe<ContentTypeToContentNodeConnection>;
  /** Whether content of this type should be deleted when the author of it is deleted from the system. */
  deleteWithUser?: Maybe<Scalars['Boolean']>;
  /** Description of the content type. */
  description?: Maybe<Scalars['String']>;
  /** Whether to exclude nodes of this content type from front end search results. */
  excludeFromSearch?: Maybe<Scalars['Boolean']>;
  /** The plural name of the content type within the GraphQL Schema. */
  graphqlPluralName?: Maybe<Scalars['String']>;
  /** The singular name of the content type within the GraphQL Schema. */
  graphqlSingleName?: Maybe<Scalars['String']>;
  /** Whether this content type should have archives. Content archives are generated by type and by date. */
  hasArchive?: Maybe<Scalars['Boolean']>;
  /** Whether the content type is hierarchical, for example pages. */
  hierarchical?: Maybe<Scalars['Boolean']>;
  /** The globally unique identifier of the post-type object. */
  id: Scalars['ID'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether this page is set to the static front page. */
  isFrontPage: Scalars['Boolean'];
  /** Whether this page is set to the blog posts page. */
  isPostsPage: Scalars['Boolean'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** Display name of the content type. */
  label?: Maybe<Scalars['String']>;
  /** Details about the content type labels. */
  labels?: Maybe<PostTypeLabelDetails>;
  /** The name of the icon file to display as a menu icon. */
  menuIcon?: Maybe<Scalars['String']>;
  /** The position of this post type in the menu. Only applies if show_in_menu is true. */
  menuPosition?: Maybe<Scalars['Int']>;
  /** The internal name of the post type. This should not be used for display purposes. */
  name?: Maybe<Scalars['String']>;
  /** Whether a content type is intended for use publicly either via the admin interface or by front-end users. While the default settings of exclude_from_search, publicly_queryable, show_ui, and show_in_nav_menus are inherited from public, each does not rely on this relationship and controls a very specific intention. */
  public?: Maybe<Scalars['Boolean']>;
  /** Whether queries can be performed on the front end for the content type as part of parse_request(). */
  publiclyQueryable?: Maybe<Scalars['Boolean']>;
  /** Name of content type to display in REST API &quot;wp/v2&quot; namespace. */
  restBase?: Maybe<Scalars['String']>;
  /** The REST Controller class assigned to handling this content type. */
  restControllerClass?: Maybe<Scalars['String']>;
  /** The RankMath SEO data for the node. */
  seo?: Maybe<RankMathSeo>;
  /** Makes this content type available via the admin bar. */
  showInAdminBar?: Maybe<Scalars['Boolean']>;
  /** Whether to add the content type to the GraphQL Schema. */
  showInGraphql?: Maybe<Scalars['Boolean']>;
  /** Where to show the content type in the admin menu. To work, $show_ui must be true. If true, the post type is shown in its own top level menu. If false, no menu is shown. If a string of an existing top level menu (eg. &quot;tools.php&quot; or &quot;edit.php?post_type=page&quot;), the post type will be placed as a sub-menu of that. */
  showInMenu?: Maybe<Scalars['Boolean']>;
  /** Makes this content type available for selection in navigation menus. */
  showInNavMenus?: Maybe<Scalars['Boolean']>;
  /** Whether the content type is associated with a route under the the REST API &quot;wp/v2&quot; namespace. */
  showInRest?: Maybe<Scalars['Boolean']>;
  /** Whether to generate and allow a UI for managing this content type in the admin. */
  showUi?: Maybe<Scalars['Boolean']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};


/** An Post Type object */
export type ContentTypeConnectedTaxonomiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** An Post Type object */
export type ContentTypeContentNodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContentTypeToContentNodeConnectionWhereArgs>;
};

/** Connection to ContentType Nodes */
export type ContentTypeConnection = {
  /** A list of edges (relational context) between RootQuery and connected ContentType Nodes */
  edges: Array<ContentTypeConnectionEdge>;
  /** A list of connected ContentType Nodes */
  nodes: Array<ContentType>;
  /** Information about pagination in a connection. */
  pageInfo: ContentTypeConnectionPageInfo;
};

/** Edge between a Node and a connected ContentType */
export type ContentTypeConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The connected ContentType Node */
  node: ContentType;
};

/** Page Info on the connected ContentTypeConnectionEdge */
export type ContentTypeConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Allowed Content Types */
export enum ContentTypeEnum {
  /** The Type of Content object */
  Attachment = 'ATTACHMENT',
  /** The Type of Content object */
  Page = 'PAGE',
  /** The Type of Content object */
  Post = 'POST'
}

/** The Type of Identifier used to fetch a single Content Type node. To be used along with the "id" field. Default is "ID". */
export enum ContentTypeIdTypeEnum {
  /** The globally unique ID */
  Id = 'ID',
  /** The name of the content type. */
  Name = 'NAME'
}

/** Connection between the ContentType type and the ContentNode type */
export type ContentTypeToContentNodeConnection = Connection & ContentNodeConnection & {
  __typename?: 'ContentTypeToContentNodeConnection';
  /** Edges for the ContentTypeToContentNodeConnection connection */
  edges: Array<ContentTypeToContentNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<ContentNode>;
  /** Information about pagination in a connection. */
  pageInfo: ContentTypeToContentNodeConnectionPageInfo;
};

/** An edge in a connection */
export type ContentTypeToContentNodeConnectionEdge = ContentNodeConnectionEdge & Edge & {
  __typename?: 'ContentTypeToContentNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: ContentNode;
};

/** Page Info on the &quot;ContentTypeToContentNodeConnection&quot; */
export type ContentTypeToContentNodeConnectionPageInfo = ContentNodeConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'ContentTypeToContentNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the ContentTypeToContentNodeConnection connection */
export type ContentTypeToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the ContentType type and the Taxonomy type */
export type ContentTypeToTaxonomyConnection = Connection & TaxonomyConnection & {
  __typename?: 'ContentTypeToTaxonomyConnection';
  /** Edges for the ContentTypeToTaxonomyConnection connection */
  edges: Array<ContentTypeToTaxonomyConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Taxonomy>;
  /** Information about pagination in a connection. */
  pageInfo: ContentTypeToTaxonomyConnectionPageInfo;
};

/** An edge in a connection */
export type ContentTypeToTaxonomyConnectionEdge = Edge & TaxonomyConnectionEdge & {
  __typename?: 'ContentTypeToTaxonomyConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Taxonomy;
};

/** Page Info on the &quot;ContentTypeToTaxonomyConnection&quot; */
export type ContentTypeToTaxonomyConnectionPageInfo = PageInfo & TaxonomyConnectionPageInfo & WpPageInfo & {
  __typename?: 'ContentTypeToTaxonomyConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Allowed Content Types of the Category taxonomy. */
export enum ContentTypesOfCategoryEnum {
  /** The Type of Content object */
  Post = 'POST'
}

/** Allowed Content Types of the General taxonomy. */
export enum ContentTypesOfGeneralEnum {
  /** The Type of Content object */
  Post = 'POST'
}

/** Allowed Content Types of the PostFormat taxonomy. */
export enum ContentTypesOfPostFormatEnum {
  /** The Type of Content object */
  Post = 'POST'
}

/** Allowed Content Types of the Series taxonomy. */
export enum ContentTypesOfSeriesEnum {
  /** The Type of Content object */
  Post = 'POST'
}

/** Allowed Content Types of the Solution taxonomy. */
export enum ContentTypesOfSolutionEnum {
  /** The Type of Content object */
  Post = 'POST'
}

/** Allowed Content Types of the Tag taxonomy. */
export enum ContentTypesOfTagEnum {
  /** The Type of Content object */
  Post = 'POST'
}

/** Allowed Content Types of the Technology taxonomy. */
export enum ContentTypesOfTechnologyEnum {
  /** The Type of Content object */
  Post = 'POST'
}

/** Input for the createCategory mutation. */
export type CreateCategoryInput = {
  /** The slug that the category will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The description of the category object */
  description?: InputMaybe<Scalars['String']>;
  /** The name of the category object to mutate */
  name: Scalars['String'];
  /** The ID of the category that should be set as the parent */
  parentId?: InputMaybe<Scalars['ID']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The payload for the createCategory mutation. */
export type CreateCategoryPayload = {
  __typename?: 'CreateCategoryPayload';
  /** The created category */
  category?: Maybe<Category>;
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Input for the createComment mutation. */
export type CreateCommentInput = {
  /** The approval status of the comment. */
  approved?: InputMaybe<Scalars['String']>;
  /** The name of the comment's author. */
  author?: InputMaybe<Scalars['String']>;
  /** The email of the comment's author. */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** The url of the comment's author. */
  authorUrl?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The database ID of the post object the comment belongs to. */
  commentOn?: InputMaybe<Scalars['Int']>;
  /** Content of the comment. */
  content?: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day ( e.g. 01/31/2017 ) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date?: InputMaybe<Scalars['String']>;
  /** Parent comment ID of current comment. */
  parent?: InputMaybe<Scalars['ID']>;
  /** The approval status of the comment */
  status?: InputMaybe<CommentStatusEnum>;
  /** Type of comment. */
  type?: InputMaybe<Scalars['String']>;
};

/** The payload for the createComment mutation. */
export type CreateCommentPayload = {
  __typename?: 'CreateCommentPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The comment that was created */
  comment?: Maybe<Comment>;
  /** Whether the mutation succeeded. If the comment is not approved, the server will not return the comment to a non authenticated user, but a success message can be returned if the create succeeded, and the client can optimistically add the comment to the client cache */
  success?: Maybe<Scalars['Boolean']>;
};

/** Input for the createGeneral mutation. */
export type CreateGeneralInput = {
  /** The slug that the general will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The description of the general object */
  description?: InputMaybe<Scalars['String']>;
  /** The name of the general object to mutate */
  name: Scalars['String'];
  /** The ID of the general that should be set as the parent */
  parentId?: InputMaybe<Scalars['ID']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The payload for the createGeneral mutation. */
export type CreateGeneralPayload = {
  __typename?: 'CreateGeneralPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The created general */
  general?: Maybe<General>;
};

/** Input for the createMediaItem mutation. */
export type CreateMediaItemInput = {
  /** Alternative text to display when mediaItem is not displayed */
  altText?: InputMaybe<Scalars['String']>;
  /** The userId to assign as the author of the mediaItem */
  authorId?: InputMaybe<Scalars['ID']>;
  /** The caption for the mediaItem */
  caption?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The comment status for the mediaItem */
  commentStatus?: InputMaybe<Scalars['String']>;
  /** The date of the mediaItem */
  date?: InputMaybe<Scalars['String']>;
  /** The date (in GMT zone) of the mediaItem */
  dateGmt?: InputMaybe<Scalars['String']>;
  /** Description of the mediaItem */
  description?: InputMaybe<Scalars['String']>;
  /** The file name of the mediaItem */
  filePath?: InputMaybe<Scalars['String']>;
  /** The file type of the mediaItem */
  fileType?: InputMaybe<MimeTypeEnum>;
  /** The ID of the parent object */
  parentId?: InputMaybe<Scalars['ID']>;
  /** The ping status for the mediaItem */
  pingStatus?: InputMaybe<Scalars['String']>;
  /** The slug of the mediaItem */
  slug?: InputMaybe<Scalars['String']>;
  /** The status of the mediaItem */
  status?: InputMaybe<MediaItemStatusEnum>;
  /** The title of the mediaItem */
  title?: InputMaybe<Scalars['String']>;
};

/** The payload for the createMediaItem mutation. */
export type CreateMediaItemPayload = {
  __typename?: 'CreateMediaItemPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The MediaItem object mutation type. */
  mediaItem?: Maybe<MediaItem>;
};

/** Input for the createPage mutation. */
export type CreatePageInput = {
  /** The userId to assign as the author of the object */
  authorId?: InputMaybe<Scalars['ID']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The comment status for the object */
  commentStatus?: InputMaybe<Scalars['String']>;
  /** The content of the object */
  content?: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date?: InputMaybe<Scalars['String']>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder?: InputMaybe<Scalars['Int']>;
  /** The ID of the parent object */
  parentId?: InputMaybe<Scalars['ID']>;
  /** The password used to protect the content of the object */
  password?: InputMaybe<Scalars['String']>;
  /** The slug of the object */
  slug?: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status?: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** The payload for the createPage mutation. */
export type CreatePagePayload = {
  __typename?: 'CreatePagePayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  page?: Maybe<Page>;
};

/** Input for the createPostFormat mutation. */
export type CreatePostFormatInput = {
  /** The slug that the post_format will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The description of the post_format object */
  description?: InputMaybe<Scalars['String']>;
  /** The name of the post_format object to mutate */
  name: Scalars['String'];
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The payload for the createPostFormat mutation. */
export type CreatePostFormatPayload = {
  __typename?: 'CreatePostFormatPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The created post_format */
  postFormat?: Maybe<PostFormat>;
};

/** Input for the createPost mutation. */
export type CreatePostInput = {
  /** The userId to assign as the author of the object */
  authorId?: InputMaybe<Scalars['ID']>;
  /** Set connections between the post and categories */
  categories?: InputMaybe<PostCategoriesInput>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The comment status for the object */
  commentStatus?: InputMaybe<Scalars['String']>;
  /** The content of the object */
  content?: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date?: InputMaybe<Scalars['String']>;
  /** The excerpt of the object */
  excerpt?: InputMaybe<Scalars['String']>;
  /** Set connections between the post and general */
  general?: InputMaybe<PostGeneralInput>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder?: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password?: InputMaybe<Scalars['String']>;
  /** The ping status for the object */
  pingStatus?: InputMaybe<Scalars['String']>;
  /** URLs that have been pinged. */
  pinged?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Set connections between the post and postFormats */
  postFormats?: InputMaybe<PostPostFormatsInput>;
  /** Set connections between the post and series */
  series?: InputMaybe<PostSeriesInput>;
  /** The slug of the object */
  slug?: InputMaybe<Scalars['String']>;
  /** Set connections between the post and solutions */
  solutions?: InputMaybe<PostSolutionsInput>;
  /** The status of the object */
  status?: InputMaybe<PostStatusEnum>;
  /** Set connections between the post and tags */
  tags?: InputMaybe<PostTagsInput>;
  /** Set connections between the post and technologies */
  technologies?: InputMaybe<PostTechnologiesInput>;
  /** The title of the object */
  title?: InputMaybe<Scalars['String']>;
  /** URLs queued to be pinged. */
  toPing?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** The payload for the createPost mutation. */
export type CreatePostPayload = {
  __typename?: 'CreatePostPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  post?: Maybe<Post>;
};

/** Input for the createSeries mutation. */
export type CreateSeriesInput = {
  /** The slug that the series will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The description of the series object */
  description?: InputMaybe<Scalars['String']>;
  /** The name of the series object to mutate */
  name: Scalars['String'];
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The payload for the createSeries mutation. */
export type CreateSeriesPayload = {
  __typename?: 'CreateSeriesPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The created series */
  series?: Maybe<Series>;
};

/** Input for the createSolution mutation. */
export type CreateSolutionInput = {
  /** The slug that the solutions will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The description of the solutions object */
  description?: InputMaybe<Scalars['String']>;
  /** The name of the solutions object to mutate */
  name: Scalars['String'];
  /** The ID of the solutions that should be set as the parent */
  parentId?: InputMaybe<Scalars['ID']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The payload for the createSolution mutation. */
export type CreateSolutionPayload = {
  __typename?: 'CreateSolutionPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The created solutions */
  solution?: Maybe<Solution>;
};

/** Input for the createTag mutation. */
export type CreateTagInput = {
  /** The slug that the post_tag will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The description of the post_tag object */
  description?: InputMaybe<Scalars['String']>;
  /** The name of the post_tag object to mutate */
  name: Scalars['String'];
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The payload for the createTag mutation. */
export type CreateTagPayload = {
  __typename?: 'CreateTagPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The created post_tag */
  tag?: Maybe<Tag>;
};

/** Input for the createTechnology mutation. */
export type CreateTechnologyInput = {
  /** The slug that the technologies will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The description of the technologies object */
  description?: InputMaybe<Scalars['String']>;
  /** The name of the technologies object to mutate */
  name: Scalars['String'];
  /** The ID of the technologies that should be set as the parent */
  parentId?: InputMaybe<Scalars['ID']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The payload for the createTechnology mutation. */
export type CreateTechnologyPayload = {
  __typename?: 'CreateTechnologyPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The created technologies */
  technology?: Maybe<Technology>;
};

/** Input for the createUser mutation. */
export type CreateUserInput = {
  /** User's AOL IM account. */
  aim?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** A string containing content about the user. */
  description?: InputMaybe<Scalars['String']>;
  /** A string that will be shown on the site. Defaults to user's username. It is likely that you will want to change this, for both appearance and security through obscurity (that is if you dont use and delete the default admin user). */
  displayName?: InputMaybe<Scalars['String']>;
  /** A string containing the user's email address. */
  email?: InputMaybe<Scalars['String']>;
  /** 	The user's first name. */
  firstName?: InputMaybe<Scalars['String']>;
  /** User's Jabber account. */
  jabber?: InputMaybe<Scalars['String']>;
  /** The user's last name. */
  lastName?: InputMaybe<Scalars['String']>;
  /** User's locale. */
  locale?: InputMaybe<Scalars['String']>;
  /** A string that contains a URL-friendly name for the user. The default is the user's username. */
  nicename?: InputMaybe<Scalars['String']>;
  /** The user's nickname, defaults to the user's username. */
  nickname?: InputMaybe<Scalars['String']>;
  /** A string that contains the plain text password for the user. */
  password?: InputMaybe<Scalars['String']>;
  /** The date the user registered. Format is Y-m-d H:i:s. */
  registered?: InputMaybe<Scalars['String']>;
  /** A string for whether to enable the rich editor or not. False if not empty. */
  richEditing?: InputMaybe<Scalars['String']>;
  /** An array of roles to be assigned to the user. */
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** A string that contains the user's username for logging in. */
  username: Scalars['String'];
  /** A string containing the user's URL for the user's web site. */
  websiteUrl?: InputMaybe<Scalars['String']>;
  /** User's Yahoo IM account. */
  yim?: InputMaybe<Scalars['String']>;
};

/** The payload for the createUser mutation. */
export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The User object mutation type. */
  user?: Maybe<User>;
};

/** Object that can be identified with a Database ID */
export type DatabaseIdentifier = {
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int'];
};

/** Date values */
export type DateInput = {
  /** Day of the month (from 1 to 31) */
  day?: InputMaybe<Scalars['Int']>;
  /** Month number (from 1 to 12) */
  month?: InputMaybe<Scalars['Int']>;
  /** 4 digit year (e.g. 2017) */
  year?: InputMaybe<Scalars['Int']>;
};

/** Filter the connection based on input */
export type DateQueryInput = {
  /** Nodes should be returned after this date */
  after?: InputMaybe<DateInput>;
  /** Nodes should be returned before this date */
  before?: InputMaybe<DateInput>;
  /** Column to query against */
  column?: InputMaybe<PostObjectsConnectionDateColumnEnum>;
  /** For after/before, whether exact value should be matched or not */
  compare?: InputMaybe<Scalars['String']>;
  /** Day of the month (from 1 to 31) */
  day?: InputMaybe<Scalars['Int']>;
  /** Hour (from 0 to 23) */
  hour?: InputMaybe<Scalars['Int']>;
  /** For after/before, whether exact value should be matched or not */
  inclusive?: InputMaybe<Scalars['Boolean']>;
  /** Minute (from 0 to 59) */
  minute?: InputMaybe<Scalars['Int']>;
  /** Month number (from 1 to 12) */
  month?: InputMaybe<Scalars['Int']>;
  /** OR or AND, how the sub-arrays should be compared */
  relation?: InputMaybe<RelationEnum>;
  /** Second (0 to 59) */
  second?: InputMaybe<Scalars['Int']>;
  /** Week of the year (from 0 to 53) */
  week?: InputMaybe<Scalars['Int']>;
  /** 4 digit year (e.g. 2017) */
  year?: InputMaybe<Scalars['Int']>;
};

/** The template assigned to the node */
export type DefaultTemplate = ContentTemplate & {
  __typename?: 'DefaultTemplate';
  /** The name of the template */
  templateName?: Maybe<Scalars['String']>;
};

/** Input for the deleteCategory mutation. */
export type DeleteCategoryInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the category to delete */
  id: Scalars['ID'];
};

/** The payload for the deleteCategory mutation. */
export type DeleteCategoryPayload = {
  __typename?: 'DeleteCategoryPayload';
  /** The deleted term object */
  category?: Maybe<Category>;
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId?: Maybe<Scalars['ID']>;
};

/** Input for the deleteComment mutation. */
export type DeleteCommentInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Whether the comment should be force deleted instead of being moved to the trash */
  forceDelete?: InputMaybe<Scalars['Boolean']>;
  /** The deleted comment ID */
  id: Scalars['ID'];
};

/** The payload for the deleteComment mutation. */
export type DeleteCommentPayload = {
  __typename?: 'DeleteCommentPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The deleted comment object */
  comment?: Maybe<Comment>;
  /** The deleted comment ID */
  deletedId?: Maybe<Scalars['ID']>;
};

/** Input for the deleteGeneral mutation. */
export type DeleteGeneralInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the general to delete */
  id: Scalars['ID'];
};

/** The payload for the deleteGeneral mutation. */
export type DeleteGeneralPayload = {
  __typename?: 'DeleteGeneralPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId?: Maybe<Scalars['ID']>;
  /** The deleted term object */
  general?: Maybe<General>;
};

/** Input for the deleteMediaItem mutation. */
export type DeleteMediaItemInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Whether the mediaItem should be force deleted instead of being moved to the trash */
  forceDelete?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the mediaItem to delete */
  id: Scalars['ID'];
};

/** The payload for the deleteMediaItem mutation. */
export type DeleteMediaItemPayload = {
  __typename?: 'DeleteMediaItemPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the deleted mediaItem */
  deletedId?: Maybe<Scalars['ID']>;
  /** The mediaItem before it was deleted */
  mediaItem?: Maybe<MediaItem>;
};

/** Input for the deletePage mutation. */
export type DeletePageInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Whether the object should be force deleted instead of being moved to the trash */
  forceDelete?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the page to delete */
  id: Scalars['ID'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock?: InputMaybe<Scalars['Boolean']>;
};

/** The payload for the deletePage mutation. */
export type DeletePagePayload = {
  __typename?: 'DeletePagePayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId?: Maybe<Scalars['ID']>;
  /** The object before it was deleted */
  page?: Maybe<Page>;
};

/** Input for the deletePostFormat mutation. */
export type DeletePostFormatInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the postFormat to delete */
  id: Scalars['ID'];
};

/** The payload for the deletePostFormat mutation. */
export type DeletePostFormatPayload = {
  __typename?: 'DeletePostFormatPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId?: Maybe<Scalars['ID']>;
  /** The deleted term object */
  postFormat?: Maybe<PostFormat>;
};

/** Input for the deletePost mutation. */
export type DeletePostInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Whether the object should be force deleted instead of being moved to the trash */
  forceDelete?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the post to delete */
  id: Scalars['ID'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock?: InputMaybe<Scalars['Boolean']>;
};

/** The payload for the deletePost mutation. */
export type DeletePostPayload = {
  __typename?: 'DeletePostPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId?: Maybe<Scalars['ID']>;
  /** The object before it was deleted */
  post?: Maybe<Post>;
};

/** Input for the deleteSeries mutation. */
export type DeleteSeriesInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the series to delete */
  id: Scalars['ID'];
};

/** The payload for the deleteSeries mutation. */
export type DeleteSeriesPayload = {
  __typename?: 'DeleteSeriesPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId?: Maybe<Scalars['ID']>;
  /** The deleted term object */
  series?: Maybe<Series>;
};

/** Input for the deleteSolution mutation. */
export type DeleteSolutionInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the solution to delete */
  id: Scalars['ID'];
};

/** The payload for the deleteSolution mutation. */
export type DeleteSolutionPayload = {
  __typename?: 'DeleteSolutionPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId?: Maybe<Scalars['ID']>;
  /** The deleted term object */
  solution?: Maybe<Solution>;
};

/** Input for the deleteTag mutation. */
export type DeleteTagInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the tag to delete */
  id: Scalars['ID'];
};

/** The payload for the deleteTag mutation. */
export type DeleteTagPayload = {
  __typename?: 'DeleteTagPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId?: Maybe<Scalars['ID']>;
  /** The deleted term object */
  tag?: Maybe<Tag>;
};

/** Input for the deleteTechnology mutation. */
export type DeleteTechnologyInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the technology to delete */
  id: Scalars['ID'];
};

/** The payload for the deleteTechnology mutation. */
export type DeleteTechnologyPayload = {
  __typename?: 'DeleteTechnologyPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId?: Maybe<Scalars['ID']>;
  /** The deleted term object */
  technology?: Maybe<Technology>;
};

/** Input for the deleteUser mutation. */
export type DeleteUserInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the user you want to delete */
  id: Scalars['ID'];
  /** Reassign posts and links to new User ID. */
  reassignId?: InputMaybe<Scalars['ID']>;
};

/** The payload for the deleteUser mutation. */
export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the user that you just deleted */
  deletedId?: Maybe<Scalars['ID']>;
  /** The deleted user object */
  user?: Maybe<User>;
};

/** The discussion setting type */
export type DiscussionSettings = {
  __typename?: 'DiscussionSettings';
  /** Allow people to submit comments on new posts. */
  defaultCommentStatus?: Maybe<Scalars['String']>;
  /** Allow link notifications from other blogs (pingbacks and trackbacks) on new articles. */
  defaultPingStatus?: Maybe<Scalars['String']>;
};

/** Relational context between connected nodes */
export type Edge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The connected node */
  node: Node;
};

/** Asset enqueued by the CMS */
export type EnqueuedAsset = {
  /** The inline code to be run after the asset is loaded. */
  after?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Deprecated
   * @deprecated Use `EnqueuedAsset.media` instead.
   */
  args?: Maybe<Scalars['Boolean']>;
  /** The inline code to be run before the asset is loaded. */
  before?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The HTML conditional comment for the enqueued asset. E.g. IE 6, lte IE 7, etc */
  conditional?: Maybe<Scalars['String']>;
  /** Dependencies needed to use this asset */
  dependencies?: Maybe<Array<Maybe<EnqueuedAsset>>>;
  /**
   * Extra information needed for the script
   * @deprecated Use `EnqueuedScript.extraData` instead.
   */
  extra?: Maybe<Scalars['String']>;
  /** The handle of the enqueued asset */
  handle?: Maybe<Scalars['String']>;
  /** The ID of the enqueued asset */
  id: Scalars['ID'];
  /** The source of the asset */
  src?: Maybe<Scalars['String']>;
  /** The version of the enqueued asset */
  version?: Maybe<Scalars['String']>;
};

/** Script enqueued by the CMS */
export type EnqueuedScript = EnqueuedAsset & Node & {
  __typename?: 'EnqueuedScript';
  /** The inline code to be run after the asset is loaded. */
  after?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Deprecated
   * @deprecated Use `EnqueuedAsset.media` instead.
   */
  args?: Maybe<Scalars['Boolean']>;
  /** The inline code to be run before the asset is loaded. */
  before?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The HTML conditional comment for the enqueued asset. E.g. IE 6, lte IE 7, etc */
  conditional?: Maybe<Scalars['String']>;
  /** Dependencies needed to use this asset */
  dependencies?: Maybe<Array<Maybe<EnqueuedScript>>>;
  /**
   * Extra information needed for the script
   * @deprecated Use `EnqueuedScript.extraData` instead.
   */
  extra?: Maybe<Scalars['String']>;
  /** Extra data supplied to the enqueued script */
  extraData?: Maybe<Scalars['String']>;
  /** The handle of the enqueued asset */
  handle?: Maybe<Scalars['String']>;
  /** The global ID of the enqueued script */
  id: Scalars['ID'];
  /** The source of the asset */
  src?: Maybe<Scalars['String']>;
  /** The loading strategy to use on the script tag */
  strategy?: Maybe<ScriptLoadingStrategyEnum>;
  /** The version of the enqueued script */
  version?: Maybe<Scalars['String']>;
};

/** Connection to EnqueuedScript Nodes */
export type EnqueuedScriptConnection = {
  /** A list of edges (relational context) between ContentNode and connected EnqueuedScript Nodes */
  edges: Array<EnqueuedScriptConnectionEdge>;
  /** A list of connected EnqueuedScript Nodes */
  nodes: Array<EnqueuedScript>;
  /** Information about pagination in a connection. */
  pageInfo: EnqueuedScriptConnectionPageInfo;
};

/** Edge between a Node and a connected EnqueuedScript */
export type EnqueuedScriptConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The connected EnqueuedScript Node */
  node: EnqueuedScript;
};

/** Page Info on the connected EnqueuedScriptConnectionEdge */
export type EnqueuedScriptConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Stylesheet enqueued by the CMS */
export type EnqueuedStylesheet = EnqueuedAsset & Node & {
  __typename?: 'EnqueuedStylesheet';
  /** The inline code to be run after the asset is loaded. */
  after?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Deprecated
   * @deprecated Use `EnqueuedAsset.media` instead.
   */
  args?: Maybe<Scalars['Boolean']>;
  /** The inline code to be run before the asset is loaded. */
  before?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The HTML conditional comment for the enqueued asset. E.g. IE 6, lte IE 7, etc */
  conditional?: Maybe<Scalars['String']>;
  /** Dependencies needed to use this asset */
  dependencies?: Maybe<Array<Maybe<EnqueuedStylesheet>>>;
  /**
   * Extra information needed for the script
   * @deprecated Use `EnqueuedScript.extraData` instead.
   */
  extra?: Maybe<Scalars['String']>;
  /** The handle of the enqueued asset */
  handle?: Maybe<Scalars['String']>;
  /** The global ID of the enqueued stylesheet */
  id: Scalars['ID'];
  /** Whether the enqueued style is RTL or not */
  isRtl?: Maybe<Scalars['Boolean']>;
  /** The media attribute to use for the link */
  media?: Maybe<Scalars['String']>;
  /** The absolute path to the enqueued style. Set when the stylesheet is meant to load inline. */
  path?: Maybe<Scalars['String']>;
  /** The `rel` attribute to use for the link */
  rel?: Maybe<Scalars['String']>;
  /** The source of the asset */
  src?: Maybe<Scalars['String']>;
  /** Optional suffix, used in combination with RTL */
  suffix?: Maybe<Scalars['String']>;
  /** The title of the enqueued style. Used for preferred/alternate stylesheets. */
  title?: Maybe<Scalars['String']>;
  /** The version of the enqueued style */
  version?: Maybe<Scalars['String']>;
};

/** Connection to EnqueuedStylesheet Nodes */
export type EnqueuedStylesheetConnection = {
  /** A list of edges (relational context) between ContentNode and connected EnqueuedStylesheet Nodes */
  edges: Array<EnqueuedStylesheetConnectionEdge>;
  /** A list of connected EnqueuedStylesheet Nodes */
  nodes: Array<EnqueuedStylesheet>;
  /** Information about pagination in a connection. */
  pageInfo: EnqueuedStylesheetConnectionPageInfo;
};

/** Edge between a Node and a connected EnqueuedStylesheet */
export type EnqueuedStylesheetConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The connected EnqueuedStylesheet Node */
  node: EnqueuedStylesheet;
};

/** Page Info on the connected EnqueuedStylesheetConnectionEdge */
export type EnqueuedStylesheetConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** The general type */
export type General = DatabaseIdentifier & HierarchicalNode & HierarchicalTermNode & MenuItemLinkable & Node & NodeWithRankMathSeo & TermNode & UniformResourceIdentifiable & {
  __typename?: 'General';
  /** The ancestors of the node. Default ordered as lowest (closest to the child) to highest (closest to the root). */
  ancestors?: Maybe<GeneralToAncestorsGeneralConnection>;
  /** Connection between the general type and its children general. */
  children?: Maybe<GeneralToGeneralConnection>;
  /** Connection between the General type and the ContentNode type */
  contentNodes?: Maybe<GeneralToContentNodeConnection>;
  /** The number of objects connected to the object */
  count?: Maybe<Scalars['Int']>;
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int'];
  /** The description of the object */
  description?: Maybe<Scalars['String']>;
  /** Connection between the TermNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<TermNodeToEnqueuedScriptConnection>;
  /** Connection between the TermNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<TermNodeToEnqueuedStylesheetConnection>;
  /**
   * The id field matches the WP_Post-&gt;ID field.
   * @deprecated Deprecated in favor of databaseId
   */
  generalId?: Maybe<Scalars['Int']>;
  /** Added to the GraphQL Schema because the ACF Field Group &quot;General fields&quot; was set to Show in GraphQL. */
  generalTags?: Maybe<GeneralGeneraltags>;
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The link to the term */
  link?: Maybe<Scalars['String']>;
  /** The human friendly name of the object. */
  name?: Maybe<Scalars['String']>;
  /** Connection between the general type and its parent general. */
  parent?: Maybe<GeneralToParentGeneralConnectionEdge>;
  /** Database id of the parent node */
  parentDatabaseId?: Maybe<Scalars['Int']>;
  /** The globally unique identifier of the parent node. */
  parentId?: Maybe<Scalars['ID']>;
  /** Connection between the General type and the post type */
  posts?: Maybe<GeneralToPostConnection>;
  /** The RankMath SEO data for the node. */
  seo?: Maybe<RankMathSeo>;
  /** An alphanumeric identifier for the object unique to its type. */
  slug?: Maybe<Scalars['String']>;
  /** Connection between the General type and the Taxonomy type */
  taxonomy?: Maybe<GeneralToTaxonomyConnectionEdge>;
  /** The name of the taxonomy that the object is associated with */
  taxonomyName?: Maybe<Scalars['String']>;
  /** The ID of the term group that this term object belongs to */
  termGroupId?: Maybe<Scalars['Int']>;
  /** The taxonomy ID that the object is associated with */
  termTaxonomyId?: Maybe<Scalars['Int']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};


/** The general type */
export type GeneralAncestorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The general type */
export type GeneralChildrenArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GeneralToGeneralConnectionWhereArgs>;
};


/** The general type */
export type GeneralContentNodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GeneralToContentNodeConnectionWhereArgs>;
};


/** The general type */
export type GeneralEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The general type */
export type GeneralEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The general type */
export type GeneralPostsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GeneralToPostConnectionWhereArgs>;
};

/** Connection to general Nodes */
export type GeneralConnection = {
  /** A list of edges (relational context) between RootQuery and connected general Nodes */
  edges: Array<GeneralConnectionEdge>;
  /** A list of connected general Nodes */
  nodes: Array<General>;
  /** Information about pagination in a connection. */
  pageInfo: GeneralConnectionPageInfo;
};

/** Edge between a Node and a connected general */
export type GeneralConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The connected general Node */
  node: General;
};

/** Page Info on the connected GeneralConnectionEdge */
export type GeneralConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum GeneralIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI'
}

/** The RankMath SEO meta settings for General. */
export type GeneralMetaSettings = RankMathMetaSettingWithArchive & RankMathMetaSettingWithRobots & {
  __typename?: 'GeneralMetaSettings';
  /** Advanced robots meta tag settings. */
  advancedRobotsMeta?: Maybe<RankMathAdvancedRobotsMeta>;
  /** Description for archive pages. */
  archiveDescription?: Maybe<Scalars['String']>;
  /** Default title tag for archive page. */
  archiveTitle?: Maybe<Scalars['String']>;
  /** Whether custom robots meta for author page are set. Otherwise the default meta will be used, as set in the Global Meta tab. */
  hasCustomRobotsMeta?: Maybe<Scalars['Boolean']>;
  /** Whether the SEO Controls meta box for user profile pages is enabled. */
  hasSeoControls?: Maybe<Scalars['Boolean']>;
  /** Whether to show additional information (name &amp; total number of posts) when an author archive is shared on Slack. */
  hasSlackEnhancedSharing?: Maybe<Scalars['Boolean']>;
  /** Whether to include snippet data for this taxonomy. */
  hasSnippetData?: Maybe<Scalars['Boolean']>;
  /** Custom values for robots meta tag. */
  robotsMeta?: Maybe<Array<Maybe<RankMathRobotsMetaValueEnum>>>;
};

/** The general setting type */
export type GeneralSettings = {
  __typename?: 'GeneralSettings';
  /** A date format for all date strings. */
  dateFormat?: Maybe<Scalars['String']>;
  /** Site tagline. */
  description?: Maybe<Scalars['String']>;
  /** This address is used for admin purposes, like new user notification. */
  email?: Maybe<Scalars['String']>;
  /** WordPress locale code. */
  language?: Maybe<Scalars['String']>;
  /** A day number of the week that the week should start on. */
  startOfWeek?: Maybe<Scalars['Int']>;
  /** A time format for all time strings. */
  timeFormat?: Maybe<Scalars['String']>;
  /** A city in the same timezone as you. */
  timezone?: Maybe<Scalars['String']>;
  /** Site title. */
  title?: Maybe<Scalars['String']>;
  /** Site URL. */
  url?: Maybe<Scalars['String']>;
};

/** Connection between the General type and the general type */
export type GeneralToAncestorsGeneralConnection = Connection & GeneralConnection & {
  __typename?: 'GeneralToAncestorsGeneralConnection';
  /** Edges for the GeneralToAncestorsGeneralConnection connection */
  edges: Array<GeneralToAncestorsGeneralConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<General>;
  /** Information about pagination in a connection. */
  pageInfo: GeneralToAncestorsGeneralConnectionPageInfo;
};

/** An edge in a connection */
export type GeneralToAncestorsGeneralConnectionEdge = Edge & GeneralConnectionEdge & {
  __typename?: 'GeneralToAncestorsGeneralConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: General;
};

/** Page Info on the &quot;GeneralToAncestorsGeneralConnection&quot; */
export type GeneralToAncestorsGeneralConnectionPageInfo = GeneralConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'GeneralToAncestorsGeneralConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Connection between the General type and the ContentNode type */
export type GeneralToContentNodeConnection = Connection & ContentNodeConnection & {
  __typename?: 'GeneralToContentNodeConnection';
  /** Edges for the GeneralToContentNodeConnection connection */
  edges: Array<GeneralToContentNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<ContentNode>;
  /** Information about pagination in a connection. */
  pageInfo: GeneralToContentNodeConnectionPageInfo;
};

/** An edge in a connection */
export type GeneralToContentNodeConnectionEdge = ContentNodeConnectionEdge & Edge & {
  __typename?: 'GeneralToContentNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: ContentNode;
};

/** Page Info on the &quot;GeneralToContentNodeConnection&quot; */
export type GeneralToContentNodeConnectionPageInfo = ContentNodeConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'GeneralToContentNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the GeneralToContentNodeConnection connection */
export type GeneralToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypesOfGeneralEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the General type and the general type */
export type GeneralToGeneralConnection = Connection & GeneralConnection & {
  __typename?: 'GeneralToGeneralConnection';
  /** Edges for the GeneralToGeneralConnection connection */
  edges: Array<GeneralToGeneralConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<General>;
  /** Information about pagination in a connection. */
  pageInfo: GeneralToGeneralConnectionPageInfo;
};

/** An edge in a connection */
export type GeneralToGeneralConnectionEdge = Edge & GeneralConnectionEdge & {
  __typename?: 'GeneralToGeneralConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: General;
};

/** Page Info on the &quot;GeneralToGeneralConnection&quot; */
export type GeneralToGeneralConnectionPageInfo = GeneralConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'GeneralToGeneralConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the GeneralToGeneralConnection connection */
export type GeneralToGeneralConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the General type and the general type */
export type GeneralToParentGeneralConnectionEdge = Edge & GeneralConnectionEdge & OneToOneConnection & {
  __typename?: 'GeneralToParentGeneralConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The node of the connection, without the edges */
  node: General;
};

/** Connection between the General type and the post type */
export type GeneralToPostConnection = Connection & PostConnection & {
  __typename?: 'GeneralToPostConnection';
  /** Edges for the GeneralToPostConnection connection */
  edges: Array<GeneralToPostConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Post>;
  /** Information about pagination in a connection. */
  pageInfo: GeneralToPostConnectionPageInfo;
};

/** An edge in a connection */
export type GeneralToPostConnectionEdge = Edge & PostConnectionEdge & {
  __typename?: 'GeneralToPostConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Post;
};

/** Page Info on the &quot;GeneralToPostConnection&quot; */
export type GeneralToPostConnectionPageInfo = PageInfo & PostConnectionPageInfo & WpPageInfo & {
  __typename?: 'GeneralToPostConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the GeneralToPostConnection connection */
export type GeneralToPostConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Category ID */
  categoryId?: InputMaybe<Scalars['Int']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Use Category Slug */
  categoryName?: InputMaybe<Scalars['String']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  tag?: InputMaybe<Scalars['String']>;
  /** Use Tag ID */
  tagId?: InputMaybe<Scalars['String']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  tagSlugAnd?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  tagSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the General type and the Taxonomy type */
export type GeneralToTaxonomyConnectionEdge = Edge & OneToOneConnection & TaxonomyConnectionEdge & {
  __typename?: 'GeneralToTaxonomyConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The node of the connection, without the edges */
  node: Taxonomy;
};

/** Field Group */
export type GeneralGeneraltags = AcfFieldGroup & {
  __typename?: 'General_Generaltags';
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** Content node with hierarchical (parent/child) relationships */
export type HierarchicalContentNode = {
  /** Returns ancestors of the node. Default ordered as lowest (closest to the child) to highest (closest to the root). */
  ancestors?: Maybe<HierarchicalContentNodeToContentNodeAncestorsConnection>;
  /** Connection between the HierarchicalContentNode type and the ContentNode type */
  children?: Maybe<HierarchicalContentNodeToContentNodeChildrenConnection>;
  /** Connection between the ContentNode type and the ContentType type */
  contentType?: Maybe<ContentNodeToContentTypeConnectionEdge>;
  /** The name of the Content Type the node belongs to */
  contentTypeName: Scalars['String'];
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int'];
  /** Post publishing date. */
  date?: Maybe<Scalars['String']>;
  /** The publishing date set in GMT. */
  dateGmt?: Maybe<Scalars['String']>;
  /** The desired slug of the post */
  desiredSlug?: Maybe<Scalars['String']>;
  /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
  editingLockedBy?: Maybe<ContentNodeToEditLockConnectionEdge>;
  /** The RSS enclosure for the object */
  enclosure?: Maybe<Scalars['String']>;
  /** Connection between the ContentNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<ContentNodeToEnqueuedScriptConnection>;
  /** Connection between the ContentNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
  /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
  guid?: Maybe<Scalars['String']>;
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean'];
  /** Whether the object is a node in the preview state */
  isPreview?: Maybe<Scalars['Boolean']>;
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The user that most recently edited the node */
  lastEditedBy?: Maybe<ContentNodeToEditLastConnectionEdge>;
  /** The permalink of the post */
  link?: Maybe<Scalars['String']>;
  /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
  modified?: Maybe<Scalars['String']>;
  /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
  modifiedGmt?: Maybe<Scalars['String']>;
  /** The parent of the node. The parent object can be of various types */
  parent?: Maybe<HierarchicalContentNodeToParentContentNodeConnectionEdge>;
  /** Database id of the parent node */
  parentDatabaseId?: Maybe<Scalars['Int']>;
  /** The globally unique identifier of the parent node. */
  parentId?: Maybe<Scalars['ID']>;
  /** The database id of the preview node */
  previewRevisionDatabaseId?: Maybe<Scalars['Int']>;
  /** Whether the object is a node in the preview state */
  previewRevisionId?: Maybe<Scalars['ID']>;
  /** The RankMath SEO data for the node. */
  seo?: Maybe<RankMathSeo>;
  /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
  slug?: Maybe<Scalars['String']>;
  /** The current status of the object */
  status?: Maybe<Scalars['String']>;
  /** The template assigned to a node of content */
  template?: Maybe<ContentTemplate>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};


/** Content node with hierarchical (parent/child) relationships */
export type HierarchicalContentNodeAncestorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HierarchicalContentNodeToContentNodeAncestorsConnectionWhereArgs>;
};


/** Content node with hierarchical (parent/child) relationships */
export type HierarchicalContentNodeChildrenArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HierarchicalContentNodeToContentNodeChildrenConnectionWhereArgs>;
};


/** Content node with hierarchical (parent/child) relationships */
export type HierarchicalContentNodeEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Content node with hierarchical (parent/child) relationships */
export type HierarchicalContentNodeEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Connection between the HierarchicalContentNode type and the ContentNode type */
export type HierarchicalContentNodeToContentNodeAncestorsConnection = Connection & ContentNodeConnection & {
  __typename?: 'HierarchicalContentNodeToContentNodeAncestorsConnection';
  /** Edges for the HierarchicalContentNodeToContentNodeAncestorsConnection connection */
  edges: Array<HierarchicalContentNodeToContentNodeAncestorsConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<ContentNode>;
  /** Information about pagination in a connection. */
  pageInfo: HierarchicalContentNodeToContentNodeAncestorsConnectionPageInfo;
};

/** An edge in a connection */
export type HierarchicalContentNodeToContentNodeAncestorsConnectionEdge = ContentNodeConnectionEdge & Edge & {
  __typename?: 'HierarchicalContentNodeToContentNodeAncestorsConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: ContentNode;
};

/** Page Info on the &quot;HierarchicalContentNodeToContentNodeAncestorsConnection&quot; */
export type HierarchicalContentNodeToContentNodeAncestorsConnectionPageInfo = ContentNodeConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'HierarchicalContentNodeToContentNodeAncestorsConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the HierarchicalContentNodeToContentNodeAncestorsConnection connection */
export type HierarchicalContentNodeToContentNodeAncestorsConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the HierarchicalContentNode type and the ContentNode type */
export type HierarchicalContentNodeToContentNodeChildrenConnection = Connection & ContentNodeConnection & {
  __typename?: 'HierarchicalContentNodeToContentNodeChildrenConnection';
  /** Edges for the HierarchicalContentNodeToContentNodeChildrenConnection connection */
  edges: Array<HierarchicalContentNodeToContentNodeChildrenConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<ContentNode>;
  /** Information about pagination in a connection. */
  pageInfo: HierarchicalContentNodeToContentNodeChildrenConnectionPageInfo;
};

/** An edge in a connection */
export type HierarchicalContentNodeToContentNodeChildrenConnectionEdge = ContentNodeConnectionEdge & Edge & {
  __typename?: 'HierarchicalContentNodeToContentNodeChildrenConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: ContentNode;
};

/** Page Info on the &quot;HierarchicalContentNodeToContentNodeChildrenConnection&quot; */
export type HierarchicalContentNodeToContentNodeChildrenConnectionPageInfo = ContentNodeConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'HierarchicalContentNodeToContentNodeChildrenConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the HierarchicalContentNodeToContentNodeChildrenConnection connection */
export type HierarchicalContentNodeToContentNodeChildrenConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the HierarchicalContentNode type and the ContentNode type */
export type HierarchicalContentNodeToParentContentNodeConnectionEdge = ContentNodeConnectionEdge & Edge & OneToOneConnection & {
  __typename?: 'HierarchicalContentNodeToParentContentNodeConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The node of the connection, without the edges */
  node: ContentNode;
};

/** Node with hierarchical (parent/child) relationships */
export type HierarchicalNode = {
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int'];
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** Database id of the parent node */
  parentDatabaseId?: Maybe<Scalars['Int']>;
  /** The globally unique identifier of the parent node. */
  parentId?: Maybe<Scalars['ID']>;
};

/** Term node with hierarchical (parent/child) relationships */
export type HierarchicalTermNode = {
  /** The number of objects connected to the object */
  count?: Maybe<Scalars['Int']>;
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int'];
  /** The description of the object */
  description?: Maybe<Scalars['String']>;
  /** Connection between the TermNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<TermNodeToEnqueuedScriptConnection>;
  /** Connection between the TermNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<TermNodeToEnqueuedStylesheetConnection>;
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The link to the term */
  link?: Maybe<Scalars['String']>;
  /** The human friendly name of the object. */
  name?: Maybe<Scalars['String']>;
  /** Database id of the parent node */
  parentDatabaseId?: Maybe<Scalars['Int']>;
  /** The globally unique identifier of the parent node. */
  parentId?: Maybe<Scalars['ID']>;
  /** The RankMath SEO data for the node. */
  seo?: Maybe<RankMathSeo>;
  /** An alphanumeric identifier for the object unique to its type. */
  slug?: Maybe<Scalars['String']>;
  /** The name of the taxonomy that the object is associated with */
  taxonomyName?: Maybe<Scalars['String']>;
  /** The ID of the term group that this term object belongs to */
  termGroupId?: Maybe<Scalars['Int']>;
  /** The taxonomy ID that the object is associated with */
  termTaxonomyId?: Maybe<Scalars['Int']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};


/** Term node with hierarchical (parent/child) relationships */
export type HierarchicalTermNodeEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Term node with hierarchical (parent/child) relationships */
export type HierarchicalTermNodeEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** File details for a Media Item */
export type MediaDetails = {
  __typename?: 'MediaDetails';
  /** The filename of the mediaItem */
  file?: Maybe<Scalars['String']>;
  /** The height of the mediaItem */
  height?: Maybe<Scalars['Int']>;
  /** Meta information associated with the mediaItem */
  meta?: Maybe<MediaItemMeta>;
  /** The available sizes of the mediaItem */
  sizes?: Maybe<Array<Maybe<MediaSize>>>;
  /** The width of the mediaItem */
  width?: Maybe<Scalars['Int']>;
};


/** File details for a Media Item */
export type MediaDetailsSizesArgs = {
  exclude?: InputMaybe<Array<InputMaybe<MediaItemSizeEnum>>>;
  include?: InputMaybe<Array<InputMaybe<MediaItemSizeEnum>>>;
};

/** The mediaItem type */
export type MediaItem = ContentNode & DatabaseIdentifier & HierarchicalContentNode & HierarchicalNode & Node & NodeWithAuthor & NodeWithComments & NodeWithRankMathSeo & NodeWithTemplate & NodeWithTitle & UniformResourceIdentifiable & {
  __typename?: 'MediaItem';
  /** Alternative text to display when resource is not displayed */
  altText?: Maybe<Scalars['String']>;
  /** Returns ancestors of the node. Default ordered as lowest (closest to the child) to highest (closest to the root). */
  ancestors?: Maybe<HierarchicalContentNodeToContentNodeAncestorsConnection>;
  /** Connection between the NodeWithAuthor type and the User type */
  author?: Maybe<NodeWithAuthorToUserConnectionEdge>;
  /** The database identifier of the author of the node */
  authorDatabaseId?: Maybe<Scalars['Int']>;
  /** The globally unique identifier of the author of the node */
  authorId?: Maybe<Scalars['ID']>;
  /** The caption for the resource */
  caption?: Maybe<Scalars['String']>;
  /** Connection between the HierarchicalContentNode type and the ContentNode type */
  children?: Maybe<HierarchicalContentNodeToContentNodeChildrenConnection>;
  /** The number of comments. Even though WPGraphQL denotes this field as an integer, in WordPress this field should be saved as a numeric string for compatibility. */
  commentCount?: Maybe<Scalars['Int']>;
  /** Whether the comments are open or closed for this particular post. */
  commentStatus?: Maybe<Scalars['String']>;
  /** Connection between the MediaItem type and the Comment type */
  comments?: Maybe<MediaItemToCommentConnection>;
  /** Connection between the ContentNode type and the ContentType type */
  contentType?: Maybe<ContentNodeToContentTypeConnectionEdge>;
  /** The name of the Content Type the node belongs to */
  contentTypeName: Scalars['String'];
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int'];
  /** Post publishing date. */
  date?: Maybe<Scalars['String']>;
  /** The publishing date set in GMT. */
  dateGmt?: Maybe<Scalars['String']>;
  /** Description of the image (stored as post_content) */
  description?: Maybe<Scalars['String']>;
  /** The desired slug of the post */
  desiredSlug?: Maybe<Scalars['String']>;
  /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
  editingLockedBy?: Maybe<ContentNodeToEditLockConnectionEdge>;
  /** The RSS enclosure for the object */
  enclosure?: Maybe<Scalars['String']>;
  /** Connection between the ContentNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<ContentNodeToEnqueuedScriptConnection>;
  /** Connection between the ContentNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
  /** The filesize in bytes of the resource */
  fileSize?: Maybe<Scalars['Int']>;
  /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
  guid?: Maybe<Scalars['String']>;
  /** Whether the attachment object is password protected. */
  hasPassword?: Maybe<Scalars['Boolean']>;
  /** The globally unique identifier of the attachment object. */
  id: Scalars['ID'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean'];
  /** Whether the object is a node in the preview state */
  isPreview?: Maybe<Scalars['Boolean']>;
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The user that most recently edited the node */
  lastEditedBy?: Maybe<ContentNodeToEditLastConnectionEdge>;
  /** The permalink of the post */
  link?: Maybe<Scalars['String']>;
  /** Details about the mediaItem */
  mediaDetails?: Maybe<MediaDetails>;
  /**
   * The id field matches the WP_Post-&gt;ID field.
   * @deprecated Deprecated in favor of the databaseId field
   */
  mediaItemId: Scalars['Int'];
  /** Url of the mediaItem */
  mediaItemUrl?: Maybe<Scalars['String']>;
  /** Type of resource */
  mediaType?: Maybe<Scalars['String']>;
  /** The mime type of the mediaItem */
  mimeType?: Maybe<Scalars['String']>;
  /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
  modified?: Maybe<Scalars['String']>;
  /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
  modifiedGmt?: Maybe<Scalars['String']>;
  /** The parent of the node. The parent object can be of various types */
  parent?: Maybe<HierarchicalContentNodeToParentContentNodeConnectionEdge>;
  /** Database id of the parent node */
  parentDatabaseId?: Maybe<Scalars['Int']>;
  /** The globally unique identifier of the parent node. */
  parentId?: Maybe<Scalars['ID']>;
  /** The password for the attachment object. */
  password?: Maybe<Scalars['String']>;
  /** The database id of the preview node */
  previewRevisionDatabaseId?: Maybe<Scalars['Int']>;
  /** Whether the object is a node in the preview state */
  previewRevisionId?: Maybe<Scalars['ID']>;
  /** The RankMath SEO data for the node. */
  seo?: Maybe<RankMathSeo>;
  /** The sizes attribute value for an image. */
  sizes?: Maybe<Scalars['String']>;
  /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
  slug?: Maybe<Scalars['String']>;
  /** Url of the mediaItem */
  sourceUrl?: Maybe<Scalars['String']>;
  /** The srcset attribute specifies the URL of the image to use in different situations. It is a comma separated string of urls and their widths. */
  srcSet?: Maybe<Scalars['String']>;
  /** The current status of the object */
  status?: Maybe<Scalars['String']>;
  /** The template assigned to a node of content */
  template?: Maybe<ContentTemplate>;
  /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
  title?: Maybe<Scalars['String']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};


/** The mediaItem type */
export type MediaItemAncestorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HierarchicalContentNodeToContentNodeAncestorsConnectionWhereArgs>;
};


/** The mediaItem type */
export type MediaItemCaptionArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};


/** The mediaItem type */
export type MediaItemChildrenArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HierarchicalContentNodeToContentNodeChildrenConnectionWhereArgs>;
};


/** The mediaItem type */
export type MediaItemCommentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MediaItemToCommentConnectionWhereArgs>;
};


/** The mediaItem type */
export type MediaItemDescriptionArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};


/** The mediaItem type */
export type MediaItemEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The mediaItem type */
export type MediaItemEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The mediaItem type */
export type MediaItemFileSizeArgs = {
  size?: InputMaybe<MediaItemSizeEnum>;
};


/** The mediaItem type */
export type MediaItemSizesArgs = {
  size?: InputMaybe<MediaItemSizeEnum>;
};


/** The mediaItem type */
export type MediaItemSourceUrlArgs = {
  size?: InputMaybe<MediaItemSizeEnum>;
};


/** The mediaItem type */
export type MediaItemSrcSetArgs = {
  size?: InputMaybe<MediaItemSizeEnum>;
};


/** The mediaItem type */
export type MediaItemTitleArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};

/** Connection to mediaItem Nodes */
export type MediaItemConnection = {
  /** A list of edges (relational context) between RootQuery and connected mediaItem Nodes */
  edges: Array<MediaItemConnectionEdge>;
  /** A list of connected mediaItem Nodes */
  nodes: Array<MediaItem>;
  /** Information about pagination in a connection. */
  pageInfo: MediaItemConnectionPageInfo;
};

/** Edge between a Node and a connected mediaItem */
export type MediaItemConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The connected mediaItem Node */
  node: MediaItem;
};

/** Page Info on the connected MediaItemConnectionEdge */
export type MediaItemConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum MediaItemIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  Slug = 'SLUG',
  /** Identify a media item by its source url */
  SourceUrl = 'SOURCE_URL',
  /** Identify a resource by the URI. */
  Uri = 'URI'
}

/** Meta connected to a MediaItem */
export type MediaItemMeta = {
  __typename?: 'MediaItemMeta';
  /** Aperture measurement of the media item. */
  aperture?: Maybe<Scalars['Float']>;
  /** Information about the camera used to create the media item. */
  camera?: Maybe<Scalars['String']>;
  /** The text string description associated with the media item. */
  caption?: Maybe<Scalars['String']>;
  /** Copyright information associated with the media item. */
  copyright?: Maybe<Scalars['String']>;
  /** The date/time when the media was created. */
  createdTimestamp?: Maybe<Scalars['Int']>;
  /** The original creator of the media item. */
  credit?: Maybe<Scalars['String']>;
  /** The focal length value of the media item. */
  focalLength?: Maybe<Scalars['Float']>;
  /** The ISO (International Organization for Standardization) value of the media item. */
  iso?: Maybe<Scalars['Int']>;
  /** List of keywords used to describe or identfy the media item. */
  keywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The vertical or horizontal aspect of the media item. */
  orientation?: Maybe<Scalars['String']>;
  /** The shutter speed information of the media item. */
  shutterSpeed?: Maybe<Scalars['Float']>;
  /** A useful title for the media item. */
  title?: Maybe<Scalars['String']>;
};

/** The size of the media item object. */
export enum MediaItemSizeEnum {
  /** MediaItem with the large size */
  Large = 'LARGE',
  /** MediaItem with the medium size */
  Medium = 'MEDIUM',
  /** MediaItem with the medium_large size */
  MediumLarge = 'MEDIUM_LARGE',
  /** MediaItem with the thumbnail size */
  Thumbnail = 'THUMBNAIL',
  /** MediaItem with the 1536x1536 size */
  '1536X1536' = '_1536X1536',
  /** MediaItem with the 2048x2048 size */
  '2048X2048' = '_2048X2048'
}

/** The status of the media item object. */
export enum MediaItemStatusEnum {
  /** Objects with the auto-draft status */
  AutoDraft = 'AUTO_DRAFT',
  /** Objects with the inherit status */
  Inherit = 'INHERIT',
  /** Objects with the private status */
  Private = 'PRIVATE',
  /** Objects with the trash status */
  Trash = 'TRASH'
}

/** Connection between the MediaItem type and the Comment type */
export type MediaItemToCommentConnection = CommentConnection & Connection & {
  __typename?: 'MediaItemToCommentConnection';
  /** Edges for the MediaItemToCommentConnection connection */
  edges: Array<MediaItemToCommentConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Comment>;
  /** Information about pagination in a connection. */
  pageInfo: MediaItemToCommentConnectionPageInfo;
};

/** An edge in a connection */
export type MediaItemToCommentConnectionEdge = CommentConnectionEdge & Edge & {
  __typename?: 'MediaItemToCommentConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Comment;
};

/** Page Info on the &quot;MediaItemToCommentConnection&quot; */
export type MediaItemToCommentConnectionPageInfo = CommentConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'MediaItemToCommentConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the MediaItemToCommentConnection connection */
export type MediaItemToCommentConnectionWhereArgs = {
  /** Comment author email address. */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** Array of author IDs to include comments for. */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to exclude comments for. */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Comment author URL. */
  authorUrl?: InputMaybe<Scalars['String']>;
  /** Array of comment IDs to include. */
  commentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  commentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Include comments of a given type. */
  commentType?: InputMaybe<Scalars['String']>;
  /** Include comments from a given array of comment types. */
  commentTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude comments from a given array of comment types. */
  commentTypeNotIn?: InputMaybe<Scalars['String']>;
  /** Content object author ID to limit results by. */
  contentAuthor?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to retrieve comments for. */
  contentAuthorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  contentAuthorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  contentId?: InputMaybe<Scalars['ID']>;
  /** Array of content object IDs to include affiliated comments for. */
  contentIdIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  contentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  contentName?: InputMaybe<Scalars['String']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  contentParent?: InputMaybe<Scalars['Int']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentStatus?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentType?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  includeUnapproved?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Karma score to retrieve matching comments for. */
  karma?: InputMaybe<Scalars['Int']>;
  /** The cardinality of the order of the connection */
  order?: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  orderby?: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Array of parent IDs of comments to retrieve children for. */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Search term(s) to retrieve matching comments for. */
  search?: InputMaybe<Scalars['String']>;
  /** Comment status to limit results by. */
  status?: InputMaybe<Scalars['String']>;
  /** Include comments for a specific user ID. */
  userId?: InputMaybe<Scalars['ID']>;
};

/** Details of an available size for a media item */
export type MediaSize = {
  __typename?: 'MediaSize';
  /** The filename of the referenced size */
  file?: Maybe<Scalars['String']>;
  /** The filesize of the resource */
  fileSize?: Maybe<Scalars['Int']>;
  /** The height of the referenced size */
  height?: Maybe<Scalars['String']>;
  /** The mime type of the referenced size */
  mimeType?: Maybe<Scalars['String']>;
  /** The referenced size name */
  name?: Maybe<Scalars['String']>;
  /** The url of the referenced size */
  sourceUrl?: Maybe<Scalars['String']>;
  /** The width of the referenced size */
  width?: Maybe<Scalars['String']>;
};

/** Menus are the containers for navigation items. Menus can be assigned to menu locations, which are typically registered by the active theme. */
export type Menu = DatabaseIdentifier & Node & {
  __typename?: 'Menu';
  /** The number of items in the menu */
  count?: Maybe<Scalars['Int']>;
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int'];
  /** The globally unique identifier of the nav menu object. */
  id: Scalars['ID'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** The locations a menu is assigned to */
  locations?: Maybe<Array<Maybe<MenuLocationEnum>>>;
  /**
   * WP ID of the nav menu.
   * @deprecated Deprecated in favor of the databaseId field
   */
  menuId?: Maybe<Scalars['Int']>;
  /** Connection between the Menu type and the MenuItem type */
  menuItems?: Maybe<MenuToMenuItemConnection>;
  /** Added to the GraphQL Schema because the ACF Field Group &quot;Menu Options&quot; was set to Show in GraphQL. */
  menuOptions?: Maybe<MenuMenuoptions>;
  /** Display name of the menu. Equivalent to WP_Term-&gt;name. */
  name?: Maybe<Scalars['String']>;
  /** The url friendly name of the menu. Equivalent to WP_Term-&gt;slug */
  slug?: Maybe<Scalars['String']>;
};


/** Menus are the containers for navigation items. Menus can be assigned to menu locations, which are typically registered by the active theme. */
export type MenuMenuItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MenuToMenuItemConnectionWhereArgs>;
};

/** Connection to Menu Nodes */
export type MenuConnection = {
  /** A list of edges (relational context) between RootQuery and connected Menu Nodes */
  edges: Array<MenuConnectionEdge>;
  /** A list of connected Menu Nodes */
  nodes: Array<Menu>;
  /** Information about pagination in a connection. */
  pageInfo: MenuConnectionPageInfo;
};

/** Edge between a Node and a connected Menu */
export type MenuConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The connected Menu Node */
  node: Menu;
};

/** Page Info on the connected MenuConnectionEdge */
export type MenuConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Navigation menu items are the individual items assigned to a menu. These are rendered as the links in a navigation menu. */
export type MenuItem = DatabaseIdentifier & Node & {
  __typename?: 'MenuItem';
  /** Connection between the MenuItem type and the MenuItem type */
  childItems?: Maybe<MenuItemToMenuItemConnection>;
  /** Connection from MenuItem to it&#039;s connected node */
  connectedNode?: Maybe<MenuItemToMenuItemLinkableConnectionEdge>;
  /**
   * The object connected to this menu item.
   * @deprecated Deprecated in favor of the connectedNode field
   */
  connectedObject?: Maybe<MenuItemObjectUnion>;
  /** Class attribute for the menu item link */
  cssClasses?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int'];
  /** Description of the menu item. */
  description?: Maybe<Scalars['String']>;
  /** The globally unique identifier of the nav menu item object. */
  id: Scalars['ID'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Label or title of the menu item. */
  label?: Maybe<Scalars['String']>;
  /** Link relationship (XFN) of the menu item. */
  linkRelationship?: Maybe<Scalars['String']>;
  /** The locations the menu item&#039;s Menu is assigned to */
  locations?: Maybe<Array<Maybe<MenuLocationEnum>>>;
  /** The Menu a MenuItem is part of */
  menu?: Maybe<MenuItemToMenuConnectionEdge>;
  /**
   * WP ID of the menu item.
   * @deprecated Deprecated in favor of the databaseId field
   */
  menuItemId?: Maybe<Scalars['Int']>;
  /** Added to the GraphQL Schema because the ACF Field Group &quot;Custom Menu Item Options&quot; was set to Show in GraphQL. */
  menuItemOptions?: Maybe<MenuItemMenuitemoptions>;
  /** Menu item order */
  order?: Maybe<Scalars['Int']>;
  /** The database id of the parent menu item or null if it is the root */
  parentDatabaseId?: Maybe<Scalars['Int']>;
  /** The globally unique identifier of the parent nav menu item object. */
  parentId?: Maybe<Scalars['ID']>;
  /** Path for the resource. Relative path for internal resources. Absolute path for external resources. */
  path?: Maybe<Scalars['String']>;
  /** Target attribute for the menu item link. */
  target?: Maybe<Scalars['String']>;
  /** Title attribute for the menu item link */
  title?: Maybe<Scalars['String']>;
  /** The uri of the resource the menu item links to */
  uri?: Maybe<Scalars['String']>;
  /** URL or destination of the menu item. */
  url?: Maybe<Scalars['String']>;
};


/** Navigation menu items are the individual items assigned to a menu. These are rendered as the links in a navigation menu. */
export type MenuItemChildItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MenuItemToMenuItemConnectionWhereArgs>;
};

/** Connection to MenuItem Nodes */
export type MenuItemConnection = {
  /** A list of edges (relational context) between RootQuery and connected MenuItem Nodes */
  edges: Array<MenuItemConnectionEdge>;
  /** A list of connected MenuItem Nodes */
  nodes: Array<MenuItem>;
  /** Information about pagination in a connection. */
  pageInfo: MenuItemConnectionPageInfo;
};

/** Edge between a Node and a connected MenuItem */
export type MenuItemConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The connected MenuItem Node */
  node: MenuItem;
};

/** Page Info on the connected MenuItemConnectionEdge */
export type MenuItemConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Nodes that can be linked to as Menu Items */
export type MenuItemLinkable = {
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int'];
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean'];
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};

/** Edge between a Node and a connected MenuItemLinkable */
export type MenuItemLinkableConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The connected MenuItemLinkable Node */
  node: MenuItemLinkable;
};

/** The Type of Identifier used to fetch a single node. Default is "ID". To be used along with the "id" field. */
export enum MenuItemNodeIdTypeEnum {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID'
}

/** Deprecated in favor of MenuItemLinkeable Interface */
export type MenuItemObjectUnion = Category | General | Page | Post | Series | Solution | Tag | Technology;

/** Connection between the MenuItem type and the Menu type */
export type MenuItemToMenuConnectionEdge = Edge & MenuConnectionEdge & OneToOneConnection & {
  __typename?: 'MenuItemToMenuConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The node of the connection, without the edges */
  node: Menu;
};

/** Connection between the MenuItem type and the MenuItem type */
export type MenuItemToMenuItemConnection = Connection & MenuItemConnection & {
  __typename?: 'MenuItemToMenuItemConnection';
  /** Edges for the MenuItemToMenuItemConnection connection */
  edges: Array<MenuItemToMenuItemConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<MenuItem>;
  /** Information about pagination in a connection. */
  pageInfo: MenuItemToMenuItemConnectionPageInfo;
};

/** An edge in a connection */
export type MenuItemToMenuItemConnectionEdge = Edge & MenuItemConnectionEdge & {
  __typename?: 'MenuItemToMenuItemConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: MenuItem;
};

/** Page Info on the &quot;MenuItemToMenuItemConnection&quot; */
export type MenuItemToMenuItemConnectionPageInfo = MenuItemConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'MenuItemToMenuItemConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the MenuItemToMenuItemConnection connection */
export type MenuItemToMenuItemConnectionWhereArgs = {
  /** The database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** The menu location for the menu being queried */
  location?: InputMaybe<MenuLocationEnum>;
  /** The database ID of the parent menu object */
  parentDatabaseId?: InputMaybe<Scalars['Int']>;
  /** The ID of the parent menu object */
  parentId?: InputMaybe<Scalars['ID']>;
};

/** Connection between the MenuItem type and the MenuItemLinkable type */
export type MenuItemToMenuItemLinkableConnectionEdge = Edge & MenuItemLinkableConnectionEdge & OneToOneConnection & {
  __typename?: 'MenuItemToMenuItemLinkableConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The node of the connection, without the edges */
  node: MenuItemLinkable;
};

/** Field Group */
export type MenuItemMenuitemoptions = AcfFieldGroup & {
  __typename?: 'MenuItem_Menuitemoptions';
  enabled?: Maybe<Scalars['Boolean']>;
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
  /**
   * Type of Menu Item
   * Use this to tell the UI if this should be a simple link or a CTA
   */
  itemType?: Maybe<Scalars['String']>;
};

/** Registered menu locations */
export enum MenuLocationEnum {
  /** Put the menu in the blog location */
  Blog = 'BLOG',
  /** Put the menu in the extra_1 location */
  Extra_1 = 'EXTRA_1',
  /** Put the menu in the extra_2 location */
  Extra_2 = 'EXTRA_2',
  /** Put the menu in the extra_3 location */
  Extra_3 = 'EXTRA_3',
  /** Put the menu in the footer_1 location */
  Footer_1 = 'FOOTER_1',
  /** Put the menu in the footer_2 location */
  Footer_2 = 'FOOTER_2',
  /** Put the menu in the footer_3 location */
  Footer_3 = 'FOOTER_3',
  /** Put the menu in the main location */
  Main = 'MAIN'
}

/** The Type of Identifier used to fetch a single node. Default is "ID". To be used along with the "id" field. */
export enum MenuNodeIdTypeEnum {
  /** Identify a menu node by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a menu node by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a menu node by the slug of menu location to which it is assigned */
  Location = 'LOCATION',
  /** Identify a menu node by its name */
  Name = 'NAME',
  /** Identify a menu node by its slug */
  Slug = 'SLUG'
}

/** Connection between the Menu type and the MenuItem type */
export type MenuToMenuItemConnection = Connection & MenuItemConnection & {
  __typename?: 'MenuToMenuItemConnection';
  /** Edges for the MenuToMenuItemConnection connection */
  edges: Array<MenuToMenuItemConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<MenuItem>;
  /** Information about pagination in a connection. */
  pageInfo: MenuToMenuItemConnectionPageInfo;
};

/** An edge in a connection */
export type MenuToMenuItemConnectionEdge = Edge & MenuItemConnectionEdge & {
  __typename?: 'MenuToMenuItemConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: MenuItem;
};

/** Page Info on the &quot;MenuToMenuItemConnection&quot; */
export type MenuToMenuItemConnectionPageInfo = MenuItemConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'MenuToMenuItemConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the MenuToMenuItemConnection connection */
export type MenuToMenuItemConnectionWhereArgs = {
  /** The database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** The menu location for the menu being queried */
  location?: InputMaybe<MenuLocationEnum>;
  /** The database ID of the parent menu object */
  parentDatabaseId?: InputMaybe<Scalars['Int']>;
  /** The ID of the parent menu object */
  parentId?: InputMaybe<Scalars['ID']>;
};

/** Field Group */
export type MenuMenuoptions = AcfFieldGroup & {
  __typename?: 'Menu_Menuoptions';
  disableSearch?: Maybe<Scalars['Boolean']>;
  disableSharing?: Maybe<Scalars['Boolean']>;
  enabled?: Maybe<Scalars['Boolean']>;
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
  /**
   * What type of menu will this be? 
   * This option is to make menus forward compatible so that in the future we can tell the UI about different types of menu.
   */
  menuType?: Maybe<Scalars['String']>;
  searchLabel?: Maybe<Scalars['String']>;
};

/** The MimeType of the object */
export enum MimeTypeEnum {
  /** application/java mime type. */
  ApplicationJava = 'APPLICATION_JAVA',
  /** application/javascript mime type. */
  ApplicationJavascript = 'APPLICATION_JAVASCRIPT',
  /** application/msword mime type. */
  ApplicationMsword = 'APPLICATION_MSWORD',
  /** application/octet-stream mime type. */
  ApplicationOctetStream = 'APPLICATION_OCTET_STREAM',
  /** application/onenote mime type. */
  ApplicationOnenote = 'APPLICATION_ONENOTE',
  /** application/oxps mime type. */
  ApplicationOxps = 'APPLICATION_OXPS',
  /** application/pdf mime type. */
  ApplicationPdf = 'APPLICATION_PDF',
  /** application/rar mime type. */
  ApplicationRar = 'APPLICATION_RAR',
  /** application/rtf mime type. */
  ApplicationRtf = 'APPLICATION_RTF',
  /** application/ttaf+xml mime type. */
  ApplicationTtafXml = 'APPLICATION_TTAF_XML',
  /** application/vnd.apple.keynote mime type. */
  ApplicationVndAppleKeynote = 'APPLICATION_VND_APPLE_KEYNOTE',
  /** application/vnd.apple.numbers mime type. */
  ApplicationVndAppleNumbers = 'APPLICATION_VND_APPLE_NUMBERS',
  /** application/vnd.apple.pages mime type. */
  ApplicationVndApplePages = 'APPLICATION_VND_APPLE_PAGES',
  /** application/vnd.ms-access mime type. */
  ApplicationVndMsAccess = 'APPLICATION_VND_MS_ACCESS',
  /** application/vnd.ms-excel mime type. */
  ApplicationVndMsExcel = 'APPLICATION_VND_MS_EXCEL',
  /** application/vnd.ms-excel.addin.macroEnabled.12 mime type. */
  ApplicationVndMsExcelAddinMacroenabled_12 = 'APPLICATION_VND_MS_EXCEL_ADDIN_MACROENABLED_12',
  /** application/vnd.ms-excel.sheet.binary.macroEnabled.12 mime type. */
  ApplicationVndMsExcelSheetBinaryMacroenabled_12 = 'APPLICATION_VND_MS_EXCEL_SHEET_BINARY_MACROENABLED_12',
  /** application/vnd.ms-excel.sheet.macroEnabled.12 mime type. */
  ApplicationVndMsExcelSheetMacroenabled_12 = 'APPLICATION_VND_MS_EXCEL_SHEET_MACROENABLED_12',
  /** application/vnd.ms-excel.template.macroEnabled.12 mime type. */
  ApplicationVndMsExcelTemplateMacroenabled_12 = 'APPLICATION_VND_MS_EXCEL_TEMPLATE_MACROENABLED_12',
  /** application/vnd.ms-powerpoint mime type. */
  ApplicationVndMsPowerpoint = 'APPLICATION_VND_MS_POWERPOINT',
  /** application/vnd.ms-powerpoint.addin.macroEnabled.12 mime type. */
  ApplicationVndMsPowerpointAddinMacroenabled_12 = 'APPLICATION_VND_MS_POWERPOINT_ADDIN_MACROENABLED_12',
  /** application/vnd.ms-powerpoint.presentation.macroEnabled.12 mime type. */
  ApplicationVndMsPowerpointPresentationMacroenabled_12 = 'APPLICATION_VND_MS_POWERPOINT_PRESENTATION_MACROENABLED_12',
  /** application/vnd.ms-powerpoint.slideshow.macroEnabled.12 mime type. */
  ApplicationVndMsPowerpointSlideshowMacroenabled_12 = 'APPLICATION_VND_MS_POWERPOINT_SLIDESHOW_MACROENABLED_12',
  /** application/vnd.ms-powerpoint.slide.macroEnabled.12 mime type. */
  ApplicationVndMsPowerpointSlideMacroenabled_12 = 'APPLICATION_VND_MS_POWERPOINT_SLIDE_MACROENABLED_12',
  /** application/vnd.ms-powerpoint.template.macroEnabled.12 mime type. */
  ApplicationVndMsPowerpointTemplateMacroenabled_12 = 'APPLICATION_VND_MS_POWERPOINT_TEMPLATE_MACROENABLED_12',
  /** application/vnd.ms-project mime type. */
  ApplicationVndMsProject = 'APPLICATION_VND_MS_PROJECT',
  /** application/vnd.ms-word.document.macroEnabled.12 mime type. */
  ApplicationVndMsWordDocumentMacroenabled_12 = 'APPLICATION_VND_MS_WORD_DOCUMENT_MACROENABLED_12',
  /** application/vnd.ms-word.template.macroEnabled.12 mime type. */
  ApplicationVndMsWordTemplateMacroenabled_12 = 'APPLICATION_VND_MS_WORD_TEMPLATE_MACROENABLED_12',
  /** application/vnd.ms-write mime type. */
  ApplicationVndMsWrite = 'APPLICATION_VND_MS_WRITE',
  /** application/vnd.ms-xpsdocument mime type. */
  ApplicationVndMsXpsdocument = 'APPLICATION_VND_MS_XPSDOCUMENT',
  /** application/vnd.oasis.opendocument.chart mime type. */
  ApplicationVndOasisOpendocumentChart = 'APPLICATION_VND_OASIS_OPENDOCUMENT_CHART',
  /** application/vnd.oasis.opendocument.database mime type. */
  ApplicationVndOasisOpendocumentDatabase = 'APPLICATION_VND_OASIS_OPENDOCUMENT_DATABASE',
  /** application/vnd.oasis.opendocument.formula mime type. */
  ApplicationVndOasisOpendocumentFormula = 'APPLICATION_VND_OASIS_OPENDOCUMENT_FORMULA',
  /** application/vnd.oasis.opendocument.graphics mime type. */
  ApplicationVndOasisOpendocumentGraphics = 'APPLICATION_VND_OASIS_OPENDOCUMENT_GRAPHICS',
  /** application/vnd.oasis.opendocument.presentation mime type. */
  ApplicationVndOasisOpendocumentPresentation = 'APPLICATION_VND_OASIS_OPENDOCUMENT_PRESENTATION',
  /** application/vnd.oasis.opendocument.spreadsheet mime type. */
  ApplicationVndOasisOpendocumentSpreadsheet = 'APPLICATION_VND_OASIS_OPENDOCUMENT_SPREADSHEET',
  /** application/vnd.oasis.opendocument.text mime type. */
  ApplicationVndOasisOpendocumentText = 'APPLICATION_VND_OASIS_OPENDOCUMENT_TEXT',
  /** application/vnd.openxmlformats-officedocument.presentationml.presentation mime type. */
  ApplicationVndOpenxmlformatsOfficedocumentPresentationmlPresentation = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_PRESENTATION',
  /** application/vnd.openxmlformats-officedocument.presentationml.slide mime type. */
  ApplicationVndOpenxmlformatsOfficedocumentPresentationmlSlide = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_SLIDE',
  /** application/vnd.openxmlformats-officedocument.presentationml.slideshow mime type. */
  ApplicationVndOpenxmlformatsOfficedocumentPresentationmlSlideshow = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_SLIDESHOW',
  /** application/vnd.openxmlformats-officedocument.presentationml.template mime type. */
  ApplicationVndOpenxmlformatsOfficedocumentPresentationmlTemplate = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_TEMPLATE',
  /** application/vnd.openxmlformats-officedocument.spreadsheetml.sheet mime type. */
  ApplicationVndOpenxmlformatsOfficedocumentSpreadsheetmlSheet = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_SPREADSHEETML_SHEET',
  /** application/vnd.openxmlformats-officedocument.spreadsheetml.template mime type. */
  ApplicationVndOpenxmlformatsOfficedocumentSpreadsheetmlTemplate = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_SPREADSHEETML_TEMPLATE',
  /** application/vnd.openxmlformats-officedocument.wordprocessingml.document mime type. */
  ApplicationVndOpenxmlformatsOfficedocumentWordprocessingmlDocument = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_WORDPROCESSINGML_DOCUMENT',
  /** application/vnd.openxmlformats-officedocument.wordprocessingml.template mime type. */
  ApplicationVndOpenxmlformatsOfficedocumentWordprocessingmlTemplate = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_WORDPROCESSINGML_TEMPLATE',
  /** application/wordperfect mime type. */
  ApplicationWordperfect = 'APPLICATION_WORDPERFECT',
  /** application/x-7z-compressed mime type. */
  ApplicationX_7ZCompressed = 'APPLICATION_X_7Z_COMPRESSED',
  /** application/x-gzip mime type. */
  ApplicationXGzip = 'APPLICATION_X_GZIP',
  /** application/x-tar mime type. */
  ApplicationXTar = 'APPLICATION_X_TAR',
  /** application/zip mime type. */
  ApplicationZip = 'APPLICATION_ZIP',
  /** audio/aac mime type. */
  AudioAac = 'AUDIO_AAC',
  /** audio/flac mime type. */
  AudioFlac = 'AUDIO_FLAC',
  /** audio/midi mime type. */
  AudioMidi = 'AUDIO_MIDI',
  /** audio/mpeg mime type. */
  AudioMpeg = 'AUDIO_MPEG',
  /** audio/ogg mime type. */
  AudioOgg = 'AUDIO_OGG',
  /** audio/wav mime type. */
  AudioWav = 'AUDIO_WAV',
  /** audio/x-matroska mime type. */
  AudioXMatroska = 'AUDIO_X_MATROSKA',
  /** audio/x-ms-wax mime type. */
  AudioXMsWax = 'AUDIO_X_MS_WAX',
  /** audio/x-ms-wma mime type. */
  AudioXMsWma = 'AUDIO_X_MS_WMA',
  /** audio/x-realaudio mime type. */
  AudioXRealaudio = 'AUDIO_X_REALAUDIO',
  /** image/avif mime type. */
  ImageAvif = 'IMAGE_AVIF',
  /** image/bmp mime type. */
  ImageBmp = 'IMAGE_BMP',
  /** image/gif mime type. */
  ImageGif = 'IMAGE_GIF',
  /** image/heic mime type. */
  ImageHeic = 'IMAGE_HEIC',
  /** image/heic-sequence mime type. */
  ImageHeicSequence = 'IMAGE_HEIC_SEQUENCE',
  /** image/heif mime type. */
  ImageHeif = 'IMAGE_HEIF',
  /** image/heif-sequence mime type. */
  ImageHeifSequence = 'IMAGE_HEIF_SEQUENCE',
  /** image/jpeg mime type. */
  ImageJpeg = 'IMAGE_JPEG',
  /** image/png mime type. */
  ImagePng = 'IMAGE_PNG',
  /** image/tiff mime type. */
  ImageTiff = 'IMAGE_TIFF',
  /** image/webp mime type. */
  ImageWebp = 'IMAGE_WEBP',
  /** image/x-icon mime type. */
  ImageXIcon = 'IMAGE_X_ICON',
  /** text/calendar mime type. */
  TextCalendar = 'TEXT_CALENDAR',
  /** text/css mime type. */
  TextCss = 'TEXT_CSS',
  /** text/csv mime type. */
  TextCsv = 'TEXT_CSV',
  /** text/html mime type. */
  TextHtml = 'TEXT_HTML',
  /** text/plain mime type. */
  TextPlain = 'TEXT_PLAIN',
  /** text/richtext mime type. */
  TextRichtext = 'TEXT_RICHTEXT',
  /** text/tab-separated-values mime type. */
  TextTabSeparatedValues = 'TEXT_TAB_SEPARATED_VALUES',
  /** text/vtt mime type. */
  TextVtt = 'TEXT_VTT',
  /** video/3gpp mime type. */
  Video_3Gpp = 'VIDEO_3GPP',
  /** video/3gpp2 mime type. */
  Video_3Gpp2 = 'VIDEO_3GPP2',
  /** video/avi mime type. */
  VideoAvi = 'VIDEO_AVI',
  /** video/divx mime type. */
  VideoDivx = 'VIDEO_DIVX',
  /** video/mp4 mime type. */
  VideoMp4 = 'VIDEO_MP4',
  /** video/mpeg mime type. */
  VideoMpeg = 'VIDEO_MPEG',
  /** video/ogg mime type. */
  VideoOgg = 'VIDEO_OGG',
  /** video/quicktime mime type. */
  VideoQuicktime = 'VIDEO_QUICKTIME',
  /** video/webm mime type. */
  VideoWebm = 'VIDEO_WEBM',
  /** video/x-flv mime type. */
  VideoXFlv = 'VIDEO_X_FLV',
  /** video/x-matroska mime type. */
  VideoXMatroska = 'VIDEO_X_MATROSKA',
  /** video/x-ms-asf mime type. */
  VideoXMsAsf = 'VIDEO_X_MS_ASF',
  /** video/x-ms-wm mime type. */
  VideoXMsWm = 'VIDEO_X_MS_WM',
  /** video/x-ms-wmv mime type. */
  VideoXMsWmv = 'VIDEO_X_MS_WMV',
  /** video/x-ms-wmx mime type. */
  VideoXMsWmx = 'VIDEO_X_MS_WMX'
}

/** An object with an ID */
export type Node = {
  /** The globally unique ID for the object */
  id: Scalars['ID'];
};

/** A node that can have an author assigned to it */
export type NodeWithAuthor = {
  /** Connection between the NodeWithAuthor type and the User type */
  author?: Maybe<NodeWithAuthorToUserConnectionEdge>;
  /** The database identifier of the author of the node */
  authorDatabaseId?: Maybe<Scalars['Int']>;
  /** The globally unique identifier of the author of the node */
  authorId?: Maybe<Scalars['ID']>;
  /** The globally unique ID for the object */
  id: Scalars['ID'];
};

/** Connection between the NodeWithAuthor type and the User type */
export type NodeWithAuthorToUserConnectionEdge = Edge & OneToOneConnection & UserConnectionEdge & {
  __typename?: 'NodeWithAuthorToUserConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The node of the connection, without the edges */
  node: User;
};

/** A node that can have comments associated with it */
export type NodeWithComments = {
  /** The number of comments. Even though WPGraphQL denotes this field as an integer, in WordPress this field should be saved as a numeric string for compatibility. */
  commentCount?: Maybe<Scalars['Int']>;
  /** Whether the comments are open or closed for this particular post. */
  commentStatus?: Maybe<Scalars['String']>;
  /** The globally unique ID for the object */
  id: Scalars['ID'];
};

/** A node that supports the content editor */
export type NodeWithContentEditor = {
  /** The content of the post. */
  content?: Maybe<Scalars['String']>;
  /** The globally unique ID for the object */
  id: Scalars['ID'];
};


/** A node that supports the content editor */
export type NodeWithContentEditorContentArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};

/** A node that can have an excerpt */
export type NodeWithExcerpt = {
  /** The excerpt of the post. */
  excerpt?: Maybe<Scalars['String']>;
  /** The globally unique ID for the object */
  id: Scalars['ID'];
};


/** A node that can have an excerpt */
export type NodeWithExcerptExcerptArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};

/** A node that can have a featured image set */
export type NodeWithFeaturedImage = {
  /** Connection between the NodeWithFeaturedImage type and the MediaItem type */
  featuredImage?: Maybe<NodeWithFeaturedImageToMediaItemConnectionEdge>;
  /** The database identifier for the featured image node assigned to the content node */
  featuredImageDatabaseId?: Maybe<Scalars['Int']>;
  /** Globally unique ID of the featured image assigned to the node */
  featuredImageId?: Maybe<Scalars['ID']>;
  /** The globally unique ID for the object */
  id: Scalars['ID'];
};

/** Connection between the NodeWithFeaturedImage type and the MediaItem type */
export type NodeWithFeaturedImageToMediaItemConnectionEdge = Edge & MediaItemConnectionEdge & OneToOneConnection & {
  __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The node of the connection, without the edges */
  node: MediaItem;
};

/** A node that can have page attributes */
export type NodeWithPageAttributes = {
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder?: Maybe<Scalars['Int']>;
};

/** A node with RankMath SEO data. */
export type NodeWithRankMathSeo = {
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** The RankMath SEO data for the node. */
  seo?: Maybe<RankMathSeo>;
};

/** A node that can have revisions */
export type NodeWithRevisions = {
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** True if the node is a revision of another node */
  isRevision?: Maybe<Scalars['Boolean']>;
  /** If the current node is a revision, this field exposes the node this is a revision of. Returns null if the node is not a revision of another node. */
  revisionOf?: Maybe<NodeWithRevisionsToContentNodeConnectionEdge>;
};

/** Connection between the NodeWithRevisions type and the ContentNode type */
export type NodeWithRevisionsToContentNodeConnectionEdge = ContentNodeConnectionEdge & Edge & OneToOneConnection & {
  __typename?: 'NodeWithRevisionsToContentNodeConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The node of the connection, without the edges */
  node: ContentNode;
};

/** A node that can have a template associated with it */
export type NodeWithTemplate = {
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** The template assigned to the node */
  template?: Maybe<ContentTemplate>;
};

/** A node that NodeWith a title */
export type NodeWithTitle = {
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
  title?: Maybe<Scalars['String']>;
};


/** A node that NodeWith a title */
export type NodeWithTitleTitleArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};

/** A node that can have trackbacks and pingbacks */
export type NodeWithTrackbacks = {
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** Whether the pings are open or closed for this particular post. */
  pingStatus?: Maybe<Scalars['String']>;
  /** URLs that have been pinged. */
  pinged?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** URLs queued to be pinged. */
  toPing?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Offset pagination input type */
export type OffsetPagination = {
  /** Number of post to show per page. Passed to posts_per_page of WP_Query. */
  offset?: InputMaybe<Scalars['Int']>;
  /** Number of post to show per page. Passed to posts_per_page of WP_Query. */
  size?: InputMaybe<Scalars['Int']>;
};

/** Get information about the offset pagination state */
export type OffsetPaginationPageInfo = {
  __typename?: 'OffsetPaginationPageInfo';
  /** True if there is one or more nodes available in this connection. Eg. you can increase the offset at least by one. */
  hasMore?: Maybe<Scalars['Boolean']>;
  /** True when offset can be decresed eg. offset is 0&lt; */
  hasPrevious?: Maybe<Scalars['Boolean']>;
  /** Total amount of nodes in this connection */
  total?: Maybe<Scalars['Int']>;
};

/** A singular connection from one Node to another, with support for relational data on the &quot;edge&quot; of the connection. */
export type OneToOneConnection = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The connected node */
  node: Node;
};

/** The cardinality of the connection order */
export enum OrderEnum {
  /** Sort the query result set in an ascending order */
  Asc = 'ASC',
  /** Sort the query result set in a descending order */
  Desc = 'DESC'
}

/** The page type */
export type Page = ContentNode & DatabaseIdentifier & HierarchicalContentNode & HierarchicalNode & MenuItemLinkable & Node & NodeWithAuthor & NodeWithComments & NodeWithContentEditor & NodeWithFeaturedImage & NodeWithPageAttributes & NodeWithRankMathSeo & NodeWithRevisions & NodeWithTemplate & NodeWithTitle & Previewable & UniformResourceIdentifiable & {
  __typename?: 'Page';
  /** Returns ancestors of the node. Default ordered as lowest (closest to the child) to highest (closest to the root). */
  ancestors?: Maybe<HierarchicalContentNodeToContentNodeAncestorsConnection>;
  /** Connection between the NodeWithAuthor type and the User type */
  author?: Maybe<NodeWithAuthorToUserConnectionEdge>;
  /** The database identifier of the author of the node */
  authorDatabaseId?: Maybe<Scalars['Int']>;
  /** The globally unique identifier of the author of the node */
  authorId?: Maybe<Scalars['ID']>;
  /** Connection between the HierarchicalContentNode type and the ContentNode type */
  children?: Maybe<HierarchicalContentNodeToContentNodeChildrenConnection>;
  /** The number of comments. Even though WPGraphQL denotes this field as an integer, in WordPress this field should be saved as a numeric string for compatibility. */
  commentCount?: Maybe<Scalars['Int']>;
  /** Whether the comments are open or closed for this particular post. */
  commentStatus?: Maybe<Scalars['String']>;
  /** Connection between the Page type and the Comment type */
  comments?: Maybe<PageToCommentConnection>;
  /** The content of the post. */
  content?: Maybe<Scalars['String']>;
  /** Connection between the ContentNode type and the ContentType type */
  contentType?: Maybe<ContentNodeToContentTypeConnectionEdge>;
  /** The name of the Content Type the node belongs to */
  contentTypeName: Scalars['String'];
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int'];
  /** Post publishing date. */
  date?: Maybe<Scalars['String']>;
  /** The publishing date set in GMT. */
  dateGmt?: Maybe<Scalars['String']>;
  /** The desired slug of the post */
  desiredSlug?: Maybe<Scalars['String']>;
  /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
  editingLockedBy?: Maybe<ContentNodeToEditLockConnectionEdge>;
  /** The RSS enclosure for the object */
  enclosure?: Maybe<Scalars['String']>;
  /** Connection between the ContentNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<ContentNodeToEnqueuedScriptConnection>;
  /** Connection between the ContentNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
  /** Connection between the NodeWithFeaturedImage type and the MediaItem type */
  featuredImage?: Maybe<NodeWithFeaturedImageToMediaItemConnectionEdge>;
  /** The database identifier for the featured image node assigned to the content node */
  featuredImageDatabaseId?: Maybe<Scalars['Int']>;
  /** Globally unique ID of the featured image assigned to the node */
  featuredImageId?: Maybe<Scalars['ID']>;
  /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
  guid?: Maybe<Scalars['String']>;
  /** Whether the page object is password protected. */
  hasPassword?: Maybe<Scalars['Boolean']>;
  /** The globally unique identifier of the page object. */
  id: Scalars['ID'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether this page is set to the static front page. */
  isFrontPage: Scalars['Boolean'];
  /** Whether this page is set to the blog posts page. */
  isPostsPage: Scalars['Boolean'];
  /** Whether the object is a node in the preview state */
  isPreview?: Maybe<Scalars['Boolean']>;
  /** Whether this page is set to the privacy page. */
  isPrivacyPage: Scalars['Boolean'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** True if the node is a revision of another node */
  isRevision?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The user that most recently edited the node */
  lastEditedBy?: Maybe<ContentNodeToEditLastConnectionEdge>;
  /** The permalink of the post */
  link?: Maybe<Scalars['String']>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder?: Maybe<Scalars['Int']>;
  /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
  modified?: Maybe<Scalars['String']>;
  /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
  modifiedGmt?: Maybe<Scalars['String']>;
  /**
   * The id field matches the WP_Post-&gt;ID field.
   * @deprecated Deprecated in favor of the databaseId field
   */
  pageId: Scalars['Int'];
  /** The parent of the node. The parent object can be of various types */
  parent?: Maybe<HierarchicalContentNodeToParentContentNodeConnectionEdge>;
  /** Database id of the parent node */
  parentDatabaseId?: Maybe<Scalars['Int']>;
  /** The globally unique identifier of the parent node. */
  parentId?: Maybe<Scalars['ID']>;
  /** The password for the page object. */
  password?: Maybe<Scalars['String']>;
  /** Connection between the Page type and the page type */
  preview?: Maybe<PageToPreviewConnectionEdge>;
  /** The database id of the preview node */
  previewRevisionDatabaseId?: Maybe<Scalars['Int']>;
  /** Whether the object is a node in the preview state */
  previewRevisionId?: Maybe<Scalars['ID']>;
  /** If the current node is a revision, this field exposes the node this is a revision of. Returns null if the node is not a revision of another node. */
  revisionOf?: Maybe<NodeWithRevisionsToContentNodeConnectionEdge>;
  /** Connection between the Page type and the page type */
  revisions?: Maybe<PageToRevisionConnection>;
  /** The RankMath SEO data for the node. */
  seo?: Maybe<RankMathSeo>;
  /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
  slug?: Maybe<Scalars['String']>;
  /** The current status of the object */
  status?: Maybe<Scalars['String']>;
  /** The template assigned to a node of content */
  template?: Maybe<ContentTemplate>;
  /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
  title?: Maybe<Scalars['String']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};


/** The page type */
export type PageAncestorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HierarchicalContentNodeToContentNodeAncestorsConnectionWhereArgs>;
};


/** The page type */
export type PageChildrenArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HierarchicalContentNodeToContentNodeChildrenConnectionWhereArgs>;
};


/** The page type */
export type PageCommentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PageToCommentConnectionWhereArgs>;
};


/** The page type */
export type PageContentArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};


/** The page type */
export type PageEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The page type */
export type PageEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The page type */
export type PageRevisionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PageToRevisionConnectionWhereArgs>;
};


/** The page type */
export type PageTitleArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};

/** Connection to page Nodes */
export type PageConnection = {
  /** A list of edges (relational context) between RootQuery and connected page Nodes */
  edges: Array<PageConnectionEdge>;
  /** A list of connected page Nodes */
  nodes: Array<Page>;
  /** Information about pagination in a connection. */
  pageInfo: PageConnectionPageInfo;
};

/** Edge between a Node and a connected page */
export type PageConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The connected page Node */
  node: Page;
};

/** Page Info on the connected PageConnectionEdge */
export type PageConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum PageIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the URI. */
  Uri = 'URI'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** The RankMath SEO meta settings for Pages. */
export type PageMetaSettings = RankMathMetaSettingWithRobots & {
  __typename?: 'PageMetaSettings';
  /** Advanced robots meta tag settings. */
  advancedRobotsMeta?: Maybe<RankMathAdvancedRobotsMeta>;
  /** List of custom fields name to include in the Page analysis */
  analyzedFields?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Default article type when creating a new Pages. */
  articleType?: Maybe<RankMathArticleTypeEnum>;
  /** Default description for single Pages pages. */
  description?: Maybe<Scalars['String']>;
  /** Whether to list bulk editing columns to the post listing screen. */
  hasBulkEditing?: Maybe<RankMathBulkEditingTypeEnum>;
  /** Whether custom robots meta for author page are set. Otherwise the default meta will be used, as set in the Global Meta tab. */
  hasCustomRobotsMeta?: Maybe<Scalars['Boolean']>;
  /** Whether Link Suggestions meta box and the Pillar Content featured are enabled for this post type. */
  hasLinkSuggestions?: Maybe<Scalars['Boolean']>;
  /** Whether the SEO Controls meta box for user profile pages is enabled. */
  hasSeoControls?: Maybe<Scalars['Boolean']>;
  /** Whether to show additional information (name &amp; total number of posts) when an author archive is shared on Slack. */
  hasSlackEnhancedSharing?: Maybe<Scalars['Boolean']>;
  /** Custom values for robots meta tag. */
  robotsMeta?: Maybe<Array<Maybe<RankMathRobotsMetaValueEnum>>>;
  /** Whether to use the Focus Keyword as the default text for the links instead of the post titles. */
  shouldUseFocusKeyword?: Maybe<Scalars['Boolean']>;
  /** Default rich snippet headline. */
  snippetDescription?: Maybe<Scalars['String']>;
  /** Default rich snippet headline. */
  snippetHeadline?: Maybe<Scalars['String']>;
  /** Default rich snippet select when creating a new Pages. */
  snippetType?: Maybe<RankMathSnippetTypeEnum>;
  /** The default image to display when sharing this post type on social media */
  socialImage?: Maybe<MediaItem>;
  /** Default title tag for single Pages pages. */
  title?: Maybe<Scalars['String']>;
};

/** Connection between the Page type and the Comment type */
export type PageToCommentConnection = CommentConnection & Connection & {
  __typename?: 'PageToCommentConnection';
  /** Edges for the PageToCommentConnection connection */
  edges: Array<PageToCommentConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Comment>;
  /** Information about pagination in a connection. */
  pageInfo: PageToCommentConnectionPageInfo;
};

/** An edge in a connection */
export type PageToCommentConnectionEdge = CommentConnectionEdge & Edge & {
  __typename?: 'PageToCommentConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Comment;
};

/** Page Info on the &quot;PageToCommentConnection&quot; */
export type PageToCommentConnectionPageInfo = CommentConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'PageToCommentConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the PageToCommentConnection connection */
export type PageToCommentConnectionWhereArgs = {
  /** Comment author email address. */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** Array of author IDs to include comments for. */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to exclude comments for. */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Comment author URL. */
  authorUrl?: InputMaybe<Scalars['String']>;
  /** Array of comment IDs to include. */
  commentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  commentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Include comments of a given type. */
  commentType?: InputMaybe<Scalars['String']>;
  /** Include comments from a given array of comment types. */
  commentTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude comments from a given array of comment types. */
  commentTypeNotIn?: InputMaybe<Scalars['String']>;
  /** Content object author ID to limit results by. */
  contentAuthor?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to retrieve comments for. */
  contentAuthorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  contentAuthorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  contentId?: InputMaybe<Scalars['ID']>;
  /** Array of content object IDs to include affiliated comments for. */
  contentIdIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  contentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  contentName?: InputMaybe<Scalars['String']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  contentParent?: InputMaybe<Scalars['Int']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentStatus?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentType?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  includeUnapproved?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Karma score to retrieve matching comments for. */
  karma?: InputMaybe<Scalars['Int']>;
  /** The cardinality of the order of the connection */
  order?: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  orderby?: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Array of parent IDs of comments to retrieve children for. */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Search term(s) to retrieve matching comments for. */
  search?: InputMaybe<Scalars['String']>;
  /** Comment status to limit results by. */
  status?: InputMaybe<Scalars['String']>;
  /** Include comments for a specific user ID. */
  userId?: InputMaybe<Scalars['ID']>;
};

/** Connection between the Page type and the page type */
export type PageToPreviewConnectionEdge = Edge & OneToOneConnection & PageConnectionEdge & {
  __typename?: 'PageToPreviewConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The node of the connection, without the edges */
  node: Page;
};

/** Connection between the Page type and the page type */
export type PageToRevisionConnection = Connection & PageConnection & {
  __typename?: 'PageToRevisionConnection';
  /** Edges for the PageToRevisionConnection connection */
  edges: Array<PageToRevisionConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Page>;
  /** Information about pagination in a connection. */
  pageInfo: PageToRevisionConnectionPageInfo;
};

/** An edge in a connection */
export type PageToRevisionConnectionEdge = Edge & PageConnectionEdge & {
  __typename?: 'PageToRevisionConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Page;
};

/** Page Info on the &quot;PageToRevisionConnection&quot; */
export type PageToRevisionConnectionPageInfo = PageConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'PageToRevisionConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the PageToRevisionConnection connection */
export type PageToRevisionConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** An plugin object */
export type Plugin = Node & {
  __typename?: 'Plugin';
  /** Name of the plugin author(s), may also be a company name. */
  author?: Maybe<Scalars['String']>;
  /** URI for the related author(s)/company website. */
  authorUri?: Maybe<Scalars['String']>;
  /** Description of the plugin. */
  description?: Maybe<Scalars['String']>;
  /** The globally unique identifier of the plugin object. */
  id: Scalars['ID'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Display name of the plugin. */
  name?: Maybe<Scalars['String']>;
  /** Plugin path. */
  path?: Maybe<Scalars['String']>;
  /** URI for the plugin website. This is useful for directing users for support requests etc. */
  pluginUri?: Maybe<Scalars['String']>;
  /** Current version of the plugin. */
  version?: Maybe<Scalars['String']>;
};

/** Connection to Plugin Nodes */
export type PluginConnection = {
  /** A list of edges (relational context) between RootQuery and connected Plugin Nodes */
  edges: Array<PluginConnectionEdge>;
  /** A list of connected Plugin Nodes */
  nodes: Array<Plugin>;
  /** Information about pagination in a connection. */
  pageInfo: PluginConnectionPageInfo;
};

/** Edge between a Node and a connected Plugin */
export type PluginConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The connected Plugin Node */
  node: Plugin;
};

/** Page Info on the connected PluginConnectionEdge */
export type PluginConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** The status of the WordPress plugin. */
export enum PluginStatusEnum {
  /** The plugin is currently active. */
  Active = 'ACTIVE',
  /** The plugin is a drop-in plugin. */
  DropIn = 'DROP_IN',
  /** The plugin is currently inactive. */
  Inactive = 'INACTIVE',
  /** The plugin is a must-use plugin. */
  MustUse = 'MUST_USE',
  /** The plugin is technically active but was paused while loading. */
  Paused = 'PAUSED',
  /** The plugin was active recently. */
  RecentlyActive = 'RECENTLY_ACTIVE',
  /** The plugin has an upgrade available. */
  Upgrade = 'UPGRADE'
}

/** The post type */
export type Post = ContentNode & DatabaseIdentifier & MenuItemLinkable & Node & NodeWithAuthor & NodeWithComments & NodeWithContentEditor & NodeWithExcerpt & NodeWithFeaturedImage & NodeWithRankMathSeo & NodeWithRevisions & NodeWithTemplate & NodeWithTitle & NodeWithTrackbacks & Previewable & UniformResourceIdentifiable & {
  __typename?: 'Post';
  /**
   * The ancestors of the content node.
   * @deprecated This content type is not hierarchical and typically will not have ancestors
   */
  ancestors?: Maybe<PostToPostConnection>;
  /** Connection between the NodeWithAuthor type and the User type */
  author?: Maybe<NodeWithAuthorToUserConnectionEdge>;
  /** The database identifier of the author of the node */
  authorDatabaseId?: Maybe<Scalars['Int']>;
  /** The globally unique identifier of the author of the node */
  authorId?: Maybe<Scalars['ID']>;
  /** Added to the GraphQL Schema because the ACF Field Group &quot;Blog Post Related Services&quot; was set to Show in GraphQL. */
  blogPostRelatedServices?: Maybe<PostBlogpostrelatedservices>;
  /** Connection between the Post type and the category type */
  categories?: Maybe<PostToCategoryConnection>;
  /** List of code blocks defined via ACF. */
  codeBlocks?: Maybe<Array<Maybe<CodeBlock>>>;
  /** The number of comments. Even though WPGraphQL denotes this field as an integer, in WordPress this field should be saved as a numeric string for compatibility. */
  commentCount?: Maybe<Scalars['Int']>;
  /** Whether the comments are open or closed for this particular post. */
  commentStatus?: Maybe<Scalars['String']>;
  /** Connection between the Post type and the Comment type */
  comments?: Maybe<PostToCommentConnection>;
  /** The content of the post. */
  content?: Maybe<Scalars['String']>;
  /** Connection between the ContentNode type and the ContentType type */
  contentType?: Maybe<ContentNodeToContentTypeConnectionEdge>;
  /** The name of the Content Type the node belongs to */
  contentTypeName: Scalars['String'];
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int'];
  /** Post publishing date. */
  date?: Maybe<Scalars['String']>;
  /** The publishing date set in GMT. */
  dateGmt?: Maybe<Scalars['String']>;
  /** The desired slug of the post */
  desiredSlug?: Maybe<Scalars['String']>;
  /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
  editingLockedBy?: Maybe<ContentNodeToEditLockConnectionEdge>;
  /** The RSS enclosure for the object */
  enclosure?: Maybe<Scalars['String']>;
  /** Connection between the ContentNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<ContentNodeToEnqueuedScriptConnection>;
  /** Connection between the ContentNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
  /** The excerpt of the post. */
  excerpt?: Maybe<Scalars['String']>;
  /** Connection between the NodeWithFeaturedImage type and the MediaItem type */
  featuredImage?: Maybe<NodeWithFeaturedImageToMediaItemConnectionEdge>;
  /** The database identifier for the featured image node assigned to the content node */
  featuredImageDatabaseId?: Maybe<Scalars['Int']>;
  /** Globally unique ID of the featured image assigned to the node */
  featuredImageId?: Maybe<Scalars['ID']>;
  /** Debug field to test if our filter is working */
  filterDebug?: Maybe<Scalars['String']>;
  /** Connection between the Post type and the general type */
  general?: Maybe<PostToGeneralConnection>;
  /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
  guid?: Maybe<Scalars['String']>;
  /** Whether the post object is password protected. */
  hasPassword?: Maybe<Scalars['Boolean']>;
  /** The globally unique identifier of the post object. */
  id: Scalars['ID'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean'];
  /** Whether the object is a node in the preview state */
  isPreview?: Maybe<Scalars['Boolean']>;
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** True if the node is a revision of another node */
  isRevision?: Maybe<Scalars['Boolean']>;
  /** Whether this page is sticky */
  isSticky: Scalars['Boolean'];
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The user that most recently edited the node */
  lastEditedBy?: Maybe<ContentNodeToEditLastConnectionEdge>;
  /** The permalink of the post */
  link?: Maybe<Scalars['String']>;
  /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
  modified?: Maybe<Scalars['String']>;
  /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
  modifiedGmt?: Maybe<Scalars['String']>;
  /**
   * The parent of the content node.
   * @deprecated This content type is not hierarchical and typically will not have a parent
   */
  parent?: Maybe<PostToParentConnectionEdge>;
  /** The password for the post object. */
  password?: Maybe<Scalars['String']>;
  /** Whether the pings are open or closed for this particular post. */
  pingStatus?: Maybe<Scalars['String']>;
  /** URLs that have been pinged. */
  pinged?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Connection between the Post type and the postFormat type */
  postFormats?: Maybe<PostToPostFormatConnection>;
  /**
   * The id field matches the WP_Post-&gt;ID field.
   * @deprecated Deprecated in favor of the databaseId field
   */
  postId: Scalars['Int'];
  /** Manually add a &quot;Last Updated&quot; date | Added to the GraphQL Schema because the ACF Field Group &quot;Last Updated Date&quot; was set to Show in GraphQL. */
  postLastUpdated?: Maybe<PostPostlastupdated>;
  /** Added to the GraphQL Schema because the ACF Field Group &quot;Blog Post Options&quot; was set to Show in GraphQL. */
  postOptions?: Maybe<PostPostoptions>;
  /** Connection between the Post type and the post type */
  preview?: Maybe<PostToPreviewConnectionEdge>;
  /** The database id of the preview node */
  previewRevisionDatabaseId?: Maybe<Scalars['Int']>;
  /** Whether the object is a node in the preview state */
  previewRevisionId?: Maybe<Scalars['ID']>;
  /** If the current node is a revision, this field exposes the node this is a revision of. Returns null if the node is not a revision of another node. */
  revisionOf?: Maybe<NodeWithRevisionsToContentNodeConnectionEdge>;
  /** Connection between the Post type and the post type */
  revisions?: Maybe<PostToRevisionConnection>;
  /** The RankMath SEO data for the node. */
  seo?: Maybe<RankMathSeo>;
  /** Connection between the Post type and the series type */
  series?: Maybe<PostToSeriesConnection>;
  /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
  slug?: Maybe<Scalars['String']>;
  /** Connection between the Post type and the solution type */
  solutions?: Maybe<PostToSolutionConnection>;
  /** The current status of the object */
  status?: Maybe<Scalars['String']>;
  /** Connection between the Post type and the tag type */
  tags?: Maybe<PostToTagConnection>;
  /** Connection between the Post type and the technology type */
  technologies?: Maybe<PostToTechnologyConnection>;
  /** The template assigned to the node */
  template?: Maybe<ContentTemplate>;
  /** Connection between the Post type and the TermNode type */
  terms?: Maybe<PostToTermNodeConnection>;
  /** Calculates how many minutes it could take to read the post */
  timeToRead?: Maybe<Scalars['Int']>;
  /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
  title?: Maybe<Scalars['String']>;
  /** URLs queued to be pinged. */
  toPing?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};


/** The post type */
export type PostAncestorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The post type */
export type PostCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PostToCategoryConnectionWhereArgs>;
};


/** The post type */
export type PostCommentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PostToCommentConnectionWhereArgs>;
};


/** The post type */
export type PostContentArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};


/** The post type */
export type PostEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The post type */
export type PostEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The post type */
export type PostExcerptArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};


/** The post type */
export type PostGeneralArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PostToGeneralConnectionWhereArgs>;
};


/** The post type */
export type PostPostFormatsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PostToPostFormatConnectionWhereArgs>;
};


/** The post type */
export type PostRevisionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PostToRevisionConnectionWhereArgs>;
};


/** The post type */
export type PostSeriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PostToSeriesConnectionWhereArgs>;
};


/** The post type */
export type PostSolutionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PostToSolutionConnectionWhereArgs>;
};


/** The post type */
export type PostTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PostToTagConnectionWhereArgs>;
};


/** The post type */
export type PostTechnologiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PostToTechnologyConnectionWhereArgs>;
};


/** The post type */
export type PostTermsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PostToTermNodeConnectionWhereArgs>;
};


/** The post type */
export type PostTitleArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};

/** Set relationships between the post to categories */
export type PostCategoriesInput = {
  /** If true, this will append the category to existing related categories. If false, this will replace existing relationships. Default true. */
  append?: InputMaybe<Scalars['Boolean']>;
  /** The input list of items to set. */
  nodes?: InputMaybe<Array<InputMaybe<PostCategoriesNodeInput>>>;
};

/** List of categories to connect the post to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type PostCategoriesNodeInput = {
  /** The description of the category. This field is used to set a description of the category if a new one is created during the mutation. */
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the category. If present, this will be used to connect to the post. If no existing category exists with this ID, no connection will be made. */
  id?: InputMaybe<Scalars['ID']>;
  /** The name of the category. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name?: InputMaybe<Scalars['String']>;
  /** The slug of the category. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug?: InputMaybe<Scalars['String']>;
};

/** Connection to post Nodes */
export type PostConnection = {
  /** A list of edges (relational context) between RootQuery and connected post Nodes */
  edges: Array<PostConnectionEdge>;
  /** A list of connected post Nodes */
  nodes: Array<Post>;
  /** Information about pagination in a connection. */
  pageInfo: PostConnectionPageInfo;
};

/** Edge between a Node and a connected post */
export type PostConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The connected post Node */
  node: Post;
};

/** Page Info on the connected PostConnectionEdge */
export type PostConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** The postFormat type */
export type PostFormat = DatabaseIdentifier & Node & NodeWithRankMathSeo & TermNode & UniformResourceIdentifiable & {
  __typename?: 'PostFormat';
  /** Connection between the PostFormat type and the ContentNode type */
  contentNodes?: Maybe<PostFormatToContentNodeConnection>;
  /** The number of objects connected to the object */
  count?: Maybe<Scalars['Int']>;
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int'];
  /** The description of the object */
  description?: Maybe<Scalars['String']>;
  /** Connection between the TermNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<TermNodeToEnqueuedScriptConnection>;
  /** Connection between the TermNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<TermNodeToEnqueuedStylesheetConnection>;
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The link to the term */
  link?: Maybe<Scalars['String']>;
  /** The human friendly name of the object. */
  name?: Maybe<Scalars['String']>;
  /**
   * The id field matches the WP_Post-&gt;ID field.
   * @deprecated Deprecated in favor of databaseId
   */
  postFormatId?: Maybe<Scalars['Int']>;
  /** Connection between the PostFormat type and the post type */
  posts?: Maybe<PostFormatToPostConnection>;
  /** The RankMath SEO data for the node. */
  seo?: Maybe<RankMathSeo>;
  /** An alphanumeric identifier for the object unique to its type. */
  slug?: Maybe<Scalars['String']>;
  /** Connection between the PostFormat type and the Taxonomy type */
  taxonomy?: Maybe<PostFormatToTaxonomyConnectionEdge>;
  /** The name of the taxonomy that the object is associated with */
  taxonomyName?: Maybe<Scalars['String']>;
  /** The ID of the term group that this term object belongs to */
  termGroupId?: Maybe<Scalars['Int']>;
  /** The taxonomy ID that the object is associated with */
  termTaxonomyId?: Maybe<Scalars['Int']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};


/** The postFormat type */
export type PostFormatContentNodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PostFormatToContentNodeConnectionWhereArgs>;
};


/** The postFormat type */
export type PostFormatEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The postFormat type */
export type PostFormatEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The postFormat type */
export type PostFormatPostsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PostFormatToPostConnectionWhereArgs>;
};

/** Connection to postFormat Nodes */
export type PostFormatConnection = {
  /** A list of edges (relational context) between RootQuery and connected postFormat Nodes */
  edges: Array<PostFormatConnectionEdge>;
  /** A list of connected postFormat Nodes */
  nodes: Array<PostFormat>;
  /** Information about pagination in a connection. */
  pageInfo: PostFormatConnectionPageInfo;
};

/** Edge between a Node and a connected postFormat */
export type PostFormatConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The connected postFormat Node */
  node: PostFormat;
};

/** Page Info on the connected PostFormatConnectionEdge */
export type PostFormatConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum PostFormatIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI'
}

/** The RankMath SEO meta settings for Formats. */
export type PostFormatMetaSettings = RankMathMetaSettingWithArchive & RankMathMetaSettingWithRobots & {
  __typename?: 'PostFormatMetaSettings';
  /** Advanced robots meta tag settings. */
  advancedRobotsMeta?: Maybe<RankMathAdvancedRobotsMeta>;
  /** Description for archive pages. */
  archiveDescription?: Maybe<Scalars['String']>;
  /** Default title tag for archive page. */
  archiveTitle?: Maybe<Scalars['String']>;
  /** Whether custom robots meta for author page are set. Otherwise the default meta will be used, as set in the Global Meta tab. */
  hasCustomRobotsMeta?: Maybe<Scalars['Boolean']>;
  /** Whether to show additional information (name &amp; total number of posts) when an author archive is shared on Slack. */
  hasSlackEnhancedSharing?: Maybe<Scalars['Boolean']>;
  /** Custom values for robots meta tag. */
  robotsMeta?: Maybe<Array<Maybe<RankMathRobotsMetaValueEnum>>>;
};

/** Connection between the PostFormat type and the ContentNode type */
export type PostFormatToContentNodeConnection = Connection & ContentNodeConnection & {
  __typename?: 'PostFormatToContentNodeConnection';
  /** Edges for the PostFormatToContentNodeConnection connection */
  edges: Array<PostFormatToContentNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<ContentNode>;
  /** Information about pagination in a connection. */
  pageInfo: PostFormatToContentNodeConnectionPageInfo;
};

/** An edge in a connection */
export type PostFormatToContentNodeConnectionEdge = ContentNodeConnectionEdge & Edge & {
  __typename?: 'PostFormatToContentNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: ContentNode;
};

/** Page Info on the &quot;PostFormatToContentNodeConnection&quot; */
export type PostFormatToContentNodeConnectionPageInfo = ContentNodeConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'PostFormatToContentNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the PostFormatToContentNodeConnection connection */
export type PostFormatToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypesOfPostFormatEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the PostFormat type and the post type */
export type PostFormatToPostConnection = Connection & PostConnection & {
  __typename?: 'PostFormatToPostConnection';
  /** Edges for the PostFormatToPostConnection connection */
  edges: Array<PostFormatToPostConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Post>;
  /** Information about pagination in a connection. */
  pageInfo: PostFormatToPostConnectionPageInfo;
};

/** An edge in a connection */
export type PostFormatToPostConnectionEdge = Edge & PostConnectionEdge & {
  __typename?: 'PostFormatToPostConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Post;
};

/** Page Info on the &quot;PostFormatToPostConnection&quot; */
export type PostFormatToPostConnectionPageInfo = PageInfo & PostConnectionPageInfo & WpPageInfo & {
  __typename?: 'PostFormatToPostConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the PostFormatToPostConnection connection */
export type PostFormatToPostConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Category ID */
  categoryId?: InputMaybe<Scalars['Int']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Use Category Slug */
  categoryName?: InputMaybe<Scalars['String']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  tag?: InputMaybe<Scalars['String']>;
  /** Use Tag ID */
  tagId?: InputMaybe<Scalars['String']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  tagSlugAnd?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  tagSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the PostFormat type and the Taxonomy type */
export type PostFormatToTaxonomyConnectionEdge = Edge & OneToOneConnection & TaxonomyConnectionEdge & {
  __typename?: 'PostFormatToTaxonomyConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The node of the connection, without the edges */
  node: Taxonomy;
};

/** Set relationships between the post to general */
export type PostGeneralInput = {
  /** If true, this will append the general to existing related general. If false, this will replace existing relationships. Default true. */
  append?: InputMaybe<Scalars['Boolean']>;
  /** The input list of items to set. */
  nodes?: InputMaybe<Array<InputMaybe<PostGeneralNodeInput>>>;
};

/** List of general to connect the post to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type PostGeneralNodeInput = {
  /** The description of the general. This field is used to set a description of the general if a new one is created during the mutation. */
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the general. If present, this will be used to connect to the post. If no existing general exists with this ID, no connection will be made. */
  id?: InputMaybe<Scalars['ID']>;
  /** The name of the general. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name?: InputMaybe<Scalars['String']>;
  /** The slug of the general. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum PostIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  Slug = 'SLUG',
  /** Identify a resource by the URI. */
  Uri = 'URI'
}

/** The RankMath SEO meta settings for Posts. */
export type PostMetaSettings = RankMathMetaSettingWithRobots & {
  __typename?: 'PostMetaSettings';
  /** Advanced robots meta tag settings. */
  advancedRobotsMeta?: Maybe<RankMathAdvancedRobotsMeta>;
  /** List of custom fields name to include in the Page analysis */
  analyzedFields?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Default article type when creating a new Posts. */
  articleType?: Maybe<RankMathArticleTypeEnum>;
  /** Default description for single Posts pages. */
  description?: Maybe<Scalars['String']>;
  /** Whether to list bulk editing columns to the post listing screen. */
  hasBulkEditing?: Maybe<RankMathBulkEditingTypeEnum>;
  /** Whether custom robots meta for author page are set. Otherwise the default meta will be used, as set in the Global Meta tab. */
  hasCustomRobotsMeta?: Maybe<Scalars['Boolean']>;
  /** Whether Link Suggestions meta box and the Pillar Content featured are enabled for this post type. */
  hasLinkSuggestions?: Maybe<Scalars['Boolean']>;
  /** Whether the SEO Controls meta box for user profile pages is enabled. */
  hasSeoControls?: Maybe<Scalars['Boolean']>;
  /** Whether to show additional information (name &amp; total number of posts) when an author archive is shared on Slack. */
  hasSlackEnhancedSharing?: Maybe<Scalars['Boolean']>;
  /** Custom values for robots meta tag. */
  robotsMeta?: Maybe<Array<Maybe<RankMathRobotsMetaValueEnum>>>;
  /** Whether to use the Focus Keyword as the default text for the links instead of the post titles. */
  shouldUseFocusKeyword?: Maybe<Scalars['Boolean']>;
  /** Default rich snippet headline. */
  snippetDescription?: Maybe<Scalars['String']>;
  /** Default rich snippet headline. */
  snippetHeadline?: Maybe<Scalars['String']>;
  /** Default rich snippet select when creating a new Posts. */
  snippetType?: Maybe<RankMathSnippetTypeEnum>;
  /** The default image to display when sharing this post type on social media */
  socialImage?: Maybe<MediaItem>;
  /** Default title tag for single Posts pages. */
  title?: Maybe<Scalars['String']>;
};

/** The format of post field data. */
export enum PostObjectFieldFormatEnum {
  /** Provide the field value directly from database. Null on unauthenticated requests. */
  Raw = 'RAW',
  /** Provide the field value as rendered by WordPress. Default. */
  Rendered = 'RENDERED'
}

/** The column to use when filtering by date */
export enum PostObjectsConnectionDateColumnEnum {
  /** The date the comment was created in local time. */
  Date = 'DATE',
  /** The most recent modification date of the comment. */
  Modified = 'MODIFIED'
}

/** Field to order the connection by */
export enum PostObjectsConnectionOrderbyEnum {
  /** Order by author */
  Author = 'AUTHOR',
  /** Order by the number of comments it has acquired */
  CommentCount = 'COMMENT_COUNT',
  /** Order by publish date */
  Date = 'DATE',
  /** Preserve the ID order given in the IN array */
  In = 'IN',
  /** Order by the menu order value */
  MenuOrder = 'MENU_ORDER',
  /** Order by last modified date */
  Modified = 'MODIFIED',
  /** Preserve slug order given in the NAME_IN array */
  NameIn = 'NAME_IN',
  /** Order by parent ID */
  Parent = 'PARENT',
  /** Order by slug */
  Slug = 'SLUG',
  /** Order by title */
  Title = 'TITLE'
}

/** Options for ordering the connection */
export type PostObjectsConnectionOrderbyInput = {
  /** The field to order the connection by */
  field: PostObjectsConnectionOrderbyEnum;
  /** Possible directions in which to order a list of items */
  order: OrderEnum;
};

/** Set relationships between the post to postFormats */
export type PostPostFormatsInput = {
  /** If true, this will append the postFormat to existing related postFormats. If false, this will replace existing relationships. Default true. */
  append?: InputMaybe<Scalars['Boolean']>;
  /** The input list of items to set. */
  nodes?: InputMaybe<Array<InputMaybe<PostPostFormatsNodeInput>>>;
};

/** List of postFormats to connect the post to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type PostPostFormatsNodeInput = {
  /** The description of the postFormat. This field is used to set a description of the postFormat if a new one is created during the mutation. */
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the postFormat. If present, this will be used to connect to the post. If no existing postFormat exists with this ID, no connection will be made. */
  id?: InputMaybe<Scalars['ID']>;
  /** The name of the postFormat. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name?: InputMaybe<Scalars['String']>;
  /** The slug of the postFormat. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug?: InputMaybe<Scalars['String']>;
};

/** Set relationships between the post to series */
export type PostSeriesInput = {
  /** If true, this will append the series to existing related series. If false, this will replace existing relationships. Default true. */
  append?: InputMaybe<Scalars['Boolean']>;
  /** The input list of items to set. */
  nodes?: InputMaybe<Array<InputMaybe<PostSeriesNodeInput>>>;
};

/** List of series to connect the post to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type PostSeriesNodeInput = {
  /** The description of the series. This field is used to set a description of the series if a new one is created during the mutation. */
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the series. If present, this will be used to connect to the post. If no existing series exists with this ID, no connection will be made. */
  id?: InputMaybe<Scalars['ID']>;
  /** The name of the series. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name?: InputMaybe<Scalars['String']>;
  /** The slug of the series. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug?: InputMaybe<Scalars['String']>;
};

/** Set relationships between the post to solutions */
export type PostSolutionsInput = {
  /** If true, this will append the solution to existing related solutions. If false, this will replace existing relationships. Default true. */
  append?: InputMaybe<Scalars['Boolean']>;
  /** The input list of items to set. */
  nodes?: InputMaybe<Array<InputMaybe<PostSolutionsNodeInput>>>;
};

/** List of solutions to connect the post to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type PostSolutionsNodeInput = {
  /** The description of the solution. This field is used to set a description of the solution if a new one is created during the mutation. */
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the solution. If present, this will be used to connect to the post. If no existing solution exists with this ID, no connection will be made. */
  id?: InputMaybe<Scalars['ID']>;
  /** The name of the solution. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name?: InputMaybe<Scalars['String']>;
  /** The slug of the solution. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The status of the object. */
export enum PostStatusEnum {
  /** Objects with the acf-disabled status */
  AcfDisabled = 'ACF_DISABLED',
  /** Objects with the auto-draft status */
  AutoDraft = 'AUTO_DRAFT',
  /** Objects with the draft status */
  Draft = 'DRAFT',
  /** Objects with the future status */
  Future = 'FUTURE',
  /** Objects with the inherit status */
  Inherit = 'INHERIT',
  /** Objects with the pending status */
  Pending = 'PENDING',
  /** Objects with the private status */
  Private = 'PRIVATE',
  /** Objects with the publish status */
  Publish = 'PUBLISH',
  /** Objects with the request-completed status */
  RequestCompleted = 'REQUEST_COMPLETED',
  /** Objects with the request-confirmed status */
  RequestConfirmed = 'REQUEST_CONFIRMED',
  /** Objects with the request-failed status */
  RequestFailed = 'REQUEST_FAILED',
  /** Objects with the request-pending status */
  RequestPending = 'REQUEST_PENDING',
  /** Objects with the trash status */
  Trash = 'TRASH'
}

/** Set relationships between the post to tags */
export type PostTagsInput = {
  /** If true, this will append the tag to existing related tags. If false, this will replace existing relationships. Default true. */
  append?: InputMaybe<Scalars['Boolean']>;
  /** The input list of items to set. */
  nodes?: InputMaybe<Array<InputMaybe<PostTagsNodeInput>>>;
};

/** List of tags to connect the post to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type PostTagsNodeInput = {
  /** The description of the tag. This field is used to set a description of the tag if a new one is created during the mutation. */
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the tag. If present, this will be used to connect to the post. If no existing tag exists with this ID, no connection will be made. */
  id?: InputMaybe<Scalars['ID']>;
  /** The name of the tag. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name?: InputMaybe<Scalars['String']>;
  /** The slug of the tag. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug?: InputMaybe<Scalars['String']>;
};

/** Set relationships between the post to technologies */
export type PostTechnologiesInput = {
  /** If true, this will append the technology to existing related technologies. If false, this will replace existing relationships. Default true. */
  append?: InputMaybe<Scalars['Boolean']>;
  /** The input list of items to set. */
  nodes?: InputMaybe<Array<InputMaybe<PostTechnologiesNodeInput>>>;
};

/** List of technologies to connect the post to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type PostTechnologiesNodeInput = {
  /** The description of the technology. This field is used to set a description of the technology if a new one is created during the mutation. */
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the technology. If present, this will be used to connect to the post. If no existing technology exists with this ID, no connection will be made. */
  id?: InputMaybe<Scalars['ID']>;
  /** The name of the technology. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name?: InputMaybe<Scalars['String']>;
  /** The slug of the technology. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug?: InputMaybe<Scalars['String']>;
};

/** Connection between the Post type and the category type */
export type PostToCategoryConnection = CategoryConnection & Connection & {
  __typename?: 'PostToCategoryConnection';
  /** Edges for the PostToCategoryConnection connection */
  edges: Array<PostToCategoryConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Category>;
  /** Information about pagination in a connection. */
  pageInfo: PostToCategoryConnectionPageInfo;
};

/** An edge in a connection */
export type PostToCategoryConnectionEdge = CategoryConnectionEdge & Edge & {
  __typename?: 'PostToCategoryConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Category;
};

/** Page Info on the &quot;PostToCategoryConnection&quot; */
export type PostToCategoryConnectionPageInfo = CategoryConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'PostToCategoryConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the PostToCategoryConnection connection */
export type PostToCategoryConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the Post type and the Comment type */
export type PostToCommentConnection = CommentConnection & Connection & {
  __typename?: 'PostToCommentConnection';
  /** Edges for the PostToCommentConnection connection */
  edges: Array<PostToCommentConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Comment>;
  /** Information about pagination in a connection. */
  pageInfo: PostToCommentConnectionPageInfo;
};

/** An edge in a connection */
export type PostToCommentConnectionEdge = CommentConnectionEdge & Edge & {
  __typename?: 'PostToCommentConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Comment;
};

/** Page Info on the &quot;PostToCommentConnection&quot; */
export type PostToCommentConnectionPageInfo = CommentConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'PostToCommentConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the PostToCommentConnection connection */
export type PostToCommentConnectionWhereArgs = {
  /** Comment author email address. */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** Array of author IDs to include comments for. */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to exclude comments for. */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Comment author URL. */
  authorUrl?: InputMaybe<Scalars['String']>;
  /** Array of comment IDs to include. */
  commentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  commentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Include comments of a given type. */
  commentType?: InputMaybe<Scalars['String']>;
  /** Include comments from a given array of comment types. */
  commentTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude comments from a given array of comment types. */
  commentTypeNotIn?: InputMaybe<Scalars['String']>;
  /** Content object author ID to limit results by. */
  contentAuthor?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to retrieve comments for. */
  contentAuthorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  contentAuthorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  contentId?: InputMaybe<Scalars['ID']>;
  /** Array of content object IDs to include affiliated comments for. */
  contentIdIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  contentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  contentName?: InputMaybe<Scalars['String']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  contentParent?: InputMaybe<Scalars['Int']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentStatus?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentType?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  includeUnapproved?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Karma score to retrieve matching comments for. */
  karma?: InputMaybe<Scalars['Int']>;
  /** The cardinality of the order of the connection */
  order?: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  orderby?: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Array of parent IDs of comments to retrieve children for. */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Search term(s) to retrieve matching comments for. */
  search?: InputMaybe<Scalars['String']>;
  /** Comment status to limit results by. */
  status?: InputMaybe<Scalars['String']>;
  /** Include comments for a specific user ID. */
  userId?: InputMaybe<Scalars['ID']>;
};

/** Connection between the Post type and the general type */
export type PostToGeneralConnection = Connection & GeneralConnection & {
  __typename?: 'PostToGeneralConnection';
  /** Edges for the PostToGeneralConnection connection */
  edges: Array<PostToGeneralConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<General>;
  /** Information about pagination in a connection. */
  pageInfo: PostToGeneralConnectionPageInfo;
};

/** An edge in a connection */
export type PostToGeneralConnectionEdge = Edge & GeneralConnectionEdge & {
  __typename?: 'PostToGeneralConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: General;
};

/** Page Info on the &quot;PostToGeneralConnection&quot; */
export type PostToGeneralConnectionPageInfo = GeneralConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'PostToGeneralConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the PostToGeneralConnection connection */
export type PostToGeneralConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the Post type and the post type */
export type PostToParentConnectionEdge = Edge & OneToOneConnection & PostConnectionEdge & {
  __typename?: 'PostToParentConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /**
   * The node of the connection, without the edges
   * @deprecated This content type is not hierarchical and typically will not have a parent
   */
  node: Post;
};

/** Connection between the Post type and the post type */
export type PostToPostConnection = Connection & PostConnection & {
  __typename?: 'PostToPostConnection';
  /** Edges for the PostToPostConnection connection */
  edges: Array<PostToPostConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Post>;
  /** Information about pagination in a connection. */
  pageInfo: PostToPostConnectionPageInfo;
};

/** An edge in a connection */
export type PostToPostConnectionEdge = Edge & PostConnectionEdge & {
  __typename?: 'PostToPostConnectionEdge';
  /**
   * A cursor for use in pagination
   * @deprecated This content type is not hierarchical and typically will not have ancestors
   */
  cursor?: Maybe<Scalars['String']>;
  /**
   * The item at the end of the edge
   * @deprecated This content type is not hierarchical and typically will not have ancestors
   */
  node: Post;
};

/** Page Info on the &quot;PostToPostConnection&quot; */
export type PostToPostConnectionPageInfo = PageInfo & PostConnectionPageInfo & WpPageInfo & {
  __typename?: 'PostToPostConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Connection between the Post type and the postFormat type */
export type PostToPostFormatConnection = Connection & PostFormatConnection & {
  __typename?: 'PostToPostFormatConnection';
  /** Edges for the PostToPostFormatConnection connection */
  edges: Array<PostToPostFormatConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<PostFormat>;
  /** Information about pagination in a connection. */
  pageInfo: PostToPostFormatConnectionPageInfo;
};

/** An edge in a connection */
export type PostToPostFormatConnectionEdge = Edge & PostFormatConnectionEdge & {
  __typename?: 'PostToPostFormatConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: PostFormat;
};

/** Page Info on the &quot;PostToPostFormatConnection&quot; */
export type PostToPostFormatConnectionPageInfo = PageInfo & PostFormatConnectionPageInfo & WpPageInfo & {
  __typename?: 'PostToPostFormatConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the PostToPostFormatConnection connection */
export type PostToPostFormatConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the Post type and the post type */
export type PostToPreviewConnectionEdge = Edge & OneToOneConnection & PostConnectionEdge & {
  __typename?: 'PostToPreviewConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The node of the connection, without the edges */
  node: Post;
};

/** Connection between the Post type and the post type */
export type PostToRevisionConnection = Connection & PostConnection & {
  __typename?: 'PostToRevisionConnection';
  /** Edges for the PostToRevisionConnection connection */
  edges: Array<PostToRevisionConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Post>;
  /** Information about pagination in a connection. */
  pageInfo: PostToRevisionConnectionPageInfo;
};

/** An edge in a connection */
export type PostToRevisionConnectionEdge = Edge & PostConnectionEdge & {
  __typename?: 'PostToRevisionConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Post;
};

/** Page Info on the &quot;PostToRevisionConnection&quot; */
export type PostToRevisionConnectionPageInfo = PageInfo & PostConnectionPageInfo & WpPageInfo & {
  __typename?: 'PostToRevisionConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the PostToRevisionConnection connection */
export type PostToRevisionConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Category ID */
  categoryId?: InputMaybe<Scalars['Int']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Use Category Slug */
  categoryName?: InputMaybe<Scalars['String']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  tag?: InputMaybe<Scalars['String']>;
  /** Use Tag ID */
  tagId?: InputMaybe<Scalars['String']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  tagSlugAnd?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  tagSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the Post type and the series type */
export type PostToSeriesConnection = Connection & SeriesConnection & {
  __typename?: 'PostToSeriesConnection';
  /** Edges for the PostToSeriesConnection connection */
  edges: Array<PostToSeriesConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Series>;
  /** Information about pagination in a connection. */
  pageInfo: PostToSeriesConnectionPageInfo;
};

/** An edge in a connection */
export type PostToSeriesConnectionEdge = Edge & SeriesConnectionEdge & {
  __typename?: 'PostToSeriesConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Series;
};

/** Page Info on the &quot;PostToSeriesConnection&quot; */
export type PostToSeriesConnectionPageInfo = PageInfo & SeriesConnectionPageInfo & WpPageInfo & {
  __typename?: 'PostToSeriesConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the PostToSeriesConnection connection */
export type PostToSeriesConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the Post type and the solution type */
export type PostToSolutionConnection = Connection & SolutionConnection & {
  __typename?: 'PostToSolutionConnection';
  /** Edges for the PostToSolutionConnection connection */
  edges: Array<PostToSolutionConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Solution>;
  /** Information about pagination in a connection. */
  pageInfo: PostToSolutionConnectionPageInfo;
};

/** An edge in a connection */
export type PostToSolutionConnectionEdge = Edge & SolutionConnectionEdge & {
  __typename?: 'PostToSolutionConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Solution;
};

/** Page Info on the &quot;PostToSolutionConnection&quot; */
export type PostToSolutionConnectionPageInfo = PageInfo & SolutionConnectionPageInfo & WpPageInfo & {
  __typename?: 'PostToSolutionConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the PostToSolutionConnection connection */
export type PostToSolutionConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the Post type and the tag type */
export type PostToTagConnection = Connection & TagConnection & {
  __typename?: 'PostToTagConnection';
  /** Edges for the PostToTagConnection connection */
  edges: Array<PostToTagConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Tag>;
  /** Information about pagination in a connection. */
  pageInfo: PostToTagConnectionPageInfo;
};

/** An edge in a connection */
export type PostToTagConnectionEdge = Edge & TagConnectionEdge & {
  __typename?: 'PostToTagConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Tag;
};

/** Page Info on the &quot;PostToTagConnection&quot; */
export type PostToTagConnectionPageInfo = PageInfo & TagConnectionPageInfo & WpPageInfo & {
  __typename?: 'PostToTagConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the PostToTagConnection connection */
export type PostToTagConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the Post type and the technology type */
export type PostToTechnologyConnection = Connection & TechnologyConnection & {
  __typename?: 'PostToTechnologyConnection';
  /** Edges for the PostToTechnologyConnection connection */
  edges: Array<PostToTechnologyConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Technology>;
  /** Information about pagination in a connection. */
  pageInfo: PostToTechnologyConnectionPageInfo;
};

/** An edge in a connection */
export type PostToTechnologyConnectionEdge = Edge & TechnologyConnectionEdge & {
  __typename?: 'PostToTechnologyConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Technology;
};

/** Page Info on the &quot;PostToTechnologyConnection&quot; */
export type PostToTechnologyConnectionPageInfo = PageInfo & TechnologyConnectionPageInfo & WpPageInfo & {
  __typename?: 'PostToTechnologyConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the PostToTechnologyConnection connection */
export type PostToTechnologyConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the Post type and the TermNode type */
export type PostToTermNodeConnection = Connection & TermNodeConnection & {
  __typename?: 'PostToTermNodeConnection';
  /** Edges for the PostToTermNodeConnection connection */
  edges: Array<PostToTermNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<TermNode>;
  /** Information about pagination in a connection. */
  pageInfo: PostToTermNodeConnectionPageInfo;
};

/** An edge in a connection */
export type PostToTermNodeConnectionEdge = Edge & TermNodeConnectionEdge & {
  __typename?: 'PostToTermNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: TermNode;
};

/** Page Info on the &quot;PostToTermNodeConnection&quot; */
export type PostToTermNodeConnectionPageInfo = PageInfo & TermNodeConnectionPageInfo & WpPageInfo & {
  __typename?: 'PostToTermNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the PostToTermNodeConnection connection */
export type PostToTermNodeConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The Taxonomy to filter terms by */
  taxonomies?: InputMaybe<Array<InputMaybe<TaxonomyEnum>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Details for labels of the PostType */
export type PostTypeLabelDetails = {
  __typename?: 'PostTypeLabelDetails';
  /** Default is ‘Add New’ for both hierarchical and non-hierarchical types. */
  addNew?: Maybe<Scalars['String']>;
  /** Label for adding a new singular item. */
  addNewItem?: Maybe<Scalars['String']>;
  /** Label to signify all items in a submenu link. */
  allItems?: Maybe<Scalars['String']>;
  /** Label for archives in nav menus */
  archives?: Maybe<Scalars['String']>;
  /** Label for the attributes meta box. */
  attributes?: Maybe<Scalars['String']>;
  /** Label for editing a singular item. */
  editItem?: Maybe<Scalars['String']>;
  /** Label for the Featured Image meta box title. */
  featuredImage?: Maybe<Scalars['String']>;
  /** Label for the table views hidden heading. */
  filterItemsList?: Maybe<Scalars['String']>;
  /** Label for the media frame button. */
  insertIntoItem?: Maybe<Scalars['String']>;
  /** Label for the table hidden heading. */
  itemsList?: Maybe<Scalars['String']>;
  /** Label for the table pagination hidden heading. */
  itemsListNavigation?: Maybe<Scalars['String']>;
  /** Label for the menu name. */
  menuName?: Maybe<Scalars['String']>;
  /** General name for the post type, usually plural. */
  name?: Maybe<Scalars['String']>;
  /** Label for the new item page title. */
  newItem?: Maybe<Scalars['String']>;
  /** Label used when no items are found. */
  notFound?: Maybe<Scalars['String']>;
  /** Label used when no items are in the trash. */
  notFoundInTrash?: Maybe<Scalars['String']>;
  /** Label used to prefix parents of hierarchical items. */
  parentItemColon?: Maybe<Scalars['String']>;
  /** Label for removing the featured image. */
  removeFeaturedImage?: Maybe<Scalars['String']>;
  /** Label for searching plural items. */
  searchItems?: Maybe<Scalars['String']>;
  /** Label for setting the featured image. */
  setFeaturedImage?: Maybe<Scalars['String']>;
  /** Name for one object of this post type. */
  singularName?: Maybe<Scalars['String']>;
  /** Label for the media frame filter. */
  uploadedToThisItem?: Maybe<Scalars['String']>;
  /** Label in the media frame for using a featured image. */
  useFeaturedImage?: Maybe<Scalars['String']>;
  /** Label for viewing a singular item. */
  viewItem?: Maybe<Scalars['String']>;
  /** Label for viewing post type archives. */
  viewItems?: Maybe<Scalars['String']>;
};

/** Field Group */
export type PostBlogpostrelatedservices = AcfFieldGroup & {
  __typename?: 'Post_Blogpostrelatedservices';
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
  realtedServices?: Maybe<Array<Maybe<PostBlogpostrelatedservicesRealtedServices>>>;
};

/** Field Group */
export type PostBlogpostrelatedservicesRealtedServices = AcfFieldGroup & {
  __typename?: 'Post_Blogpostrelatedservices_realtedServices';
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
  serviceLabel?: Maybe<Scalars['String']>;
  serviceUrl?: Maybe<Scalars['String']>;
};

/** Field Group */
export type PostPostlastupdated = AcfFieldGroup & {
  __typename?: 'Post_Postlastupdated';
  datemodified?: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
  showLastUpdated?: Maybe<Scalars['Boolean']>;
};

/** Field Group */
export type PostPostoptions = AcfFieldGroup & {
  __typename?: 'Post_Postoptions';
  elementsVisibilityOptions?: Maybe<PostPostoptionsElementsVisibilityOptions>;
  faqOptions?: Maybe<PostPostoptionsFaqOptions>;
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
  keyQuestionsOptions?: Maybe<PostPostoptionsKeyQuestionsOptions>;
  relatedPostsOptions?: Maybe<PostPostoptionsRelatedPostsOptions>;
  upNextWidget?: Maybe<PostPostoptionsUpNextWidget>;
};

/** Field Group */
export type PostPostoptionsElementsVisibilityOptions = AcfFieldGroup & {
  __typename?: 'Post_Postoptions_ElementsVisibilityOptions';
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
  /** Will hide the Article contents section */
  hideArticleContents?: Maybe<Scalars['Boolean']>;
  /** Will hide all displayed information about the post author */
  hideAuthor?: Maybe<Scalars['Boolean']>;
  /** Will hide the comments section, both read and post */
  hideComments?: Maybe<Scalars['Boolean']>;
  /** Will hide the ability to share this post on social media */
  hideSharing?: Maybe<Scalars['Boolean']>;
};

/** Field Group */
export type PostPostoptionsFaqOptions = AcfFieldGroup & {
  __typename?: 'Post_Postoptions_FaqOptions';
  faqSectionTitle?: Maybe<Scalars['String']>;
  faqs?: Maybe<Array<Maybe<PostPostoptionsFaqOptionsFaqs>>>;
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
  /** Will show the FAQ section, you will need to add the questions and answers below */
  showFaq?: Maybe<Scalars['Boolean']>;
};

/** Field Group */
export type PostPostoptionsFaqOptionsFaqs = AcfFieldGroup & {
  __typename?: 'Post_Postoptions_FaqOptions_faqs';
  answer?: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
};

/** Field Group */
export type PostPostoptionsKeyQuestionsOptions = AcfFieldGroup & {
  __typename?: 'Post_Postoptions_KeyQuestionsOptions';
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
  keyQuestions?: Maybe<Array<Maybe<PostPostoptionsKeyQuestionsOptionsKeyQuestions>>>;
  /** Will show the key questions section, you will need to add the key questions below */
  showKeyQuestions?: Maybe<Scalars['Boolean']>;
};

/** Field Group */
export type PostPostoptionsKeyQuestionsOptionsKeyQuestions = AcfFieldGroup & {
  __typename?: 'Post_Postoptions_KeyQuestionsOptions_keyQuestions';
  answer?: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
};

/** Field Group */
export type PostPostoptionsRelatedPostsOptions = AcfFieldGroup & {
  __typename?: 'Post_Postoptions_RelatedPostsOptions';
  /** System will get a set of related posts to this one automatically. By turning this off, you will need to manually select six posts. */
  automaticRelatedPosts?: Maybe<Scalars['Boolean']>;
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
  relatedPosts?: Maybe<Array<Maybe<PostPostoptionsRelatedPostsOptionsRelatedPosts>>>;
};

export type PostPostoptionsRelatedPostsOptionsRelatedPosts = Post;

/** Field Group */
export type PostPostoptionsUpNextWidget = AcfFieldGroup & {
  __typename?: 'Post_Postoptions_UpNextWidget';
  automaticUpNextWidget?: Maybe<Scalars['Boolean']>;
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
  /** Up next widget will show by default, disabling it here will remove it from this post. */
  showUpNextWidget?: Maybe<Scalars['Boolean']>;
  upNext?: Maybe<PostPostoptionsUpNextWidgetUpNext>;
};

export type PostPostoptionsUpNextWidgetUpNext = Post;

/** Nodes that can be seen in a preview (unpublished) state. */
export type Previewable = {
  /** Whether the object is a node in the preview state */
  isPreview?: Maybe<Scalars['Boolean']>;
  /** The database id of the preview node */
  previewRevisionDatabaseId?: Maybe<Scalars['Int']>;
  /** Whether the object is a node in the preview state */
  previewRevisionId?: Maybe<Scalars['ID']>;
};

/** The config for an advanced robots meta values. */
export type RankMathAdvancedRobotsMeta = {
  __typename?: 'RankMathAdvancedRobotsMeta';
  /** Whether to specify a maximum size of image preview to be shown for images on the page. */
  hasImagePreview?: Maybe<Scalars['Boolean']>;
  /** Whether to specify a maximum text length of a snippet of your page */
  hasSnippet?: Maybe<Scalars['Boolean']>;
  /** Whether to specify a maximum duration of an animated video preview. */
  hasVideoPreview?: Maybe<Scalars['Boolean']>;
  /** The maximum size of image preview to be shown for images. */
  imagePreviewSize?: Maybe<RankMathImagePreviewSize>;
  /** The maximum text length (in characters) of the snippet. -1 for no limit. */
  snippetLength?: Maybe<Scalars['Int']>;
  /** The maximum duration (seconds characters) of the snippet. -1 for no limit. */
  videoDuration?: Maybe<Scalars['Int']>;
};

/** The SEO Article Type */
export enum RankMathArticleTypeEnum {
  /** Article. */
  Article = 'ARTICLE',
  /** Blog post. */
  BlogPost = 'BLOG_POST',
  /** News article. */
  NewsArticle = 'NEWS_ARTICLE'
}

/** The RankMath SEO Author Archive meta settings. */
export type RankMathAuthorArchiveMetaSettings = RankMathMetaSettingWithArchive & RankMathMetaSettingWithRobots & {
  __typename?: 'RankMathAuthorArchiveMetaSettings';
  /** Advanced robots meta tag settings. */
  advancedRobotsMeta?: Maybe<RankMathAdvancedRobotsMeta>;
  /** Description for archive pages. */
  archiveDescription?: Maybe<Scalars['String']>;
  /** Default title tag for archive page. */
  archiveTitle?: Maybe<Scalars['String']>;
  /** Change the `/author/` part in author archive URLs. */
  baseSlug?: Maybe<Scalars['String']>;
  /** Whether author archives are enabled. */
  hasArchives?: Maybe<Scalars['Boolean']>;
  /** Whether custom robots meta for author page are set. Otherwise the default meta will be used, as set in the Global Meta tab. */
  hasCustomRobotsMeta?: Maybe<Scalars['Boolean']>;
  /** Whether the SEO Controls meta box for user profile pages is enabled. */
  hasSeoControls?: Maybe<Scalars['Boolean']>;
  /** Whether to show additional information (name &amp; total number of posts) when an author archive is shared on Slack. */
  hasSlackEnhancedSharing?: Maybe<Scalars['Boolean']>;
  /** Custom values for robots meta tag. */
  robotsMeta?: Maybe<Array<Maybe<RankMathRobotsMetaValueEnum>>>;
};

/** The Breadcrumb trail. */
export type RankMathBreadcrumbs = {
  __typename?: 'RankMathBreadcrumbs';
  /** Whether the given breadcrumb is hidden from the schema */
  isHidden?: Maybe<Scalars['Boolean']>;
  /** The text for the given breadcrumb */
  text?: Maybe<Scalars['String']>;
  /** The url for the given breadcrumb */
  url?: Maybe<Scalars['String']>;
};

/** The RankMath SEO breadcrumbs settings. */
export type RankMathBreadcrumbsConfig = {
  __typename?: 'RankMathBreadcrumbsConfig';
  /** Format the label used for archive pages. */
  archiveFormat?: Maybe<Scalars['String']>;
  /** Whether to show all ancestor categories, if a category is a child category. */
  hasAncestorCategories?: Maybe<Scalars['Boolean']>;
  /** Whether to display the homepage breadcrumb in trail. */
  hasHome?: Maybe<Scalars['Boolean']>;
  /** Whether the post title is visible in the breadcrumbs. */
  hasPostTitle?: Maybe<Scalars['Boolean']>;
  /** Whether the taxonomy name is visible in the breadcrumbs. */
  hasTaxonomyName?: Maybe<Scalars['Boolean']>;
  /** Label used for homepage link (first item) in breadcrumbs. */
  homeLabel?: Maybe<Scalars['String']>;
  /** Link to use for homepage (first item) in breadcrumbs. */
  homeUrl?: Maybe<Scalars['String']>;
  /** Label used for 404 error item in breadcrumbs. */
  notFoundLabel?: Maybe<Scalars['String']>;
  /** Prefix for the breadcrumb path. */
  prefix?: Maybe<Scalars['String']>;
  /** Format the label used for search results pages. */
  searchFormat?: Maybe<Scalars['String']>;
  /** Separator character or string that appears between breadcrumb items. */
  separator?: Maybe<Scalars['String']>;
};

/** The setting chosen for the RankMath Bulk Editing feature */
export enum RankMathBulkEditingTypeEnum {
  /** Disabled. */
  Disabled = 'DISABLED',
  /** Enabled. */
  Enabled = 'ENABLED',
  /** Read only. */
  ReadOnly = 'READ_ONLY'
}

/** The category term object SEO data */
export type RankMathCategoryTermSeo = RankMathSeo & {
  __typename?: 'RankMathCategoryTermSeo';
  /** The title to use in the breadcrumbs for this post */
  breadcrumbTitle?: Maybe<Scalars['String']>;
  /** The breadcrumbs trail for the given object */
  breadcrumbs?: Maybe<Array<Maybe<RankMathBreadcrumbs>>>;
  /** The canonical url. */
  canonicalUrl?: Maybe<Scalars['String']>;
  /** The meta description. */
  description?: Maybe<Scalars['String']>;
  /** The focus keywords you want to rank for */
  focusKeywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The fully-rendered `head` tag for the given item */
  fullHead?: Maybe<Scalars['String']>;
  /** The JSON+LD data */
  jsonLd?: Maybe<RankMathJsonLd>;
  /** The open graph meta properties. */
  openGraph?: Maybe<RankMathOpenGraphMeta>;
  /** A list of the robots meta properties to output. */
  robots?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The title. */
  title?: Maybe<Scalars['String']>;
};

/** The seo data for Post Objects */
export type RankMathContentNodeSeo = {
  /** The title to use in the breadcrumbs for this post */
  breadcrumbTitle?: Maybe<Scalars['String']>;
  /** The breadcrumbs trail for the given object */
  breadcrumbs?: Maybe<Array<Maybe<RankMathBreadcrumbs>>>;
  /** The canonical url. */
  canonicalUrl?: Maybe<Scalars['String']>;
  /** The meta description. */
  description?: Maybe<Scalars['String']>;
  /** The focus keywords you want to rank for */
  focusKeywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The fully-rendered `head` tag for the given item */
  fullHead?: Maybe<Scalars['String']>;
  /** Whether the item is considered pillar (cornerstone) content */
  isPillarContent?: Maybe<Scalars['Boolean']>;
  /** The JSON+LD data */
  jsonLd?: Maybe<RankMathJsonLd>;
  /** The open graph meta properties. */
  openGraph?: Maybe<RankMathOpenGraphMeta>;
  /** A list of the robots meta properties to output. */
  robots?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The SEO score */
  seoScore?: Maybe<RankMathSeoScore>;
  /** The title. */
  title?: Maybe<Scalars['String']>;
};

/** The RankMath SEO Post Type settings. */
export type RankMathContentTypeMetaSettings = {
  __typename?: 'RankMathContentTypeMetaSettings';
  /** The RankMath SEO meta settings for Pages. */
  page?: Maybe<PageMetaSettings>;
  /** The RankMath SEO meta settings for Posts. */
  post?: Maybe<PostMetaSettings>;
};

/** The RankMath SEO DateArchive meta settings. */
export type RankMathDateArchiveMetaSettings = RankMathMetaSettingWithArchive & RankMathMetaSettingWithRobots & {
  __typename?: 'RankMathDateArchiveMetaSettings';
  /** Advanced robots meta tag settings. */
  advancedRobotsMeta?: Maybe<RankMathAdvancedRobotsMeta>;
  /** Description for archive pages. */
  archiveDescription?: Maybe<Scalars['String']>;
  /** Default title tag for archive page. */
  archiveTitle?: Maybe<Scalars['String']>;
  /** Whether archives are enabled. */
  hasArchives?: Maybe<Scalars['Boolean']>;
  /** Custom values for robots meta tag. */
  robotsMeta?: Maybe<Array<Maybe<RankMathRobotsMetaValueEnum>>>;
};

/** RankMath Frontend SEO Score settings. */
export type RankMathFrontendSeoScore = {
  __typename?: 'RankMathFrontendSeoScore';
  /** The list of post types which should display the calculated SEO score. */
  enabledPostTypes?: Maybe<Array<Maybe<ContentTypeEnum>>>;
  /** Whether to insert a backlink to RankMath.com to show your support, if you are showing the SEO scores on the front end. */
  hasRankMathBacklink?: Maybe<Scalars['Boolean']>;
  /** Where the SEO score badges should be displayed automatically, or if the `[rank_math_seo_score]` shortcode is used instead. */
  position?: Maybe<RankMathSeoScorePositionEnum>;
  /** The list of post types which should display the calculated SEO score. */
  template?: Maybe<RankMathSeoScoreTemplateTypeEnum>;
};

/** The RankMath SEO general site settings */
export type RankMathGeneral = {
  __typename?: 'RankMathGeneral';
  /** Breadcrumbs settings. */
  breadcrumbs?: Maybe<RankMathBreadcrumbsConfig>;
  /** Frontend SEO score settings. */
  frontendSeoScore?: Maybe<RankMathFrontendSeoScore>;
  /** Whether RankMath breadcrumbs are enabled. */
  hasBreadcrumbs?: Maybe<Scalars['Boolean']>;
  /** Whether to display the calculated SEO Score as a badge on the frontend. It can be disabled for specific posts in the post editor. */
  hasFrontendSeoScore?: Maybe<Scalars['Boolean']>;
  /** Link settings. */
  links?: Maybe<RankMathLinks>;
  /** The content to add after each post in your site feeds */
  rssAfterContent?: Maybe<Scalars['String']>;
  /** The content to add before each post in your site feeds */
  rssBeforeContent?: Maybe<Scalars['String']>;
  /** Webmaster Tools settings. */
  webmaster?: Maybe<RankMathWebmaster>;
};

/** The general term object SEO data */
export type RankMathGeneralTermSeo = RankMathSeo & {
  __typename?: 'RankMathGeneralTermSeo';
  /** The title to use in the breadcrumbs for this post */
  breadcrumbTitle?: Maybe<Scalars['String']>;
  /** The breadcrumbs trail for the given object */
  breadcrumbs?: Maybe<Array<Maybe<RankMathBreadcrumbs>>>;
  /** The canonical url. */
  canonicalUrl?: Maybe<Scalars['String']>;
  /** The meta description. */
  description?: Maybe<Scalars['String']>;
  /** The focus keywords you want to rank for */
  focusKeywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The fully-rendered `head` tag for the given item */
  fullHead?: Maybe<Scalars['String']>;
  /** The JSON+LD data */
  jsonLd?: Maybe<RankMathJsonLd>;
  /** The open graph meta properties. */
  openGraph?: Maybe<RankMathOpenGraphMeta>;
  /** A list of the robots meta properties to output. */
  robots?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The title. */
  title?: Maybe<Scalars['String']>;
};

/** The RankMath SEO Global settings. */
export type RankMathGlobalMetaSettings = RankMathMetaSettingWithRobots & {
  __typename?: 'RankMathGlobalMetaSettings';
  /** Advanced robots meta tag settings. */
  advancedRobotsMeta?: Maybe<RankMathAdvancedRobotsMeta>;
  /** When a featured image or an OpenGraph Image is not set for individual posts/pages/CPTs, this image will be used as a fallback thumbnail when your post is shared on Facebook. */
  openGraphImage?: Maybe<MediaItem>;
  /** Custom values for robots meta tag. */
  robotsMeta?: Maybe<Array<Maybe<RankMathRobotsMetaValueEnum>>>;
  /** The separator character used in titles. */
  separator?: Maybe<Scalars['String']>;
  /** Whether to automatically capitalize the first character of each word in the titles. */
  shouldCapitalizeTitles?: Maybe<Scalars['Boolean']>;
  /** Whether to index enpty Taxonomy archives */
  shouldIndexEmptyTaxonomies?: Maybe<Scalars['Boolean']>;
  /** Card type selected when creating a new post. This will also be applied for posts without a card type selected. */
  twitterCardType?: Maybe<RankMathTwitterCardTypeEnum>;
};

/** The RankMath SEO Homepage settings. Only used when the Settings &gt; Reading &gt; Your homepage displays is set to `Your latest posts`. */
export type RankMathHomepageMetaSettings = RankMathMetaSettingWithRobots & {
  __typename?: 'RankMathHomepageMetaSettings';
  /** Advanced robots meta tag settings. */
  advancedRobotsMeta?: Maybe<RankMathAdvancedRobotsMeta>;
  /** Meta description. */
  description?: Maybe<Scalars['String']>;
  /** Whether custom robots meta for author page are set. Otherwise the default meta will be used, as set in the Global Meta tab. */
  hasCustomRobotsMeta?: Maybe<Scalars['Boolean']>;
  /** Custom values for robots meta tag. */
  robotsMeta?: Maybe<Array<Maybe<RankMathRobotsMetaValueEnum>>>;
  /** Description when shared on Facebook, Twitter and other social networks. */
  socialDescription?: Maybe<Scalars['String']>;
  /** Image displayed when your homepage is shared on Facebook and other social networks. */
  socialImage?: Maybe<MediaItem>;
  /** Title when shared on Facebook, Twitter and other social networks. */
  socialTitle?: Maybe<Scalars['String']>;
  /** Title tag. */
  title?: Maybe<Scalars['String']>;
};

/** Robots meta image preview size. */
export enum RankMathImagePreviewSize {
  /** Large */
  Large = 'LARGE',
  /** Prevents search engines from following links on the pages */
  None = 'NONE',
  /** Standard. */
  Standard = 'STANDARD'
}

/** The JSON+LD information. */
export type RankMathJsonLd = {
  __typename?: 'RankMathJsonLd';
  /** The raw JSON+LD output */
  raw?: Maybe<Scalars['String']>;
};

/** The knowledge graph type */
export enum RankMathKnowledgeGraphTypeEnum {
  /** Company. */
  Company = 'COMPANY',
  /** Person. */
  Person = 'PERSON'
}

/** The RankMath SEO links settings. */
export type RankMathLinks = {
  __typename?: 'RankMathLinks';
  /** The default redirection url for attachments without a parent post */
  defaultAttachmentRedirectUrl?: Maybe<Scalars['String']>;
  /** Whether  /category/ should be included in category archive URLs. */
  hasCategoryBase?: Maybe<Scalars['Boolean']>;
  /** Only add `nofollow` attributes to links with the following target domains. If null, `nofollow` will be applied to &lt;em&gt;all&lt;/em&gt; external domains. */
  nofollowDomains?: Maybe<Scalars['String']>;
  /** `nofollow` attributes will &lt;em&gt;not&lt;/em&gt; be added to links with the following target domains. */
  nofollowExcludedDomains?: Maybe<Scalars['String']>;
  /** Whether to automatically add the `rel=&quot;nofollow&quot; attribute to links pointing to external image files. */
  shouldNofollowImageLinks?: Maybe<Scalars['Boolean']>;
  /** Whether to automatically add the `rel=&quot;nofollow&quot; attribute to external links appearing in your posts, pages, and other post types. */
  shouldNofollowLinks?: Maybe<Scalars['Boolean']>;
  /** Whether to automatically add `target=&quot;_blank&quot;` attribute for external links appearing in your posts, pages, and other post types to make them open in a new browser tab or window. */
  shouldOpenInNewWindow?: Maybe<Scalars['Boolean']>;
  /** Whether to redirect all attachment page URLs to the post they appear in. */
  shouldRedirectAttachments?: Maybe<Scalars['Boolean']>;
};

/** The RankMath SEO Local settings. */
export type RankMathLocalMetaSettings = {
  __typename?: 'RankMathLocalMetaSettings';
  /** The logo to be used in the Google&#039;s Knowledge Graph. */
  logo?: Maybe<MediaItem>;
  /** Your name or company name to be used in Google&#039;s Knowledge Graph */
  name?: Maybe<Scalars['String']>;
  /** Whether the site represents a person or an organization. */
  type?: Maybe<RankMathKnowledgeGraphTypeEnum>;
  /** URL of the item. */
  url?: Maybe<Scalars['String']>;
};

/** The attachment post object SEO data */
export type RankMathMediaItemObjectSeo = RankMathContentNodeSeo & RankMathSeo & {
  __typename?: 'RankMathMediaItemObjectSeo';
  /** The title to use in the breadcrumbs for this post */
  breadcrumbTitle?: Maybe<Scalars['String']>;
  /** The breadcrumbs trail for the given object */
  breadcrumbs?: Maybe<Array<Maybe<RankMathBreadcrumbs>>>;
  /** The canonical url. */
  canonicalUrl?: Maybe<Scalars['String']>;
  /** The meta description. */
  description?: Maybe<Scalars['String']>;
  /** The focus keywords you want to rank for */
  focusKeywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The fully-rendered `head` tag for the given item */
  fullHead?: Maybe<Scalars['String']>;
  /** Whether the item is considered pillar (cornerstone) content */
  isPillarContent?: Maybe<Scalars['Boolean']>;
  /** The JSON+LD data */
  jsonLd?: Maybe<RankMathJsonLd>;
  /** The open graph meta properties. */
  openGraph?: Maybe<RankMathOpenGraphMeta>;
  /** A list of the robots meta properties to output. */
  robots?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The SEO score */
  seoScore?: Maybe<RankMathSeoScore>;
  /** The title. */
  title?: Maybe<Scalars['String']>;
};

/** The attachment post type object SEO data */
export type RankMathMediaItemTypeSeo = RankMathSeo & {
  __typename?: 'RankMathMediaItemTypeSeo';
  /** The title to use in the breadcrumbs for this post */
  breadcrumbTitle?: Maybe<Scalars['String']>;
  /** The breadcrumbs trail for the given object */
  breadcrumbs?: Maybe<Array<Maybe<RankMathBreadcrumbs>>>;
  /** The canonical url. */
  canonicalUrl?: Maybe<Scalars['String']>;
  /** The meta description. */
  description?: Maybe<Scalars['String']>;
  /** The focus keywords you want to rank for */
  focusKeywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The fully-rendered `head` tag for the given item */
  fullHead?: Maybe<Scalars['String']>;
  /** The JSON+LD data */
  jsonLd?: Maybe<RankMathJsonLd>;
  /** The open graph meta properties. */
  openGraph?: Maybe<RankMathOpenGraphMeta>;
  /** A list of the robots meta properties to output. */
  robots?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The title. */
  title?: Maybe<Scalars['String']>;
};

/** The RankMath SEO titles and meta site settings */
export type RankMathMeta = {
  __typename?: 'RankMathMeta';
  /** Author Archive settings. */
  authorArchives?: Maybe<RankMathAuthorArchiveMetaSettings>;
  /** Content type settings. */
  contentTypes?: Maybe<RankMathContentTypeMetaSettings>;
  /** Date Archive settings. */
  dateArchives?: Maybe<RankMathDateArchiveMetaSettings>;
  /** Global settings. */
  global?: Maybe<RankMathGlobalMetaSettings>;
  /** Homepage settings. Only used is the Homepage is set to display a list of posts. */
  homepage?: Maybe<RankMathHomepageMetaSettings>;
  /** Local settings. */
  local?: Maybe<RankMathLocalMetaSettings>;
  /** Title tag on 404 Not Found error page. */
  notFoundTitle?: Maybe<Scalars['String']>;
  /** Title tag on search results page. */
  searchTitle?: Maybe<Scalars['String']>;
  /** Whether to index paginated archive pages from getting. */
  shouldIndexArchiveSubpages?: Maybe<Scalars['Boolean']>;
  /** Whether to index /page/2 and further of any archive. */
  shouldIndexPaginatedPages?: Maybe<Scalars['Boolean']>;
  /** Whether to index password protected pages and posts. */
  shouldIndexPasswordProtected?: Maybe<Scalars['Boolean']>;
  /** Whether to index search result pages. */
  shouldIndexSearch?: Maybe<Scalars['Boolean']>;
  /** Social settings. */
  social?: Maybe<RankMathSocialMetaSettings>;
  /** Taxonomy settings. */
  taxonomies?: Maybe<RankMathTaxonomyMetaSettings>;
};

/** Meta Settings with archive fields. */
export type RankMathMetaSettingWithArchive = {
  /** Description for archive pages. */
  archiveDescription?: Maybe<Scalars['String']>;
  /** Default title tag for archive page. */
  archiveTitle?: Maybe<Scalars['String']>;
};

/** Meta settings with robots fields. */
export type RankMathMetaSettingWithRobots = {
  /** Advanced robots meta tag settings. */
  advancedRobotsMeta?: Maybe<RankMathAdvancedRobotsMeta>;
  /** Custom values for robots meta tag. */
  robotsMeta?: Maybe<Array<Maybe<RankMathRobotsMetaValueEnum>>>;
};

/** The OpenGraph Article meta. */
export type RankMathOpenGraphArticle = {
  __typename?: 'RankMathOpenGraphArticle';
  /** The author. */
  author?: Maybe<Scalars['String']>;
  /** The date modified. */
  modifiedTime?: Maybe<Scalars['String']>;
  /** The date published. */
  publishedTime?: Maybe<Scalars['String']>;
  /** The publisher */
  publisher?: Maybe<Scalars['String']>;
  /** The article category. */
  section?: Maybe<Scalars['String']>;
  /** The article tags. */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** The OpenGraph Facebook meta. */
export type RankMathOpenGraphFacebook = {
  __typename?: 'RankMathOpenGraphFacebook';
  /** The Facebook admins associated with this resource */
  admins?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The Facebook app ID associated with this resource */
  appId?: Maybe<Scalars['ID']>;
};

/** The OpenGraph Image meta. */
export type RankMathOpenGraphImage = {
  __typename?: 'RankMathOpenGraphImage';
  /** Height of image in pixels.  */
  height?: Maybe<Scalars['Float']>;
  /** The https:// URL for the image. */
  secureUrl?: Maybe<Scalars['String']>;
  /** MIME type of the image.  */
  type?: Maybe<Scalars['String']>;
  /** URL for the image. */
  url?: Maybe<Scalars['String']>;
  /** Width of image in pixels. */
  width?: Maybe<Scalars['Float']>;
};

/** The Facebook OpenGraph Locale. */
export enum RankMathOpenGraphLocaleEnum {
  /** af_ZA. */
  AfZa = 'AF_ZA',
  /** ak_GH. */
  AkGh = 'AK_GH',
  /** am_ET. */
  AmEt = 'AM_ET',
  /** ar_AR. */
  ArAr = 'AR_AR',
  /** as_IN. */
  AsIn = 'AS_IN',
  /** ay_BO. */
  AyBo = 'AY_BO',
  /** az_AZ. */
  AzAz = 'AZ_AZ',
  /** be_BY. */
  BeBy = 'BE_BY',
  /** bg_BG. */
  BgBg = 'BG_BG',
  /** bn_IN. */
  BnIn = 'BN_IN',
  /** bp_IN. */
  BpIn = 'BP_IN',
  /** br_FR. */
  BrFr = 'BR_FR',
  /** bs_BA. */
  BsBa = 'BS_BA',
  /** ca_ES. */
  CaEs = 'CA_ES',
  /** cb_IQ. */
  CbIq = 'CB_IQ',
  /** ck_US. */
  CkUs = 'CK_US',
  /** co_FR. */
  CoFr = 'CO_FR',
  /** cs_CZ. */
  CsCz = 'CS_CZ',
  /** cx_PH. */
  CxPh = 'CX_PH',
  /** cy_GB. */
  CyGb = 'CY_GB',
  /** da_DK. */
  DaDk = 'DA_DK',
  /** de_DE. */
  DeDe = 'DE_DE',
  /** el_GR. */
  ElGr = 'EL_GR',
  /** em_ZM. */
  EmZm = 'EM_ZM',
  /** en_GB. */
  EnGb = 'EN_GB',
  /** en_PI. */
  EnPi = 'EN_PI',
  /** en_UD. */
  EnUd = 'EN_UD',
  /** en_US. */
  EnUs = 'EN_US',
  /** eo_EO. */
  EoEo = 'EO_EO',
  /** es_ES. */
  EsEs = 'ES_ES',
  /** es_LA. */
  EsLa = 'ES_LA',
  /** es_MX. */
  EsMx = 'ES_MX',
  /** et_EE. */
  EtEe = 'ET_EE',
  /** eu_ES. */
  EuEs = 'EU_ES',
  /** fa_IR. */
  FaIr = 'FA_IR',
  /** fb_LT. */
  FbLt = 'FB_LT',
  /** ff_NG. */
  FfNg = 'FF_NG',
  /** fi_FI. */
  FiFi = 'FI_FI',
  /** fo_FO. */
  FoFo = 'FO_FO',
  /** fr_CA. */
  FrCa = 'FR_CA',
  /** fr_FR. */
  FrFr = 'FR_FR',
  /** fy_NL. */
  FyNl = 'FY_NL',
  /** ga_IE. */
  GaIe = 'GA_IE',
  /** gl_ES. */
  GlEs = 'GL_ES',
  /** gn_PY. */
  GnPy = 'GN_PY',
  /** gu_IN. */
  GuIn = 'GU_IN',
  /** gx_GR. */
  GxGr = 'GX_GR',
  /** ha_NG. */
  HaNg = 'HA_NG',
  /** he_IL. */
  HeIl = 'HE_IL',
  /** hi_IN. */
  HiIn = 'HI_IN',
  /** hr_HR. */
  HrHr = 'HR_HR',
  /** ht_HT. */
  HtHt = 'HT_HT',
  /** hu_HU. */
  HuHu = 'HU_HU',
  /** hy_AM. */
  HyAm = 'HY_AM',
  /** id_ID. */
  IdId = 'ID_ID',
  /** ig_NG. */
  IgNg = 'IG_NG',
  /** ik_US. */
  IkUs = 'IK_US',
  /** is_IS. */
  IsIs = 'IS_IS',
  /** it_IT. */
  ItIt = 'IT_IT',
  /** iu_CA. */
  IuCa = 'IU_CA',
  /** ja_JP. */
  JaJp = 'JA_JP',
  /** ja_KS. */
  JaKs = 'JA_KS',
  /** jv_ID. */
  JvId = 'JV_ID',
  /** ka_GE. */
  KaGe = 'KA_GE',
  /** kk_KZ. */
  KkKz = 'KK_KZ',
  /** km_KH. */
  KmKh = 'KM_KH',
  /** kn_IN. */
  KnIn = 'KN_IN',
  /** ko_KR. */
  KoKr = 'KO_KR',
  /** ks_IN. */
  KsIn = 'KS_IN',
  /** ku_TR. */
  KuTr = 'KU_TR',
  /** ky_KG. */
  KyKg = 'KY_KG',
  /** la_VA. */
  LaVa = 'LA_VA',
  /** lg_UG. */
  LgUg = 'LG_UG',
  /** li_NL. */
  LiNl = 'LI_NL',
  /** ln_CD. */
  LnCd = 'LN_CD',
  /** lo_LA. */
  LoLa = 'LO_LA',
  /** lt_LT. */
  LtLt = 'LT_LT',
  /** lv_LV. */
  LvLv = 'LV_LV',
  /** mg_MG. */
  MgMg = 'MG_MG',
  /** mi_NZ. */
  MiNz = 'MI_NZ',
  /** mk_MK. */
  MkMk = 'MK_MK',
  /** ml_IN. */
  MlIn = 'ML_IN',
  /** mn_MN. */
  MnMn = 'MN_MN',
  /** mr_IN. */
  MrIn = 'MR_IN',
  /** ms_MY. */
  MsMy = 'MS_MY',
  /** mt_MT. */
  MtMt = 'MT_MT',
  /** my_MM. */
  MyMm = 'MY_MM',
  /** nb_NO. */
  NbNo = 'NB_NO',
  /** nd_ZW. */
  NdZw = 'ND_ZW',
  /** ne_NP. */
  NeNp = 'NE_NP',
  /** nl_BE. */
  NlBe = 'NL_BE',
  /** nl_NL. */
  NlNl = 'NL_NL',
  /** nn_NO. */
  NnNo = 'NN_NO',
  /** nr_ZA. */
  NrZa = 'NR_ZA',
  /** ns_ZA. */
  NsZa = 'NS_ZA',
  /** ny_MW. */
  NyMw = 'NY_MW',
  /** om_ET. */
  OmEt = 'OM_ET',
  /** or_IN. */
  OrIn = 'OR_IN',
  /** pa_IN. */
  PaIn = 'PA_IN',
  /** pl_PL. */
  PlPl = 'PL_PL',
  /** ps_AF. */
  PsAf = 'PS_AF',
  /** pt_BR. */
  PtBr = 'PT_BR',
  /** pt_PT. */
  PtPt = 'PT_PT',
  /** qc_GT. */
  QcGt = 'QC_GT',
  /** qr_GR. */
  QrGr = 'QR_GR',
  /** qu_PE. */
  QuPe = 'QU_PE',
  /** qz_MM. */
  QzMm = 'QZ_MM',
  /** rm_CH. */
  RmCh = 'RM_CH',
  /** ro_RO. */
  RoRo = 'RO_RO',
  /** ru_RU. */
  RuRu = 'RU_RU',
  /** rw_RW. */
  RwRw = 'RW_RW',
  /** sa_IN. */
  SaIn = 'SA_IN',
  /** sc_IT. */
  ScIt = 'SC_IT',
  /** se_NO. */
  SeNo = 'SE_NO',
  /** si_LK. */
  SiLk = 'SI_LK',
  /** sk_SK. */
  SkSk = 'SK_SK',
  /** sl_SI. */
  SlSi = 'SL_SI',
  /** sn_ZW. */
  SnZw = 'SN_ZW',
  /** so_SO. */
  SoSo = 'SO_SO',
  /** sq_AL. */
  SqAl = 'SQ_AL',
  /** sr_RS. */
  SrRs = 'SR_RS',
  /** ss_SZ. */
  SsSz = 'SS_SZ',
  /** st_ZA. */
  StZa = 'ST_ZA',
  /** su_ID. */
  SuId = 'SU_ID',
  /** sv_SE. */
  SvSe = 'SV_SE',
  /** sw_KE. */
  SwKe = 'SW_KE',
  /** sy_SY. */
  SySy = 'SY_SY',
  /** sz_PL. */
  SzPl = 'SZ_PL',
  /** ta_IN. */
  TaIn = 'TA_IN',
  /** te_IN. */
  TeIn = 'TE_IN',
  /** tg_TJ. */
  TgTj = 'TG_TJ',
  /** th_TH. */
  ThTh = 'TH_TH',
  /** tk_TM. */
  TkTm = 'TK_TM',
  /** tl_PH. */
  TlPh = 'TL_PH',
  /** tl_ST. */
  TlSt = 'TL_ST',
  /** tn_BW. */
  TnBw = 'TN_BW',
  /** tr_TR. */
  TrTr = 'TR_TR',
  /** ts_ZA. */
  TsZa = 'TS_ZA',
  /** tt_RU. */
  TtRu = 'TT_RU',
  /** tz_MA. */
  TzMa = 'TZ_MA',
  /** uk_UA. */
  UkUa = 'UK_UA',
  /** ur_PK. */
  UrPk = 'UR_PK',
  /** uz_UZ. */
  UzUz = 'UZ_UZ',
  /** ve_ZA. */
  VeZa = 'VE_ZA',
  /** vi_VN. */
  ViVn = 'VI_VN',
  /** wo_SN. */
  WoSn = 'WO_SN',
  /** xh_ZA. */
  XhZa = 'XH_ZA',
  /** yi_DE. */
  YiDe = 'YI_DE',
  /** yo_NG. */
  YoNg = 'YO_NG',
  /** zh_CN. */
  ZhCn = 'ZH_CN',
  /** zh_HK. */
  ZhHk = 'ZH_HK',
  /** zh_TW. */
  ZhTw = 'ZH_TW',
  /** zu_ZA. */
  ZuZa = 'ZU_ZA',
  /** zz_TR. */
  ZzTr = 'ZZ_TR'
}

/** The OpenGraph meta. */
export type RankMathOpenGraphMeta = {
  __typename?: 'RankMathOpenGraphMeta';
  /** A list of other locales this page is available in */
  alternateLocales?: Maybe<Array<Maybe<RankMathOpenGraphLocaleEnum>>>;
  /** The OpenGraph Article meta. */
  articleMeta?: Maybe<RankMathOpenGraphArticle>;
  /** A brief description of the content, usually between 2 and 4 sentences.  */
  description?: Maybe<Scalars['String']>;
  /** The Facebook OpenGraph meta values. */
  facebookMeta?: Maybe<RankMathOpenGraphFacebook>;
  /** The OpenGraph image meta */
  image?: Maybe<RankMathOpenGraphImage>;
  /** The locale of the resource. */
  locale?: Maybe<RankMathOpenGraphLocaleEnum>;
  /** The Facebook OpenGraph meta values. */
  productMeta?: Maybe<RankMathProduct>;
  /** The name of the site this resource is associated with. */
  siteName?: Maybe<Scalars['String']>;
  /** The Slack Enhanced Data meta values. */
  slackEnhancedData?: Maybe<Array<Maybe<RankMathOpenGraphSlackEnhancedData>>>;
  /** The title of your object as it should appear within the graph. */
  title?: Maybe<Scalars['String']>;
  /** The Twitter OpenGraph meta values. */
  twitterMeta?: Maybe<RankMathOpenGraphTwitter>;
  /** The OpenGraph object type. */
  type?: Maybe<Scalars['String']>;
  /** The updated time */
  updatedTime?: Maybe<Scalars['String']>;
  /** The canonical URL of your object that will be used as its permanent ID in the graph. */
  url?: Maybe<Scalars['String']>;
  /** The Twitter OpenGraph meta values. */
  videoMeta?: Maybe<RankMathOpenGraphVideo>;
};

/** The OpenGraph Product availibility */
export enum RankMathOpenGraphProductAvailabilityEnum {
  /** The product is in stock */
  InStock = 'IN_STOCK',
  /** The product is out of stock */
  OutOfStock = 'OUT_OF_STOCK'
}

/** The Enhanced Data Tags for Slack Sharing. */
export type RankMathOpenGraphSlackEnhancedData = {
  __typename?: 'RankMathOpenGraphSlackEnhancedData';
  /** The Enhanced Data */
  data?: Maybe<Scalars['String']>;
  /** The Enhanced Data label */
  label?: Maybe<Scalars['String']>;
};

/** The OpenGraph Twitter meta. */
export type RankMathOpenGraphTwitter = {
  __typename?: 'RankMathOpenGraphTwitter';
  /** The app country. */
  appCountry?: Maybe<Scalars['String']>;
  /** The Twitter card type */
  card?: Maybe<RankMathTwitterCardTypeEnum>;
  /** @username of content creator */
  creator?: Maybe<Scalars['String']>;
  /** Description of content (maximum 200 characters) */
  description?: Maybe<Scalars['String']>;
  /** The Twitter Google Play app meta */
  googleplayApp?: Maybe<RankMathOpenGraphTwitterApp>;
  /** URL of image to use in the card. */
  image?: Maybe<Scalars['String']>;
  /** The Twitter iPad app meta */
  ipadApp?: Maybe<RankMathOpenGraphTwitterApp>;
  /** The Twitter iPhone app meta */
  iphoneApp?: Maybe<RankMathOpenGraphTwitterApp>;
  /** URL to raw video or audio stream */
  playerStream?: Maybe<Scalars['String']>;
  /** The content type of the stream */
  playerStreamContentType?: Maybe<Scalars['String']>;
  /** URL of the twitter player. */
  playerUrl?: Maybe<Scalars['Int']>;
  /** @username of website */
  site?: Maybe<Scalars['String']>;
  /** Title of content */
  title?: Maybe<Scalars['String']>;
};

/** The OpenGraph Twitter App meta. */
export type RankMathOpenGraphTwitterApp = {
  __typename?: 'RankMathOpenGraphTwitterApp';
  /** The App ID . */
  id?: Maybe<Scalars['ID']>;
  /** The name of the Twitter app. */
  name?: Maybe<Scalars['String']>;
  /** Your app\’s custom URL scheme. */
  url?: Maybe<Scalars['String']>;
};

/** The OpenGraph Video meta. */
export type RankMathOpenGraphVideo = {
  __typename?: 'RankMathOpenGraphVideo';
  /** The duration of the video. */
  duration?: Maybe<Scalars['String']>;
  /** The URL of the video. */
  url?: Maybe<Scalars['String']>;
};

/** The page post object SEO data */
export type RankMathPageObjectSeo = RankMathContentNodeSeo & RankMathSeo & {
  __typename?: 'RankMathPageObjectSeo';
  /** The title to use in the breadcrumbs for this post */
  breadcrumbTitle?: Maybe<Scalars['String']>;
  /** The breadcrumbs trail for the given object */
  breadcrumbs?: Maybe<Array<Maybe<RankMathBreadcrumbs>>>;
  /** The canonical url. */
  canonicalUrl?: Maybe<Scalars['String']>;
  /** The meta description. */
  description?: Maybe<Scalars['String']>;
  /** The focus keywords you want to rank for */
  focusKeywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The fully-rendered `head` tag for the given item */
  fullHead?: Maybe<Scalars['String']>;
  /** Whether the item is considered pillar (cornerstone) content */
  isPillarContent?: Maybe<Scalars['Boolean']>;
  /** The JSON+LD data */
  jsonLd?: Maybe<RankMathJsonLd>;
  /** The open graph meta properties. */
  openGraph?: Maybe<RankMathOpenGraphMeta>;
  /** A list of the robots meta properties to output. */
  robots?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The SEO score */
  seoScore?: Maybe<RankMathSeoScore>;
  /** The title. */
  title?: Maybe<Scalars['String']>;
};

/** The page post type object SEO data */
export type RankMathPageTypeSeo = RankMathSeo & {
  __typename?: 'RankMathPageTypeSeo';
  /** The title to use in the breadcrumbs for this post */
  breadcrumbTitle?: Maybe<Scalars['String']>;
  /** The breadcrumbs trail for the given object */
  breadcrumbs?: Maybe<Array<Maybe<RankMathBreadcrumbs>>>;
  /** The canonical url. */
  canonicalUrl?: Maybe<Scalars['String']>;
  /** The meta description. */
  description?: Maybe<Scalars['String']>;
  /** The focus keywords you want to rank for */
  focusKeywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The fully-rendered `head` tag for the given item */
  fullHead?: Maybe<Scalars['String']>;
  /** The JSON+LD data */
  jsonLd?: Maybe<RankMathJsonLd>;
  /** The open graph meta properties. */
  openGraph?: Maybe<RankMathOpenGraphMeta>;
  /** A list of the robots meta properties to output. */
  robots?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The title. */
  title?: Maybe<Scalars['String']>;
};

/** The post_format term object SEO data */
export type RankMathPostFormatTermSeo = RankMathSeo & {
  __typename?: 'RankMathPostFormatTermSeo';
  /** The title to use in the breadcrumbs for this post */
  breadcrumbTitle?: Maybe<Scalars['String']>;
  /** The breadcrumbs trail for the given object */
  breadcrumbs?: Maybe<Array<Maybe<RankMathBreadcrumbs>>>;
  /** The canonical url. */
  canonicalUrl?: Maybe<Scalars['String']>;
  /** The meta description. */
  description?: Maybe<Scalars['String']>;
  /** The focus keywords you want to rank for */
  focusKeywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The fully-rendered `head` tag for the given item */
  fullHead?: Maybe<Scalars['String']>;
  /** The JSON+LD data */
  jsonLd?: Maybe<RankMathJsonLd>;
  /** The open graph meta properties. */
  openGraph?: Maybe<RankMathOpenGraphMeta>;
  /** A list of the robots meta properties to output. */
  robots?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The title. */
  title?: Maybe<Scalars['String']>;
};

/** The post post object SEO data */
export type RankMathPostObjectSeo = RankMathContentNodeSeo & RankMathSeo & {
  __typename?: 'RankMathPostObjectSeo';
  /** The title to use in the breadcrumbs for this post */
  breadcrumbTitle?: Maybe<Scalars['String']>;
  /** The breadcrumbs trail for the given object */
  breadcrumbs?: Maybe<Array<Maybe<RankMathBreadcrumbs>>>;
  /** The canonical url. */
  canonicalUrl?: Maybe<Scalars['String']>;
  /** The meta description. */
  description?: Maybe<Scalars['String']>;
  /** The focus keywords you want to rank for */
  focusKeywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The fully-rendered `head` tag for the given item */
  fullHead?: Maybe<Scalars['String']>;
  /** Whether the item is considered pillar (cornerstone) content */
  isPillarContent?: Maybe<Scalars['Boolean']>;
  /** The JSON+LD data */
  jsonLd?: Maybe<RankMathJsonLd>;
  /** The open graph meta properties. */
  openGraph?: Maybe<RankMathOpenGraphMeta>;
  /** A list of the robots meta properties to output. */
  robots?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The SEO score */
  seoScore?: Maybe<RankMathSeoScore>;
  /** The title. */
  title?: Maybe<Scalars['String']>;
};

/** The post post type object SEO data */
export type RankMathPostTypeSeo = RankMathSeo & {
  __typename?: 'RankMathPostTypeSeo';
  /** The title to use in the breadcrumbs for this post */
  breadcrumbTitle?: Maybe<Scalars['String']>;
  /** The breadcrumbs trail for the given object */
  breadcrumbs?: Maybe<Array<Maybe<RankMathBreadcrumbs>>>;
  /** The canonical url. */
  canonicalUrl?: Maybe<Scalars['String']>;
  /** The meta description. */
  description?: Maybe<Scalars['String']>;
  /** The focus keywords you want to rank for */
  focusKeywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The fully-rendered `head` tag for the given item */
  fullHead?: Maybe<Scalars['String']>;
  /** The JSON+LD data */
  jsonLd?: Maybe<RankMathJsonLd>;
  /** The open graph meta properties. */
  openGraph?: Maybe<RankMathOpenGraphMeta>;
  /** A list of the robots meta properties to output. */
  robots?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The title. */
  title?: Maybe<Scalars['String']>;
};

/** The OpenGraph Product meta. */
export type RankMathProduct = {
  __typename?: 'RankMathProduct';
  /** The currency of the object price. */
  availability?: Maybe<RankMathOpenGraphProductAvailabilityEnum>;
  /** The brand of the product. */
  brand?: Maybe<Scalars['String']>;
  /** The currency of the object price. */
  currency?: Maybe<Scalars['String']>;
  /** The price of the object */
  price?: Maybe<Scalars['Float']>;
};

/** Robot meta value tag. */
export enum RankMathRobotsMetaValueEnum {
  /** IndexInstructs search engines to index and show these pages in the search results. */
  Index = 'INDEX',
  /** No ArchivePrevents search engines from showing Cached links for pages */
  Noarchive = 'NOARCHIVE',
  /** No FollowPrevents search engines from following links on the pages */
  Nofollow = 'NOFOLLOW',
  /** No Image IndexPrevents images on a page from being indexed by Google and other search engines */
  Noimageindex = 'NOIMAGEINDEX',
  /** No IndexPrevents pages from being indexed and displayed in search engine result pages */
  Noindex = 'NOINDEX',
  /** No SnippetPrevents a snippet from being shown in the search results */
  Nosnippet = 'NOSNIPPET'
}

/** Base SEO fields shared across WP types. */
export type RankMathSeo = {
  /** The title to use in the breadcrumbs for this post */
  breadcrumbTitle?: Maybe<Scalars['String']>;
  /** The breadcrumbs trail for the given object */
  breadcrumbs?: Maybe<Array<Maybe<RankMathBreadcrumbs>>>;
  /** The canonical url. */
  canonicalUrl?: Maybe<Scalars['String']>;
  /** The meta description. */
  description?: Maybe<Scalars['String']>;
  /** The focus keywords you want to rank for */
  focusKeywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The fully-rendered `head` tag for the given item */
  fullHead?: Maybe<Scalars['String']>;
  /** The JSON+LD data */
  jsonLd?: Maybe<RankMathJsonLd>;
  /** The open graph meta properties. */
  openGraph?: Maybe<RankMathOpenGraphMeta>;
  /** A list of the robots meta properties to output. */
  robots?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The title. */
  title?: Maybe<Scalars['String']>;
};

/** The SEO rating */
export enum RankMathSeoRatingEnum {
  /** Bad ( < 50 ) score */
  Bad = 'BAD',
  /** Good (50-79) score */
  Good = 'GOOD',
  /** Great ( > 80 ) score */
  Great = 'GREAT',
  /** Unknown score. */
  Unknown = 'UNKNOWN'
}

/** The Seo score information. */
export type RankMathSeoScore = {
  __typename?: 'RankMathSeoScore';
  /** The html output for the Frontend SEO badge */
  badgeHtml?: Maybe<Scalars['String']>;
  /** Whether the SEO score should be displayed on the frontend */
  hasFrontendScore?: Maybe<Scalars['Boolean']>;
  /** The SEO score */
  rating?: Maybe<RankMathSeoRatingEnum>;
  /** The SEO score */
  score?: Maybe<Scalars['Int']>;
};

/** The frontend SEO Score position */
export enum RankMathSeoScorePositionEnum {
  /** Above & below content */
  Both = 'BOTH',
  /** Below content */
  Bottom = 'BOTTOM',
  /** Custom (use shortcode) */
  Custom = 'CUSTOM',
  /** Above content */
  Top = 'TOP'
}

/** The frontend SEO Score template type */
export enum RankMathSeoScoreTemplateTypeEnum {
  /** Circle template */
  Circle = 'CIRCLE',
  /** Square template */
  Square = 'SQUARE'
}

/** The series term object SEO data */
export type RankMathSeriesTermSeo = RankMathSeo & {
  __typename?: 'RankMathSeriesTermSeo';
  /** The title to use in the breadcrumbs for this post */
  breadcrumbTitle?: Maybe<Scalars['String']>;
  /** The breadcrumbs trail for the given object */
  breadcrumbs?: Maybe<Array<Maybe<RankMathBreadcrumbs>>>;
  /** The canonical url. */
  canonicalUrl?: Maybe<Scalars['String']>;
  /** The meta description. */
  description?: Maybe<Scalars['String']>;
  /** The focus keywords you want to rank for */
  focusKeywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The fully-rendered `head` tag for the given item */
  fullHead?: Maybe<Scalars['String']>;
  /** The JSON+LD data */
  jsonLd?: Maybe<RankMathJsonLd>;
  /** The open graph meta properties. */
  openGraph?: Maybe<RankMathOpenGraphMeta>;
  /** A list of the robots meta properties to output. */
  robots?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The title. */
  title?: Maybe<Scalars['String']>;
};

/** The RankMath SEO site settings */
export type RankMathSettings = {
  __typename?: 'RankMathSettings';
  /** General settings. */
  general?: Maybe<RankMathGeneral>;
  /** Meta settings. */
  meta?: Maybe<RankMathMeta>;
  /** Sitemap settings. */
  sitemap?: Maybe<RankMathSitemap>;
};

/** The RankMath SEO titles and meta site settings */
export type RankMathSitemap = {
  __typename?: 'RankMathSitemap';
  /** Author sitemap settings. Null if authors are not indexable. */
  author?: Maybe<RankMathSitemapAuthorSettings>;
  /** Content types included in the sitemap. */
  contentTypes?: Maybe<Array<Maybe<RankMathSitemapContentTypeSettings>>>;
  /** Sitemap general settings. */
  general?: Maybe<RankMathSitemapGeneralSettings>;
  /** The URL to the sitemap index. */
  sitemapIndexUrl?: Maybe<Scalars['String']>;
  /** Content types included in the sitemap. */
  taxonomies?: Maybe<Array<Maybe<RankMathSitemapTaxonomySettings>>>;
};


/** The RankMath SEO titles and meta site settings */
export type RankMathSitemapContentTypesArgs = {
  include?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
};


/** The RankMath SEO titles and meta site settings */
export type RankMathSitemapTaxonomiesArgs = {
  include?: InputMaybe<Array<InputMaybe<TaxonomyEnum>>>;
};

/** The RankMath SEO Sitemap general settings. */
export type RankMathSitemapAuthorSettings = {
  __typename?: 'RankMathSitemapAuthorSettings';
  /** The connected authors whose URLs are included in the sitemap */
  connectedAuthors?: Maybe<RankMathSitemapAuthorSettingsToUserConnection>;
  /** List of user roles excluded from the sitemap. */
  excludedRoles?: Maybe<Array<Maybe<UserRoleEnum>>>;
  /** List of user IDs excluded from the sitemap. */
  excludedUserDatabaseIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** The sitemap URL. */
  sitemapUrl?: Maybe<Scalars['String']>;
};


/** The RankMath SEO Sitemap general settings. */
export type RankMathSitemapAuthorSettingsConnectedAuthorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Connection between the RankMathSitemapAuthorSettings type and the User type */
export type RankMathSitemapAuthorSettingsToUserConnection = Connection & UserConnection & {
  __typename?: 'RankMathSitemapAuthorSettingsToUserConnection';
  /** Edges for the RankMathSitemapAuthorSettingsToUserConnection connection */
  edges: Array<RankMathSitemapAuthorSettingsToUserConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<User>;
  /** Information about pagination in a connection. */
  pageInfo: RankMathSitemapAuthorSettingsToUserConnectionPageInfo;
};

/** An edge in a connection */
export type RankMathSitemapAuthorSettingsToUserConnectionEdge = Edge & UserConnectionEdge & {
  __typename?: 'RankMathSitemapAuthorSettingsToUserConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: User;
};

/** Page Info on the &quot;RankMathSitemapAuthorSettingsToUserConnection&quot; */
export type RankMathSitemapAuthorSettingsToUserConnectionPageInfo = PageInfo & UserConnectionPageInfo & WpPageInfo & {
  __typename?: 'RankMathSitemapAuthorSettingsToUserConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** The RankMath SEO Sitemap general settings. */
export type RankMathSitemapContentTypeSettings = {
  __typename?: 'RankMathSitemapContentTypeSettings';
  /** The connected authors whose URLs are included in the sitemap */
  connectedContentNodes?: Maybe<RankMathSitemapContentTypeSettingsToContentNodeConnection>;
  /** List of custom field (post meta) names which contain image URLs to include them in the sitemaps. */
  customImageMetaKeys?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Whether the content type is included in the sitemap. */
  isInSitemap?: Maybe<Scalars['Boolean']>;
  /** The sitemap URL. */
  sitemapUrl?: Maybe<Scalars['String']>;
  /** The content type. */
  type?: Maybe<ContentTypeEnum>;
};


/** The RankMath SEO Sitemap general settings. */
export type RankMathSitemapContentTypeSettingsConnectedContentNodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Connection between the RankMathSitemapContentTypeSettings type and the ContentNode type */
export type RankMathSitemapContentTypeSettingsToContentNodeConnection = Connection & ContentNodeConnection & {
  __typename?: 'RankMathSitemapContentTypeSettingsToContentNodeConnection';
  /** Edges for the RankMathSitemapContentTypeSettingsToContentNodeConnection connection */
  edges: Array<RankMathSitemapContentTypeSettingsToContentNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<ContentNode>;
  /** Information about pagination in a connection. */
  pageInfo: RankMathSitemapContentTypeSettingsToContentNodeConnectionPageInfo;
};

/** An edge in a connection */
export type RankMathSitemapContentTypeSettingsToContentNodeConnectionEdge = ContentNodeConnectionEdge & Edge & {
  __typename?: 'RankMathSitemapContentTypeSettingsToContentNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: ContentNode;
};

/** Page Info on the &quot;RankMathSitemapContentTypeSettingsToContentNodeConnection&quot; */
export type RankMathSitemapContentTypeSettingsToContentNodeConnectionPageInfo = ContentNodeConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'RankMathSitemapContentTypeSettingsToContentNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** The RankMath SEO Sitemap general settings. */
export type RankMathSitemapGeneralSettings = {
  __typename?: 'RankMathSitemapGeneralSettings';
  /** Whether to notify search engines when the sitemap is updated. */
  canPingSearchEngines?: Maybe<Scalars['Boolean']>;
  /** A list of post IDs excluded from the sitemap. This option **applies** to all posts types including posts, pages, and custom post types. */
  excludedPostDatabaseIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** A list of term IDs excluded from the sitemap. This option **applies** to all taxonomies. */
  excludedTermDatabaseIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Whether the Featured Image is included in sitemaps too, even if it does not appear directly in the post content. */
  hasFeaturedImage?: Maybe<Scalars['Boolean']>;
  /** Whether reference to images from the post content is included in sitemaps. */
  hasImages?: Maybe<Scalars['Boolean']>;
  /** Max number of links on each sitemap page. */
  linksPerSitemap?: Maybe<Scalars['Int']>;
};

/** The RankMath SEO Sitemap general settings. */
export type RankMathSitemapTaxonomySettings = {
  __typename?: 'RankMathSitemapTaxonomySettings';
  /** The connected authors whose URLs are included in the sitemap */
  connectedTerms?: Maybe<RankMathSitemapTaxonomySettingsToTermNodeConnection>;
  /** Whether to archive pages of terms that have no posts associated. */
  hasEmptyTerms?: Maybe<Scalars['Boolean']>;
  /** Whether the content type is included in the sitemap. */
  isInSitemap?: Maybe<Scalars['Boolean']>;
  /** The sitemap URL. */
  sitemapUrl?: Maybe<Scalars['String']>;
  /** The taxonomy type. */
  type?: Maybe<TaxonomyEnum>;
};


/** The RankMath SEO Sitemap general settings. */
export type RankMathSitemapTaxonomySettingsConnectedTermsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Connection between the RankMathSitemapTaxonomySettings type and the TermNode type */
export type RankMathSitemapTaxonomySettingsToTermNodeConnection = Connection & TermNodeConnection & {
  __typename?: 'RankMathSitemapTaxonomySettingsToTermNodeConnection';
  /** Edges for the RankMathSitemapTaxonomySettingsToTermNodeConnection connection */
  edges: Array<RankMathSitemapTaxonomySettingsToTermNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<TermNode>;
  /** Information about pagination in a connection. */
  pageInfo: RankMathSitemapTaxonomySettingsToTermNodeConnectionPageInfo;
};

/** An edge in a connection */
export type RankMathSitemapTaxonomySettingsToTermNodeConnectionEdge = Edge & TermNodeConnectionEdge & {
  __typename?: 'RankMathSitemapTaxonomySettingsToTermNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: TermNode;
};

/** Page Info on the &quot;RankMathSitemapTaxonomySettingsToTermNodeConnection&quot; */
export type RankMathSitemapTaxonomySettingsToTermNodeConnectionPageInfo = PageInfo & TermNodeConnectionPageInfo & WpPageInfo & {
  __typename?: 'RankMathSitemapTaxonomySettingsToTermNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** The rich snippet type. */
export enum RankMathSnippetTypeEnum {
  /** Article */
  Article = 'ARTICLE',
  /** Book */
  Book = 'BOOK',
  /** Course */
  Course = 'COURSE',
  /** DataSet */
  Dataset = 'DATASET',
  /** Event */
  Event = 'EVENT',
  /** Fact Check */
  Factcheck = 'FACTCHECK',
  /** Job Posting */
  Jobposting = 'JOBPOSTING',
  /** Local Business */
  LocalBusiness = 'LOCAL_BUSINESS',
  /** Movie */
  Movie = 'MOVIE',
  /** Music */
  Music = 'MUSIC',
  /** None (Click here to set one) */
  Off = 'OFF',
  /** Person */
  Person = 'PERSON',
  /** Product */
  Product = 'PRODUCT',
  /** Recipe */
  Recipe = 'RECIPE',
  /** Restaurant */
  Restaurant = 'RESTAURANT',
  /** Service */
  Service = 'SERVICE',
  /** Software Application */
  Software = 'SOFTWARE',
  /** Video */
  Video = 'VIDEO'
}

/** The RankMath SEO Social settings. */
export type RankMathSocialMetaSettings = {
  __typename?: 'RankMathSocialMetaSettings';
  /** A list of numeric Facebook admin User Ids. */
  facebookAdminId?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** The facebook Facebook app ID. */
  facebookAppId?: Maybe<Scalars['Int']>;
  /** The personal Facebook profile URL used to show authorship when articles are shared on Facebook. */
  facebookAuthorUrl?: Maybe<Scalars['String']>;
  /** The complete Facebook page URL. */
  facebookPageUrl?: Maybe<Scalars['String']>;
  /** Twitter Username of the auther used in the `twitter:creater` tag. */
  twitterAuthorName?: Maybe<Scalars['String']>;
};

/** The solutions term object SEO data */
export type RankMathSolutionTermSeo = RankMathSeo & {
  __typename?: 'RankMathSolutionTermSeo';
  /** The title to use in the breadcrumbs for this post */
  breadcrumbTitle?: Maybe<Scalars['String']>;
  /** The breadcrumbs trail for the given object */
  breadcrumbs?: Maybe<Array<Maybe<RankMathBreadcrumbs>>>;
  /** The canonical url. */
  canonicalUrl?: Maybe<Scalars['String']>;
  /** The meta description. */
  description?: Maybe<Scalars['String']>;
  /** The focus keywords you want to rank for */
  focusKeywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The fully-rendered `head` tag for the given item */
  fullHead?: Maybe<Scalars['String']>;
  /** The JSON+LD data */
  jsonLd?: Maybe<RankMathJsonLd>;
  /** The open graph meta properties. */
  openGraph?: Maybe<RankMathOpenGraphMeta>;
  /** A list of the robots meta properties to output. */
  robots?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The title. */
  title?: Maybe<Scalars['String']>;
};

/** The post_tag term object SEO data */
export type RankMathTagTermSeo = RankMathSeo & {
  __typename?: 'RankMathTagTermSeo';
  /** The title to use in the breadcrumbs for this post */
  breadcrumbTitle?: Maybe<Scalars['String']>;
  /** The breadcrumbs trail for the given object */
  breadcrumbs?: Maybe<Array<Maybe<RankMathBreadcrumbs>>>;
  /** The canonical url. */
  canonicalUrl?: Maybe<Scalars['String']>;
  /** The meta description. */
  description?: Maybe<Scalars['String']>;
  /** The focus keywords you want to rank for */
  focusKeywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The fully-rendered `head` tag for the given item */
  fullHead?: Maybe<Scalars['String']>;
  /** The JSON+LD data */
  jsonLd?: Maybe<RankMathJsonLd>;
  /** The open graph meta properties. */
  openGraph?: Maybe<RankMathOpenGraphMeta>;
  /** A list of the robots meta properties to output. */
  robots?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The title. */
  title?: Maybe<Scalars['String']>;
};

/** The RankMath SEO Taxonomy meta settings. */
export type RankMathTaxonomyMetaSettings = {
  __typename?: 'RankMathTaxonomyMetaSettings';
  /** The RankMath SEO meta settings for Categories. */
  category?: Maybe<CategoryMetaSettings>;
  /** The RankMath SEO meta settings for General. */
  general?: Maybe<GeneralMetaSettings>;
  /** The RankMath SEO meta settings for Formats. */
  postFormat?: Maybe<PostFormatMetaSettings>;
  /** The RankMath SEO meta settings for Blog Series. */
  series?: Maybe<SeriesMetaSettings>;
  /** The RankMath SEO meta settings for Solutions. */
  solution?: Maybe<SolutionMetaSettings>;
  /** The RankMath SEO meta settings for Tags. */
  tag?: Maybe<TagMetaSettings>;
  /** The RankMath SEO meta settings for Technologies. */
  technology?: Maybe<TechnologyMetaSettings>;
};

/** The technologies term object SEO data */
export type RankMathTechnologyTermSeo = RankMathSeo & {
  __typename?: 'RankMathTechnologyTermSeo';
  /** The title to use in the breadcrumbs for this post */
  breadcrumbTitle?: Maybe<Scalars['String']>;
  /** The breadcrumbs trail for the given object */
  breadcrumbs?: Maybe<Array<Maybe<RankMathBreadcrumbs>>>;
  /** The canonical url. */
  canonicalUrl?: Maybe<Scalars['String']>;
  /** The meta description. */
  description?: Maybe<Scalars['String']>;
  /** The focus keywords you want to rank for */
  focusKeywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The fully-rendered `head` tag for the given item */
  fullHead?: Maybe<Scalars['String']>;
  /** The JSON+LD data */
  jsonLd?: Maybe<RankMathJsonLd>;
  /** The open graph meta properties. */
  openGraph?: Maybe<RankMathOpenGraphMeta>;
  /** A list of the robots meta properties to output. */
  robots?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The title. */
  title?: Maybe<Scalars['String']>;
};

/** The Twitter Card Type Enum */
export enum RankMathTwitterCardTypeEnum {
  /** The twitter App card */
  App = 'APP',
  /** The twitter Player card */
  Player = 'PLAYER',
  /** Summary Card. */
  Summary = 'SUMMARY',
  /** Summary Card with Large Image. */
  SummaryLargeImage = 'SUMMARY_LARGE_IMAGE'
}

/** The user object SEO data */
export type RankMathUserSeo = RankMathSeo & {
  __typename?: 'RankMathUserSeo';
  /** The title to use in the breadcrumbs for this post */
  breadcrumbTitle?: Maybe<Scalars['String']>;
  /** The breadcrumbs trail for the given object */
  breadcrumbs?: Maybe<Array<Maybe<RankMathBreadcrumbs>>>;
  /** The canonical url. */
  canonicalUrl?: Maybe<Scalars['String']>;
  /** The meta description. */
  description?: Maybe<Scalars['String']>;
  /** The focus keywords you want to rank for */
  focusKeywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The fully-rendered `head` tag for the given item */
  fullHead?: Maybe<Scalars['String']>;
  /** The JSON+LD data */
  jsonLd?: Maybe<RankMathJsonLd>;
  /** The open graph meta properties. */
  openGraph?: Maybe<RankMathOpenGraphMeta>;
  /** A list of the robots meta properties to output. */
  robots?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The title. */
  title?: Maybe<Scalars['String']>;
};

/** The RankMath SEO Webmaster Tools settings */
export type RankMathWebmaster = {
  __typename?: 'RankMathWebmaster';
  /** The Baidu Webmaster Tools verification HTML code or ID. */
  baidu?: Maybe<Scalars['String']>;
  /** The Bing Webmaster Tools verification HTML code or ID. */
  bing?: Maybe<Scalars['String']>;
  /** The Google Search Console verification HTML code or ID. */
  google?: Maybe<Scalars['String']>;
  /** The Norton Safe Web verification HTML code or ID. */
  norton?: Maybe<Scalars['String']>;
  /** The Pinterest verification HTML code or ID. */
  pinterest?: Maybe<Scalars['String']>;
  /** The Yandex verification HTML code or ID. */
  yandex?: Maybe<Scalars['String']>;
};

/** The reading setting type */
export type ReadingSettings = {
  __typename?: 'ReadingSettings';
  /** The ID of the page that should display the latest posts */
  pageForPosts?: Maybe<Scalars['Int']>;
  /** The ID of the page that should be displayed on the front page */
  pageOnFront?: Maybe<Scalars['Int']>;
  /** Blog pages show at most. */
  postsPerPage?: Maybe<Scalars['Int']>;
  /** Whether or not the search engine discovery is enabled */
  searchEngineDiscovery?: Maybe<Scalars['Boolean']>;
  /** What to show on the front page */
  showOnFront?: Maybe<Scalars['String']>;
};

/** Input for the registerUser mutation. */
export type RegisterUserInput = {
  /** User's AOL IM account. */
  aim?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** A string containing content about the user. */
  description?: InputMaybe<Scalars['String']>;
  /** A string that will be shown on the site. Defaults to user's username. It is likely that you will want to change this, for both appearance and security through obscurity (that is if you dont use and delete the default admin user). */
  displayName?: InputMaybe<Scalars['String']>;
  /** A string containing the user's email address. */
  email?: InputMaybe<Scalars['String']>;
  /** 	The user's first name. */
  firstName?: InputMaybe<Scalars['String']>;
  /** User's Jabber account. */
  jabber?: InputMaybe<Scalars['String']>;
  /** The user's last name. */
  lastName?: InputMaybe<Scalars['String']>;
  /** User's locale. */
  locale?: InputMaybe<Scalars['String']>;
  /** A string that contains a URL-friendly name for the user. The default is the user's username. */
  nicename?: InputMaybe<Scalars['String']>;
  /** The user's nickname, defaults to the user's username. */
  nickname?: InputMaybe<Scalars['String']>;
  /** A string that contains the plain text password for the user. */
  password?: InputMaybe<Scalars['String']>;
  /** The date the user registered. Format is Y-m-d H:i:s. */
  registered?: InputMaybe<Scalars['String']>;
  /** A string for whether to enable the rich editor or not. False if not empty. */
  richEditing?: InputMaybe<Scalars['String']>;
  /** A string that contains the user's username. */
  username: Scalars['String'];
  /** A string containing the user's URL for the user's web site. */
  websiteUrl?: InputMaybe<Scalars['String']>;
  /** User's Yahoo IM account. */
  yim?: InputMaybe<Scalars['String']>;
};

/** The payload for the registerUser mutation. */
export type RegisterUserPayload = {
  __typename?: 'RegisterUserPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The User object mutation type. */
  user?: Maybe<User>;
};

/** The logical relation between each item in the array when there are more than one. */
export enum RelationEnum {
  /** The logical AND condition returns true if both operands are true, otherwise, it returns false. */
  And = 'AND',
  /** The logical OR condition returns false if both operands are false, otherwise, it returns true. */
  Or = 'OR'
}

/** Input for the resetUserPassword mutation. */
export type ResetUserPasswordInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Password reset key */
  key?: InputMaybe<Scalars['String']>;
  /** The user's login (username). */
  login?: InputMaybe<Scalars['String']>;
  /** The new password. */
  password?: InputMaybe<Scalars['String']>;
};

/** The payload for the resetUserPassword mutation. */
export type ResetUserPasswordPayload = {
  __typename?: 'ResetUserPasswordPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The User object mutation type. */
  user?: Maybe<User>;
};

/** Input for the restoreComment mutation. */
export type RestoreCommentInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the comment to be restored */
  id: Scalars['ID'];
};

/** The payload for the restoreComment mutation. */
export type RestoreCommentPayload = {
  __typename?: 'RestoreCommentPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The restored comment object */
  comment?: Maybe<Comment>;
  /** The ID of the restored comment */
  restoredId?: Maybe<Scalars['ID']>;
};

/** The root mutation */
export type RootMutation = {
  __typename?: 'RootMutation';
  /** The createCategory mutation */
  createCategory?: Maybe<CreateCategoryPayload>;
  /** The createComment mutation */
  createComment?: Maybe<CreateCommentPayload>;
  /** The createGeneral mutation */
  createGeneral?: Maybe<CreateGeneralPayload>;
  /** The createMediaItem mutation */
  createMediaItem?: Maybe<CreateMediaItemPayload>;
  /** The createPage mutation */
  createPage?: Maybe<CreatePagePayload>;
  /** The createPost mutation */
  createPost?: Maybe<CreatePostPayload>;
  /** The createPostFormat mutation */
  createPostFormat?: Maybe<CreatePostFormatPayload>;
  /** The createSeries mutation */
  createSeries?: Maybe<CreateSeriesPayload>;
  /** The createSolution mutation */
  createSolution?: Maybe<CreateSolutionPayload>;
  /** The createTag mutation */
  createTag?: Maybe<CreateTagPayload>;
  /** The createTechnology mutation */
  createTechnology?: Maybe<CreateTechnologyPayload>;
  /** The createUser mutation */
  createUser?: Maybe<CreateUserPayload>;
  /** The deleteCategory mutation */
  deleteCategory?: Maybe<DeleteCategoryPayload>;
  /** The deleteComment mutation */
  deleteComment?: Maybe<DeleteCommentPayload>;
  /** The deleteGeneral mutation */
  deleteGeneral?: Maybe<DeleteGeneralPayload>;
  /** The deleteMediaItem mutation */
  deleteMediaItem?: Maybe<DeleteMediaItemPayload>;
  /** The deletePage mutation */
  deletePage?: Maybe<DeletePagePayload>;
  /** The deletePost mutation */
  deletePost?: Maybe<DeletePostPayload>;
  /** The deletePostFormat mutation */
  deletePostFormat?: Maybe<DeletePostFormatPayload>;
  /** The deleteSeries mutation */
  deleteSeries?: Maybe<DeleteSeriesPayload>;
  /** The deleteSolution mutation */
  deleteSolution?: Maybe<DeleteSolutionPayload>;
  /** The deleteTag mutation */
  deleteTag?: Maybe<DeleteTagPayload>;
  /** The deleteTechnology mutation */
  deleteTechnology?: Maybe<DeleteTechnologyPayload>;
  /** The deleteUser mutation */
  deleteUser?: Maybe<DeleteUserPayload>;
  /** Increase the count. */
  increaseCount?: Maybe<Scalars['Int']>;
  /** The registerUser mutation */
  registerUser?: Maybe<RegisterUserPayload>;
  /** The resetUserPassword mutation */
  resetUserPassword?: Maybe<ResetUserPasswordPayload>;
  /** The restoreComment mutation */
  restoreComment?: Maybe<RestoreCommentPayload>;
  /** Send password reset email to user */
  sendPasswordResetEmail?: Maybe<SendPasswordResetEmailPayload>;
  /** The updateCategory mutation */
  updateCategory?: Maybe<UpdateCategoryPayload>;
  /** The updateComment mutation */
  updateComment?: Maybe<UpdateCommentPayload>;
  /** The updateGeneral mutation */
  updateGeneral?: Maybe<UpdateGeneralPayload>;
  /** The updateMediaItem mutation */
  updateMediaItem?: Maybe<UpdateMediaItemPayload>;
  /** The updatePage mutation */
  updatePage?: Maybe<UpdatePagePayload>;
  /** The updatePost mutation */
  updatePost?: Maybe<UpdatePostPayload>;
  /** The updatePostFormat mutation */
  updatePostFormat?: Maybe<UpdatePostFormatPayload>;
  /** The updateSeries mutation */
  updateSeries?: Maybe<UpdateSeriesPayload>;
  /** The updateSettings mutation */
  updateSettings?: Maybe<UpdateSettingsPayload>;
  /** The updateSolution mutation */
  updateSolution?: Maybe<UpdateSolutionPayload>;
  /** The updateTag mutation */
  updateTag?: Maybe<UpdateTagPayload>;
  /** The updateTechnology mutation */
  updateTechnology?: Maybe<UpdateTechnologyPayload>;
  /** The updateUser mutation */
  updateUser?: Maybe<UpdateUserPayload>;
};


/** The root mutation */
export type RootMutationCreateCategoryArgs = {
  input: CreateCategoryInput;
};


/** The root mutation */
export type RootMutationCreateCommentArgs = {
  input: CreateCommentInput;
};


/** The root mutation */
export type RootMutationCreateGeneralArgs = {
  input: CreateGeneralInput;
};


/** The root mutation */
export type RootMutationCreateMediaItemArgs = {
  input: CreateMediaItemInput;
};


/** The root mutation */
export type RootMutationCreatePageArgs = {
  input: CreatePageInput;
};


/** The root mutation */
export type RootMutationCreatePostArgs = {
  input: CreatePostInput;
};


/** The root mutation */
export type RootMutationCreatePostFormatArgs = {
  input: CreatePostFormatInput;
};


/** The root mutation */
export type RootMutationCreateSeriesArgs = {
  input: CreateSeriesInput;
};


/** The root mutation */
export type RootMutationCreateSolutionArgs = {
  input: CreateSolutionInput;
};


/** The root mutation */
export type RootMutationCreateTagArgs = {
  input: CreateTagInput;
};


/** The root mutation */
export type RootMutationCreateTechnologyArgs = {
  input: CreateTechnologyInput;
};


/** The root mutation */
export type RootMutationCreateUserArgs = {
  input: CreateUserInput;
};


/** The root mutation */
export type RootMutationDeleteCategoryArgs = {
  input: DeleteCategoryInput;
};


/** The root mutation */
export type RootMutationDeleteCommentArgs = {
  input: DeleteCommentInput;
};


/** The root mutation */
export type RootMutationDeleteGeneralArgs = {
  input: DeleteGeneralInput;
};


/** The root mutation */
export type RootMutationDeleteMediaItemArgs = {
  input: DeleteMediaItemInput;
};


/** The root mutation */
export type RootMutationDeletePageArgs = {
  input: DeletePageInput;
};


/** The root mutation */
export type RootMutationDeletePostArgs = {
  input: DeletePostInput;
};


/** The root mutation */
export type RootMutationDeletePostFormatArgs = {
  input: DeletePostFormatInput;
};


/** The root mutation */
export type RootMutationDeleteSeriesArgs = {
  input: DeleteSeriesInput;
};


/** The root mutation */
export type RootMutationDeleteSolutionArgs = {
  input: DeleteSolutionInput;
};


/** The root mutation */
export type RootMutationDeleteTagArgs = {
  input: DeleteTagInput;
};


/** The root mutation */
export type RootMutationDeleteTechnologyArgs = {
  input: DeleteTechnologyInput;
};


/** The root mutation */
export type RootMutationDeleteUserArgs = {
  input: DeleteUserInput;
};


/** The root mutation */
export type RootMutationIncreaseCountArgs = {
  count?: InputMaybe<Scalars['Int']>;
};


/** The root mutation */
export type RootMutationRegisterUserArgs = {
  input: RegisterUserInput;
};


/** The root mutation */
export type RootMutationResetUserPasswordArgs = {
  input: ResetUserPasswordInput;
};


/** The root mutation */
export type RootMutationRestoreCommentArgs = {
  input: RestoreCommentInput;
};


/** The root mutation */
export type RootMutationSendPasswordResetEmailArgs = {
  input: SendPasswordResetEmailInput;
};


/** The root mutation */
export type RootMutationUpdateCategoryArgs = {
  input: UpdateCategoryInput;
};


/** The root mutation */
export type RootMutationUpdateCommentArgs = {
  input: UpdateCommentInput;
};


/** The root mutation */
export type RootMutationUpdateGeneralArgs = {
  input: UpdateGeneralInput;
};


/** The root mutation */
export type RootMutationUpdateMediaItemArgs = {
  input: UpdateMediaItemInput;
};


/** The root mutation */
export type RootMutationUpdatePageArgs = {
  input: UpdatePageInput;
};


/** The root mutation */
export type RootMutationUpdatePostArgs = {
  input: UpdatePostInput;
};


/** The root mutation */
export type RootMutationUpdatePostFormatArgs = {
  input: UpdatePostFormatInput;
};


/** The root mutation */
export type RootMutationUpdateSeriesArgs = {
  input: UpdateSeriesInput;
};


/** The root mutation */
export type RootMutationUpdateSettingsArgs = {
  input: UpdateSettingsInput;
};


/** The root mutation */
export type RootMutationUpdateSolutionArgs = {
  input: UpdateSolutionInput;
};


/** The root mutation */
export type RootMutationUpdateTagArgs = {
  input: UpdateTagInput;
};


/** The root mutation */
export type RootMutationUpdateTechnologyArgs = {
  input: UpdateTechnologyInput;
};


/** The root mutation */
export type RootMutationUpdateUserArgs = {
  input: UpdateUserInput;
};

/** The root entry point into the Graph */
export type RootQuery = {
  __typename?: 'RootQuery';
  /** Blog Homepage Options options. */
  acfOptionsBlogHomepageOptions?: Maybe<AcfOptionsBlogHomepageOptions>;
  /** Blog Search Results Options options. */
  acfOptionsBlogSearchResultsOptions?: Maybe<AcfOptionsBlogSearchResultsOptions>;
  /** Connection between the RootQuery type and the general type */
  allGeneral?: Maybe<RootQueryToGeneralConnection>;
  /** Connection between the RootQuery type and the series type */
  allSeries?: Maybe<RootQueryToSeriesConnection>;
  /** Entry point to get all settings for the site */
  allSettings?: Maybe<Settings>;
  /** Connection between the RootQuery type and the category type */
  categories?: Maybe<RootQueryToCategoryConnection>;
  /** A 0bject */
  category?: Maybe<Category>;
  /** Returns a Comment */
  comment?: Maybe<Comment>;
  /** Connection between the RootQuery type and the Comment type */
  comments?: Maybe<RootQueryToCommentConnection>;
  /** A node used to manage content */
  contentNode?: Maybe<ContentNode>;
  /** Connection between the RootQuery type and the ContentNode type */
  contentNodes?: Maybe<RootQueryToContentNodeConnection>;
  /** Fetch a Content Type node by unique Identifier */
  contentType?: Maybe<ContentType>;
  /** Connection between the RootQuery type and the ContentType type */
  contentTypes?: Maybe<RootQueryToContentTypeConnection>;
  /** Fields of the &#039;DiscussionSettings&#039; settings group */
  discussionSettings?: Maybe<DiscussionSettings>;
  /** Detailed debug info about filter processing */
  filterDebugDetailed?: Maybe<Scalars['String']>;
  /** Final query args debug info */
  filterDebugFinal?: Maybe<Scalars['String']>;
  /** Debug info about filter calls */
  filterDebugInfo?: Maybe<Scalars['String']>;
  /** A 0bject */
  general?: Maybe<General>;
  /** Fields of the &#039;GeneralSettings&#039; settings group */
  generalSettings?: Maybe<GeneralSettings>;
  /** An object of the mediaItem Type.  */
  mediaItem?: Maybe<MediaItem>;
  /**
   * A mediaItem object
   * @deprecated Deprecated in favor of using the single entry point for this type with ID and IDType fields. For example, instead of postBy( id: &quot;&quot; ), use post(id: &quot;&quot; idType: &quot;&quot;)
   */
  mediaItemBy?: Maybe<MediaItem>;
  /** Connection between the RootQuery type and the mediaItem type */
  mediaItems?: Maybe<RootQueryToMediaItemConnection>;
  /** A WordPress navigation menu */
  menu?: Maybe<Menu>;
  /** A WordPress navigation menu item */
  menuItem?: Maybe<MenuItem>;
  /** Connection between the RootQuery type and the MenuItem type */
  menuItems?: Maybe<RootQueryToMenuItemConnection>;
  /** Connection between the RootQuery type and the Menu type */
  menus?: Maybe<RootQueryToMenuConnection>;
  /** Fetches an object given its ID */
  node?: Maybe<Node>;
  /** Fetches an object given its Unique Resource Identifier */
  nodeByUri?: Maybe<UniformResourceIdentifiable>;
  /** An object of the page Type.  */
  page?: Maybe<Page>;
  /**
   * A page object
   * @deprecated Deprecated in favor of using the single entry point for this type with ID and IDType fields. For example, instead of postBy( id: &quot;&quot; ), use post(id: &quot;&quot; idType: &quot;&quot;)
   */
  pageBy?: Maybe<Page>;
  /** Connection between the RootQuery type and the page type */
  pages?: Maybe<RootQueryToPageConnection>;
  /** A WordPress plugin */
  plugin?: Maybe<Plugin>;
  /** Connection between the RootQuery type and the Plugin type */
  plugins?: Maybe<RootQueryToPluginConnection>;
  /** An object of the post Type.  */
  post?: Maybe<Post>;
  /**
   * A post object
   * @deprecated Deprecated in favor of using the single entry point for this type with ID and IDType fields. For example, instead of postBy( id: &quot;&quot; ), use post(id: &quot;&quot; idType: &quot;&quot;)
   */
  postBy?: Maybe<Post>;
  /** A 0bject */
  postFormat?: Maybe<PostFormat>;
  /** Connection between the RootQuery type and the postFormat type */
  postFormats?: Maybe<RootQueryToPostFormatConnection>;
  /** Connection between the RootQuery type and the post type */
  posts?: Maybe<RootQueryToPostConnection>;
  /** RankMath SEO site settings */
  rankMathSettings?: Maybe<RankMathSettings>;
  /** Fields of the &#039;ReadingSettings&#039; settings group */
  readingSettings?: Maybe<ReadingSettings>;
  /** Connection between the RootQuery type and the EnqueuedScript type */
  registeredScripts?: Maybe<RootQueryToEnqueuedScriptConnection>;
  /** Connection between the RootQuery type and the EnqueuedStylesheet type */
  registeredStylesheets?: Maybe<RootQueryToEnqueuedStylesheetConnection>;
  /** Connection between the RootQuery type and the ContentNode type */
  revisions?: Maybe<RootQueryToRevisionsConnection>;
  /** A 0bject */
  series?: Maybe<Series>;
  /** A 0bject */
  solution?: Maybe<Solution>;
  /** Connection between the RootQuery type and the solution type */
  solutions?: Maybe<RootQueryToSolutionConnection>;
  /** A 0bject */
  tag?: Maybe<Tag>;
  /** Connection between the RootQuery type and the tag type */
  tags?: Maybe<RootQueryToTagConnection>;
  /** Connection between the RootQuery type and the Taxonomy type */
  taxonomies?: Maybe<RootQueryToTaxonomyConnection>;
  /** Fetch a Taxonomy node by unique Identifier */
  taxonomy?: Maybe<Taxonomy>;
  /** Connection between the RootQuery type and the technology type */
  technologies?: Maybe<RootQueryToTechnologyConnection>;
  /** A 0bject */
  technology?: Maybe<Technology>;
  /** A node in a taxonomy used to group and relate content nodes */
  termNode?: Maybe<TermNode>;
  /** Connection between the RootQuery type and the TermNode type */
  terms?: Maybe<RootQueryToTermNodeConnection>;
  /** Test if term 419 exists and has posts */
  testTerm419?: Maybe<Scalars['String']>;
  /** A Theme object */
  theme?: Maybe<Theme>;
  /** Connection between the RootQuery type and the Theme type */
  themes?: Maybe<RootQueryToThemeConnection>;
  /** Returns a user */
  user?: Maybe<User>;
  /** Returns a user role */
  userRole?: Maybe<UserRole>;
  /** Connection between the RootQuery type and the UserRole type */
  userRoles?: Maybe<RootQueryToUserRoleConnection>;
  /** Connection between the RootQuery type and the User type */
  users?: Maybe<RootQueryToUserConnection>;
  /** Returns the current user */
  viewer?: Maybe<User>;
  /** Fields of the &#039;WritingSettings&#039; settings group */
  writingSettings?: Maybe<WritingSettings>;
};


/** The root entry point into the Graph */
export type RootQueryAllGeneralArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToGeneralConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryAllSeriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToSeriesConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToCategoryConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryCategoryArgs = {
  id: Scalars['ID'];
  idType?: InputMaybe<CategoryIdType>;
};


/** The root entry point into the Graph */
export type RootQueryCommentArgs = {
  id: Scalars['ID'];
  idType?: InputMaybe<CommentNodeIdTypeEnum>;
};


/** The root entry point into the Graph */
export type RootQueryCommentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToCommentConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryContentNodeArgs = {
  asPreview?: InputMaybe<Scalars['Boolean']>;
  contentType?: InputMaybe<ContentTypeEnum>;
  id: Scalars['ID'];
  idType?: InputMaybe<ContentNodeIdTypeEnum>;
};


/** The root entry point into the Graph */
export type RootQueryContentNodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToContentNodeConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryContentTypeArgs = {
  id: Scalars['ID'];
  idType?: InputMaybe<ContentTypeIdTypeEnum>;
};


/** The root entry point into the Graph */
export type RootQueryContentTypesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The root entry point into the Graph */
export type RootQueryGeneralArgs = {
  id: Scalars['ID'];
  idType?: InputMaybe<GeneralIdType>;
};


/** The root entry point into the Graph */
export type RootQueryMediaItemArgs = {
  asPreview?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  idType?: InputMaybe<MediaItemIdType>;
};


/** The root entry point into the Graph */
export type RootQueryMediaItemByArgs = {
  id?: InputMaybe<Scalars['ID']>;
  mediaItemId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  uri?: InputMaybe<Scalars['String']>;
};


/** The root entry point into the Graph */
export type RootQueryMediaItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToMediaItemConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryMenuArgs = {
  id: Scalars['ID'];
  idType?: InputMaybe<MenuNodeIdTypeEnum>;
};


/** The root entry point into the Graph */
export type RootQueryMenuItemArgs = {
  id: Scalars['ID'];
  idType?: InputMaybe<MenuItemNodeIdTypeEnum>;
};


/** The root entry point into the Graph */
export type RootQueryMenuItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToMenuItemConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryMenusArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToMenuConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryNodeArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


/** The root entry point into the Graph */
export type RootQueryNodeByUriArgs = {
  uri: Scalars['String'];
};


/** The root entry point into the Graph */
export type RootQueryPageArgs = {
  asPreview?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  idType?: InputMaybe<PageIdType>;
};


/** The root entry point into the Graph */
export type RootQueryPageByArgs = {
  id?: InputMaybe<Scalars['ID']>;
  pageId?: InputMaybe<Scalars['Int']>;
  uri?: InputMaybe<Scalars['String']>;
};


/** The root entry point into the Graph */
export type RootQueryPagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToPageConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryPluginArgs = {
  id: Scalars['ID'];
};


/** The root entry point into the Graph */
export type RootQueryPluginsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToPluginConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryPostArgs = {
  asPreview?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  idType?: InputMaybe<PostIdType>;
};


/** The root entry point into the Graph */
export type RootQueryPostByArgs = {
  id?: InputMaybe<Scalars['ID']>;
  postId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  uri?: InputMaybe<Scalars['String']>;
};


/** The root entry point into the Graph */
export type RootQueryPostFormatArgs = {
  id: Scalars['ID'];
  idType?: InputMaybe<PostFormatIdType>;
};


/** The root entry point into the Graph */
export type RootQueryPostFormatsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToPostFormatConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryPostsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToPostConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryRegisteredScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The root entry point into the Graph */
export type RootQueryRegisteredStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The root entry point into the Graph */
export type RootQueryRevisionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToRevisionsConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQuerySeriesArgs = {
  id: Scalars['ID'];
  idType?: InputMaybe<SeriesIdType>;
};


/** The root entry point into the Graph */
export type RootQuerySolutionArgs = {
  id: Scalars['ID'];
  idType?: InputMaybe<SolutionIdType>;
};


/** The root entry point into the Graph */
export type RootQuerySolutionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToSolutionConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryTagArgs = {
  id: Scalars['ID'];
  idType?: InputMaybe<TagIdType>;
};


/** The root entry point into the Graph */
export type RootQueryTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToTagConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryTaxonomiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The root entry point into the Graph */
export type RootQueryTaxonomyArgs = {
  id: Scalars['ID'];
  idType?: InputMaybe<TaxonomyIdTypeEnum>;
};


/** The root entry point into the Graph */
export type RootQueryTechnologiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToTechnologyConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryTechnologyArgs = {
  id: Scalars['ID'];
  idType?: InputMaybe<TechnologyIdType>;
};


/** The root entry point into the Graph */
export type RootQueryTermNodeArgs = {
  id: Scalars['ID'];
  idType?: InputMaybe<TermNodeIdTypeEnum>;
  taxonomy?: InputMaybe<TaxonomyEnum>;
};


/** The root entry point into the Graph */
export type RootQueryTermsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToTermNodeConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryThemeArgs = {
  id: Scalars['ID'];
};


/** The root entry point into the Graph */
export type RootQueryThemesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The root entry point into the Graph */
export type RootQueryUserArgs = {
  id: Scalars['ID'];
  idType?: InputMaybe<UserNodeIdTypeEnum>;
};


/** The root entry point into the Graph */
export type RootQueryUserRoleArgs = {
  id: Scalars['ID'];
};


/** The root entry point into the Graph */
export type RootQueryUserRolesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The root entry point into the Graph */
export type RootQueryUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToUserConnectionWhereArgs>;
};

/** Connection between the RootQuery type and the category type */
export type RootQueryToCategoryConnection = CategoryConnection & Connection & {
  __typename?: 'RootQueryToCategoryConnection';
  /** Edges for the RootQueryToCategoryConnection connection */
  edges: Array<RootQueryToCategoryConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Category>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToCategoryConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToCategoryConnectionEdge = CategoryConnectionEdge & Edge & {
  __typename?: 'RootQueryToCategoryConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Category;
};

/** Page Info on the &quot;RootQueryToCategoryConnection&quot; */
export type RootQueryToCategoryConnectionPageInfo = CategoryConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'RootQueryToCategoryConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the RootQueryToCategoryConnection connection */
export type RootQueryToCategoryConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the RootQuery type and the Comment type */
export type RootQueryToCommentConnection = CommentConnection & Connection & {
  __typename?: 'RootQueryToCommentConnection';
  /** Edges for the RootQueryToCommentConnection connection */
  edges: Array<RootQueryToCommentConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Comment>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToCommentConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToCommentConnectionEdge = CommentConnectionEdge & Edge & {
  __typename?: 'RootQueryToCommentConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Comment;
};

/** Page Info on the &quot;RootQueryToCommentConnection&quot; */
export type RootQueryToCommentConnectionPageInfo = CommentConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'RootQueryToCommentConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the RootQueryToCommentConnection connection */
export type RootQueryToCommentConnectionWhereArgs = {
  /** Comment author email address. */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** Array of author IDs to include comments for. */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to exclude comments for. */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Comment author URL. */
  authorUrl?: InputMaybe<Scalars['String']>;
  /** Array of comment IDs to include. */
  commentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  commentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Include comments of a given type. */
  commentType?: InputMaybe<Scalars['String']>;
  /** Include comments from a given array of comment types. */
  commentTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude comments from a given array of comment types. */
  commentTypeNotIn?: InputMaybe<Scalars['String']>;
  /** Content object author ID to limit results by. */
  contentAuthor?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to retrieve comments for. */
  contentAuthorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  contentAuthorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  contentId?: InputMaybe<Scalars['ID']>;
  /** Array of content object IDs to include affiliated comments for. */
  contentIdIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  contentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  contentName?: InputMaybe<Scalars['String']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  contentParent?: InputMaybe<Scalars['Int']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentStatus?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentType?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  includeUnapproved?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Karma score to retrieve matching comments for. */
  karma?: InputMaybe<Scalars['Int']>;
  /** The cardinality of the order of the connection */
  order?: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  orderby?: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Array of parent IDs of comments to retrieve children for. */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Search term(s) to retrieve matching comments for. */
  search?: InputMaybe<Scalars['String']>;
  /** Comment status to limit results by. */
  status?: InputMaybe<Scalars['String']>;
  /** Include comments for a specific user ID. */
  userId?: InputMaybe<Scalars['ID']>;
};

/** Connection between the RootQuery type and the ContentNode type */
export type RootQueryToContentNodeConnection = Connection & ContentNodeConnection & {
  __typename?: 'RootQueryToContentNodeConnection';
  /** Edges for the RootQueryToContentNodeConnection connection */
  edges: Array<RootQueryToContentNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<ContentNode>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToContentNodeConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToContentNodeConnectionEdge = ContentNodeConnectionEdge & Edge & {
  __typename?: 'RootQueryToContentNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: ContentNode;
};

/** Page Info on the &quot;RootQueryToContentNodeConnection&quot; */
export type RootQueryToContentNodeConnectionPageInfo = ContentNodeConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'RootQueryToContentNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the RootQueryToContentNodeConnection connection */
export type RootQueryToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Paginate content nodes with offsets */
  offsetPagination?: InputMaybe<OffsetPagination>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the RootQuery type and the ContentType type */
export type RootQueryToContentTypeConnection = Connection & ContentTypeConnection & {
  __typename?: 'RootQueryToContentTypeConnection';
  /** Edges for the RootQueryToContentTypeConnection connection */
  edges: Array<RootQueryToContentTypeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<ContentType>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToContentTypeConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToContentTypeConnectionEdge = ContentTypeConnectionEdge & Edge & {
  __typename?: 'RootQueryToContentTypeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: ContentType;
};

/** Page Info on the &quot;RootQueryToContentTypeConnection&quot; */
export type RootQueryToContentTypeConnectionPageInfo = ContentTypeConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'RootQueryToContentTypeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Connection between the RootQuery type and the EnqueuedScript type */
export type RootQueryToEnqueuedScriptConnection = Connection & EnqueuedScriptConnection & {
  __typename?: 'RootQueryToEnqueuedScriptConnection';
  /** Edges for the RootQueryToEnqueuedScriptConnection connection */
  edges: Array<RootQueryToEnqueuedScriptConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<EnqueuedScript>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToEnqueuedScriptConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToEnqueuedScriptConnectionEdge = Edge & EnqueuedScriptConnectionEdge & {
  __typename?: 'RootQueryToEnqueuedScriptConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: EnqueuedScript;
};

/** Page Info on the &quot;RootQueryToEnqueuedScriptConnection&quot; */
export type RootQueryToEnqueuedScriptConnectionPageInfo = EnqueuedScriptConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'RootQueryToEnqueuedScriptConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Connection between the RootQuery type and the EnqueuedStylesheet type */
export type RootQueryToEnqueuedStylesheetConnection = Connection & EnqueuedStylesheetConnection & {
  __typename?: 'RootQueryToEnqueuedStylesheetConnection';
  /** Edges for the RootQueryToEnqueuedStylesheetConnection connection */
  edges: Array<RootQueryToEnqueuedStylesheetConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<EnqueuedStylesheet>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToEnqueuedStylesheetConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToEnqueuedStylesheetConnectionEdge = Edge & EnqueuedStylesheetConnectionEdge & {
  __typename?: 'RootQueryToEnqueuedStylesheetConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: EnqueuedStylesheet;
};

/** Page Info on the &quot;RootQueryToEnqueuedStylesheetConnection&quot; */
export type RootQueryToEnqueuedStylesheetConnectionPageInfo = EnqueuedStylesheetConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'RootQueryToEnqueuedStylesheetConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Connection between the RootQuery type and the general type */
export type RootQueryToGeneralConnection = Connection & GeneralConnection & {
  __typename?: 'RootQueryToGeneralConnection';
  /** Edges for the RootQueryToGeneralConnection connection */
  edges: Array<RootQueryToGeneralConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<General>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToGeneralConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToGeneralConnectionEdge = Edge & GeneralConnectionEdge & {
  __typename?: 'RootQueryToGeneralConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: General;
};

/** Page Info on the &quot;RootQueryToGeneralConnection&quot; */
export type RootQueryToGeneralConnectionPageInfo = GeneralConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'RootQueryToGeneralConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the RootQueryToGeneralConnection connection */
export type RootQueryToGeneralConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the RootQuery type and the mediaItem type */
export type RootQueryToMediaItemConnection = Connection & MediaItemConnection & {
  __typename?: 'RootQueryToMediaItemConnection';
  /** Edges for the RootQueryToMediaItemConnection connection */
  edges: Array<RootQueryToMediaItemConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<MediaItem>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToMediaItemConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToMediaItemConnectionEdge = Edge & MediaItemConnectionEdge & {
  __typename?: 'RootQueryToMediaItemConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: MediaItem;
};

/** Page Info on the &quot;RootQueryToMediaItemConnection&quot; */
export type RootQueryToMediaItemConnectionPageInfo = MediaItemConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'RootQueryToMediaItemConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the RootQueryToMediaItemConnection connection */
export type RootQueryToMediaItemConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Paginate MediaItems with offsets */
  offsetPagination?: InputMaybe<OffsetPagination>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the RootQuery type and the Menu type */
export type RootQueryToMenuConnection = Connection & MenuConnection & {
  __typename?: 'RootQueryToMenuConnection';
  /** Edges for the RootQueryToMenuConnection connection */
  edges: Array<RootQueryToMenuConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Menu>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToMenuConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToMenuConnectionEdge = Edge & MenuConnectionEdge & {
  __typename?: 'RootQueryToMenuConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Menu;
};

/** Page Info on the &quot;RootQueryToMenuConnection&quot; */
export type RootQueryToMenuConnectionPageInfo = MenuConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'RootQueryToMenuConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the RootQueryToMenuConnection connection */
export type RootQueryToMenuConnectionWhereArgs = {
  /** The database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** The menu location for the menu being queried */
  location?: InputMaybe<MenuLocationEnum>;
  /** The slug of the menu to query items for */
  slug?: InputMaybe<Scalars['String']>;
};

/** Connection between the RootQuery type and the MenuItem type */
export type RootQueryToMenuItemConnection = Connection & MenuItemConnection & {
  __typename?: 'RootQueryToMenuItemConnection';
  /** Edges for the RootQueryToMenuItemConnection connection */
  edges: Array<RootQueryToMenuItemConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<MenuItem>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToMenuItemConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToMenuItemConnectionEdge = Edge & MenuItemConnectionEdge & {
  __typename?: 'RootQueryToMenuItemConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: MenuItem;
};

/** Page Info on the &quot;RootQueryToMenuItemConnection&quot; */
export type RootQueryToMenuItemConnectionPageInfo = MenuItemConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'RootQueryToMenuItemConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the RootQueryToMenuItemConnection connection */
export type RootQueryToMenuItemConnectionWhereArgs = {
  /** The database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** The menu location for the menu being queried */
  location?: InputMaybe<MenuLocationEnum>;
  /** The database ID of the parent menu object */
  parentDatabaseId?: InputMaybe<Scalars['Int']>;
  /** The ID of the parent menu object */
  parentId?: InputMaybe<Scalars['ID']>;
};

/** Connection between the RootQuery type and the page type */
export type RootQueryToPageConnection = Connection & PageConnection & {
  __typename?: 'RootQueryToPageConnection';
  /** Edges for the RootQueryToPageConnection connection */
  edges: Array<RootQueryToPageConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Page>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToPageConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToPageConnectionEdge = Edge & PageConnectionEdge & {
  __typename?: 'RootQueryToPageConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Page;
};

/** Page Info on the &quot;RootQueryToPageConnection&quot; */
export type RootQueryToPageConnectionPageInfo = PageConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'RootQueryToPageConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the RootQueryToPageConnection connection */
export type RootQueryToPageConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Paginate Pages with offsets */
  offsetPagination?: InputMaybe<OffsetPagination>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the RootQuery type and the Plugin type */
export type RootQueryToPluginConnection = Connection & PluginConnection & {
  __typename?: 'RootQueryToPluginConnection';
  /** Edges for the RootQueryToPluginConnection connection */
  edges: Array<RootQueryToPluginConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Plugin>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToPluginConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToPluginConnectionEdge = Edge & PluginConnectionEdge & {
  __typename?: 'RootQueryToPluginConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Plugin;
};

/** Page Info on the &quot;RootQueryToPluginConnection&quot; */
export type RootQueryToPluginConnectionPageInfo = PageInfo & PluginConnectionPageInfo & WpPageInfo & {
  __typename?: 'RootQueryToPluginConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the RootQueryToPluginConnection connection */
export type RootQueryToPluginConnectionWhereArgs = {
  /** Show plugin based on a keyword search. */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve plugins where plugin status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PluginStatusEnum>>>;
  /** Show plugins with a specific status. */
  status?: InputMaybe<PluginStatusEnum>;
};

/** Connection between the RootQuery type and the post type */
export type RootQueryToPostConnection = Connection & PostConnection & {
  __typename?: 'RootQueryToPostConnection';
  /** Edges for the RootQueryToPostConnection connection */
  edges: Array<RootQueryToPostConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Post>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToPostConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToPostConnectionEdge = Edge & PostConnectionEdge & {
  __typename?: 'RootQueryToPostConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Post;
};

/** Page Info on the &quot;RootQueryToPostConnection&quot; */
export type RootQueryToPostConnectionPageInfo = PageInfo & PostConnectionPageInfo & WpPageInfo & {
  __typename?: 'RootQueryToPostConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the RootQueryToPostConnection connection */
export type RootQueryToPostConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Category ID */
  categoryId?: InputMaybe<Scalars['Int']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Use Category Slug */
  categoryName?: InputMaybe<Scalars['String']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** Array of general IDs to filter posts by */
  general?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of general IDs to include posts from */
  generalIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of general IDs to exclude posts from */
  generalNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Paginate Posts with offsets */
  offsetPagination?: InputMaybe<OffsetPagination>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Array of solution IDs to filter posts by */
  solutions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of solution IDs to include posts from */
  solutionsIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of solution IDs to exclude posts from */
  solutionsNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  tag?: InputMaybe<Scalars['String']>;
  /** Use Tag ID */
  tagId?: InputMaybe<Scalars['String']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  tagSlugAnd?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  tagSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of technology IDs to filter posts by */
  technologies?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of technology IDs to include posts from */
  technologiesIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of technology IDs to exclude posts from */
  technologiesNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the RootQuery type and the postFormat type */
export type RootQueryToPostFormatConnection = Connection & PostFormatConnection & {
  __typename?: 'RootQueryToPostFormatConnection';
  /** Edges for the RootQueryToPostFormatConnection connection */
  edges: Array<RootQueryToPostFormatConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<PostFormat>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToPostFormatConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToPostFormatConnectionEdge = Edge & PostFormatConnectionEdge & {
  __typename?: 'RootQueryToPostFormatConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: PostFormat;
};

/** Page Info on the &quot;RootQueryToPostFormatConnection&quot; */
export type RootQueryToPostFormatConnectionPageInfo = PageInfo & PostFormatConnectionPageInfo & WpPageInfo & {
  __typename?: 'RootQueryToPostFormatConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the RootQueryToPostFormatConnection connection */
export type RootQueryToPostFormatConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the RootQuery type and the ContentNode type */
export type RootQueryToRevisionsConnection = Connection & ContentNodeConnection & {
  __typename?: 'RootQueryToRevisionsConnection';
  /** Edges for the RootQueryToRevisionsConnection connection */
  edges: Array<RootQueryToRevisionsConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<ContentNode>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToRevisionsConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToRevisionsConnectionEdge = ContentNodeConnectionEdge & Edge & {
  __typename?: 'RootQueryToRevisionsConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: ContentNode;
};

/** Page Info on the &quot;RootQueryToRevisionsConnection&quot; */
export type RootQueryToRevisionsConnectionPageInfo = ContentNodeConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'RootQueryToRevisionsConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the RootQueryToRevisionsConnection connection */
export type RootQueryToRevisionsConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the RootQuery type and the series type */
export type RootQueryToSeriesConnection = Connection & SeriesConnection & {
  __typename?: 'RootQueryToSeriesConnection';
  /** Edges for the RootQueryToSeriesConnection connection */
  edges: Array<RootQueryToSeriesConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Series>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToSeriesConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToSeriesConnectionEdge = Edge & SeriesConnectionEdge & {
  __typename?: 'RootQueryToSeriesConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Series;
};

/** Page Info on the &quot;RootQueryToSeriesConnection&quot; */
export type RootQueryToSeriesConnectionPageInfo = PageInfo & SeriesConnectionPageInfo & WpPageInfo & {
  __typename?: 'RootQueryToSeriesConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the RootQueryToSeriesConnection connection */
export type RootQueryToSeriesConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the RootQuery type and the solution type */
export type RootQueryToSolutionConnection = Connection & SolutionConnection & {
  __typename?: 'RootQueryToSolutionConnection';
  /** Edges for the RootQueryToSolutionConnection connection */
  edges: Array<RootQueryToSolutionConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Solution>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToSolutionConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToSolutionConnectionEdge = Edge & SolutionConnectionEdge & {
  __typename?: 'RootQueryToSolutionConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Solution;
};

/** Page Info on the &quot;RootQueryToSolutionConnection&quot; */
export type RootQueryToSolutionConnectionPageInfo = PageInfo & SolutionConnectionPageInfo & WpPageInfo & {
  __typename?: 'RootQueryToSolutionConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the RootQueryToSolutionConnection connection */
export type RootQueryToSolutionConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the RootQuery type and the tag type */
export type RootQueryToTagConnection = Connection & TagConnection & {
  __typename?: 'RootQueryToTagConnection';
  /** Edges for the RootQueryToTagConnection connection */
  edges: Array<RootQueryToTagConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Tag>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToTagConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToTagConnectionEdge = Edge & TagConnectionEdge & {
  __typename?: 'RootQueryToTagConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Tag;
};

/** Page Info on the &quot;RootQueryToTagConnection&quot; */
export type RootQueryToTagConnectionPageInfo = PageInfo & TagConnectionPageInfo & WpPageInfo & {
  __typename?: 'RootQueryToTagConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the RootQueryToTagConnection connection */
export type RootQueryToTagConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the RootQuery type and the Taxonomy type */
export type RootQueryToTaxonomyConnection = Connection & TaxonomyConnection & {
  __typename?: 'RootQueryToTaxonomyConnection';
  /** Edges for the RootQueryToTaxonomyConnection connection */
  edges: Array<RootQueryToTaxonomyConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Taxonomy>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToTaxonomyConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToTaxonomyConnectionEdge = Edge & TaxonomyConnectionEdge & {
  __typename?: 'RootQueryToTaxonomyConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Taxonomy;
};

/** Page Info on the &quot;RootQueryToTaxonomyConnection&quot; */
export type RootQueryToTaxonomyConnectionPageInfo = PageInfo & TaxonomyConnectionPageInfo & WpPageInfo & {
  __typename?: 'RootQueryToTaxonomyConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Connection between the RootQuery type and the technology type */
export type RootQueryToTechnologyConnection = Connection & TechnologyConnection & {
  __typename?: 'RootQueryToTechnologyConnection';
  /** Edges for the RootQueryToTechnologyConnection connection */
  edges: Array<RootQueryToTechnologyConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Technology>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToTechnologyConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToTechnologyConnectionEdge = Edge & TechnologyConnectionEdge & {
  __typename?: 'RootQueryToTechnologyConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Technology;
};

/** Page Info on the &quot;RootQueryToTechnologyConnection&quot; */
export type RootQueryToTechnologyConnectionPageInfo = PageInfo & TechnologyConnectionPageInfo & WpPageInfo & {
  __typename?: 'RootQueryToTechnologyConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the RootQueryToTechnologyConnection connection */
export type RootQueryToTechnologyConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the RootQuery type and the TermNode type */
export type RootQueryToTermNodeConnection = Connection & TermNodeConnection & {
  __typename?: 'RootQueryToTermNodeConnection';
  /** Edges for the RootQueryToTermNodeConnection connection */
  edges: Array<RootQueryToTermNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<TermNode>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToTermNodeConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToTermNodeConnectionEdge = Edge & TermNodeConnectionEdge & {
  __typename?: 'RootQueryToTermNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: TermNode;
};

/** Page Info on the &quot;RootQueryToTermNodeConnection&quot; */
export type RootQueryToTermNodeConnectionPageInfo = PageInfo & TermNodeConnectionPageInfo & WpPageInfo & {
  __typename?: 'RootQueryToTermNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the RootQueryToTermNodeConnection connection */
export type RootQueryToTermNodeConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The Taxonomy to filter terms by */
  taxonomies?: InputMaybe<Array<InputMaybe<TaxonomyEnum>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the RootQuery type and the Theme type */
export type RootQueryToThemeConnection = Connection & ThemeConnection & {
  __typename?: 'RootQueryToThemeConnection';
  /** Edges for the RootQueryToThemeConnection connection */
  edges: Array<RootQueryToThemeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Theme>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToThemeConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToThemeConnectionEdge = Edge & ThemeConnectionEdge & {
  __typename?: 'RootQueryToThemeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Theme;
};

/** Page Info on the &quot;RootQueryToThemeConnection&quot; */
export type RootQueryToThemeConnectionPageInfo = PageInfo & ThemeConnectionPageInfo & WpPageInfo & {
  __typename?: 'RootQueryToThemeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Connection between the RootQuery type and the User type */
export type RootQueryToUserConnection = Connection & UserConnection & {
  __typename?: 'RootQueryToUserConnection';
  /** Edges for the RootQueryToUserConnection connection */
  edges: Array<RootQueryToUserConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<User>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToUserConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToUserConnectionEdge = Edge & UserConnectionEdge & {
  __typename?: 'RootQueryToUserConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: User;
};

/** Page Info on the &quot;RootQueryToUserConnection&quot; */
export type RootQueryToUserConnectionPageInfo = PageInfo & UserConnectionPageInfo & WpPageInfo & {
  __typename?: 'RootQueryToUserConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the RootQueryToUserConnection connection */
export type RootQueryToUserConnectionWhereArgs = {
  /** Array of userIds to exclude. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Pass an array of post types to filter results to users who have published posts in those post types. */
  hasPublishedPosts?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Array of userIds to include. */
  include?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** The user login. */
  login?: InputMaybe<Scalars['String']>;
  /** An array of logins to include. Users matching one of these logins will be included in results. */
  loginIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** An array of logins to exclude. Users matching one of these logins will not be included in results. */
  loginNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The user nicename. */
  nicename?: InputMaybe<Scalars['String']>;
  /** An array of nicenames to include. Users matching one of these nicenames will be included in results. */
  nicenameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** An array of nicenames to exclude. Users matching one of these nicenames will not be included in results. */
  nicenameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Paginate users with offsets */
  offsetPagination?: InputMaybe<OffsetPagination>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<UsersConnectionOrderbyInput>>>;
  /** An array of role names that users must match to be included in results. Note that this is an inclusive list: users must match *each* role. */
  role?: InputMaybe<UserRoleEnum>;
  /** An array of role names. Matched users must have at least one of these roles. */
  roleIn?: InputMaybe<Array<InputMaybe<UserRoleEnum>>>;
  /** An array of role names to exclude. Users matching one or more of these roles will not be included in results. */
  roleNotIn?: InputMaybe<Array<InputMaybe<UserRoleEnum>>>;
  /** Search keyword. Searches for possible string matches on columns. When "searchColumns" is left empty, it tries to determine which column to search in based on search string. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of column names to be searched. Accepts 'ID', 'login', 'nicename', 'email', 'url'. */
  searchColumns?: InputMaybe<Array<InputMaybe<UsersConnectionSearchColumnEnum>>>;
};

/** Connection between the RootQuery type and the UserRole type */
export type RootQueryToUserRoleConnection = Connection & UserRoleConnection & {
  __typename?: 'RootQueryToUserRoleConnection';
  /** Edges for the RootQueryToUserRoleConnection connection */
  edges: Array<RootQueryToUserRoleConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<UserRole>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToUserRoleConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToUserRoleConnectionEdge = Edge & UserRoleConnectionEdge & {
  __typename?: 'RootQueryToUserRoleConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: UserRole;
};

/** Page Info on the &quot;RootQueryToUserRoleConnection&quot; */
export type RootQueryToUserRoleConnectionPageInfo = PageInfo & UserRoleConnectionPageInfo & WpPageInfo & {
  __typename?: 'RootQueryToUserRoleConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** The strategy to use when loading the script */
export enum ScriptLoadingStrategyEnum {
  /** Use the script `async` attribute */
  Async = 'ASYNC',
  /** Use the script `defer` attribute */
  Defer = 'DEFER'
}

/** Input for the sendPasswordResetEmail mutation. */
export type SendPasswordResetEmailInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** A string that contains the user's username or email address. */
  username: Scalars['String'];
};

/** The payload for the sendPasswordResetEmail mutation. */
export type SendPasswordResetEmailPayload = {
  __typename?: 'SendPasswordResetEmailPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Whether the mutation completed successfully. This does NOT necessarily mean that an email was sent. */
  success?: Maybe<Scalars['Boolean']>;
  /**
   * The user that the password reset email was sent to
   * @deprecated This field will be removed in a future version of WPGraphQL
   */
  user?: Maybe<User>;
};

/** The series type */
export type Series = DatabaseIdentifier & MenuItemLinkable & Node & NodeWithRankMathSeo & TermNode & UniformResourceIdentifiable & {
  __typename?: 'Series';
  /** Connection between the Series type and the ContentNode type */
  contentNodes?: Maybe<SeriesToContentNodeConnection>;
  /** The number of objects connected to the object */
  count?: Maybe<Scalars['Int']>;
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int'];
  /** The description of the object */
  description?: Maybe<Scalars['String']>;
  /** Connection between the TermNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<TermNodeToEnqueuedScriptConnection>;
  /** Connection between the TermNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<TermNodeToEnqueuedStylesheetConnection>;
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The link to the term */
  link?: Maybe<Scalars['String']>;
  /** The human friendly name of the object. */
  name?: Maybe<Scalars['String']>;
  /** Connection between the Series type and the post type */
  posts?: Maybe<SeriesToPostConnection>;
  /** The RankMath SEO data for the node. */
  seo?: Maybe<RankMathSeo>;
  /**
   * The id field matches the WP_Post-&gt;ID field.
   * @deprecated Deprecated in favor of databaseId
   */
  seriesId?: Maybe<Scalars['Int']>;
  /** An alphanumeric identifier for the object unique to its type. */
  slug?: Maybe<Scalars['String']>;
  /** Connection between the Series type and the Taxonomy type */
  taxonomy?: Maybe<SeriesToTaxonomyConnectionEdge>;
  /** The name of the taxonomy that the object is associated with */
  taxonomyName?: Maybe<Scalars['String']>;
  /** The ID of the term group that this term object belongs to */
  termGroupId?: Maybe<Scalars['Int']>;
  /** The taxonomy ID that the object is associated with */
  termTaxonomyId?: Maybe<Scalars['Int']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};


/** The series type */
export type SeriesContentNodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SeriesToContentNodeConnectionWhereArgs>;
};


/** The series type */
export type SeriesEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The series type */
export type SeriesEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The series type */
export type SeriesPostsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SeriesToPostConnectionWhereArgs>;
};

/** Connection to series Nodes */
export type SeriesConnection = {
  /** A list of edges (relational context) between RootQuery and connected series Nodes */
  edges: Array<SeriesConnectionEdge>;
  /** A list of connected series Nodes */
  nodes: Array<Series>;
  /** Information about pagination in a connection. */
  pageInfo: SeriesConnectionPageInfo;
};

/** Edge between a Node and a connected series */
export type SeriesConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The connected series Node */
  node: Series;
};

/** Page Info on the connected SeriesConnectionEdge */
export type SeriesConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum SeriesIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI'
}

/** The RankMath SEO meta settings for Blog Series. */
export type SeriesMetaSettings = RankMathMetaSettingWithArchive & RankMathMetaSettingWithRobots & {
  __typename?: 'SeriesMetaSettings';
  /** Advanced robots meta tag settings. */
  advancedRobotsMeta?: Maybe<RankMathAdvancedRobotsMeta>;
  /** Description for archive pages. */
  archiveDescription?: Maybe<Scalars['String']>;
  /** Default title tag for archive page. */
  archiveTitle?: Maybe<Scalars['String']>;
  /** Whether custom robots meta for author page are set. Otherwise the default meta will be used, as set in the Global Meta tab. */
  hasCustomRobotsMeta?: Maybe<Scalars['Boolean']>;
  /** Whether the SEO Controls meta box for user profile pages is enabled. */
  hasSeoControls?: Maybe<Scalars['Boolean']>;
  /** Whether to show additional information (name &amp; total number of posts) when an author archive is shared on Slack. */
  hasSlackEnhancedSharing?: Maybe<Scalars['Boolean']>;
  /** Whether to include snippet data for this taxonomy. */
  hasSnippetData?: Maybe<Scalars['Boolean']>;
  /** Custom values for robots meta tag. */
  robotsMeta?: Maybe<Array<Maybe<RankMathRobotsMetaValueEnum>>>;
};

/** Connection between the Series type and the ContentNode type */
export type SeriesToContentNodeConnection = Connection & ContentNodeConnection & {
  __typename?: 'SeriesToContentNodeConnection';
  /** Edges for the SeriesToContentNodeConnection connection */
  edges: Array<SeriesToContentNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<ContentNode>;
  /** Information about pagination in a connection. */
  pageInfo: SeriesToContentNodeConnectionPageInfo;
};

/** An edge in a connection */
export type SeriesToContentNodeConnectionEdge = ContentNodeConnectionEdge & Edge & {
  __typename?: 'SeriesToContentNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: ContentNode;
};

/** Page Info on the &quot;SeriesToContentNodeConnection&quot; */
export type SeriesToContentNodeConnectionPageInfo = ContentNodeConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'SeriesToContentNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the SeriesToContentNodeConnection connection */
export type SeriesToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypesOfSeriesEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the Series type and the post type */
export type SeriesToPostConnection = Connection & PostConnection & {
  __typename?: 'SeriesToPostConnection';
  /** Edges for the SeriesToPostConnection connection */
  edges: Array<SeriesToPostConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Post>;
  /** Information about pagination in a connection. */
  pageInfo: SeriesToPostConnectionPageInfo;
};

/** An edge in a connection */
export type SeriesToPostConnectionEdge = Edge & PostConnectionEdge & {
  __typename?: 'SeriesToPostConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Post;
};

/** Page Info on the &quot;SeriesToPostConnection&quot; */
export type SeriesToPostConnectionPageInfo = PageInfo & PostConnectionPageInfo & WpPageInfo & {
  __typename?: 'SeriesToPostConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the SeriesToPostConnection connection */
export type SeriesToPostConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Category ID */
  categoryId?: InputMaybe<Scalars['Int']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Use Category Slug */
  categoryName?: InputMaybe<Scalars['String']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  tag?: InputMaybe<Scalars['String']>;
  /** Use Tag ID */
  tagId?: InputMaybe<Scalars['String']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  tagSlugAnd?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  tagSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the Series type and the Taxonomy type */
export type SeriesToTaxonomyConnectionEdge = Edge & OneToOneConnection & TaxonomyConnectionEdge & {
  __typename?: 'SeriesToTaxonomyConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The node of the connection, without the edges */
  node: Taxonomy;
};

/** All of the registered settings */
export type Settings = {
  __typename?: 'Settings';
  /** Settings of the the string Settings Group */
  discussionSettingsDefaultCommentStatus?: Maybe<Scalars['String']>;
  /** Settings of the the string Settings Group */
  discussionSettingsDefaultPingStatus?: Maybe<Scalars['String']>;
  /** Settings of the the string Settings Group */
  generalSettingsDateFormat?: Maybe<Scalars['String']>;
  /** Settings of the the string Settings Group */
  generalSettingsDescription?: Maybe<Scalars['String']>;
  /** Settings of the the string Settings Group */
  generalSettingsEmail?: Maybe<Scalars['String']>;
  /** Settings of the the string Settings Group */
  generalSettingsLanguage?: Maybe<Scalars['String']>;
  /** Settings of the the integer Settings Group */
  generalSettingsStartOfWeek?: Maybe<Scalars['Int']>;
  /** Settings of the the string Settings Group */
  generalSettingsTimeFormat?: Maybe<Scalars['String']>;
  /** Settings of the the string Settings Group */
  generalSettingsTimezone?: Maybe<Scalars['String']>;
  /** Settings of the the string Settings Group */
  generalSettingsTitle?: Maybe<Scalars['String']>;
  /** Settings of the the string Settings Group */
  generalSettingsUrl?: Maybe<Scalars['String']>;
  /** Settings of the the integer Settings Group */
  readingSettingsPageForPosts?: Maybe<Scalars['Int']>;
  /** Settings of the the integer Settings Group */
  readingSettingsPageOnFront?: Maybe<Scalars['Int']>;
  /** Settings of the the integer Settings Group */
  readingSettingsPostsPerPage?: Maybe<Scalars['Int']>;
  /** Settings of the the string Settings Group */
  readingSettingsShowOnFront?: Maybe<Scalars['String']>;
  /** Settings of the the integer Settings Group */
  writingSettingsDefaultCategory?: Maybe<Scalars['Int']>;
  /** Settings of the the string Settings Group */
  writingSettingsDefaultPostFormat?: Maybe<Scalars['String']>;
  /** Settings of the the boolean Settings Group */
  writingSettingsUseSmilies?: Maybe<Scalars['Boolean']>;
};

/** The solution type */
export type Solution = DatabaseIdentifier & HierarchicalNode & HierarchicalTermNode & MenuItemLinkable & Node & NodeWithRankMathSeo & TermNode & UniformResourceIdentifiable & {
  __typename?: 'Solution';
  /** The ancestors of the node. Default ordered as lowest (closest to the child) to highest (closest to the root). */
  ancestors?: Maybe<SolutionToAncestorsSolutionConnection>;
  /** Connection between the solution type and its children solutions. */
  children?: Maybe<SolutionToSolutionConnection>;
  /** Connection between the Solution type and the ContentNode type */
  contentNodes?: Maybe<SolutionToContentNodeConnection>;
  /** The number of objects connected to the object */
  count?: Maybe<Scalars['Int']>;
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int'];
  /** The description of the object */
  description?: Maybe<Scalars['String']>;
  /** Connection between the TermNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<TermNodeToEnqueuedScriptConnection>;
  /** Connection between the TermNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<TermNodeToEnqueuedStylesheetConnection>;
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The link to the term */
  link?: Maybe<Scalars['String']>;
  /** The human friendly name of the object. */
  name?: Maybe<Scalars['String']>;
  /** Connection between the solution type and its parent solution. */
  parent?: Maybe<SolutionToParentSolutionConnectionEdge>;
  /** Database id of the parent node */
  parentDatabaseId?: Maybe<Scalars['Int']>;
  /** The globally unique identifier of the parent node. */
  parentId?: Maybe<Scalars['ID']>;
  /** Connection between the Solution type and the post type */
  posts?: Maybe<SolutionToPostConnection>;
  /** The RankMath SEO data for the node. */
  seo?: Maybe<RankMathSeo>;
  /** An alphanumeric identifier for the object unique to its type. */
  slug?: Maybe<Scalars['String']>;
  /**
   * The id field matches the WP_Post-&gt;ID field.
   * @deprecated Deprecated in favor of databaseId
   */
  solutionId?: Maybe<Scalars['Int']>;
  /** Added to the GraphQL Schema because the ACF Field Group &quot;Solution fields&quot; was set to Show in GraphQL. */
  solutions?: Maybe<SolutionSolutions>;
  /** Connection between the Solution type and the Taxonomy type */
  taxonomy?: Maybe<SolutionToTaxonomyConnectionEdge>;
  /** The name of the taxonomy that the object is associated with */
  taxonomyName?: Maybe<Scalars['String']>;
  /** The ID of the term group that this term object belongs to */
  termGroupId?: Maybe<Scalars['Int']>;
  /** The taxonomy ID that the object is associated with */
  termTaxonomyId?: Maybe<Scalars['Int']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};


/** The solution type */
export type SolutionAncestorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The solution type */
export type SolutionChildrenArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SolutionToSolutionConnectionWhereArgs>;
};


/** The solution type */
export type SolutionContentNodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SolutionToContentNodeConnectionWhereArgs>;
};


/** The solution type */
export type SolutionEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The solution type */
export type SolutionEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The solution type */
export type SolutionPostsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SolutionToPostConnectionWhereArgs>;
};

/** Connection to solution Nodes */
export type SolutionConnection = {
  /** A list of edges (relational context) between RootQuery and connected solution Nodes */
  edges: Array<SolutionConnectionEdge>;
  /** A list of connected solution Nodes */
  nodes: Array<Solution>;
  /** Information about pagination in a connection. */
  pageInfo: SolutionConnectionPageInfo;
};

/** Edge between a Node and a connected solution */
export type SolutionConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The connected solution Node */
  node: Solution;
};

/** Page Info on the connected SolutionConnectionEdge */
export type SolutionConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum SolutionIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI'
}

/** The RankMath SEO meta settings for Solutions. */
export type SolutionMetaSettings = RankMathMetaSettingWithArchive & RankMathMetaSettingWithRobots & {
  __typename?: 'SolutionMetaSettings';
  /** Advanced robots meta tag settings. */
  advancedRobotsMeta?: Maybe<RankMathAdvancedRobotsMeta>;
  /** Description for archive pages. */
  archiveDescription?: Maybe<Scalars['String']>;
  /** Default title tag for archive page. */
  archiveTitle?: Maybe<Scalars['String']>;
  /** Whether custom robots meta for author page are set. Otherwise the default meta will be used, as set in the Global Meta tab. */
  hasCustomRobotsMeta?: Maybe<Scalars['Boolean']>;
  /** Whether the SEO Controls meta box for user profile pages is enabled. */
  hasSeoControls?: Maybe<Scalars['Boolean']>;
  /** Whether to show additional information (name &amp; total number of posts) when an author archive is shared on Slack. */
  hasSlackEnhancedSharing?: Maybe<Scalars['Boolean']>;
  /** Whether to include snippet data for this taxonomy. */
  hasSnippetData?: Maybe<Scalars['Boolean']>;
  /** Custom values for robots meta tag. */
  robotsMeta?: Maybe<Array<Maybe<RankMathRobotsMetaValueEnum>>>;
};

/** Connection between the Solution type and the solution type */
export type SolutionToAncestorsSolutionConnection = Connection & SolutionConnection & {
  __typename?: 'SolutionToAncestorsSolutionConnection';
  /** Edges for the SolutionToAncestorsSolutionConnection connection */
  edges: Array<SolutionToAncestorsSolutionConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Solution>;
  /** Information about pagination in a connection. */
  pageInfo: SolutionToAncestorsSolutionConnectionPageInfo;
};

/** An edge in a connection */
export type SolutionToAncestorsSolutionConnectionEdge = Edge & SolutionConnectionEdge & {
  __typename?: 'SolutionToAncestorsSolutionConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Solution;
};

/** Page Info on the &quot;SolutionToAncestorsSolutionConnection&quot; */
export type SolutionToAncestorsSolutionConnectionPageInfo = PageInfo & SolutionConnectionPageInfo & WpPageInfo & {
  __typename?: 'SolutionToAncestorsSolutionConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Connection between the Solution type and the ContentNode type */
export type SolutionToContentNodeConnection = Connection & ContentNodeConnection & {
  __typename?: 'SolutionToContentNodeConnection';
  /** Edges for the SolutionToContentNodeConnection connection */
  edges: Array<SolutionToContentNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<ContentNode>;
  /** Information about pagination in a connection. */
  pageInfo: SolutionToContentNodeConnectionPageInfo;
};

/** An edge in a connection */
export type SolutionToContentNodeConnectionEdge = ContentNodeConnectionEdge & Edge & {
  __typename?: 'SolutionToContentNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: ContentNode;
};

/** Page Info on the &quot;SolutionToContentNodeConnection&quot; */
export type SolutionToContentNodeConnectionPageInfo = ContentNodeConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'SolutionToContentNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the SolutionToContentNodeConnection connection */
export type SolutionToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypesOfSolutionEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the Solution type and the solution type */
export type SolutionToParentSolutionConnectionEdge = Edge & OneToOneConnection & SolutionConnectionEdge & {
  __typename?: 'SolutionToParentSolutionConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The node of the connection, without the edges */
  node: Solution;
};

/** Connection between the Solution type and the post type */
export type SolutionToPostConnection = Connection & PostConnection & {
  __typename?: 'SolutionToPostConnection';
  /** Edges for the SolutionToPostConnection connection */
  edges: Array<SolutionToPostConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Post>;
  /** Information about pagination in a connection. */
  pageInfo: SolutionToPostConnectionPageInfo;
};

/** An edge in a connection */
export type SolutionToPostConnectionEdge = Edge & PostConnectionEdge & {
  __typename?: 'SolutionToPostConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Post;
};

/** Page Info on the &quot;SolutionToPostConnection&quot; */
export type SolutionToPostConnectionPageInfo = PageInfo & PostConnectionPageInfo & WpPageInfo & {
  __typename?: 'SolutionToPostConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the SolutionToPostConnection connection */
export type SolutionToPostConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Category ID */
  categoryId?: InputMaybe<Scalars['Int']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Use Category Slug */
  categoryName?: InputMaybe<Scalars['String']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  tag?: InputMaybe<Scalars['String']>;
  /** Use Tag ID */
  tagId?: InputMaybe<Scalars['String']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  tagSlugAnd?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  tagSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the Solution type and the solution type */
export type SolutionToSolutionConnection = Connection & SolutionConnection & {
  __typename?: 'SolutionToSolutionConnection';
  /** Edges for the SolutionToSolutionConnection connection */
  edges: Array<SolutionToSolutionConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Solution>;
  /** Information about pagination in a connection. */
  pageInfo: SolutionToSolutionConnectionPageInfo;
};

/** An edge in a connection */
export type SolutionToSolutionConnectionEdge = Edge & SolutionConnectionEdge & {
  __typename?: 'SolutionToSolutionConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Solution;
};

/** Page Info on the &quot;SolutionToSolutionConnection&quot; */
export type SolutionToSolutionConnectionPageInfo = PageInfo & SolutionConnectionPageInfo & WpPageInfo & {
  __typename?: 'SolutionToSolutionConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the SolutionToSolutionConnection connection */
export type SolutionToSolutionConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the Solution type and the Taxonomy type */
export type SolutionToTaxonomyConnectionEdge = Edge & OneToOneConnection & TaxonomyConnectionEdge & {
  __typename?: 'SolutionToTaxonomyConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The node of the connection, without the edges */
  node: Taxonomy;
};

/** Field Group */
export type SolutionSolutions = AcfFieldGroup & {
  __typename?: 'Solution_Solutions';
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** The tag type */
export type Tag = DatabaseIdentifier & MenuItemLinkable & Node & NodeWithRankMathSeo & TermNode & UniformResourceIdentifiable & {
  __typename?: 'Tag';
  /** Connection between the Tag type and the ContentNode type */
  contentNodes?: Maybe<TagToContentNodeConnection>;
  /** The number of objects connected to the object */
  count?: Maybe<Scalars['Int']>;
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int'];
  /** The description of the object */
  description?: Maybe<Scalars['String']>;
  /** Connection between the TermNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<TermNodeToEnqueuedScriptConnection>;
  /** Connection between the TermNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<TermNodeToEnqueuedStylesheetConnection>;
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The link to the term */
  link?: Maybe<Scalars['String']>;
  /** The human friendly name of the object. */
  name?: Maybe<Scalars['String']>;
  /** Connection between the Tag type and the post type */
  posts?: Maybe<TagToPostConnection>;
  /** The RankMath SEO data for the node. */
  seo?: Maybe<RankMathSeo>;
  /** An alphanumeric identifier for the object unique to its type. */
  slug?: Maybe<Scalars['String']>;
  /**
   * The id field matches the WP_Post-&gt;ID field.
   * @deprecated Deprecated in favor of databaseId
   */
  tagId?: Maybe<Scalars['Int']>;
  /** Connection between the Tag type and the Taxonomy type */
  taxonomy?: Maybe<TagToTaxonomyConnectionEdge>;
  /** The name of the taxonomy that the object is associated with */
  taxonomyName?: Maybe<Scalars['String']>;
  /** The ID of the term group that this term object belongs to */
  termGroupId?: Maybe<Scalars['Int']>;
  /** The taxonomy ID that the object is associated with */
  termTaxonomyId?: Maybe<Scalars['Int']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};


/** The tag type */
export type TagContentNodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TagToContentNodeConnectionWhereArgs>;
};


/** The tag type */
export type TagEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The tag type */
export type TagEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The tag type */
export type TagPostsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TagToPostConnectionWhereArgs>;
};

/** Connection to tag Nodes */
export type TagConnection = {
  /** A list of edges (relational context) between RootQuery and connected tag Nodes */
  edges: Array<TagConnectionEdge>;
  /** A list of connected tag Nodes */
  nodes: Array<Tag>;
  /** Information about pagination in a connection. */
  pageInfo: TagConnectionPageInfo;
};

/** Edge between a Node and a connected tag */
export type TagConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The connected tag Node */
  node: Tag;
};

/** Page Info on the connected TagConnectionEdge */
export type TagConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum TagIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI'
}

/** The RankMath SEO meta settings for Tags. */
export type TagMetaSettings = RankMathMetaSettingWithArchive & RankMathMetaSettingWithRobots & {
  __typename?: 'TagMetaSettings';
  /** Advanced robots meta tag settings. */
  advancedRobotsMeta?: Maybe<RankMathAdvancedRobotsMeta>;
  /** Description for archive pages. */
  archiveDescription?: Maybe<Scalars['String']>;
  /** Default title tag for archive page. */
  archiveTitle?: Maybe<Scalars['String']>;
  /** Whether custom robots meta for author page are set. Otherwise the default meta will be used, as set in the Global Meta tab. */
  hasCustomRobotsMeta?: Maybe<Scalars['Boolean']>;
  /** Whether the SEO Controls meta box for user profile pages is enabled. */
  hasSeoControls?: Maybe<Scalars['Boolean']>;
  /** Whether to show additional information (name &amp; total number of posts) when an author archive is shared on Slack. */
  hasSlackEnhancedSharing?: Maybe<Scalars['Boolean']>;
  /** Whether to include snippet data for this taxonomy. */
  hasSnippetData?: Maybe<Scalars['Boolean']>;
  /** Custom values for robots meta tag. */
  robotsMeta?: Maybe<Array<Maybe<RankMathRobotsMetaValueEnum>>>;
};

/** Connection between the Tag type and the ContentNode type */
export type TagToContentNodeConnection = Connection & ContentNodeConnection & {
  __typename?: 'TagToContentNodeConnection';
  /** Edges for the TagToContentNodeConnection connection */
  edges: Array<TagToContentNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<ContentNode>;
  /** Information about pagination in a connection. */
  pageInfo: TagToContentNodeConnectionPageInfo;
};

/** An edge in a connection */
export type TagToContentNodeConnectionEdge = ContentNodeConnectionEdge & Edge & {
  __typename?: 'TagToContentNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: ContentNode;
};

/** Page Info on the &quot;TagToContentNodeConnection&quot; */
export type TagToContentNodeConnectionPageInfo = ContentNodeConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'TagToContentNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the TagToContentNodeConnection connection */
export type TagToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypesOfTagEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the Tag type and the post type */
export type TagToPostConnection = Connection & PostConnection & {
  __typename?: 'TagToPostConnection';
  /** Edges for the TagToPostConnection connection */
  edges: Array<TagToPostConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Post>;
  /** Information about pagination in a connection. */
  pageInfo: TagToPostConnectionPageInfo;
};

/** An edge in a connection */
export type TagToPostConnectionEdge = Edge & PostConnectionEdge & {
  __typename?: 'TagToPostConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Post;
};

/** Page Info on the &quot;TagToPostConnection&quot; */
export type TagToPostConnectionPageInfo = PageInfo & PostConnectionPageInfo & WpPageInfo & {
  __typename?: 'TagToPostConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the TagToPostConnection connection */
export type TagToPostConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Category ID */
  categoryId?: InputMaybe<Scalars['Int']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Use Category Slug */
  categoryName?: InputMaybe<Scalars['String']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  tag?: InputMaybe<Scalars['String']>;
  /** Use Tag ID */
  tagId?: InputMaybe<Scalars['String']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  tagSlugAnd?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  tagSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the Tag type and the Taxonomy type */
export type TagToTaxonomyConnectionEdge = Edge & OneToOneConnection & TaxonomyConnectionEdge & {
  __typename?: 'TagToTaxonomyConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The node of the connection, without the edges */
  node: Taxonomy;
};

/** A taxonomy object */
export type Taxonomy = Node & {
  __typename?: 'Taxonomy';
  /** List of Content Types associated with the Taxonomy */
  connectedContentTypes?: Maybe<TaxonomyToContentTypeConnection>;
  /** List of Term Nodes associated with the Taxonomy */
  connectedTerms?: Maybe<TaxonomyToTermNodeConnection>;
  /** Description of the taxonomy. This field is equivalent to WP_Taxonomy-&gt;description */
  description?: Maybe<Scalars['String']>;
  /** The plural name of the post type within the GraphQL Schema. */
  graphqlPluralName?: Maybe<Scalars['String']>;
  /** The singular name of the post type within the GraphQL Schema. */
  graphqlSingleName?: Maybe<Scalars['String']>;
  /** Whether the taxonomy is hierarchical */
  hierarchical?: Maybe<Scalars['Boolean']>;
  /** The globally unique identifier of the taxonomy object. */
  id: Scalars['ID'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Name of the taxonomy shown in the menu. Usually plural. */
  label?: Maybe<Scalars['String']>;
  /** The display name of the taxonomy. This field is equivalent to WP_Taxonomy-&gt;label */
  name?: Maybe<Scalars['String']>;
  /** Whether the taxonomy is publicly queryable */
  public?: Maybe<Scalars['Boolean']>;
  /** Name of content type to display in REST API &quot;wp/v2&quot; namespace. */
  restBase?: Maybe<Scalars['String']>;
  /** The REST Controller class assigned to handling this content type. */
  restControllerClass?: Maybe<Scalars['String']>;
  /** Whether to show the taxonomy as part of a tag cloud widget. This field is equivalent to WP_Taxonomy-&gt;show_tagcloud */
  showCloud?: Maybe<Scalars['Boolean']>;
  /** Whether to display a column for the taxonomy on its post type listing screens. */
  showInAdminColumn?: Maybe<Scalars['Boolean']>;
  /** Whether to add the post type to the GraphQL Schema. */
  showInGraphql?: Maybe<Scalars['Boolean']>;
  /** Whether to show the taxonomy in the admin menu */
  showInMenu?: Maybe<Scalars['Boolean']>;
  /** Whether the taxonomy is available for selection in navigation menus. */
  showInNavMenus?: Maybe<Scalars['Boolean']>;
  /** Whether to show the taxonomy in the quick/bulk edit panel. */
  showInQuickEdit?: Maybe<Scalars['Boolean']>;
  /** Whether to add the post type route in the REST API &quot;wp/v2&quot; namespace. */
  showInRest?: Maybe<Scalars['Boolean']>;
  /** Whether to generate and allow a UI for managing terms in this taxonomy in the admin */
  showUi?: Maybe<Scalars['Boolean']>;
};


/** A taxonomy object */
export type TaxonomyConnectedContentTypesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** A taxonomy object */
export type TaxonomyConnectedTermsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Connection to Taxonomy Nodes */
export type TaxonomyConnection = {
  /** A list of edges (relational context) between RootQuery and connected Taxonomy Nodes */
  edges: Array<TaxonomyConnectionEdge>;
  /** A list of connected Taxonomy Nodes */
  nodes: Array<Taxonomy>;
  /** Information about pagination in a connection. */
  pageInfo: TaxonomyConnectionPageInfo;
};

/** Edge between a Node and a connected Taxonomy */
export type TaxonomyConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The connected Taxonomy Node */
  node: Taxonomy;
};

/** Page Info on the connected TaxonomyConnectionEdge */
export type TaxonomyConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Allowed taxonomies */
export enum TaxonomyEnum {
  /** Taxonomy enum category */
  Category = 'CATEGORY',
  /** Taxonomy enum general */
  General = 'GENERAL',
  /** Taxonomy enum post_format */
  Postformat = 'POSTFORMAT',
  /** Taxonomy enum series */
  Series = 'SERIES',
  /** Taxonomy enum solutions */
  Solution = 'SOLUTION',
  /** Taxonomy enum post_tag */
  Tag = 'TAG',
  /** Taxonomy enum technologies */
  Technology = 'TECHNOLOGY'
}

/** The Type of Identifier used to fetch a single Taxonomy node. To be used along with the "id" field. Default is "ID". */
export enum TaxonomyIdTypeEnum {
  /** The globally unique ID */
  Id = 'ID',
  /** The name of the taxonomy */
  Name = 'NAME'
}

/** Connection between the Taxonomy type and the ContentType type */
export type TaxonomyToContentTypeConnection = Connection & ContentTypeConnection & {
  __typename?: 'TaxonomyToContentTypeConnection';
  /** Edges for the TaxonomyToContentTypeConnection connection */
  edges: Array<TaxonomyToContentTypeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<ContentType>;
  /** Information about pagination in a connection. */
  pageInfo: TaxonomyToContentTypeConnectionPageInfo;
};

/** An edge in a connection */
export type TaxonomyToContentTypeConnectionEdge = ContentTypeConnectionEdge & Edge & {
  __typename?: 'TaxonomyToContentTypeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: ContentType;
};

/** Page Info on the &quot;TaxonomyToContentTypeConnection&quot; */
export type TaxonomyToContentTypeConnectionPageInfo = ContentTypeConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'TaxonomyToContentTypeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Connection between the Taxonomy type and the TermNode type */
export type TaxonomyToTermNodeConnection = Connection & TermNodeConnection & {
  __typename?: 'TaxonomyToTermNodeConnection';
  /** Edges for the TaxonomyToTermNodeConnection connection */
  edges: Array<TaxonomyToTermNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<TermNode>;
  /** Information about pagination in a connection. */
  pageInfo: TaxonomyToTermNodeConnectionPageInfo;
};

/** An edge in a connection */
export type TaxonomyToTermNodeConnectionEdge = Edge & TermNodeConnectionEdge & {
  __typename?: 'TaxonomyToTermNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: TermNode;
};

/** Page Info on the &quot;TaxonomyToTermNodeConnection&quot; */
export type TaxonomyToTermNodeConnectionPageInfo = PageInfo & TermNodeConnectionPageInfo & WpPageInfo & {
  __typename?: 'TaxonomyToTermNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** The technology type */
export type Technology = DatabaseIdentifier & HierarchicalNode & HierarchicalTermNode & MenuItemLinkable & Node & NodeWithRankMathSeo & TermNode & UniformResourceIdentifiable & {
  __typename?: 'Technology';
  /** The ancestors of the node. Default ordered as lowest (closest to the child) to highest (closest to the root). */
  ancestors?: Maybe<TechnologyToAncestorsTechnologyConnection>;
  /** Connection between the technology type and its children technologies. */
  children?: Maybe<TechnologyToTechnologyConnection>;
  /** Connection between the Technology type and the ContentNode type */
  contentNodes?: Maybe<TechnologyToContentNodeConnection>;
  /** The number of objects connected to the object */
  count?: Maybe<Scalars['Int']>;
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int'];
  /** The description of the object */
  description?: Maybe<Scalars['String']>;
  /** Connection between the TermNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<TermNodeToEnqueuedScriptConnection>;
  /** Connection between the TermNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<TermNodeToEnqueuedStylesheetConnection>;
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The link to the term */
  link?: Maybe<Scalars['String']>;
  /** The human friendly name of the object. */
  name?: Maybe<Scalars['String']>;
  /** Connection between the technology type and its parent technology. */
  parent?: Maybe<TechnologyToParentTechnologyConnectionEdge>;
  /** Database id of the parent node */
  parentDatabaseId?: Maybe<Scalars['Int']>;
  /** The globally unique identifier of the parent node. */
  parentId?: Maybe<Scalars['ID']>;
  /** Connection between the Technology type and the post type */
  posts?: Maybe<TechnologyToPostConnection>;
  /** The RankMath SEO data for the node. */
  seo?: Maybe<RankMathSeo>;
  /** An alphanumeric identifier for the object unique to its type. */
  slug?: Maybe<Scalars['String']>;
  /** Connection between the Technology type and the Taxonomy type */
  taxonomy?: Maybe<TechnologyToTaxonomyConnectionEdge>;
  /** The name of the taxonomy that the object is associated with */
  taxonomyName?: Maybe<Scalars['String']>;
  /** Added to the GraphQL Schema because the ACF Field Group &quot;Tenchnology fields&quot; was set to Show in GraphQL. */
  technologies?: Maybe<TechnologyTechnologies>;
  /**
   * The id field matches the WP_Post-&gt;ID field.
   * @deprecated Deprecated in favor of databaseId
   */
  technologyId?: Maybe<Scalars['Int']>;
  /** The ID of the term group that this term object belongs to */
  termGroupId?: Maybe<Scalars['Int']>;
  /** The taxonomy ID that the object is associated with */
  termTaxonomyId?: Maybe<Scalars['Int']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};


/** The technology type */
export type TechnologyAncestorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The technology type */
export type TechnologyChildrenArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TechnologyToTechnologyConnectionWhereArgs>;
};


/** The technology type */
export type TechnologyContentNodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TechnologyToContentNodeConnectionWhereArgs>;
};


/** The technology type */
export type TechnologyEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The technology type */
export type TechnologyEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The technology type */
export type TechnologyPostsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TechnologyToPostConnectionWhereArgs>;
};

/** Connection to technology Nodes */
export type TechnologyConnection = {
  /** A list of edges (relational context) between RootQuery and connected technology Nodes */
  edges: Array<TechnologyConnectionEdge>;
  /** A list of connected technology Nodes */
  nodes: Array<Technology>;
  /** Information about pagination in a connection. */
  pageInfo: TechnologyConnectionPageInfo;
};

/** Edge between a Node and a connected technology */
export type TechnologyConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The connected technology Node */
  node: Technology;
};

/** Page Info on the connected TechnologyConnectionEdge */
export type TechnologyConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum TechnologyIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI'
}

/** The RankMath SEO meta settings for Technologies. */
export type TechnologyMetaSettings = RankMathMetaSettingWithArchive & RankMathMetaSettingWithRobots & {
  __typename?: 'TechnologyMetaSettings';
  /** Advanced robots meta tag settings. */
  advancedRobotsMeta?: Maybe<RankMathAdvancedRobotsMeta>;
  /** Description for archive pages. */
  archiveDescription?: Maybe<Scalars['String']>;
  /** Default title tag for archive page. */
  archiveTitle?: Maybe<Scalars['String']>;
  /** Whether custom robots meta for author page are set. Otherwise the default meta will be used, as set in the Global Meta tab. */
  hasCustomRobotsMeta?: Maybe<Scalars['Boolean']>;
  /** Whether the SEO Controls meta box for user profile pages is enabled. */
  hasSeoControls?: Maybe<Scalars['Boolean']>;
  /** Whether to show additional information (name &amp; total number of posts) when an author archive is shared on Slack. */
  hasSlackEnhancedSharing?: Maybe<Scalars['Boolean']>;
  /** Whether to include snippet data for this taxonomy. */
  hasSnippetData?: Maybe<Scalars['Boolean']>;
  /** Custom values for robots meta tag. */
  robotsMeta?: Maybe<Array<Maybe<RankMathRobotsMetaValueEnum>>>;
};

/** Connection between the Technology type and the technology type */
export type TechnologyToAncestorsTechnologyConnection = Connection & TechnologyConnection & {
  __typename?: 'TechnologyToAncestorsTechnologyConnection';
  /** Edges for the TechnologyToAncestorsTechnologyConnection connection */
  edges: Array<TechnologyToAncestorsTechnologyConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Technology>;
  /** Information about pagination in a connection. */
  pageInfo: TechnologyToAncestorsTechnologyConnectionPageInfo;
};

/** An edge in a connection */
export type TechnologyToAncestorsTechnologyConnectionEdge = Edge & TechnologyConnectionEdge & {
  __typename?: 'TechnologyToAncestorsTechnologyConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Technology;
};

/** Page Info on the &quot;TechnologyToAncestorsTechnologyConnection&quot; */
export type TechnologyToAncestorsTechnologyConnectionPageInfo = PageInfo & TechnologyConnectionPageInfo & WpPageInfo & {
  __typename?: 'TechnologyToAncestorsTechnologyConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Connection between the Technology type and the ContentNode type */
export type TechnologyToContentNodeConnection = Connection & ContentNodeConnection & {
  __typename?: 'TechnologyToContentNodeConnection';
  /** Edges for the TechnologyToContentNodeConnection connection */
  edges: Array<TechnologyToContentNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<ContentNode>;
  /** Information about pagination in a connection. */
  pageInfo: TechnologyToContentNodeConnectionPageInfo;
};

/** An edge in a connection */
export type TechnologyToContentNodeConnectionEdge = ContentNodeConnectionEdge & Edge & {
  __typename?: 'TechnologyToContentNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: ContentNode;
};

/** Page Info on the &quot;TechnologyToContentNodeConnection&quot; */
export type TechnologyToContentNodeConnectionPageInfo = ContentNodeConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'TechnologyToContentNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the TechnologyToContentNodeConnection connection */
export type TechnologyToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypesOfTechnologyEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the Technology type and the technology type */
export type TechnologyToParentTechnologyConnectionEdge = Edge & OneToOneConnection & TechnologyConnectionEdge & {
  __typename?: 'TechnologyToParentTechnologyConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The node of the connection, without the edges */
  node: Technology;
};

/** Connection between the Technology type and the post type */
export type TechnologyToPostConnection = Connection & PostConnection & {
  __typename?: 'TechnologyToPostConnection';
  /** Edges for the TechnologyToPostConnection connection */
  edges: Array<TechnologyToPostConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Post>;
  /** Information about pagination in a connection. */
  pageInfo: TechnologyToPostConnectionPageInfo;
};

/** An edge in a connection */
export type TechnologyToPostConnectionEdge = Edge & PostConnectionEdge & {
  __typename?: 'TechnologyToPostConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Post;
};

/** Page Info on the &quot;TechnologyToPostConnection&quot; */
export type TechnologyToPostConnectionPageInfo = PageInfo & PostConnectionPageInfo & WpPageInfo & {
  __typename?: 'TechnologyToPostConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the TechnologyToPostConnection connection */
export type TechnologyToPostConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Category ID */
  categoryId?: InputMaybe<Scalars['Int']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Use Category Slug */
  categoryName?: InputMaybe<Scalars['String']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  tag?: InputMaybe<Scalars['String']>;
  /** Use Tag ID */
  tagId?: InputMaybe<Scalars['String']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  tagSlugAnd?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  tagSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the Technology type and the Taxonomy type */
export type TechnologyToTaxonomyConnectionEdge = Edge & OneToOneConnection & TaxonomyConnectionEdge & {
  __typename?: 'TechnologyToTaxonomyConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The node of the connection, without the edges */
  node: Taxonomy;
};

/** Connection between the Technology type and the technology type */
export type TechnologyToTechnologyConnection = Connection & TechnologyConnection & {
  __typename?: 'TechnologyToTechnologyConnection';
  /** Edges for the TechnologyToTechnologyConnection connection */
  edges: Array<TechnologyToTechnologyConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Technology>;
  /** Information about pagination in a connection. */
  pageInfo: TechnologyToTechnologyConnectionPageInfo;
};

/** An edge in a connection */
export type TechnologyToTechnologyConnectionEdge = Edge & TechnologyConnectionEdge & {
  __typename?: 'TechnologyToTechnologyConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Technology;
};

/** Page Info on the &quot;TechnologyToTechnologyConnection&quot; */
export type TechnologyToTechnologyConnectionPageInfo = PageInfo & TechnologyConnectionPageInfo & WpPageInfo & {
  __typename?: 'TechnologyToTechnologyConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the TechnologyToTechnologyConnection connection */
export type TechnologyToTechnologyConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Field Group */
export type TechnologyTechnologies = AcfFieldGroup & {
  __typename?: 'Technology_Technologies';
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** Terms are nodes within a Taxonomy, used to group and relate other nodes. */
export type TermNode = {
  /** The number of objects connected to the object */
  count?: Maybe<Scalars['Int']>;
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int'];
  /** The description of the object */
  description?: Maybe<Scalars['String']>;
  /** Connection between the TermNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<TermNodeToEnqueuedScriptConnection>;
  /** Connection between the TermNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<TermNodeToEnqueuedStylesheetConnection>;
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The link to the term */
  link?: Maybe<Scalars['String']>;
  /** The human friendly name of the object. */
  name?: Maybe<Scalars['String']>;
  /** The RankMath SEO data for the node. */
  seo?: Maybe<RankMathSeo>;
  /** An alphanumeric identifier for the object unique to its type. */
  slug?: Maybe<Scalars['String']>;
  /** The name of the taxonomy that the object is associated with */
  taxonomyName?: Maybe<Scalars['String']>;
  /** The ID of the term group that this term object belongs to */
  termGroupId?: Maybe<Scalars['Int']>;
  /** The taxonomy ID that the object is associated with */
  termTaxonomyId?: Maybe<Scalars['Int']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};


/** Terms are nodes within a Taxonomy, used to group and relate other nodes. */
export type TermNodeEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Terms are nodes within a Taxonomy, used to group and relate other nodes. */
export type TermNodeEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Connection to TermNode Nodes */
export type TermNodeConnection = {
  /** A list of edges (relational context) between RootQuery and connected TermNode Nodes */
  edges: Array<TermNodeConnectionEdge>;
  /** A list of connected TermNode Nodes */
  nodes: Array<TermNode>;
  /** Information about pagination in a connection. */
  pageInfo: TermNodeConnectionPageInfo;
};

/** Edge between a Node and a connected TermNode */
export type TermNodeConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The connected TermNode Node */
  node: TermNode;
};

/** Page Info on the connected TermNodeConnectionEdge */
export type TermNodeConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is "ID". To be used along with the "id" field. */
export enum TermNodeIdTypeEnum {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI'
}

/** Connection between the TermNode type and the EnqueuedScript type */
export type TermNodeToEnqueuedScriptConnection = Connection & EnqueuedScriptConnection & {
  __typename?: 'TermNodeToEnqueuedScriptConnection';
  /** Edges for the TermNodeToEnqueuedScriptConnection connection */
  edges: Array<TermNodeToEnqueuedScriptConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<EnqueuedScript>;
  /** Information about pagination in a connection. */
  pageInfo: TermNodeToEnqueuedScriptConnectionPageInfo;
};

/** An edge in a connection */
export type TermNodeToEnqueuedScriptConnectionEdge = Edge & EnqueuedScriptConnectionEdge & {
  __typename?: 'TermNodeToEnqueuedScriptConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: EnqueuedScript;
};

/** Page Info on the &quot;TermNodeToEnqueuedScriptConnection&quot; */
export type TermNodeToEnqueuedScriptConnectionPageInfo = EnqueuedScriptConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'TermNodeToEnqueuedScriptConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Connection between the TermNode type and the EnqueuedStylesheet type */
export type TermNodeToEnqueuedStylesheetConnection = Connection & EnqueuedStylesheetConnection & {
  __typename?: 'TermNodeToEnqueuedStylesheetConnection';
  /** Edges for the TermNodeToEnqueuedStylesheetConnection connection */
  edges: Array<TermNodeToEnqueuedStylesheetConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<EnqueuedStylesheet>;
  /** Information about pagination in a connection. */
  pageInfo: TermNodeToEnqueuedStylesheetConnectionPageInfo;
};

/** An edge in a connection */
export type TermNodeToEnqueuedStylesheetConnectionEdge = Edge & EnqueuedStylesheetConnectionEdge & {
  __typename?: 'TermNodeToEnqueuedStylesheetConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: EnqueuedStylesheet;
};

/** Page Info on the &quot;TermNodeToEnqueuedStylesheetConnection&quot; */
export type TermNodeToEnqueuedStylesheetConnectionPageInfo = EnqueuedStylesheetConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'TermNodeToEnqueuedStylesheetConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Options for ordering the connection by */
export enum TermObjectsConnectionOrderbyEnum {
  /** Order the connection by item count. */
  Count = 'COUNT',
  /** Order the connection by description. */
  Description = 'DESCRIPTION',
  /** Order the connection by name. */
  Name = 'NAME',
  /** Order the connection by slug. */
  Slug = 'SLUG',
  /** Order the connection by term group. */
  TermGroup = 'TERM_GROUP',
  /** Order the connection by term id. */
  TermId = 'TERM_ID',
  /** Order the connection by term order. */
  TermOrder = 'TERM_ORDER'
}

/** A theme object */
export type Theme = Node & {
  __typename?: 'Theme';
  /** Name of the theme author(s), could also be a company name. This field is equivalent to WP_Theme-&gt;get( &quot;Author&quot; ). */
  author?: Maybe<Scalars['String']>;
  /** URI for the author/company website. This field is equivalent to WP_Theme-&gt;get( &quot;AuthorURI&quot; ). */
  authorUri?: Maybe<Scalars['String']>;
  /** The description of the theme. This field is equivalent to WP_Theme-&gt;get( &quot;Description&quot; ). */
  description?: Maybe<Scalars['String']>;
  /** The globally unique identifier of the theme object. */
  id: Scalars['ID'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Display name of the theme. This field is equivalent to WP_Theme-&gt;get( &quot;Name&quot; ). */
  name?: Maybe<Scalars['String']>;
  /** The URL of the screenshot for the theme. The screenshot is intended to give an overview of what the theme looks like. This field is equivalent to WP_Theme-&gt;get_screenshot(). */
  screenshot?: Maybe<Scalars['String']>;
  /** The theme slug is used to internally match themes. Theme slugs can have subdirectories like: my-theme/sub-theme. This field is equivalent to WP_Theme-&gt;get_stylesheet(). */
  slug?: Maybe<Scalars['String']>;
  /** URI for the author/company website. This field is equivalent to WP_Theme-&gt;get( &quot;Tags&quot; ). */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A URI if the theme has a website associated with it. The Theme URI is handy for directing users to a theme site for support etc. This field is equivalent to WP_Theme-&gt;get( &quot;ThemeURI&quot; ). */
  themeUri?: Maybe<Scalars['String']>;
  /** The current version of the theme. This field is equivalent to WP_Theme-&gt;get( &quot;Version&quot; ). */
  version?: Maybe<Scalars['String']>;
};

/** Connection to Theme Nodes */
export type ThemeConnection = {
  /** A list of edges (relational context) between RootQuery and connected Theme Nodes */
  edges: Array<ThemeConnectionEdge>;
  /** A list of connected Theme Nodes */
  nodes: Array<Theme>;
  /** Information about pagination in a connection. */
  pageInfo: ThemeConnectionPageInfo;
};

/** Edge between a Node and a connected Theme */
export type ThemeConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The connected Theme Node */
  node: Theme;
};

/** Page Info on the connected ThemeConnectionEdge */
export type ThemeConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Any node that has a URI */
export type UniformResourceIdentifiable = {
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean'];
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};

/** Input for the updateCategory mutation. */
export type UpdateCategoryInput = {
  /** The slug that the category will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The description of the category object */
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the category object to update */
  id: Scalars['ID'];
  /** The name of the category object to mutate */
  name?: InputMaybe<Scalars['String']>;
  /** The ID of the category that should be set as the parent */
  parentId?: InputMaybe<Scalars['ID']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The payload for the updateCategory mutation. */
export type UpdateCategoryPayload = {
  __typename?: 'UpdateCategoryPayload';
  /** The created category */
  category?: Maybe<Category>;
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Input for the updateComment mutation. */
export type UpdateCommentInput = {
  /** The approval status of the comment. */
  approved?: InputMaybe<Scalars['String']>;
  /** The name of the comment's author. */
  author?: InputMaybe<Scalars['String']>;
  /** The email of the comment's author. */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** The url of the comment's author. */
  authorUrl?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The database ID of the post object the comment belongs to. */
  commentOn?: InputMaybe<Scalars['Int']>;
  /** Content of the comment. */
  content?: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day ( e.g. 01/31/2017 ) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date?: InputMaybe<Scalars['String']>;
  /** The ID of the comment being updated. */
  id: Scalars['ID'];
  /** Parent comment ID of current comment. */
  parent?: InputMaybe<Scalars['ID']>;
  /** The approval status of the comment */
  status?: InputMaybe<CommentStatusEnum>;
  /** Type of comment. */
  type?: InputMaybe<Scalars['String']>;
};

/** The payload for the updateComment mutation. */
export type UpdateCommentPayload = {
  __typename?: 'UpdateCommentPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The comment that was created */
  comment?: Maybe<Comment>;
  /** Whether the mutation succeeded. If the comment is not approved, the server will not return the comment to a non authenticated user, but a success message can be returned if the create succeeded, and the client can optimistically add the comment to the client cache */
  success?: Maybe<Scalars['Boolean']>;
};

/** Input for the updateGeneral mutation. */
export type UpdateGeneralInput = {
  /** The slug that the general will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The description of the general object */
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the general object to update */
  id: Scalars['ID'];
  /** The name of the general object to mutate */
  name?: InputMaybe<Scalars['String']>;
  /** The ID of the general that should be set as the parent */
  parentId?: InputMaybe<Scalars['ID']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The payload for the updateGeneral mutation. */
export type UpdateGeneralPayload = {
  __typename?: 'UpdateGeneralPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The created general */
  general?: Maybe<General>;
};

/** Input for the updateMediaItem mutation. */
export type UpdateMediaItemInput = {
  /** Alternative text to display when mediaItem is not displayed */
  altText?: InputMaybe<Scalars['String']>;
  /** The userId to assign as the author of the mediaItem */
  authorId?: InputMaybe<Scalars['ID']>;
  /** The caption for the mediaItem */
  caption?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The comment status for the mediaItem */
  commentStatus?: InputMaybe<Scalars['String']>;
  /** The date of the mediaItem */
  date?: InputMaybe<Scalars['String']>;
  /** The date (in GMT zone) of the mediaItem */
  dateGmt?: InputMaybe<Scalars['String']>;
  /** Description of the mediaItem */
  description?: InputMaybe<Scalars['String']>;
  /** The file name of the mediaItem */
  filePath?: InputMaybe<Scalars['String']>;
  /** The file type of the mediaItem */
  fileType?: InputMaybe<MimeTypeEnum>;
  /** The ID of the mediaItem object */
  id: Scalars['ID'];
  /** The ID of the parent object */
  parentId?: InputMaybe<Scalars['ID']>;
  /** The ping status for the mediaItem */
  pingStatus?: InputMaybe<Scalars['String']>;
  /** The slug of the mediaItem */
  slug?: InputMaybe<Scalars['String']>;
  /** The status of the mediaItem */
  status?: InputMaybe<MediaItemStatusEnum>;
  /** The title of the mediaItem */
  title?: InputMaybe<Scalars['String']>;
};

/** The payload for the updateMediaItem mutation. */
export type UpdateMediaItemPayload = {
  __typename?: 'UpdateMediaItemPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The MediaItem object mutation type. */
  mediaItem?: Maybe<MediaItem>;
};

/** Input for the updatePage mutation. */
export type UpdatePageInput = {
  /** The userId to assign as the author of the object */
  authorId?: InputMaybe<Scalars['ID']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The comment status for the object */
  commentStatus?: InputMaybe<Scalars['String']>;
  /** The content of the object */
  content?: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date?: InputMaybe<Scalars['String']>;
  /** The ID of the page object */
  id: Scalars['ID'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock?: InputMaybe<Scalars['Boolean']>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder?: InputMaybe<Scalars['Int']>;
  /** The ID of the parent object */
  parentId?: InputMaybe<Scalars['ID']>;
  /** The password used to protect the content of the object */
  password?: InputMaybe<Scalars['String']>;
  /** The slug of the object */
  slug?: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status?: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** The payload for the updatePage mutation. */
export type UpdatePagePayload = {
  __typename?: 'UpdatePagePayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  page?: Maybe<Page>;
};

/** Input for the updatePostFormat mutation. */
export type UpdatePostFormatInput = {
  /** The slug that the post_format will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The description of the post_format object */
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the postFormat object to update */
  id: Scalars['ID'];
  /** The name of the post_format object to mutate */
  name?: InputMaybe<Scalars['String']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The payload for the updatePostFormat mutation. */
export type UpdatePostFormatPayload = {
  __typename?: 'UpdatePostFormatPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The created post_format */
  postFormat?: Maybe<PostFormat>;
};

/** Input for the updatePost mutation. */
export type UpdatePostInput = {
  /** The userId to assign as the author of the object */
  authorId?: InputMaybe<Scalars['ID']>;
  /** Set connections between the post and categories */
  categories?: InputMaybe<PostCategoriesInput>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The comment status for the object */
  commentStatus?: InputMaybe<Scalars['String']>;
  /** The content of the object */
  content?: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date?: InputMaybe<Scalars['String']>;
  /** The excerpt of the object */
  excerpt?: InputMaybe<Scalars['String']>;
  /** Set connections between the post and general */
  general?: InputMaybe<PostGeneralInput>;
  /** The ID of the post object */
  id: Scalars['ID'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock?: InputMaybe<Scalars['Boolean']>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder?: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password?: InputMaybe<Scalars['String']>;
  /** The ping status for the object */
  pingStatus?: InputMaybe<Scalars['String']>;
  /** URLs that have been pinged. */
  pinged?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Set connections between the post and postFormats */
  postFormats?: InputMaybe<PostPostFormatsInput>;
  /** Set connections between the post and series */
  series?: InputMaybe<PostSeriesInput>;
  /** The slug of the object */
  slug?: InputMaybe<Scalars['String']>;
  /** Set connections between the post and solutions */
  solutions?: InputMaybe<PostSolutionsInput>;
  /** The status of the object */
  status?: InputMaybe<PostStatusEnum>;
  /** Set connections between the post and tags */
  tags?: InputMaybe<PostTagsInput>;
  /** Set connections between the post and technologies */
  technologies?: InputMaybe<PostTechnologiesInput>;
  /** The title of the object */
  title?: InputMaybe<Scalars['String']>;
  /** URLs queued to be pinged. */
  toPing?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** The payload for the updatePost mutation. */
export type UpdatePostPayload = {
  __typename?: 'UpdatePostPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  post?: Maybe<Post>;
};

/** Input for the updateSeries mutation. */
export type UpdateSeriesInput = {
  /** The slug that the series will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The description of the series object */
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the series object to update */
  id: Scalars['ID'];
  /** The name of the series object to mutate */
  name?: InputMaybe<Scalars['String']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The payload for the updateSeries mutation. */
export type UpdateSeriesPayload = {
  __typename?: 'UpdateSeriesPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The created series */
  series?: Maybe<Series>;
};

/** Input for the updateSettings mutation. */
export type UpdateSettingsInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Allow people to submit comments on new posts. */
  discussionSettingsDefaultCommentStatus?: InputMaybe<Scalars['String']>;
  /** Allow link notifications from other blogs (pingbacks and trackbacks) on new articles. */
  discussionSettingsDefaultPingStatus?: InputMaybe<Scalars['String']>;
  /** A date format for all date strings. */
  generalSettingsDateFormat?: InputMaybe<Scalars['String']>;
  /** Site tagline. */
  generalSettingsDescription?: InputMaybe<Scalars['String']>;
  /** This address is used for admin purposes, like new user notification. */
  generalSettingsEmail?: InputMaybe<Scalars['String']>;
  /** WordPress locale code. */
  generalSettingsLanguage?: InputMaybe<Scalars['String']>;
  /** A day number of the week that the week should start on. */
  generalSettingsStartOfWeek?: InputMaybe<Scalars['Int']>;
  /** A time format for all time strings. */
  generalSettingsTimeFormat?: InputMaybe<Scalars['String']>;
  /** A city in the same timezone as you. */
  generalSettingsTimezone?: InputMaybe<Scalars['String']>;
  /** Site title. */
  generalSettingsTitle?: InputMaybe<Scalars['String']>;
  /** Site URL. */
  generalSettingsUrl?: InputMaybe<Scalars['String']>;
  /** The ID of the page that should display the latest posts */
  readingSettingsPageForPosts?: InputMaybe<Scalars['Int']>;
  /** The ID of the page that should be displayed on the front page */
  readingSettingsPageOnFront?: InputMaybe<Scalars['Int']>;
  /** Blog pages show at most. */
  readingSettingsPostsPerPage?: InputMaybe<Scalars['Int']>;
  /** What to show on the front page */
  readingSettingsShowOnFront?: InputMaybe<Scalars['String']>;
  /** Default post category. */
  writingSettingsDefaultCategory?: InputMaybe<Scalars['Int']>;
  /** Default post format. */
  writingSettingsDefaultPostFormat?: InputMaybe<Scalars['String']>;
  /** Convert emoticons like :-) and :-P to graphics on display. */
  writingSettingsUseSmilies?: InputMaybe<Scalars['Boolean']>;
};

/** The payload for the updateSettings mutation. */
export type UpdateSettingsPayload = {
  __typename?: 'UpdateSettingsPayload';
  /** Update all settings. */
  allSettings?: Maybe<Settings>;
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Update the DiscussionSettings setting. */
  discussionSettings?: Maybe<DiscussionSettings>;
  /** Update the GeneralSettings setting. */
  generalSettings?: Maybe<GeneralSettings>;
  /** Update the ReadingSettings setting. */
  readingSettings?: Maybe<ReadingSettings>;
  /** Update the WritingSettings setting. */
  writingSettings?: Maybe<WritingSettings>;
};

/** Input for the updateSolution mutation. */
export type UpdateSolutionInput = {
  /** The slug that the solutions will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The description of the solutions object */
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the solution object to update */
  id: Scalars['ID'];
  /** The name of the solutions object to mutate */
  name?: InputMaybe<Scalars['String']>;
  /** The ID of the solutions that should be set as the parent */
  parentId?: InputMaybe<Scalars['ID']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The payload for the updateSolution mutation. */
export type UpdateSolutionPayload = {
  __typename?: 'UpdateSolutionPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The created solutions */
  solution?: Maybe<Solution>;
};

/** Input for the updateTag mutation. */
export type UpdateTagInput = {
  /** The slug that the post_tag will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The description of the post_tag object */
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the tag object to update */
  id: Scalars['ID'];
  /** The name of the post_tag object to mutate */
  name?: InputMaybe<Scalars['String']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The payload for the updateTag mutation. */
export type UpdateTagPayload = {
  __typename?: 'UpdateTagPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The created post_tag */
  tag?: Maybe<Tag>;
};

/** Input for the updateTechnology mutation. */
export type UpdateTechnologyInput = {
  /** The slug that the technologies will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The description of the technologies object */
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the technology object to update */
  id: Scalars['ID'];
  /** The name of the technologies object to mutate */
  name?: InputMaybe<Scalars['String']>;
  /** The ID of the technologies that should be set as the parent */
  parentId?: InputMaybe<Scalars['ID']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The payload for the updateTechnology mutation. */
export type UpdateTechnologyPayload = {
  __typename?: 'UpdateTechnologyPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The created technologies */
  technology?: Maybe<Technology>;
};

/** Input for the updateUser mutation. */
export type UpdateUserInput = {
  /** User's AOL IM account. */
  aim?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** A string containing content about the user. */
  description?: InputMaybe<Scalars['String']>;
  /** A string that will be shown on the site. Defaults to user's username. It is likely that you will want to change this, for both appearance and security through obscurity (that is if you dont use and delete the default admin user). */
  displayName?: InputMaybe<Scalars['String']>;
  /** A string containing the user's email address. */
  email?: InputMaybe<Scalars['String']>;
  /** 	The user's first name. */
  firstName?: InputMaybe<Scalars['String']>;
  /** The ID of the user */
  id: Scalars['ID'];
  /** User's Jabber account. */
  jabber?: InputMaybe<Scalars['String']>;
  /** The user's last name. */
  lastName?: InputMaybe<Scalars['String']>;
  /** User's locale. */
  locale?: InputMaybe<Scalars['String']>;
  /** A string that contains a URL-friendly name for the user. The default is the user's username. */
  nicename?: InputMaybe<Scalars['String']>;
  /** The user's nickname, defaults to the user's username. */
  nickname?: InputMaybe<Scalars['String']>;
  /** A string that contains the plain text password for the user. */
  password?: InputMaybe<Scalars['String']>;
  /** The date the user registered. Format is Y-m-d H:i:s. */
  registered?: InputMaybe<Scalars['String']>;
  /** A string for whether to enable the rich editor or not. False if not empty. */
  richEditing?: InputMaybe<Scalars['String']>;
  /** An array of roles to be assigned to the user. */
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** A string containing the user's URL for the user's web site. */
  websiteUrl?: InputMaybe<Scalars['String']>;
  /** User's Yahoo IM account. */
  yim?: InputMaybe<Scalars['String']>;
};

/** The payload for the updateUser mutation. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The User object mutation type. */
  user?: Maybe<User>;
};

/** A User object */
export type User = Commenter & DatabaseIdentifier & Node & NodeWithRankMathSeo & UniformResourceIdentifiable & {
  __typename?: 'User';
  /** Avatar object for user. The avatar object can be retrieved in different sizes by specifying the size argument. */
  avatar?: Maybe<Avatar>;
  /** User metadata option name. Usually it will be &quot;wp_capabilities&quot;. */
  capKey?: Maybe<Scalars['String']>;
  /** A list of capabilities (permissions) granted to the user */
  capabilities?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Connection between the User type and the Comment type */
  comments?: Maybe<UserToCommentConnection>;
  /** Added to the GraphQL Schema because the ACF Field Group &quot;User Options&quot; was set to Show in GraphQL. */
  customFields?: Maybe<UserCustomfields>;
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int'];
  /** Description of the user. */
  description?: Maybe<Scalars['String']>;
  /** Email address of the user. This is equivalent to the WP_User-&gt;user_email property. */
  email?: Maybe<Scalars['String']>;
  /** Connection between the User type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<UserToEnqueuedScriptConnection>;
  /** Connection between the User type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<UserToEnqueuedStylesheetConnection>;
  /** A complete list of capabilities including capabilities inherited from a role. This is equivalent to the array keys of WP_User-&gt;allcaps. */
  extraCapabilities?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** First name of the user. This is equivalent to the WP_User-&gt;user_first_name property. */
  firstName?: Maybe<Scalars['String']>;
  /** The globally unique identifier for the user object. */
  id: Scalars['ID'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** Last name of the user. This is equivalent to the WP_User-&gt;user_last_name property. */
  lastName?: Maybe<Scalars['String']>;
  /** The preferred language locale set for the user. Value derived from get_user_locale(). */
  locale?: Maybe<Scalars['String']>;
  /** Connection between the User type and the mediaItem type */
  mediaItems?: Maybe<UserToMediaItemConnection>;
  /** Display name of the user. This is equivalent to the WP_User-&gt;display_name property. */
  name?: Maybe<Scalars['String']>;
  /** The nicename for the user. This field is equivalent to WP_User-&gt;user_nicename */
  nicename?: Maybe<Scalars['String']>;
  /** Nickname of the user. */
  nickname?: Maybe<Scalars['String']>;
  /** Connection between the User type and the page type */
  pages?: Maybe<UserToPageConnection>;
  /** Connection between the User type and the post type */
  posts?: Maybe<UserToPostConnection>;
  /** The date the user registered or was created. The field follows a full ISO8601 date string format. */
  registeredDate?: Maybe<Scalars['String']>;
  /** Connection between the User and Revisions authored by the user */
  revisions?: Maybe<UserToRevisionsConnection>;
  /** Connection between the User type and the UserRole type */
  roles?: Maybe<UserToUserRoleConnection>;
  /** The RankMath SEO data for the node. */
  seo?: Maybe<RankMathSeo>;
  /** Whether the Toolbar should be displayed when the user is viewing the site. */
  shouldShowAdminToolbar?: Maybe<Scalars['Boolean']>;
  /** The slug for the user. This field is equivalent to WP_User-&gt;user_nicename */
  slug?: Maybe<Scalars['String']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
  /** A website url that is associated with the user. */
  url?: Maybe<Scalars['String']>;
  /**
   * The Id of the user. Equivalent to WP_User-&gt;ID
   * @deprecated Deprecated in favor of the databaseId field
   */
  userId?: Maybe<Scalars['Int']>;
  /** Username for the user. This field is equivalent to WP_User-&gt;user_login. */
  username?: Maybe<Scalars['String']>;
};


/** A User object */
export type UserAvatarArgs = {
  forceDefault?: InputMaybe<Scalars['Boolean']>;
  rating?: InputMaybe<AvatarRatingEnum>;
  size?: InputMaybe<Scalars['Int']>;
};


/** A User object */
export type UserCommentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserToCommentConnectionWhereArgs>;
};


/** A User object */
export type UserEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** A User object */
export type UserEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** A User object */
export type UserMediaItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserToMediaItemConnectionWhereArgs>;
};


/** A User object */
export type UserPagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserToPageConnectionWhereArgs>;
};


/** A User object */
export type UserPostsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserToPostConnectionWhereArgs>;
};


/** A User object */
export type UserRevisionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserToRevisionsConnectionWhereArgs>;
};


/** A User object */
export type UserRolesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Connection to User Nodes */
export type UserConnection = {
  /** A list of edges (relational context) between RootQuery and connected User Nodes */
  edges: Array<UserConnectionEdge>;
  /** A list of connected User Nodes */
  nodes: Array<User>;
  /** Information about pagination in a connection. */
  pageInfo: UserConnectionPageInfo;
};

/** Edge between a Node and a connected User */
export type UserConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The connected User Node */
  node: User;
};

/** Page Info on the connected UserConnectionEdge */
export type UserConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single User node. To be used along with the "id" field. Default is "ID". */
export enum UserNodeIdTypeEnum {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The Email of the User */
  Email = 'EMAIL',
  /** The hashed Global ID */
  Id = 'ID',
  /** The slug of the User */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI',
  /** The username the User uses to login with */
  Username = 'USERNAME'
}

/** A user role object */
export type UserRole = Node & {
  __typename?: 'UserRole';
  /** The capabilities that belong to this role */
  capabilities?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The display name of the role */
  displayName?: Maybe<Scalars['String']>;
  /** The globally unique identifier for the user role object. */
  id: Scalars['ID'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** The registered name of the role */
  name?: Maybe<Scalars['String']>;
};

/** Connection to UserRole Nodes */
export type UserRoleConnection = {
  /** A list of edges (relational context) between RootQuery and connected UserRole Nodes */
  edges: Array<UserRoleConnectionEdge>;
  /** A list of connected UserRole Nodes */
  nodes: Array<UserRole>;
  /** Information about pagination in a connection. */
  pageInfo: UserRoleConnectionPageInfo;
};

/** Edge between a Node and a connected UserRole */
export type UserRoleConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']>;
  /** The connected UserRole Node */
  node: UserRole;
};

/** Page Info on the connected UserRoleConnectionEdge */
export type UserRoleConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Names of available user roles */
export enum UserRoleEnum {
  /** User role with specific capabilities */
  Administrator = 'ADMINISTRATOR',
  /** User role with specific capabilities */
  Author = 'AUTHOR',
  /** User role with specific capabilities */
  Contributor = 'CONTRIBUTOR',
  /** User role with specific capabilities */
  Editor = 'EDITOR',
  /** User role with specific capabilities */
  Subscriber = 'SUBSCRIBER'
}

/** Connection between the User type and the Comment type */
export type UserToCommentConnection = CommentConnection & Connection & {
  __typename?: 'UserToCommentConnection';
  /** Edges for the UserToCommentConnection connection */
  edges: Array<UserToCommentConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Comment>;
  /** Information about pagination in a connection. */
  pageInfo: UserToCommentConnectionPageInfo;
};

/** An edge in a connection */
export type UserToCommentConnectionEdge = CommentConnectionEdge & Edge & {
  __typename?: 'UserToCommentConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Comment;
};

/** Page Info on the &quot;UserToCommentConnection&quot; */
export type UserToCommentConnectionPageInfo = CommentConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'UserToCommentConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the UserToCommentConnection connection */
export type UserToCommentConnectionWhereArgs = {
  /** Comment author email address. */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** Array of author IDs to include comments for. */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to exclude comments for. */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Comment author URL. */
  authorUrl?: InputMaybe<Scalars['String']>;
  /** Array of comment IDs to include. */
  commentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  commentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Include comments of a given type. */
  commentType?: InputMaybe<Scalars['String']>;
  /** Include comments from a given array of comment types. */
  commentTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude comments from a given array of comment types. */
  commentTypeNotIn?: InputMaybe<Scalars['String']>;
  /** Content object author ID to limit results by. */
  contentAuthor?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to retrieve comments for. */
  contentAuthorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  contentAuthorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  contentId?: InputMaybe<Scalars['ID']>;
  /** Array of content object IDs to include affiliated comments for. */
  contentIdIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  contentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  contentName?: InputMaybe<Scalars['String']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  contentParent?: InputMaybe<Scalars['Int']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentStatus?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentType?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  includeUnapproved?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Karma score to retrieve matching comments for. */
  karma?: InputMaybe<Scalars['Int']>;
  /** The cardinality of the order of the connection */
  order?: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  orderby?: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Array of parent IDs of comments to retrieve children for. */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Search term(s) to retrieve matching comments for. */
  search?: InputMaybe<Scalars['String']>;
  /** Comment status to limit results by. */
  status?: InputMaybe<Scalars['String']>;
  /** Include comments for a specific user ID. */
  userId?: InputMaybe<Scalars['ID']>;
};

/** Connection between the User type and the EnqueuedScript type */
export type UserToEnqueuedScriptConnection = Connection & EnqueuedScriptConnection & {
  __typename?: 'UserToEnqueuedScriptConnection';
  /** Edges for the UserToEnqueuedScriptConnection connection */
  edges: Array<UserToEnqueuedScriptConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<EnqueuedScript>;
  /** Information about pagination in a connection. */
  pageInfo: UserToEnqueuedScriptConnectionPageInfo;
};

/** An edge in a connection */
export type UserToEnqueuedScriptConnectionEdge = Edge & EnqueuedScriptConnectionEdge & {
  __typename?: 'UserToEnqueuedScriptConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: EnqueuedScript;
};

/** Page Info on the &quot;UserToEnqueuedScriptConnection&quot; */
export type UserToEnqueuedScriptConnectionPageInfo = EnqueuedScriptConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'UserToEnqueuedScriptConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Connection between the User type and the EnqueuedStylesheet type */
export type UserToEnqueuedStylesheetConnection = Connection & EnqueuedStylesheetConnection & {
  __typename?: 'UserToEnqueuedStylesheetConnection';
  /** Edges for the UserToEnqueuedStylesheetConnection connection */
  edges: Array<UserToEnqueuedStylesheetConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<EnqueuedStylesheet>;
  /** Information about pagination in a connection. */
  pageInfo: UserToEnqueuedStylesheetConnectionPageInfo;
};

/** An edge in a connection */
export type UserToEnqueuedStylesheetConnectionEdge = Edge & EnqueuedStylesheetConnectionEdge & {
  __typename?: 'UserToEnqueuedStylesheetConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: EnqueuedStylesheet;
};

/** Page Info on the &quot;UserToEnqueuedStylesheetConnection&quot; */
export type UserToEnqueuedStylesheetConnectionPageInfo = EnqueuedStylesheetConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'UserToEnqueuedStylesheetConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Connection between the User type and the mediaItem type */
export type UserToMediaItemConnection = Connection & MediaItemConnection & {
  __typename?: 'UserToMediaItemConnection';
  /** Edges for the UserToMediaItemConnection connection */
  edges: Array<UserToMediaItemConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<MediaItem>;
  /** Information about pagination in a connection. */
  pageInfo: UserToMediaItemConnectionPageInfo;
};

/** An edge in a connection */
export type UserToMediaItemConnectionEdge = Edge & MediaItemConnectionEdge & {
  __typename?: 'UserToMediaItemConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: MediaItem;
};

/** Page Info on the &quot;UserToMediaItemConnection&quot; */
export type UserToMediaItemConnectionPageInfo = MediaItemConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'UserToMediaItemConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the UserToMediaItemConnection connection */
export type UserToMediaItemConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the User type and the page type */
export type UserToPageConnection = Connection & PageConnection & {
  __typename?: 'UserToPageConnection';
  /** Edges for the UserToPageConnection connection */
  edges: Array<UserToPageConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Page>;
  /** Information about pagination in a connection. */
  pageInfo: UserToPageConnectionPageInfo;
};

/** An edge in a connection */
export type UserToPageConnectionEdge = Edge & PageConnectionEdge & {
  __typename?: 'UserToPageConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Page;
};

/** Page Info on the &quot;UserToPageConnection&quot; */
export type UserToPageConnectionPageInfo = PageConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'UserToPageConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the UserToPageConnection connection */
export type UserToPageConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the User type and the post type */
export type UserToPostConnection = Connection & PostConnection & {
  __typename?: 'UserToPostConnection';
  /** Edges for the UserToPostConnection connection */
  edges: Array<UserToPostConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Post>;
  /** Information about pagination in a connection. */
  pageInfo: UserToPostConnectionPageInfo;
};

/** An edge in a connection */
export type UserToPostConnectionEdge = Edge & PostConnectionEdge & {
  __typename?: 'UserToPostConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: Post;
};

/** Page Info on the &quot;UserToPostConnection&quot; */
export type UserToPostConnectionPageInfo = PageInfo & PostConnectionPageInfo & WpPageInfo & {
  __typename?: 'UserToPostConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the UserToPostConnection connection */
export type UserToPostConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Category ID */
  categoryId?: InputMaybe<Scalars['Int']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Use Category Slug */
  categoryName?: InputMaybe<Scalars['String']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  tag?: InputMaybe<Scalars['String']>;
  /** Use Tag ID */
  tagId?: InputMaybe<Scalars['String']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  tagSlugAnd?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  tagSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the User type and the ContentNode type */
export type UserToRevisionsConnection = Connection & ContentNodeConnection & {
  __typename?: 'UserToRevisionsConnection';
  /** Edges for the UserToRevisionsConnection connection */
  edges: Array<UserToRevisionsConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<ContentNode>;
  /** Information about pagination in a connection. */
  pageInfo: UserToRevisionsConnectionPageInfo;
};

/** An edge in a connection */
export type UserToRevisionsConnectionEdge = ContentNodeConnectionEdge & Edge & {
  __typename?: 'UserToRevisionsConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: ContentNode;
};

/** Page Info on the &quot;UserToRevisionsConnection&quot; */
export type UserToRevisionsConnectionPageInfo = ContentNodeConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'UserToRevisionsConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Arguments for filtering the UserToRevisionsConnection connection */
export type UserToRevisionsConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the User type and the UserRole type */
export type UserToUserRoleConnection = Connection & UserRoleConnection & {
  __typename?: 'UserToUserRoleConnection';
  /** Edges for the UserToUserRoleConnection connection */
  edges: Array<UserToUserRoleConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<UserRole>;
  /** Information about pagination in a connection. */
  pageInfo: UserToUserRoleConnectionPageInfo;
};

/** An edge in a connection */
export type UserToUserRoleConnectionEdge = Edge & UserRoleConnectionEdge & {
  __typename?: 'UserToUserRoleConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node: UserRole;
};

/** Page Info on the &quot;UserToUserRoleConnection&quot; */
export type UserToUserRoleConnectionPageInfo = PageInfo & UserRoleConnectionPageInfo & WpPageInfo & {
  __typename?: 'UserToUserRoleConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Field Group */
export type UserCustomfields = AcfFieldGroup & {
  __typename?: 'User_Customfields';
  authorImage?: Maybe<Scalars['String']>;
  bdRole?: Maybe<Scalars['String']>;
  /**
   * Enter the longer biographical information here. For a shorter bio, use the default WordPress Bio input above.
   * Please keep this between 50-150 words to best suit it in the UI.
   */
  bioLong?: Maybe<Scalars['String']>;
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
  generalTags?: Maybe<Array<Maybe<General>>>;
  instagram?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  solutions?: Maybe<Array<Maybe<Solution>>>;
  technologies?: Maybe<Array<Maybe<Technology>>>;
  verifiedAt?: Maybe<Scalars['Boolean']>;
  xTwitter?: Maybe<Scalars['String']>;
  yearsOfExperience?: Maybe<Scalars['Float']>;
  youtube?: Maybe<Scalars['String']>;
};

/** Field to order the connection by */
export enum UsersConnectionOrderbyEnum {
  /** Order by display name */
  DisplayName = 'DISPLAY_NAME',
  /** Order by email address */
  Email = 'EMAIL',
  /** Order by login */
  Login = 'LOGIN',
  /** Preserve the login order given in the LOGIN_IN array */
  LoginIn = 'LOGIN_IN',
  /** Order by nice name */
  NiceName = 'NICE_NAME',
  /** Preserve the nice name order given in the NICE_NAME_IN array */
  NiceNameIn = 'NICE_NAME_IN',
  /** Order by registration date */
  Registered = 'REGISTERED',
  /** Order by URL */
  Url = 'URL'
}

/** Options for ordering the connection */
export type UsersConnectionOrderbyInput = {
  /** The field name used to sort the results. */
  field: UsersConnectionOrderbyEnum;
  /** The cardinality of the order of the connection */
  order?: InputMaybe<OrderEnum>;
};

/** Column used for searching for users. */
export enum UsersConnectionSearchColumnEnum {
  /** The user's email address. */
  Email = 'EMAIL',
  /** The globally unique ID. */
  Id = 'ID',
  /** The username the User uses to login with. */
  Login = 'LOGIN',
  /** A URL-friendly name for the user. The default is the user's username. */
  Nicename = 'NICENAME',
  /** The URL of the user's website. */
  Url = 'URL'
}

/** Information about pagination in a connection. */
export type WpPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Get information about the offset pagination state in the current connection */
  offsetPagination?: Maybe<OffsetPaginationPageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** The writing setting type */
export type WritingSettings = {
  __typename?: 'WritingSettings';
  /** Default post category. */
  defaultCategory?: Maybe<Scalars['Int']>;
  /** Default post format. */
  defaultPostFormat?: Maybe<Scalars['String']>;
  /** Convert emoticons like :-) and :-P to graphics on display. */
  useSmilies?: Maybe<Scalars['Boolean']>;
};

export type AllPostsQueryVariables = Exact<{
  perPage?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type AllPostsQuery = { __typename?: 'RootQuery', posts?: { __typename?: 'RootQueryToPostConnection', edges: Array<{ __typename?: 'RootQueryToPostConnectionEdge', node: { __typename?: 'Post', date?: string | null, id: string, slug?: string | null, title?: string | null, excerpt?: string | null, timeToRead?: number | null, postOptions?: { __typename?: 'Post_Postoptions', elementsVisibilityOptions?: { __typename?: 'Post_Postoptions_ElementsVisibilityOptions', hideAuthor?: boolean | null } | null } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', id: string, altText?: string | null, mediaDetails?: { __typename?: 'MediaDetails', file?: string | null } | null } } | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', id: string, databaseId: number, slug?: string | null, name?: string | null }> } | null, author?: { __typename?: 'NodeWithAuthorToUserConnectionEdge', node: { __typename?: 'User', id: string, name?: string | null, avatar?: { __typename?: 'Avatar', url?: string | null } | null, customFields?: { __typename?: 'User_Customfields', authorImage?: string | null } | null } } | null } }>, pageInfo: { __typename?: 'RootQueryToPostConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null } } | null };

export type AllPostsPathsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPostsPathsQuery = { __typename?: 'RootQuery', posts?: { __typename?: 'RootQueryToPostConnection', pageInfo: { __typename?: 'RootQueryToPostConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', total?: number | null } | null } } | null };

export type AuthorSeoFragment = { __typename?: 'User', name?: string | null, seo?: { __typename?: 'RankMathCategoryTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathGeneralTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathMediaItemObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathMediaItemTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPageObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPageTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostFormatTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathSeriesTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathSolutionTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathTagTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathTechnologyTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathUserSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | null, avatar?: { __typename?: 'Avatar', height?: number | null, width?: number | null, url?: string | null } | null, customFields?: { __typename?: 'User_Customfields', authorImage?: string | null } | null };

export type AuthorPageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AuthorPageQuery = { __typename?: 'RootQuery', user?: { __typename?: 'User', databaseId: number, name?: string | null, slug?: string | null, description?: string | null, avatar?: { __typename?: 'Avatar', url?: string | null, height?: number | null, width?: number | null } | null, customFields?: { __typename?: 'User_Customfields', authorImage?: string | null, bdRole?: string | null, bioLong?: string | null, verifiedAt?: boolean | null, xTwitter?: string | null, yearsOfExperience?: number | null, youtube?: string | null, linkedin?: string | null, instagram?: string | null, generalTags?: Array<{ __typename?: 'General', name?: string | null, databaseId: number, generalTags?: { __typename?: 'General_Generaltags', url?: string | null } | null } | null> | null, solutions?: Array<{ __typename?: 'Solution', name?: string | null, databaseId: number, solutions?: { __typename?: 'Solution_Solutions', url?: string | null } | null } | null> | null, technologies?: Array<{ __typename?: 'Technology', name?: string | null, databaseId: number, technologies?: { __typename?: 'Technology_Technologies', url?: string | null } | null } | null> | null } | null, seo?: { __typename?: 'RankMathCategoryTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathGeneralTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathMediaItemObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathMediaItemTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPageObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPageTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostFormatTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathSeriesTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathSolutionTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathTagTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathTechnologyTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathUserSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | null } | null };

export type AuthorPostsQueryVariables = Exact<{
  authorId?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type AuthorPostsQuery = { __typename?: 'RootQuery', posts?: { __typename?: 'RootQueryToPostConnection', edges: Array<{ __typename?: 'RootQueryToPostConnectionEdge', node: { __typename?: 'Post', date?: string | null, id: string, slug?: string | null, title?: string | null, excerpt?: string | null, timeToRead?: number | null, postOptions?: { __typename?: 'Post_Postoptions', elementsVisibilityOptions?: { __typename?: 'Post_Postoptions_ElementsVisibilityOptions', hideAuthor?: boolean | null } | null } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', id: string, altText?: string | null, mediaDetails?: { __typename?: 'MediaDetails', file?: string | null } | null } } | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', id: string, databaseId: number, slug?: string | null, name?: string | null }> } | null, author?: { __typename?: 'NodeWithAuthorToUserConnectionEdge', node: { __typename?: 'User', id: string, name?: string | null, avatar?: { __typename?: 'Avatar', url?: string | null } | null, customFields?: { __typename?: 'User_Customfields', authorImage?: string | null } | null } } | null } }>, pageInfo: { __typename?: 'RootQueryToPostConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null } } | null };

export type AuthorPathsQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthorPathsQuery = { __typename?: 'RootQuery', users?: { __typename?: 'RootQueryToUserConnection', nodes: Array<{ __typename?: 'User', slug?: string | null, posts?: { __typename?: 'UserToPostConnection', pageInfo: { __typename?: 'UserToPostConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', total?: number | null } | null } } | null }> } | null };

export type AllAuthorsQueryVariables = Exact<{
  size?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type AllAuthorsQuery = { __typename?: 'RootQuery', users?: { __typename?: 'RootQueryToUserConnection', nodes: Array<{ __typename?: 'User', slug?: string | null, firstName?: string | null, lastName?: string | null, posts?: { __typename?: 'UserToPostConnection', pageInfo: { __typename?: 'UserToPostConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', total?: number | null } | null } } | null, customFields?: { __typename?: 'User_Customfields', authorImage?: string | null, bdRole?: string | null } | null }>, pageInfo: { __typename?: 'RootQueryToUserConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', total?: number | null, hasMore?: boolean | null, hasPrevious?: boolean | null } | null } } | null };

export type CountAuthorsQueryVariables = Exact<{ [key: string]: never; }>;


export type CountAuthorsQuery = { __typename?: 'RootQuery', users?: { __typename?: 'RootQueryToUserConnection', pageInfo: { __typename?: 'RootQueryToUserConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', total?: number | null } | null } } | null };

export type LastThreePostsQueryVariables = Exact<{ [key: string]: never; }>;


export type LastThreePostsQuery = { __typename?: 'RootQuery', posts?: { __typename?: 'RootQueryToPostConnection', nodes: Array<{ __typename?: 'Post', id: string, date?: string | null, slug?: string | null, title?: string | null, excerpt?: string | null, timeToRead?: number | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', id: string, altText?: string | null, mediaDetails?: { __typename?: 'MediaDetails', file?: string | null } | null } } | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', id: string, databaseId: number, slug?: string | null, name?: string | null }> } | null, author?: { __typename?: 'NodeWithAuthorToUserConnectionEdge', node: { __typename?: 'User', id: string, name?: string | null, avatar?: { __typename?: 'Avatar', url?: string | null } | null, customFields?: { __typename?: 'User_Customfields', authorImage?: string | null } | null } } | null }> } | null };

export type SubcategoryPageQueryVariables = Exact<{
  slug: Scalars['ID'];
  categoryName: Scalars['String'];
  postOffset?: InputMaybe<Scalars['Int']>;
}>;


export type SubcategoryPageQuery = { __typename?: 'RootQuery', category?: { __typename?: 'Category', name?: string | null, description?: string | null, count?: number | null, parentDatabaseId?: number | null, parent?: { __typename?: 'CategoryToParentCategoryConnectionEdge', node: { __typename?: 'Category', name?: string | null, slug?: string | null, children?: { __typename?: 'CategoryToCategoryConnection', nodes: Array<{ __typename?: 'Category', parentDatabaseId?: number | null, name?: string | null, slug?: string | null, count?: number | null }> } | null } } | null, categoryPage?: { __typename?: 'Category_Categorypage', ctaHeadline?: string | null, ctaBody?: string | null, about?: string | null, ctaLinks?: Array<{ __typename?: 'Category_Categorypage_hubCtaLinks', label?: string | null, url?: string | null } | null> | null, featuredPosts?: Array<{ __typename?: 'Post', id: string, title?: string | null, slug?: string | null, timeToRead?: number | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, mediaDetails?: { __typename?: 'MediaDetails', file?: string | null } | null } } | null } | null> | null } | null, seo?: { __typename?: 'RankMathCategoryTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathGeneralTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathMediaItemObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathMediaItemTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPageObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPageTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostFormatTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathSeriesTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathSolutionTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathTagTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathTechnologyTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathUserSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | null } | null, posts?: { __typename?: 'RootQueryToPostConnection', pageInfo: { __typename?: 'RootQueryToPostConnectionPageInfo', hasNextPage: boolean, offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', total?: number | null } | null }, nodes: Array<{ __typename?: 'Post', id: string, title?: string | null, slug?: string | null, timeToRead?: number | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, mediaDetails?: { __typename?: 'MediaDetails', file?: string | null } | null } } | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null, slug?: string | null, parentDatabaseId?: number | null }> } | null, author?: { __typename?: 'NodeWithAuthorToUserConnectionEdge', node: { __typename?: 'User', name?: string | null, customFields?: { __typename?: 'User_Customfields', authorImage?: string | null } | null } } | null }> } | null };

export type SubcategoryPathsQueryVariables = Exact<{ [key: string]: never; }>;


export type SubcategoryPathsQuery = { __typename?: 'RootQuery', categories?: { __typename?: 'RootQueryToCategoryConnection', nodes: Array<{ __typename?: 'Category', slug?: string | null, parentDatabaseId?: number | null, parent?: { __typename?: 'CategoryToParentCategoryConnectionEdge', node: { __typename?: 'Category', name?: string | null, slug?: string | null } } | null, posts?: { __typename?: 'CategoryToPostConnection', pageInfo: { __typename?: 'CategoryToPostConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', total?: number | null } | null } } | null }> } | null };

export type CategoryPageQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;


export type CategoryPageQuery = { __typename?: 'RootQuery', category?: { __typename?: 'Category', name?: string | null, description?: string | null, count?: number | null, parentDatabaseId?: number | null, children?: { __typename?: 'CategoryToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null, slug?: string | null, count?: number | null, description?: string | null }> } | null, posts?: { __typename?: 'CategoryToPostConnection', nodes: Array<{ __typename?: 'Post', id: string, title?: string | null, slug?: string | null, timeToRead?: number | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, mediaDetails?: { __typename?: 'MediaDetails', file?: string | null } | null } } | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null, slug?: string | null, parentDatabaseId?: number | null }> } | null, author?: { __typename?: 'NodeWithAuthorToUserConnectionEdge', node: { __typename?: 'User', name?: string | null, customFields?: { __typename?: 'User_Customfields', authorImage?: string | null } | null } } | null }> } | null, categoryPage?: { __typename?: 'Category_Categorypage', ctaHeadline?: string | null, ctaBody?: string | null, about?: string | null, ctaLinks?: Array<{ __typename?: 'Category_Categorypage_hubCtaLinks', label?: string | null, url?: string | null } | null> | null, faq?: Array<{ __typename?: 'Category_Categorypage_hubFaq', question?: string | null, answer?: string | null } | null> | null, featuredPosts?: Array<{ __typename?: 'Post', id: string, title?: string | null, slug?: string | null, timeToRead?: number | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, mediaDetails?: { __typename?: 'MediaDetails', file?: string | null } | null } } | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null, slug?: string | null, parentDatabaseId?: number | null }> } | null } | null> | null } | null, seo?: { __typename?: 'RankMathCategoryTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathGeneralTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathMediaItemObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathMediaItemTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPageObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPageTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostFormatTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathSeriesTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathSolutionTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathTagTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathTechnologyTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathUserSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | null } | null };

export type CategoryPathsQueryVariables = Exact<{ [key: string]: never; }>;


export type CategoryPathsQuery = { __typename?: 'RootQuery', categories?: { __typename?: 'RootQueryToCategoryConnection', nodes: Array<{ __typename?: 'Category', slug?: string | null }> } | null };

export type SeoHomePageFragment = { __typename?: 'RootQuery', rankMathSettings?: { __typename?: 'RankMathSettings', meta?: { __typename?: 'RankMathMeta', homepage?: { __typename?: 'RankMathHomepageMetaSettings', description?: string | null, socialTitle?: string | null, socialDescription?: string | null, robotsMeta?: Array<RankMathRobotsMetaValueEnum | null> | null, socialImage?: { __typename?: 'MediaItem', altText?: string | null, mimeType?: string | null, sourceUrl?: string | null, mediaDetails?: { __typename?: 'MediaDetails', width?: number | null, height?: number | null } | null } | null } | null } | null } | null, nodeByUri?: { __typename?: 'Category' } | { __typename?: 'Comment' } | { __typename?: 'ContentType', seo?: { __typename?: 'RankMathCategoryTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathGeneralTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathMediaItemObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathMediaItemTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPageObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPageTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostFormatTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathSeriesTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathSolutionTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathTagTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathTechnologyTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathUserSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | null } | { __typename?: 'General' } | { __typename?: 'MediaItem' } | { __typename?: 'Page' } | { __typename?: 'Post' } | { __typename?: 'PostFormat' } | { __typename?: 'Series' } | { __typename?: 'Solution' } | { __typename?: 'Tag' } | { __typename?: 'Technology' } | { __typename?: 'User' } | null, acfOptionsBlogHomepageOptions?: { __typename?: 'AcfOptionsBlogHomepageOptions', blogHomeOptions?: { __typename?: 'AcfOptionsBlogHomepageOptions_Bloghomeoptions', featuredPost?: { __typename?: 'Post', id: string, seo?: { __typename?: 'RankMathCategoryTermSeo', robots?: Array<string | null> | null } | { __typename?: 'RankMathGeneralTermSeo', robots?: Array<string | null> | null } | { __typename?: 'RankMathMediaItemObjectSeo', robots?: Array<string | null> | null } | { __typename?: 'RankMathMediaItemTypeSeo', robots?: Array<string | null> | null } | { __typename?: 'RankMathPageObjectSeo', robots?: Array<string | null> | null } | { __typename?: 'RankMathPageTypeSeo', robots?: Array<string | null> | null } | { __typename?: 'RankMathPostFormatTermSeo', robots?: Array<string | null> | null } | { __typename?: 'RankMathPostObjectSeo', robots?: Array<string | null> | null } | { __typename?: 'RankMathPostTypeSeo', robots?: Array<string | null> | null } | { __typename?: 'RankMathSeriesTermSeo', robots?: Array<string | null> | null } | { __typename?: 'RankMathSolutionTermSeo', robots?: Array<string | null> | null } | { __typename?: 'RankMathTagTermSeo', robots?: Array<string | null> | null } | { __typename?: 'RankMathTechnologyTermSeo', robots?: Array<string | null> | null } | { __typename?: 'RankMathUserSeo', robots?: Array<string | null> | null } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', mimeType?: string | null, altText?: string | null, sourceUrl?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, file?: string | null } | null } } | null } | null } | null } | null };

export type HomePageSeoQueryVariables = Exact<{ [key: string]: never; }>;


export type HomePageSeoQuery = { __typename?: 'RootQuery', generalSettings?: { __typename?: 'GeneralSettings', title?: string | null } | null, rankMathSettings?: { __typename?: 'RankMathSettings', meta?: { __typename?: 'RankMathMeta', homepage?: { __typename?: 'RankMathHomepageMetaSettings', description?: string | null, socialTitle?: string | null, socialDescription?: string | null, robotsMeta?: Array<RankMathRobotsMetaValueEnum | null> | null, socialImage?: { __typename?: 'MediaItem', altText?: string | null, mimeType?: string | null, sourceUrl?: string | null, mediaDetails?: { __typename?: 'MediaDetails', width?: number | null, height?: number | null } | null } | null } | null } | null } | null, nodeByUri?: { __typename?: 'Category' } | { __typename?: 'Comment' } | { __typename?: 'ContentType', seo?: { __typename?: 'RankMathCategoryTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathGeneralTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathMediaItemObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathMediaItemTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPageObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPageTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostFormatTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathSeriesTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathSolutionTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathTagTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathTechnologyTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathUserSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | null } | { __typename?: 'General' } | { __typename?: 'MediaItem' } | { __typename?: 'Page' } | { __typename?: 'Post' } | { __typename?: 'PostFormat' } | { __typename?: 'Series' } | { __typename?: 'Solution' } | { __typename?: 'Tag' } | { __typename?: 'Technology' } | { __typename?: 'User' } | null, acfOptionsBlogHomepageOptions?: { __typename?: 'AcfOptionsBlogHomepageOptions', blogHomeOptions?: { __typename?: 'AcfOptionsBlogHomepageOptions_Bloghomeoptions', featuredPost?: { __typename?: 'Post', id: string, seo?: { __typename?: 'RankMathCategoryTermSeo', robots?: Array<string | null> | null } | { __typename?: 'RankMathGeneralTermSeo', robots?: Array<string | null> | null } | { __typename?: 'RankMathMediaItemObjectSeo', robots?: Array<string | null> | null } | { __typename?: 'RankMathMediaItemTypeSeo', robots?: Array<string | null> | null } | { __typename?: 'RankMathPageObjectSeo', robots?: Array<string | null> | null } | { __typename?: 'RankMathPageTypeSeo', robots?: Array<string | null> | null } | { __typename?: 'RankMathPostFormatTermSeo', robots?: Array<string | null> | null } | { __typename?: 'RankMathPostObjectSeo', robots?: Array<string | null> | null } | { __typename?: 'RankMathPostTypeSeo', robots?: Array<string | null> | null } | { __typename?: 'RankMathSeriesTermSeo', robots?: Array<string | null> | null } | { __typename?: 'RankMathSolutionTermSeo', robots?: Array<string | null> | null } | { __typename?: 'RankMathTagTermSeo', robots?: Array<string | null> | null } | { __typename?: 'RankMathTechnologyTermSeo', robots?: Array<string | null> | null } | { __typename?: 'RankMathUserSeo', robots?: Array<string | null> | null } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', mimeType?: string | null, altText?: string | null, sourceUrl?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, file?: string | null } | null } } | null } | null } | null } | null };

export type HomePostCardFragment = { __typename?: 'Post', title?: string | null, slug?: string | null, timeToRead?: number | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, mediaDetails?: { __typename?: 'MediaDetails', file?: string | null } | null } } | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null, slug?: string | null, parentDatabaseId?: number | null }> } | null };

export type HomePageQueryVariables = Exact<{
  year: Scalars['Int'];
  month: Scalars['Int'];
}>;


export type HomePageQuery = { __typename?: 'RootQuery', posts?: { __typename?: 'RootQueryToPostConnection', nodes: Array<{ __typename?: 'Post', id: string, excerpt?: string | null, title?: string | null, slug?: string | null, timeToRead?: number | null, author?: { __typename?: 'NodeWithAuthorToUserConnectionEdge', node: { __typename?: 'User', name?: string | null, customFields?: { __typename?: 'User_Customfields', authorImage?: string | null } | null } } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, mediaDetails?: { __typename?: 'MediaDetails', file?: string | null } | null } } | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null, slug?: string | null, parentDatabaseId?: number | null }> } | null }>, pageInfo: { __typename?: 'RootQueryToPostConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', total?: number | null } | null } } | null, acfOptionsBlogHomepageOptions?: { __typename?: 'AcfOptionsBlogHomepageOptions', blogHomeFeaturedPosts?: { __typename?: 'AcfOptionsBlogHomepageOptions_Bloghomefeaturedposts', featuredPosts?: Array<{ __typename?: 'Post', id: string, title?: string | null, slug?: string | null, timeToRead?: number | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, mediaDetails?: { __typename?: 'MediaDetails', file?: string | null } | null } } | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null, slug?: string | null, parentDatabaseId?: number | null }> } | null } | null> | null } | null } | null, postsThisMonth?: { __typename?: 'RootQueryToPostConnection', pageInfo: { __typename?: 'RootQueryToPostConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', total?: number | null } | null } } | null, lastUpdated?: { __typename?: 'RootQueryToPostConnection', nodes: Array<{ __typename?: 'Post', modifiedGmt?: string | null }> } | null, categories?: { __typename?: 'RootQueryToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null, slug?: string | null, count?: number | null, children?: { __typename?: 'CategoryToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null, slug?: string | null, count?: number | null }> } | null }> } | null };

export type TagSeoFragment = { __typename?: 'Tag', seo?: { __typename?: 'RankMathCategoryTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathGeneralTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathMediaItemObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathMediaItemTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPageObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPageTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostFormatTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathSeriesTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathSolutionTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathTagTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathTechnologyTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathUserSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | null };

export type TagPageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TagPageQuery = { __typename?: 'RootQuery', tag?: { __typename?: 'Tag', databaseId: number, name?: string | null, seo?: { __typename?: 'RankMathCategoryTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathGeneralTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathMediaItemObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathMediaItemTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPageObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPageTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostFormatTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathSeriesTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathSolutionTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathTagTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathTechnologyTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathUserSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | null } | null };

export type TagPostsQueryVariables = Exact<{
  tagId?: InputMaybe<Scalars['String']>;
  perPage?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type TagPostsQuery = { __typename?: 'RootQuery', posts?: { __typename?: 'RootQueryToPostConnection', edges: Array<{ __typename?: 'RootQueryToPostConnectionEdge', node: { __typename?: 'Post', date?: string | null, id: string, slug?: string | null, title?: string | null, excerpt?: string | null, timeToRead?: number | null, postOptions?: { __typename?: 'Post_Postoptions', elementsVisibilityOptions?: { __typename?: 'Post_Postoptions_ElementsVisibilityOptions', hideAuthor?: boolean | null } | null } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', id: string, altText?: string | null, mediaDetails?: { __typename?: 'MediaDetails', file?: string | null } | null } } | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', id: string, databaseId: number, slug?: string | null, name?: string | null }> } | null, author?: { __typename?: 'NodeWithAuthorToUserConnectionEdge', node: { __typename?: 'User', id: string, name?: string | null, avatar?: { __typename?: 'Avatar', url?: string | null } | null, customFields?: { __typename?: 'User_Customfields', authorImage?: string | null } | null } } | null } }>, pageInfo: { __typename?: 'RootQueryToPostConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null } } | null };

export type TagPathsQueryVariables = Exact<{
  size?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type TagPathsQuery = { __typename?: 'RootQuery', tags?: { __typename?: 'RootQueryToTagConnection', pageInfo: { __typename?: 'RootQueryToTagConnectionPageInfo', endCursor?: string | null, hasNextPage: boolean }, nodes: Array<{ __typename?: 'Tag', slug?: string | null, posts?: { __typename?: 'TagToPostConnection', pageInfo: { __typename?: 'TagToPostConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', total?: number | null } | null } } | null }> } | null };

export type FourOFourPageQueryVariables = Exact<{ [key: string]: never; }>;


export type FourOFourPageQuery = { __typename?: 'RootQuery', acfOptionsBlogHomepageOptions?: { __typename?: 'AcfOptionsBlogHomepageOptions', blogHomeOptions?: { __typename?: 'AcfOptionsBlogHomepageOptions_Bloghomeoptions', featuredPost?: { __typename?: 'Post', id: string } | null, mostReadPostsOptions?: { __typename?: 'AcfOptionsBlogHomepageOptions_Bloghomeoptions_MostReadPostsOptions', automaticMostReadPosts?: boolean | null, mostReadPosts?: Array<{ __typename?: 'Post', id: string, date?: string | null, slug?: string | null, title?: string | null, excerpt?: string | null, timeToRead?: number | null, postOptions?: { __typename?: 'Post_Postoptions', elementsVisibilityOptions?: { __typename?: 'Post_Postoptions_ElementsVisibilityOptions', hideAuthor?: boolean | null } | null } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', id: string, altText?: string | null, mediaDetails?: { __typename?: 'MediaDetails', file?: string | null } | null } } | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', id: string, databaseId: number, slug?: string | null, name?: string | null }> } | null, author?: { __typename?: 'NodeWithAuthorToUserConnectionEdge', node: { __typename?: 'User', id: string, name?: string | null, avatar?: { __typename?: 'Avatar', url?: string | null } | null, customFields?: { __typename?: 'User_Customfields', authorImage?: string | null } | null } } | null } | null> | null } | null } | null } | null };

export type FallbackFourOFourPageQueryVariables = Exact<{
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type FallbackFourOFourPageQuery = { __typename?: 'RootQuery', posts?: { __typename?: 'RootQueryToPostConnection', edges: Array<{ __typename?: 'RootQueryToPostConnectionEdge', node: { __typename?: 'Post', id: string, date?: string | null, slug?: string | null, title?: string | null, excerpt?: string | null, timeToRead?: number | null, postOptions?: { __typename?: 'Post_Postoptions', elementsVisibilityOptions?: { __typename?: 'Post_Postoptions_ElementsVisibilityOptions', hideAuthor?: boolean | null } | null } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', id: string, altText?: string | null, mediaDetails?: { __typename?: 'MediaDetails', file?: string | null } | null } } | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', id: string, databaseId: number, slug?: string | null, name?: string | null }> } | null, author?: { __typename?: 'NodeWithAuthorToUserConnectionEdge', node: { __typename?: 'User', id: string, name?: string | null, avatar?: { __typename?: 'Avatar', url?: string | null } | null, customFields?: { __typename?: 'User_Customfields', authorImage?: string | null } | null } } | null } }> } | null };

export type AuthorFragmentFragment = { __typename?: 'User', name?: string | null, description?: string | null, slug?: string | null, customFields?: { __typename?: 'User_Customfields', authorImage?: string | null, bdRole?: string | null, bioLong?: string | null, verifiedAt?: boolean | null, xTwitter?: string | null, yearsOfExperience?: number | null, youtube?: string | null, linkedin?: string | null, instagram?: string | null, generalTags?: Array<{ __typename?: 'General', name?: string | null, databaseId: number, generalTags?: { __typename?: 'General_Generaltags', url?: string | null } | null } | null> | null, solutions?: Array<{ __typename?: 'Solution', name?: string | null, databaseId: number, solutions?: { __typename?: 'Solution_Solutions', url?: string | null } | null } | null> | null, technologies?: Array<{ __typename?: 'Technology', name?: string | null, databaseId: number, technologies?: { __typename?: 'Technology_Technologies', url?: string | null } | null } | null> | null } | null, avatar?: { __typename?: 'Avatar', url?: string | null } | null };

export type SeoSlugPageFragment = { __typename?: 'Post', date?: string | null, seo?: { __typename?: 'RankMathCategoryTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathGeneralTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathMediaItemObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathMediaItemTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPageObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPageTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostFormatTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathSeriesTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathSolutionTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathTagTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathTechnologyTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathUserSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', sourceUrl?: string | null, mimeType?: string | null, altText?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null } | null } } | null };

export type TagsFragment = { __typename?: 'Post', solutions?: { __typename?: 'PostToSolutionConnection', nodes: Array<{ __typename?: 'Solution', name?: string | null, databaseId: number }> } | null, technologies?: { __typename?: 'PostToTechnologyConnection', nodes: Array<{ __typename?: 'Technology', name?: string | null, databaseId: number }> } | null, general?: { __typename?: 'PostToGeneralConnection', nodes: Array<{ __typename?: 'General', name?: string | null, databaseId: number }> } | null };

export type SlugPageDataFragment = { __typename?: 'Post', id: string, modified?: string | null, title?: string | null, status?: string | null, databaseId: number, content?: string | null, excerpt?: string | null, timeToRead?: number | null, date?: string | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null, slug?: string | null, parentDatabaseId?: number | null, posts?: { __typename?: 'CategoryToPostConnection', nodes: Array<{ __typename?: 'Post', id: string, title?: string | null, slug?: string | null, timeToRead?: number | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, mediaDetails?: { __typename?: 'MediaDetails', file?: string | null } | null } } | null }> } | null, children?: { __typename?: 'CategoryToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null, slug?: string | null, parentDatabaseId?: number | null, count?: number | null }> } | null, categoryPage?: { __typename?: 'Category_Categorypage', featuredPosts?: Array<{ __typename?: 'Post', id: string, title?: string | null, slug?: string | null, timeToRead?: number | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, mediaDetails?: { __typename?: 'MediaDetails', file?: string | null } | null } } | null } | null> | null } | null }> } | null, postLastUpdated?: { __typename?: 'Post_Postlastupdated', datemodified?: string | null, showLastUpdated?: boolean | null } | null, postOptions?: { __typename?: 'Post_Postoptions', elementsVisibilityOptions?: { __typename?: 'Post_Postoptions_ElementsVisibilityOptions', hideAuthor?: boolean | null, hideComments?: boolean | null, hideSharing?: boolean | null, hideArticleContents?: boolean | null } | null, faqOptions?: { __typename?: 'Post_Postoptions_FaqOptions', showFaq?: boolean | null, faqSectionTitle?: string | null, faqs?: Array<{ __typename?: 'Post_Postoptions_FaqOptions_faqs', question?: string | null, answer?: string | null } | null> | null } | null } | null, series?: { __typename?: 'PostToSeriesConnection', nodes: Array<{ __typename?: 'Series', slug?: string | null, name?: string | null }> } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', file?: string | null, height?: number | null, width?: number | null } | null } } | null, tags?: { __typename?: 'PostToTagConnection', nodes: Array<{ __typename?: 'Tag', slug?: string | null, name?: string | null }> } | null, author?: { __typename?: 'NodeWithAuthorToUserConnectionEdge', node: { __typename?: 'User', name?: string | null, description?: string | null, slug?: string | null, customFields?: { __typename?: 'User_Customfields', authorImage?: string | null, bdRole?: string | null, bioLong?: string | null, verifiedAt?: boolean | null, xTwitter?: string | null, yearsOfExperience?: number | null, youtube?: string | null, linkedin?: string | null, instagram?: string | null, generalTags?: Array<{ __typename?: 'General', name?: string | null, databaseId: number, generalTags?: { __typename?: 'General_Generaltags', url?: string | null } | null } | null> | null, solutions?: Array<{ __typename?: 'Solution', name?: string | null, databaseId: number, solutions?: { __typename?: 'Solution_Solutions', url?: string | null } | null } | null> | null, technologies?: Array<{ __typename?: 'Technology', name?: string | null, databaseId: number, technologies?: { __typename?: 'Technology_Technologies', url?: string | null } | null } | null> | null } | null, avatar?: { __typename?: 'Avatar', url?: string | null } | null } } | null, solutions?: { __typename?: 'PostToSolutionConnection', nodes: Array<{ __typename?: 'Solution', name?: string | null, databaseId: number }> } | null, technologies?: { __typename?: 'PostToTechnologyConnection', nodes: Array<{ __typename?: 'Technology', name?: string | null, databaseId: number }> } | null, general?: { __typename?: 'PostToGeneralConnection', nodes: Array<{ __typename?: 'General', name?: string | null, databaseId: number }> } | null, seo?: { __typename?: 'RankMathCategoryTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathGeneralTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathMediaItemObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathMediaItemTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPageObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPageTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostFormatTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathSeriesTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathSolutionTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathTagTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathTechnologyTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathUserSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | null };

export type SlugPagePathsQueryVariables = Exact<{
  size?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type SlugPagePathsQuery = { __typename?: 'RootQuery', posts?: { __typename?: 'RootQueryToPostConnection', nodes: Array<{ __typename?: 'Post', id: string, slug?: string | null }> } | null };

export type SlugPageQueryVariables = Exact<{
  uri?: InputMaybe<Scalars['String']>;
  isPreview?: InputMaybe<Scalars['Boolean']>;
}>;


export type SlugPageQuery = { __typename?: 'RootQuery', post?: { __typename?: 'Post', id: string, modified?: string | null, title?: string | null, status?: string | null, databaseId: number, content?: string | null, excerpt?: string | null, timeToRead?: number | null, date?: string | null, preview?: { __typename?: 'PostToPreviewConnectionEdge', node: { __typename?: 'Post', id: string, modified?: string | null, title?: string | null, status?: string | null, databaseId: number, content?: string | null, excerpt?: string | null, timeToRead?: number | null, date?: string | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null, slug?: string | null, parentDatabaseId?: number | null, posts?: { __typename?: 'CategoryToPostConnection', nodes: Array<{ __typename?: 'Post', id: string, title?: string | null, slug?: string | null, timeToRead?: number | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, mediaDetails?: { __typename?: 'MediaDetails', file?: string | null } | null } } | null }> } | null, children?: { __typename?: 'CategoryToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null, slug?: string | null, parentDatabaseId?: number | null, count?: number | null }> } | null, categoryPage?: { __typename?: 'Category_Categorypage', featuredPosts?: Array<{ __typename?: 'Post', id: string, title?: string | null, slug?: string | null, timeToRead?: number | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, mediaDetails?: { __typename?: 'MediaDetails', file?: string | null } | null } } | null } | null> | null } | null }> } | null, postLastUpdated?: { __typename?: 'Post_Postlastupdated', datemodified?: string | null, showLastUpdated?: boolean | null } | null, postOptions?: { __typename?: 'Post_Postoptions', elementsVisibilityOptions?: { __typename?: 'Post_Postoptions_ElementsVisibilityOptions', hideAuthor?: boolean | null, hideComments?: boolean | null, hideSharing?: boolean | null, hideArticleContents?: boolean | null } | null, faqOptions?: { __typename?: 'Post_Postoptions_FaqOptions', showFaq?: boolean | null, faqSectionTitle?: string | null, faqs?: Array<{ __typename?: 'Post_Postoptions_FaqOptions_faqs', question?: string | null, answer?: string | null } | null> | null } | null } | null, series?: { __typename?: 'PostToSeriesConnection', nodes: Array<{ __typename?: 'Series', slug?: string | null, name?: string | null }> } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', file?: string | null, height?: number | null, width?: number | null } | null } } | null, tags?: { __typename?: 'PostToTagConnection', nodes: Array<{ __typename?: 'Tag', slug?: string | null, name?: string | null }> } | null, author?: { __typename?: 'NodeWithAuthorToUserConnectionEdge', node: { __typename?: 'User', name?: string | null, description?: string | null, slug?: string | null, customFields?: { __typename?: 'User_Customfields', authorImage?: string | null, bdRole?: string | null, bioLong?: string | null, verifiedAt?: boolean | null, xTwitter?: string | null, yearsOfExperience?: number | null, youtube?: string | null, linkedin?: string | null, instagram?: string | null, generalTags?: Array<{ __typename?: 'General', name?: string | null, databaseId: number, generalTags?: { __typename?: 'General_Generaltags', url?: string | null } | null } | null> | null, solutions?: Array<{ __typename?: 'Solution', name?: string | null, databaseId: number, solutions?: { __typename?: 'Solution_Solutions', url?: string | null } | null } | null> | null, technologies?: Array<{ __typename?: 'Technology', name?: string | null, databaseId: number, technologies?: { __typename?: 'Technology_Technologies', url?: string | null } | null } | null> | null } | null, avatar?: { __typename?: 'Avatar', url?: string | null } | null } } | null, solutions?: { __typename?: 'PostToSolutionConnection', nodes: Array<{ __typename?: 'Solution', name?: string | null, databaseId: number }> } | null, technologies?: { __typename?: 'PostToTechnologyConnection', nodes: Array<{ __typename?: 'Technology', name?: string | null, databaseId: number }> } | null, general?: { __typename?: 'PostToGeneralConnection', nodes: Array<{ __typename?: 'General', name?: string | null, databaseId: number }> } | null, seo?: { __typename?: 'RankMathCategoryTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathGeneralTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathMediaItemObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathMediaItemTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPageObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPageTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostFormatTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathSeriesTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathSolutionTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathTagTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathTechnologyTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathUserSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | null } } | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null, slug?: string | null, parentDatabaseId?: number | null, posts?: { __typename?: 'CategoryToPostConnection', nodes: Array<{ __typename?: 'Post', id: string, title?: string | null, slug?: string | null, timeToRead?: number | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, mediaDetails?: { __typename?: 'MediaDetails', file?: string | null } | null } } | null }> } | null, children?: { __typename?: 'CategoryToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null, slug?: string | null, parentDatabaseId?: number | null, count?: number | null }> } | null, categoryPage?: { __typename?: 'Category_Categorypage', featuredPosts?: Array<{ __typename?: 'Post', id: string, title?: string | null, slug?: string | null, timeToRead?: number | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, mediaDetails?: { __typename?: 'MediaDetails', file?: string | null } | null } } | null } | null> | null } | null }> } | null, postLastUpdated?: { __typename?: 'Post_Postlastupdated', datemodified?: string | null, showLastUpdated?: boolean | null } | null, postOptions?: { __typename?: 'Post_Postoptions', elementsVisibilityOptions?: { __typename?: 'Post_Postoptions_ElementsVisibilityOptions', hideAuthor?: boolean | null, hideComments?: boolean | null, hideSharing?: boolean | null, hideArticleContents?: boolean | null } | null, faqOptions?: { __typename?: 'Post_Postoptions_FaqOptions', showFaq?: boolean | null, faqSectionTitle?: string | null, faqs?: Array<{ __typename?: 'Post_Postoptions_FaqOptions_faqs', question?: string | null, answer?: string | null } | null> | null } | null } | null, series?: { __typename?: 'PostToSeriesConnection', nodes: Array<{ __typename?: 'Series', slug?: string | null, name?: string | null }> } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', file?: string | null, height?: number | null, width?: number | null } | null } } | null, tags?: { __typename?: 'PostToTagConnection', nodes: Array<{ __typename?: 'Tag', slug?: string | null, name?: string | null }> } | null, author?: { __typename?: 'NodeWithAuthorToUserConnectionEdge', node: { __typename?: 'User', name?: string | null, description?: string | null, slug?: string | null, customFields?: { __typename?: 'User_Customfields', authorImage?: string | null, bdRole?: string | null, bioLong?: string | null, verifiedAt?: boolean | null, xTwitter?: string | null, yearsOfExperience?: number | null, youtube?: string | null, linkedin?: string | null, instagram?: string | null, generalTags?: Array<{ __typename?: 'General', name?: string | null, databaseId: number, generalTags?: { __typename?: 'General_Generaltags', url?: string | null } | null } | null> | null, solutions?: Array<{ __typename?: 'Solution', name?: string | null, databaseId: number, solutions?: { __typename?: 'Solution_Solutions', url?: string | null } | null } | null> | null, technologies?: Array<{ __typename?: 'Technology', name?: string | null, databaseId: number, technologies?: { __typename?: 'Technology_Technologies', url?: string | null } | null } | null> | null } | null, avatar?: { __typename?: 'Avatar', url?: string | null } | null } } | null, solutions?: { __typename?: 'PostToSolutionConnection', nodes: Array<{ __typename?: 'Solution', name?: string | null, databaseId: number }> } | null, technologies?: { __typename?: 'PostToTechnologyConnection', nodes: Array<{ __typename?: 'Technology', name?: string | null, databaseId: number }> } | null, general?: { __typename?: 'PostToGeneralConnection', nodes: Array<{ __typename?: 'General', name?: string | null, databaseId: number }> } | null, seo?: { __typename?: 'RankMathCategoryTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathGeneralTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathMediaItemObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathMediaItemTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPageObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPageTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostFormatTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathPostTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathSeriesTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathSolutionTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathTagTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathTechnologyTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | { __typename?: 'RankMathUserSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null } | null } | null };

export type GetBatchedPostsQueryVariables = Exact<{
  idsList?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type GetBatchedPostsQuery = { __typename?: 'RootQuery', posts?: { __typename?: 'RootQueryToPostConnection', edges: Array<{ __typename?: 'RootQueryToPostConnectionEdge', node: { __typename?: 'Post', id: string, title?: string | null, slug?: string | null, timeToRead?: number | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', id: string, altText?: string | null, mediaDetails?: { __typename?: 'MediaDetails', file?: string | null } | null } } | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', id: string, name?: string | null, parentDatabaseId?: number | null, count?: number | null, slug?: string | null }> } | null } }> } | null };

export type BlogCardFragment = { __typename?: 'Post', id: string, date?: string | null, slug?: string | null, title?: string | null, excerpt?: string | null, timeToRead?: number | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', id: string, altText?: string | null, mediaDetails?: { __typename?: 'MediaDetails', file?: string | null } | null } } | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', id: string, databaseId: number, slug?: string | null, name?: string | null }> } | null, author?: { __typename?: 'NodeWithAuthorToUserConnectionEdge', node: { __typename?: 'User', id: string, name?: string | null, avatar?: { __typename?: 'Avatar', url?: string | null } | null, customFields?: { __typename?: 'User_Customfields', authorImage?: string | null } | null } } | null };

export type NavbarQueryVariables = Exact<{
  weekAgo?: InputMaybe<DateInput>;
}>;


export type NavbarQuery = { __typename?: 'RootQuery', categories?: { __typename?: 'RootQueryToCategoryConnection', nodes: Array<{ __typename?: 'Category', slug?: string | null, name?: string | null, count?: number | null, children?: { __typename?: 'CategoryToCategoryConnection', nodes: Array<{ __typename?: 'Category', slug?: string | null, name?: string | null, count?: number | null, posts?: { __typename?: 'CategoryToPostConnection', pageInfo: { __typename?: 'CategoryToPostConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', total?: number | null } | null } } | null }> } | null }> } | null, posts?: { __typename?: 'RootQueryToPostConnection', pageInfo: { __typename?: 'RootQueryToPostConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', total?: number | null } | null } } | null };

export type PostCardListFragment = { __typename?: 'Post', id: string, date?: string | null, slug?: string | null, title?: string | null, excerpt?: string | null, timeToRead?: number | null, postOptions?: { __typename?: 'Post_Postoptions', elementsVisibilityOptions?: { __typename?: 'Post_Postoptions_ElementsVisibilityOptions', hideAuthor?: boolean | null } | null } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', id: string, altText?: string | null, mediaDetails?: { __typename?: 'MediaDetails', file?: string | null } | null } } | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', id: string, databaseId: number, slug?: string | null, name?: string | null }> } | null, author?: { __typename?: 'NodeWithAuthorToUserConnectionEdge', node: { __typename?: 'User', id: string, name?: string | null, avatar?: { __typename?: 'Avatar', url?: string | null } | null, customFields?: { __typename?: 'User_Customfields', authorImage?: string | null } | null } } | null };

export type ReadNextFragment = { __typename?: 'Post', id: string, slug?: string | null, title?: string | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, mediaDetails?: { __typename?: 'MediaDetails', file?: string | null } | null } } | null };

type NodeSeoFragmentRankMathCategoryTermSeoFragment = { __typename?: 'RankMathCategoryTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null };

type NodeSeoFragmentRankMathGeneralTermSeoFragment = { __typename?: 'RankMathGeneralTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null };

type NodeSeoFragmentRankMathMediaItemObjectSeoFragment = { __typename?: 'RankMathMediaItemObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null };

type NodeSeoFragmentRankMathMediaItemTypeSeoFragment = { __typename?: 'RankMathMediaItemTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null };

type NodeSeoFragmentRankMathPageObjectSeoFragment = { __typename?: 'RankMathPageObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null };

type NodeSeoFragmentRankMathPageTypeSeoFragment = { __typename?: 'RankMathPageTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null };

type NodeSeoFragmentRankMathPostFormatTermSeoFragment = { __typename?: 'RankMathPostFormatTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null };

type NodeSeoFragmentRankMathPostObjectSeoFragment = { __typename?: 'RankMathPostObjectSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null };

type NodeSeoFragmentRankMathPostTypeSeoFragment = { __typename?: 'RankMathPostTypeSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null };

type NodeSeoFragmentRankMathSeriesTermSeoFragment = { __typename?: 'RankMathSeriesTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null };

type NodeSeoFragmentRankMathSolutionTermSeoFragment = { __typename?: 'RankMathSolutionTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null };

type NodeSeoFragmentRankMathTagTermSeoFragment = { __typename?: 'RankMathTagTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null };

type NodeSeoFragmentRankMathTechnologyTermSeoFragment = { __typename?: 'RankMathTechnologyTermSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null };

type NodeSeoFragmentRankMathUserSeoFragment = { __typename?: 'RankMathUserSeo', canonicalUrl?: string | null, description?: string | null, robots?: Array<string | null> | null, jsonLd?: { __typename?: 'RankMathJsonLd', raw?: string | null } | null, openGraph?: { __typename?: 'RankMathOpenGraphMeta', locale?: RankMathOpenGraphLocaleEnum | null, type?: string | null, title?: string | null, description?: string | null, url?: string | null, siteName?: string | null, articleMeta?: { __typename?: 'RankMathOpenGraphArticle', section?: string | null } | null, twitterMeta?: { __typename?: 'RankMathOpenGraphTwitter', card?: RankMathTwitterCardTypeEnum | null, title?: string | null, description?: string | null, image?: string | null } | null, slackEnhancedData?: Array<{ __typename?: 'RankMathOpenGraphSlackEnhancedData', data?: string | null, label?: string | null } | null> | null } | null };

export type NodeSeoFragmentFragment = NodeSeoFragmentRankMathCategoryTermSeoFragment | NodeSeoFragmentRankMathGeneralTermSeoFragment | NodeSeoFragmentRankMathMediaItemObjectSeoFragment | NodeSeoFragmentRankMathMediaItemTypeSeoFragment | NodeSeoFragmentRankMathPageObjectSeoFragment | NodeSeoFragmentRankMathPageTypeSeoFragment | NodeSeoFragmentRankMathPostFormatTermSeoFragment | NodeSeoFragmentRankMathPostObjectSeoFragment | NodeSeoFragmentRankMathPostTypeSeoFragment | NodeSeoFragmentRankMathSeriesTermSeoFragment | NodeSeoFragmentRankMathSolutionTermSeoFragment | NodeSeoFragmentRankMathTagTermSeoFragment | NodeSeoFragmentRankMathTechnologyTermSeoFragment | NodeSeoFragmentRankMathUserSeoFragment;

export type PostFragmentFragment = { __typename?: 'Post', id: string, title?: string | null, excerpt?: string | null, slug?: string | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', sourceUrl?: string | null, altText?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, file?: string | null } | null } } | null };

export type ImageFragmentFragment = { __typename?: 'MediaItem', sourceUrl?: string | null, altText?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, file?: string | null } | null };

type PageInfoFragmentCategoryToAncestorsCategoryConnectionPageInfoFragment = { __typename?: 'CategoryToAncestorsCategoryConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentCategoryToCategoryConnectionPageInfoFragment = { __typename?: 'CategoryToCategoryConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentCategoryToContentNodeConnectionPageInfoFragment = { __typename?: 'CategoryToContentNodeConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentCategoryToPostConnectionPageInfoFragment = { __typename?: 'CategoryToPostConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentCommentToCommentConnectionPageInfoFragment = { __typename?: 'CommentToCommentConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentContentNodeToEnqueuedScriptConnectionPageInfoFragment = { __typename?: 'ContentNodeToEnqueuedScriptConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentContentNodeToEnqueuedStylesheetConnectionPageInfoFragment = { __typename?: 'ContentNodeToEnqueuedStylesheetConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentContentTypeToContentNodeConnectionPageInfoFragment = { __typename?: 'ContentTypeToContentNodeConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentContentTypeToTaxonomyConnectionPageInfoFragment = { __typename?: 'ContentTypeToTaxonomyConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentGeneralToAncestorsGeneralConnectionPageInfoFragment = { __typename?: 'GeneralToAncestorsGeneralConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentGeneralToContentNodeConnectionPageInfoFragment = { __typename?: 'GeneralToContentNodeConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentGeneralToGeneralConnectionPageInfoFragment = { __typename?: 'GeneralToGeneralConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentGeneralToPostConnectionPageInfoFragment = { __typename?: 'GeneralToPostConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentHierarchicalContentNodeToContentNodeAncestorsConnectionPageInfoFragment = { __typename?: 'HierarchicalContentNodeToContentNodeAncestorsConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentHierarchicalContentNodeToContentNodeChildrenConnectionPageInfoFragment = { __typename?: 'HierarchicalContentNodeToContentNodeChildrenConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentMediaItemToCommentConnectionPageInfoFragment = { __typename?: 'MediaItemToCommentConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentMenuItemToMenuItemConnectionPageInfoFragment = { __typename?: 'MenuItemToMenuItemConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentMenuToMenuItemConnectionPageInfoFragment = { __typename?: 'MenuToMenuItemConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentPageToCommentConnectionPageInfoFragment = { __typename?: 'PageToCommentConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentPageToRevisionConnectionPageInfoFragment = { __typename?: 'PageToRevisionConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentPostFormatToContentNodeConnectionPageInfoFragment = { __typename?: 'PostFormatToContentNodeConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentPostFormatToPostConnectionPageInfoFragment = { __typename?: 'PostFormatToPostConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentPostToCategoryConnectionPageInfoFragment = { __typename?: 'PostToCategoryConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentPostToCommentConnectionPageInfoFragment = { __typename?: 'PostToCommentConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentPostToGeneralConnectionPageInfoFragment = { __typename?: 'PostToGeneralConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentPostToPostConnectionPageInfoFragment = { __typename?: 'PostToPostConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentPostToPostFormatConnectionPageInfoFragment = { __typename?: 'PostToPostFormatConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentPostToRevisionConnectionPageInfoFragment = { __typename?: 'PostToRevisionConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentPostToSeriesConnectionPageInfoFragment = { __typename?: 'PostToSeriesConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentPostToSolutionConnectionPageInfoFragment = { __typename?: 'PostToSolutionConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentPostToTagConnectionPageInfoFragment = { __typename?: 'PostToTagConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentPostToTechnologyConnectionPageInfoFragment = { __typename?: 'PostToTechnologyConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentPostToTermNodeConnectionPageInfoFragment = { __typename?: 'PostToTermNodeConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentRankMathSitemapAuthorSettingsToUserConnectionPageInfoFragment = { __typename?: 'RankMathSitemapAuthorSettingsToUserConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentRankMathSitemapContentTypeSettingsToContentNodeConnectionPageInfoFragment = { __typename?: 'RankMathSitemapContentTypeSettingsToContentNodeConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentRankMathSitemapTaxonomySettingsToTermNodeConnectionPageInfoFragment = { __typename?: 'RankMathSitemapTaxonomySettingsToTermNodeConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentRootQueryToCategoryConnectionPageInfoFragment = { __typename?: 'RootQueryToCategoryConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentRootQueryToCommentConnectionPageInfoFragment = { __typename?: 'RootQueryToCommentConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentRootQueryToContentNodeConnectionPageInfoFragment = { __typename?: 'RootQueryToContentNodeConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentRootQueryToContentTypeConnectionPageInfoFragment = { __typename?: 'RootQueryToContentTypeConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentRootQueryToEnqueuedScriptConnectionPageInfoFragment = { __typename?: 'RootQueryToEnqueuedScriptConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentRootQueryToEnqueuedStylesheetConnectionPageInfoFragment = { __typename?: 'RootQueryToEnqueuedStylesheetConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentRootQueryToGeneralConnectionPageInfoFragment = { __typename?: 'RootQueryToGeneralConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentRootQueryToMediaItemConnectionPageInfoFragment = { __typename?: 'RootQueryToMediaItemConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentRootQueryToMenuConnectionPageInfoFragment = { __typename?: 'RootQueryToMenuConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentRootQueryToMenuItemConnectionPageInfoFragment = { __typename?: 'RootQueryToMenuItemConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentRootQueryToPageConnectionPageInfoFragment = { __typename?: 'RootQueryToPageConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentRootQueryToPluginConnectionPageInfoFragment = { __typename?: 'RootQueryToPluginConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentRootQueryToPostConnectionPageInfoFragment = { __typename?: 'RootQueryToPostConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentRootQueryToPostFormatConnectionPageInfoFragment = { __typename?: 'RootQueryToPostFormatConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentRootQueryToRevisionsConnectionPageInfoFragment = { __typename?: 'RootQueryToRevisionsConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentRootQueryToSeriesConnectionPageInfoFragment = { __typename?: 'RootQueryToSeriesConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentRootQueryToSolutionConnectionPageInfoFragment = { __typename?: 'RootQueryToSolutionConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentRootQueryToTagConnectionPageInfoFragment = { __typename?: 'RootQueryToTagConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentRootQueryToTaxonomyConnectionPageInfoFragment = { __typename?: 'RootQueryToTaxonomyConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentRootQueryToTechnologyConnectionPageInfoFragment = { __typename?: 'RootQueryToTechnologyConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentRootQueryToTermNodeConnectionPageInfoFragment = { __typename?: 'RootQueryToTermNodeConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentRootQueryToThemeConnectionPageInfoFragment = { __typename?: 'RootQueryToThemeConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentRootQueryToUserConnectionPageInfoFragment = { __typename?: 'RootQueryToUserConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentRootQueryToUserRoleConnectionPageInfoFragment = { __typename?: 'RootQueryToUserRoleConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentSeriesToContentNodeConnectionPageInfoFragment = { __typename?: 'SeriesToContentNodeConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentSeriesToPostConnectionPageInfoFragment = { __typename?: 'SeriesToPostConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentSolutionToAncestorsSolutionConnectionPageInfoFragment = { __typename?: 'SolutionToAncestorsSolutionConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentSolutionToContentNodeConnectionPageInfoFragment = { __typename?: 'SolutionToContentNodeConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentSolutionToPostConnectionPageInfoFragment = { __typename?: 'SolutionToPostConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentSolutionToSolutionConnectionPageInfoFragment = { __typename?: 'SolutionToSolutionConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentTagToContentNodeConnectionPageInfoFragment = { __typename?: 'TagToContentNodeConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentTagToPostConnectionPageInfoFragment = { __typename?: 'TagToPostConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentTaxonomyToContentTypeConnectionPageInfoFragment = { __typename?: 'TaxonomyToContentTypeConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentTaxonomyToTermNodeConnectionPageInfoFragment = { __typename?: 'TaxonomyToTermNodeConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentTechnologyToAncestorsTechnologyConnectionPageInfoFragment = { __typename?: 'TechnologyToAncestorsTechnologyConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentTechnologyToContentNodeConnectionPageInfoFragment = { __typename?: 'TechnologyToContentNodeConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentTechnologyToPostConnectionPageInfoFragment = { __typename?: 'TechnologyToPostConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentTechnologyToTechnologyConnectionPageInfoFragment = { __typename?: 'TechnologyToTechnologyConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentTermNodeToEnqueuedScriptConnectionPageInfoFragment = { __typename?: 'TermNodeToEnqueuedScriptConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentTermNodeToEnqueuedStylesheetConnectionPageInfoFragment = { __typename?: 'TermNodeToEnqueuedStylesheetConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentUserToCommentConnectionPageInfoFragment = { __typename?: 'UserToCommentConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentUserToEnqueuedScriptConnectionPageInfoFragment = { __typename?: 'UserToEnqueuedScriptConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentUserToEnqueuedStylesheetConnectionPageInfoFragment = { __typename?: 'UserToEnqueuedStylesheetConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentUserToMediaItemConnectionPageInfoFragment = { __typename?: 'UserToMediaItemConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentUserToPageConnectionPageInfoFragment = { __typename?: 'UserToPageConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentUserToPostConnectionPageInfoFragment = { __typename?: 'UserToPostConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentUserToRevisionsConnectionPageInfoFragment = { __typename?: 'UserToRevisionsConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

type PageInfoFragmentUserToUserRoleConnectionPageInfoFragment = { __typename?: 'UserToUserRoleConnectionPageInfo', offsetPagination?: { __typename?: 'OffsetPaginationPageInfo', hasMore?: boolean | null, hasPrevious?: boolean | null, total?: number | null } | null };

export type PageInfoFragmentFragment = PageInfoFragmentCategoryToAncestorsCategoryConnectionPageInfoFragment | PageInfoFragmentCategoryToCategoryConnectionPageInfoFragment | PageInfoFragmentCategoryToContentNodeConnectionPageInfoFragment | PageInfoFragmentCategoryToPostConnectionPageInfoFragment | PageInfoFragmentCommentToCommentConnectionPageInfoFragment | PageInfoFragmentContentNodeToEnqueuedScriptConnectionPageInfoFragment | PageInfoFragmentContentNodeToEnqueuedStylesheetConnectionPageInfoFragment | PageInfoFragmentContentTypeToContentNodeConnectionPageInfoFragment | PageInfoFragmentContentTypeToTaxonomyConnectionPageInfoFragment | PageInfoFragmentGeneralToAncestorsGeneralConnectionPageInfoFragment | PageInfoFragmentGeneralToContentNodeConnectionPageInfoFragment | PageInfoFragmentGeneralToGeneralConnectionPageInfoFragment | PageInfoFragmentGeneralToPostConnectionPageInfoFragment | PageInfoFragmentHierarchicalContentNodeToContentNodeAncestorsConnectionPageInfoFragment | PageInfoFragmentHierarchicalContentNodeToContentNodeChildrenConnectionPageInfoFragment | PageInfoFragmentMediaItemToCommentConnectionPageInfoFragment | PageInfoFragmentMenuItemToMenuItemConnectionPageInfoFragment | PageInfoFragmentMenuToMenuItemConnectionPageInfoFragment | PageInfoFragmentPageToCommentConnectionPageInfoFragment | PageInfoFragmentPageToRevisionConnectionPageInfoFragment | PageInfoFragmentPostFormatToContentNodeConnectionPageInfoFragment | PageInfoFragmentPostFormatToPostConnectionPageInfoFragment | PageInfoFragmentPostToCategoryConnectionPageInfoFragment | PageInfoFragmentPostToCommentConnectionPageInfoFragment | PageInfoFragmentPostToGeneralConnectionPageInfoFragment | PageInfoFragmentPostToPostConnectionPageInfoFragment | PageInfoFragmentPostToPostFormatConnectionPageInfoFragment | PageInfoFragmentPostToRevisionConnectionPageInfoFragment | PageInfoFragmentPostToSeriesConnectionPageInfoFragment | PageInfoFragmentPostToSolutionConnectionPageInfoFragment | PageInfoFragmentPostToTagConnectionPageInfoFragment | PageInfoFragmentPostToTechnologyConnectionPageInfoFragment | PageInfoFragmentPostToTermNodeConnectionPageInfoFragment | PageInfoFragmentRankMathSitemapAuthorSettingsToUserConnectionPageInfoFragment | PageInfoFragmentRankMathSitemapContentTypeSettingsToContentNodeConnectionPageInfoFragment | PageInfoFragmentRankMathSitemapTaxonomySettingsToTermNodeConnectionPageInfoFragment | PageInfoFragmentRootQueryToCategoryConnectionPageInfoFragment | PageInfoFragmentRootQueryToCommentConnectionPageInfoFragment | PageInfoFragmentRootQueryToContentNodeConnectionPageInfoFragment | PageInfoFragmentRootQueryToContentTypeConnectionPageInfoFragment | PageInfoFragmentRootQueryToEnqueuedScriptConnectionPageInfoFragment | PageInfoFragmentRootQueryToEnqueuedStylesheetConnectionPageInfoFragment | PageInfoFragmentRootQueryToGeneralConnectionPageInfoFragment | PageInfoFragmentRootQueryToMediaItemConnectionPageInfoFragment | PageInfoFragmentRootQueryToMenuConnectionPageInfoFragment | PageInfoFragmentRootQueryToMenuItemConnectionPageInfoFragment | PageInfoFragmentRootQueryToPageConnectionPageInfoFragment | PageInfoFragmentRootQueryToPluginConnectionPageInfoFragment | PageInfoFragmentRootQueryToPostConnectionPageInfoFragment | PageInfoFragmentRootQueryToPostFormatConnectionPageInfoFragment | PageInfoFragmentRootQueryToRevisionsConnectionPageInfoFragment | PageInfoFragmentRootQueryToSeriesConnectionPageInfoFragment | PageInfoFragmentRootQueryToSolutionConnectionPageInfoFragment | PageInfoFragmentRootQueryToTagConnectionPageInfoFragment | PageInfoFragmentRootQueryToTaxonomyConnectionPageInfoFragment | PageInfoFragmentRootQueryToTechnologyConnectionPageInfoFragment | PageInfoFragmentRootQueryToTermNodeConnectionPageInfoFragment | PageInfoFragmentRootQueryToThemeConnectionPageInfoFragment | PageInfoFragmentRootQueryToUserConnectionPageInfoFragment | PageInfoFragmentRootQueryToUserRoleConnectionPageInfoFragment | PageInfoFragmentSeriesToContentNodeConnectionPageInfoFragment | PageInfoFragmentSeriesToPostConnectionPageInfoFragment | PageInfoFragmentSolutionToAncestorsSolutionConnectionPageInfoFragment | PageInfoFragmentSolutionToContentNodeConnectionPageInfoFragment | PageInfoFragmentSolutionToPostConnectionPageInfoFragment | PageInfoFragmentSolutionToSolutionConnectionPageInfoFragment | PageInfoFragmentTagToContentNodeConnectionPageInfoFragment | PageInfoFragmentTagToPostConnectionPageInfoFragment | PageInfoFragmentTaxonomyToContentTypeConnectionPageInfoFragment | PageInfoFragmentTaxonomyToTermNodeConnectionPageInfoFragment | PageInfoFragmentTechnologyToAncestorsTechnologyConnectionPageInfoFragment | PageInfoFragmentTechnologyToContentNodeConnectionPageInfoFragment | PageInfoFragmentTechnologyToPostConnectionPageInfoFragment | PageInfoFragmentTechnologyToTechnologyConnectionPageInfoFragment | PageInfoFragmentTermNodeToEnqueuedScriptConnectionPageInfoFragment | PageInfoFragmentTermNodeToEnqueuedStylesheetConnectionPageInfoFragment | PageInfoFragmentUserToCommentConnectionPageInfoFragment | PageInfoFragmentUserToEnqueuedScriptConnectionPageInfoFragment | PageInfoFragmentUserToEnqueuedStylesheetConnectionPageInfoFragment | PageInfoFragmentUserToMediaItemConnectionPageInfoFragment | PageInfoFragmentUserToPageConnectionPageInfoFragment | PageInfoFragmentUserToPostConnectionPageInfoFragment | PageInfoFragmentUserToRevisionsConnectionPageInfoFragment | PageInfoFragmentUserToUserRoleConnectionPageInfoFragment;

export type MenuFragmentFragment = { __typename?: 'Menu', name?: string | null, locations?: Array<MenuLocationEnum | null> | null, menuOptions?: { __typename?: 'Menu_Menuoptions', enabled?: boolean | null, searchLabel?: string | null, menuType?: string | null } | null };

export type MenuItemFragmentFragment = { __typename?: 'MenuItem', id: string, label?: string | null, linkRelationship?: string | null, url?: string | null, parentDatabaseId?: number | null, menuItemOptions?: { __typename?: 'MenuItem_Menuitemoptions', enabled?: boolean | null, itemType?: string | null } | null };

export type CreatePostMutationVariables = Exact<{
  slug: Scalars['String'];
  title: Scalars['String'];
  content: Scalars['String'];
}>;


export type CreatePostMutation = { __typename?: 'RootMutation', createPost?: { __typename?: 'CreatePostPayload', post?: { __typename?: 'Post', id: string, title?: string | null, slug?: string | null } | null } | null };

export type DeletePostMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePostMutation = { __typename?: 'RootMutation', deletePost?: { __typename?: 'DeletePostPayload', deletedId?: string | null } | null };

export type GetMenuByLocationQueryVariables = Exact<{
  location: Scalars['ID'];
}>;


export type GetMenuByLocationQuery = { __typename?: 'RootQuery', menu?: { __typename?: 'Menu', name?: string | null, locations?: Array<MenuLocationEnum | null> | null, menuItems?: { __typename?: 'MenuToMenuItemConnection', edges: Array<{ __typename?: 'MenuToMenuItemConnectionEdge', node: { __typename?: 'MenuItem', id: string, label?: string | null, linkRelationship?: string | null, url?: string | null, parentDatabaseId?: number | null, childItems?: { __typename?: 'MenuItemToMenuItemConnection', edges: Array<{ __typename?: 'MenuItemToMenuItemConnectionEdge', node: { __typename?: 'MenuItem', id: string, label?: string | null, linkRelationship?: string | null, url?: string | null, parentDatabaseId?: number | null, menuItemOptions?: { __typename?: 'MenuItem_Menuitemoptions', enabled?: boolean | null, itemType?: string | null } | null } }> } | null, menuItemOptions?: { __typename?: 'MenuItem_Menuitemoptions', enabled?: boolean | null, itemType?: string | null } | null } }> } | null, menuOptions?: { __typename?: 'Menu_Menuoptions', enabled?: boolean | null, searchLabel?: string | null, menuType?: string | null } | null } | null };

export type MenuNodeFragmentFragment = { __typename?: 'Menu', name?: string | null, locations?: Array<MenuLocationEnum | null> | null, menuItems?: { __typename?: 'MenuToMenuItemConnection', nodes: Array<{ __typename?: 'MenuItem', id: string, label?: string | null, linkRelationship?: string | null, url?: string | null, parentDatabaseId?: number | null, childItems?: { __typename?: 'MenuItemToMenuItemConnection', nodes: Array<{ __typename?: 'MenuItem', id: string, label?: string | null, linkRelationship?: string | null, url?: string | null, parentDatabaseId?: number | null, menuItemOptions?: { __typename?: 'MenuItem_Menuitemoptions', enabled?: boolean | null, itemType?: string | null } | null }> } | null, menuItemOptions?: { __typename?: 'MenuItem_Menuitemoptions', enabled?: boolean | null, itemType?: string | null } | null }> } | null, menuOptions?: { __typename?: 'Menu_Menuoptions', enabled?: boolean | null, searchLabel?: string | null, menuType?: string | null } | null };

export type GetAllMenusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllMenusQuery = { __typename?: 'RootQuery', menus?: { __typename?: 'RootQueryToMenuConnection', nodes: Array<{ __typename?: 'Menu', name?: string | null, locations?: Array<MenuLocationEnum | null> | null, menuItems?: { __typename?: 'MenuToMenuItemConnection', nodes: Array<{ __typename?: 'MenuItem', id: string, label?: string | null, linkRelationship?: string | null, url?: string | null, parentDatabaseId?: number | null, childItems?: { __typename?: 'MenuItemToMenuItemConnection', nodes: Array<{ __typename?: 'MenuItem', id: string, label?: string | null, linkRelationship?: string | null, url?: string | null, parentDatabaseId?: number | null, menuItemOptions?: { __typename?: 'MenuItem_Menuitemoptions', enabled?: boolean | null, itemType?: string | null } | null }> } | null, menuItemOptions?: { __typename?: 'MenuItem_Menuitemoptions', enabled?: boolean | null, itemType?: string | null } | null }> } | null, menuOptions?: { __typename?: 'Menu_Menuoptions', enabled?: boolean | null, searchLabel?: string | null, menuType?: string | null } | null }> } | null };

export type GetReadingSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReadingSettingsQuery = { __typename?: 'RootQuery', readingSettings?: { __typename?: 'ReadingSettings', searchEngineDiscovery?: boolean | null } | null };

export const NodeSeoFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NodeSeoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RankMathSeo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canonicalUrl"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"jsonLd"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"raw"}}]}},{"kind":"Field","name":{"kind":"Name","value":"openGraph"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"articleMeta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"section"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"siteName"}},{"kind":"Field","name":{"kind":"Name","value":"twitterMeta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slackEnhancedData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"robots"}}]}}]} as unknown as DocumentNode<NodeSeoFragmentFragment, unknown>;
export const AuthorSeoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuthorSeo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NodeSeoFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authorImage"}}]}}]}}]} as unknown as DocumentNode<AuthorSeoFragment, unknown>;
export const SeoHomePageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SeoHomePage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootQuery"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rankMathSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"homepage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"socialTitle"}},{"kind":"Field","name":{"kind":"Name","value":"socialDescription"}},{"kind":"Field","name":{"kind":"Name","value":"robotsMeta"}},{"kind":"Field","name":{"kind":"Name","value":"socialImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"sourceUrl"}},{"kind":"Field","name":{"kind":"Name","value":"mediaDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodeByUri"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uri"},"value":{"kind":"StringValue","value":"/","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NodeSeoFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"acfOptionsBlogHomepageOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blogHomeOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featuredPost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"robots"}}]}},{"kind":"Field","name":{"kind":"Name","value":"featuredImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediaDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"file"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"sourceUrl"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SeoHomePageFragment, unknown>;
export const HomePostCardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HomePostCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"featuredImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"mediaDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeToRead"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"parentDatabaseId"}}]}}]}}]}}]} as unknown as DocumentNode<HomePostCardFragment, unknown>;
export const TagSeoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagSeo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NodeSeoFragment"}}]}}]}}]} as unknown as DocumentNode<TagSeoFragment, unknown>;
export const TagsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Tags"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"solutions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"databaseId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"technologies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"databaseId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"general"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"databaseId"}}]}}]}}]}}]} as unknown as DocumentNode<TagsFragment, unknown>;
export const AuthorFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuthorFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authorImage"}},{"kind":"Field","name":{"kind":"Name","value":"bdRole"}},{"kind":"Field","name":{"kind":"Name","value":"bioLong"}},{"kind":"Field","name":{"kind":"Name","value":"generalTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generalTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"databaseId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"solutions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"solutions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"databaseId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"technologies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"technologies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"databaseId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"xTwitter"}},{"kind":"Field","name":{"kind":"Name","value":"yearsOfExperience"}},{"kind":"Field","name":{"kind":"Name","value":"youtube"}},{"kind":"Field","name":{"kind":"Name","value":"linkedin"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]} as unknown as DocumentNode<AuthorFragmentFragment, unknown>;
export const SeoSlugPageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SeoSlugPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NodeSeoFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"featuredImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediaDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sourceUrl"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"altText"}}]}}]}}]}}]} as unknown as DocumentNode<SeoSlugPageFragment, unknown>;
export const SlugPageDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SlugPageData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Tags"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"databaseId"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"parentDatabaseId"}},{"kind":"Field","name":{"kind":"Name","value":"posts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"7"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"orderby"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"DATE"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"featuredImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"mediaDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeToRead"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"parentDatabaseId"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoryPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featuredPosts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"featuredImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"mediaDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeToRead"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"excerpt"}},{"kind":"Field","name":{"kind":"Name","value":"timeToRead"}},{"kind":"Field","name":{"kind":"Name","value":"postLastUpdated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"datemodified"}},{"kind":"Field","name":{"kind":"Name","value":"showLastUpdated"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"elementsVisibilityOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hideAuthor"}},{"kind":"Field","name":{"kind":"Name","value":"hideComments"}},{"kind":"Field","name":{"kind":"Name","value":"hideSharing"}},{"kind":"Field","name":{"kind":"Name","value":"hideArticleContents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"faqOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"showFaq"}},{"kind":"Field","name":{"kind":"Name","value":"faqs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"faqSectionTitle"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"series"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"featuredImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"mediaDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuthorFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SeoSlugPage"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPreview"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"databaseId"}}]}}]} as unknown as DocumentNode<SlugPageDataFragment, unknown>;
export const BlogCardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlogCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"featuredImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mediaDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"}}]}},{"kind":"Field","name":{"kind":"Name","value":"altText"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"databaseId"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"excerpt"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authorImage"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeToRead"}}]}}]} as unknown as DocumentNode<BlogCardFragment, unknown>;
export const PostCardListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostCardList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlogCard"}},{"kind":"Field","name":{"kind":"Name","value":"postOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"elementsVisibilityOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hideAuthor"}}]}}]}}]}}]} as unknown as DocumentNode<PostCardListFragment, unknown>;
export const ReadNextFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReadNext"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"featuredImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediaDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"}}]}},{"kind":"Field","name":{"kind":"Name","value":"altText"}}]}}]}}]}}]} as unknown as DocumentNode<ReadNextFragment, unknown>;
export const ImageFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MediaItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourceUrl"}},{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"mediaDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"file"}}]}}]}}]} as unknown as DocumentNode<ImageFragmentFragment, unknown>;
export const PostFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"excerpt"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"featuredImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFragment"}}]}}]}}]}}]} as unknown as DocumentNode<PostFragmentFragment, unknown>;
export const PageInfoFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageInfoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WPPageInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offsetPagination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasMore"}},{"kind":"Field","name":{"kind":"Name","value":"hasPrevious"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<PageInfoFragmentFragment, unknown>;
export const MenuFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MenuFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Menu"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"locations"}},{"kind":"Field","name":{"kind":"Name","value":"menuOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"searchLabel"}},{"kind":"Field","name":{"kind":"Name","value":"menuType"}}]}}]}}]} as unknown as DocumentNode<MenuFragmentFragment, unknown>;
export const MenuItemFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MenuItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MenuItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"linkRelationship"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"parentDatabaseId"}},{"kind":"Field","name":{"kind":"Name","value":"menuItemOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"itemType"}}]}}]}}]} as unknown as DocumentNode<MenuItemFragmentFragment, unknown>;
export const MenuNodeFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MenuNodeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Menu"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuFragment"}},{"kind":"Field","name":{"kind":"Name","value":"menuItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"999"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuItemFragment"}},{"kind":"Field","name":{"kind":"Name","value":"childItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuItemFragment"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<MenuNodeFragmentFragment, unknown>;
export const AllPostsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllPosts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"posts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offsetPagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"orderby"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"DATE"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostCardList"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageInfoFragment"}}]}}]}}]}},...PostCardListFragmentDoc.definitions,...BlogCardFragmentDoc.definitions,...PageInfoFragmentFragmentDoc.definitions]} as unknown as DocumentNode<AllPostsQuery, AllPostsQueryVariables>;
export const AllPostsPathsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllPostsPaths"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"posts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offsetPagination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AllPostsPathsQuery, AllPostsPathsQueryVariables>;
export const AuthorPageDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AuthorPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"idType"},"value":{"kind":"EnumValue","value":"SLUG"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"databaseId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuthorFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuthorSeo"}}]}}]}},...AuthorFragmentFragmentDoc.definitions,...AuthorSeoFragmentDoc.definitions,...NodeSeoFragmentFragmentDoc.definitions]} as unknown as DocumentNode<AuthorPageQuery, AuthorPageQueryVariables>;
export const AuthorPostsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AuthorPosts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"authorId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"posts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"author"},"value":{"kind":"Variable","name":{"kind":"Name","value":"authorId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"offsetPagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"orderby"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"DATE"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostCardList"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageInfoFragment"}}]}}]}}]}},...PostCardListFragmentDoc.definitions,...BlogCardFragmentDoc.definitions,...PageInfoFragmentFragmentDoc.definitions]} as unknown as DocumentNode<AuthorPostsQuery, AuthorPostsQueryVariables>;
export const AuthorPathsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AuthorPaths"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"posts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offsetPagination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AuthorPathsQuery, AuthorPathsQueryVariables>;
export const AllAuthorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllAuthors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"size"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"EnumValue","value":"AUTHOR"}},{"kind":"ObjectField","name":{"kind":"Name","value":"hasPublishedPosts"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"POST"}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"offsetPagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"size"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"posts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offsetPagination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"customFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authorImage"}},{"kind":"Field","name":{"kind":"Name","value":"bdRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offsetPagination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"hasMore"}},{"kind":"Field","name":{"kind":"Name","value":"hasPrevious"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AllAuthorsQuery, AllAuthorsQueryVariables>;
export const CountAuthorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CountAuthors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"EnumValue","value":"AUTHOR"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offsetPagination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CountAuthorsQuery, CountAuthorsQueryVariables>;
export const LastThreePostsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LastThreePosts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"posts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offsetPagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"size"},"value":{"kind":"IntValue","value":"3"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"orderby"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"DATE"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlogCard"}}]}}]}}]}},...BlogCardFragmentDoc.definitions]} as unknown as DocumentNode<LastThreePostsQuery, LastThreePostsQueryVariables>;
export const SubcategoryPageDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SubcategoryPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postOffset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"Argument","name":{"kind":"Name","value":"idType"},"value":{"kind":"EnumValue","value":"SLUG"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"parentDatabaseId"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parentDatabaseId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoryPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ctaHeadline"}},{"kind":"Field","name":{"kind":"Name","value":"ctaBody"}},{"kind":"Field","name":{"kind":"Name","value":"ctaLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"about"}},{"kind":"Field","name":{"kind":"Name","value":"featuredPosts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"featuredImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"mediaDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeToRead"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NodeSeoFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"posts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"PUBLISH"}},{"kind":"ObjectField","name":{"kind":"Name","value":"orderby"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"DATE"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"offsetPagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"size"},"value":{"kind":"IntValue","value":"9"}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postOffset"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"categoryName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryName"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"offsetPagination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"featuredImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"mediaDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeToRead"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"parentDatabaseId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authorImage"}}]}}]}}]}}]}}]}}]}},...NodeSeoFragmentFragmentDoc.definitions]} as unknown as DocumentNode<SubcategoryPageQuery, SubcategoryPageQueryVariables>;
export const SubcategoryPathsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SubcategoryPaths"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"parentDatabaseId"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"posts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"PUBLISH"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offsetPagination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SubcategoryPathsQuery, SubcategoryPathsQueryVariables>;
export const CategoryPageDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CategoryPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"Argument","name":{"kind":"Name","value":"idType"},"value":{"kind":"EnumValue","value":"SLUG"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"parentDatabaseId"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"posts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"12"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"PUBLISH"}},{"kind":"ObjectField","name":{"kind":"Name","value":"orderby"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"DATE"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"featuredImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"mediaDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeToRead"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"parentDatabaseId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authorImage"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoryPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ctaHeadline"}},{"kind":"Field","name":{"kind":"Name","value":"ctaBody"}},{"kind":"Field","name":{"kind":"Name","value":"ctaLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"about"}},{"kind":"Field","name":{"kind":"Name","value":"faq"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"featuredPosts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"featuredImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"mediaDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeToRead"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"parentDatabaseId"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NodeSeoFragment"}}]}}]}}]}},...NodeSeoFragmentFragmentDoc.definitions]} as unknown as DocumentNode<CategoryPageQuery, CategoryPageQueryVariables>;
export const CategoryPathsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CategoryPaths"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parent"},"value":{"kind":"IntValue","value":"0"}},{"kind":"ObjectField","name":{"kind":"Name","value":"hideEmpty"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<CategoryPathsQuery, CategoryPathsQueryVariables>;
export const HomePageSeoDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HomePageSeo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generalSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SeoHomePage"}}]}},...SeoHomePageFragmentDoc.definitions,...NodeSeoFragmentFragmentDoc.definitions]} as unknown as DocumentNode<HomePageSeoQuery, HomePageSeoQueryVariables>;
export const HomePageDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HomePage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"year"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"month"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"posts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"PUBLISH"}},{"kind":"ObjectField","name":{"kind":"Name","value":"offsetPagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"size"},"value":{"kind":"IntValue","value":"13"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"orderby"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"DATE"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HomePostCard"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"excerpt"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authorImage"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offsetPagination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"acfOptionsBlogHomepageOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blogHomeFeaturedPosts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featuredPosts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HomePostCard"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"postsThisMonth"},"name":{"kind":"Name","value":"posts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"PUBLISH"}},{"kind":"ObjectField","name":{"kind":"Name","value":"offsetPagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"size"},"value":{"kind":"IntValue","value":"1"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"dateQuery"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"year"},"value":{"kind":"Variable","name":{"kind":"Name","value":"year"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"month"},"value":{"kind":"Variable","name":{"kind":"Name","value":"month"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offsetPagination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lastUpdated"},"name":{"kind":"Name","value":"posts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"PUBLISH"}},{"kind":"ObjectField","name":{"kind":"Name","value":"orderby"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"MODIFIED"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"modifiedGmt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parent"},"value":{"kind":"IntValue","value":"0"}},{"kind":"ObjectField","name":{"kind":"Name","value":"hideEmpty"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hideEmpty"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]}},...HomePostCardFragmentDoc.definitions]} as unknown as DocumentNode<HomePageQuery, HomePageQueryVariables>;
export const TagPageDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TagPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"idType"},"value":{"kind":"EnumValue","value":"SLUG"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"databaseId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagSeo"}}]}}]}},...TagSeoFragmentDoc.definitions,...NodeSeoFragmentFragmentDoc.definitions]} as unknown as DocumentNode<TagPageQuery, TagPageQueryVariables>;
export const TagPostsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TagPosts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tagId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"posts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tagId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tagId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"offsetPagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"orderby"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"DATE"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostCardList"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageInfoFragment"}}]}}]}}]}},...PostCardListFragmentDoc.definitions,...BlogCardFragmentDoc.definitions,...PageInfoFragmentFragmentDoc.definitions]} as unknown as DocumentNode<TagPostsQuery, TagPostsQueryVariables>;
export const TagPathsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TagPaths"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"size"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"size"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"posts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offsetPagination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TagPathsQuery, TagPathsQueryVariables>;
export const FourOFourPageDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FourOFourPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acfOptionsBlogHomepageOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blogHomeOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featuredPost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mostReadPostsOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"automaticMostReadPosts"}},{"kind":"Field","name":{"kind":"Name","value":"mostReadPosts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostCardList"}}]}}]}}]}}]}}]}},...PostCardListFragmentDoc.definitions,...BlogCardFragmentDoc.definitions]} as unknown as DocumentNode<FourOFourPageQuery, FourOFourPageQueryVariables>;
export const FallbackFourOFourPageDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FallbackFourOFourPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notIn"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"posts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offsetPagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"size"},"value":{"kind":"IntValue","value":"3"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"orderby"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"DATE"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"notIn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notIn"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostCardList"}}]}}]}}]}}]}},...PostCardListFragmentDoc.definitions,...BlogCardFragmentDoc.definitions]} as unknown as DocumentNode<FallbackFourOFourPageQuery, FallbackFourOFourPageQueryVariables>;
export const SlugPagePathsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SlugPagePaths"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"size"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"posts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offsetPagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"size"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"orderby"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"DATE"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<SlugPagePathsQuery, SlugPagePathsQueryVariables>;
export const SlugPageDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SlugPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uri"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPreview"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"post"},"name":{"kind":"Name","value":"postBy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uri"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uri"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SlugPageData"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPreview"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"preview"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPreview"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SlugPageData"}}]}}]}}]}}]}},...SlugPageDataFragmentDoc.definitions,...TagsFragmentDoc.definitions,...AuthorFragmentFragmentDoc.definitions,...SeoSlugPageFragmentDoc.definitions,...NodeSeoFragmentFragmentDoc.definitions]} as unknown as DocumentNode<SlugPageQuery, SlugPageQueryVariables>;
export const GetBatchedPostsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBatchedPosts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idsList"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"posts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"6"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idsList"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"timeToRead"}},{"kind":"Field","name":{"kind":"Name","value":"featuredImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"mediaDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentDatabaseId"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBatchedPostsQuery, GetBatchedPostsQueryVariables>;
export const NavbarDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Navbar"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"weekAgo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parent"},"value":{"kind":"IntValue","value":"0"}},{"kind":"ObjectField","name":{"kind":"Name","value":"hideEmpty"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"posts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dateQuery"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"weekAgo"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"PUBLISH"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offsetPagination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"posts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"PUBLISH"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offsetPagination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NavbarQuery, NavbarQueryVariables>;
export const CreatePostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"content"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"content"},"value":{"kind":"Variable","name":{"kind":"Name","value":"content"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"post"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<CreatePostMutation, CreatePostMutationVariables>;
export const DeletePostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletedId"}}]}}]}}]} as unknown as DocumentNode<DeletePostMutation, DeletePostMutationVariables>;
export const GetMenuByLocationDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_MENU_BY_LOCATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"menu"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idType"},"value":{"kind":"EnumValue","value":"LOCATION"}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuFragment"}},{"kind":"Field","name":{"kind":"Name","value":"menuItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuItemFragment"}},{"kind":"Field","name":{"kind":"Name","value":"childItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuItemFragment"}}]}}]}}]}}]}}]}}]}}]}}]}},...MenuFragmentFragmentDoc.definitions,...MenuItemFragmentFragmentDoc.definitions]} as unknown as DocumentNode<GetMenuByLocationQuery, GetMenuByLocationQueryVariables>;
export const GetAllMenusDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_ALL_MENUS"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"menus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuNodeFragment"}}]}}]}}]}},...MenuNodeFragmentFragmentDoc.definitions,...MenuFragmentFragmentDoc.definitions,...MenuItemFragmentFragmentDoc.definitions]} as unknown as DocumentNode<GetAllMenusQuery, GetAllMenusQueryVariables>;
export const GetReadingSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_READING_SETTINGS"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"readingSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchEngineDiscovery"}}]}}]}}]} as unknown as DocumentNode<GetReadingSettingsQuery, GetReadingSettingsQueryVariables>;